!function (e) {
  "object" == typeof module && "undefined" != typeof module.exports ? module.exports = e : e();
}(function () {
  (window.webpackJsonpFusionCharts = window.webpackJsonpFusionCharts || []).push([[4], {
    831: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t.DragArea = t.Radar = t.HeatMap = t.BoxAndWhisker2D = t.CandleStick = t.DragNode = t.MSStepLine = t.MultiAxisLine = t.MultilevelPie = t.SelectScatter = t.WaterFall2D = t.Kagi = t.Dragline = t.Dragcolumn2d = t.Inversemsline = t.Inversemscolumn2d = t.Inversemsarea = t.Errorscatter = t.Errorline = t.Errorbar2d = t.Mssplinearea = t.Msspline = t.MSSplineDy = t.Splinearea = t.Logmsline = t.LogStackedColumn2d = t.Logmscolumn2d = t.Spline = undefined;

      var a = O(o(598)),
          r = O(o(832)),
          n = O(o(837)),
          i = O(o(839)),
          l = O(o(601)),
          s = O(o(603)),
          c = O(o(606)),
          u = O(o(608)),
          p = O(o(841)),
          h = O(o(845)),
          d = O(o(850)),
          f = O(o(855)),
          g = O(o(857)),
          m = O(o(859)),
          v = O(o(861)),
          b = O(o(873)),
          y = O(o(880)),
          x = O(o(887)),
          k = O(o(888)),
          w = O(o(892)),
          C = O(o(897)),
          N = O(o(905)),
          S = O(o(909)),
          A = O(o(920)),
          E = O(o(933)),
          D = O(o(942)),
          _ = O(o(954)),
          T = O(o(967)),
          L = O(o(968)),
          P = O(o(969));

      function O(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      t.Spline = a["default"], t.Logmscolumn2d = r["default"], t.LogStackedColumn2d = i["default"], t.Logmsline = n["default"], t.Splinearea = l["default"], t.MSSplineDy = c["default"], t.Msspline = s["default"], t.Mssplinearea = u["default"], t.Errorbar2d = p["default"], t.Errorline = h["default"], t.Errorscatter = d["default"], t.Inversemsarea = f["default"], t.Inversemscolumn2d = g["default"], t.Inversemsline = m["default"], t.Dragcolumn2d = v["default"], t.Dragline = b["default"], t.Kagi = y["default"], t.WaterFall2D = x["default"], t.SelectScatter = k["default"], t.MultilevelPie = w["default"], t.MultiAxisLine = C["default"], t.MSStepLine = N["default"], t.DragNode = S["default"], t.CandleStick = A["default"], t.BoxAndWhisker2D = E["default"], t.HeatMap = D["default"], t.Radar = _["default"], t.DragArea = T["default"], t["default"] = {
        name: "powercharts",
        type: "package",
        requiresFusionCharts: !0,
        extension: function extension(e) {
          e.addDep(L["default"]), e.addDep(P["default"]), e.addDep(a["default"]), e.addDep(r["default"]), e.addDep(i["default"]), e.addDep(n["default"]), e.addDep(l["default"]), e.addDep(c["default"]), e.addDep(s["default"]), e.addDep(u["default"]), e.addDep(p["default"]), e.addDep(h["default"]), e.addDep(d["default"]), e.addDep(f["default"]), e.addDep(g["default"]), e.addDep(m["default"]), e.addDep(v["default"]), e.addDep(b["default"]), e.addDep(y["default"]), e.addDep(x["default"]), e.addDep(k["default"]), e.addDep(w["default"]), e.addDep(C["default"]), e.addDep(N["default"]), e.addDep(S["default"]), e.addDep(A["default"]), e.addDep(E["default"]), e.addDep(D["default"]), e.addDep(_["default"]), e.addDep(T["default"]);
        }
      };
    },
    832: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(833),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    833: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = i(o(834)),
          r = i(o(516)),
          n = i(o(432));

      function i(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function l(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var s = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return l(t, e), t.getName = function () {
          return "LogMSColumn2d";
        }, t.prototype.getName = function () {
          return "LogMSColumn2d";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.friendlyName = "Multi-series Log Column Chart", t.defaultDatasetType = "column", t.enablemousetracking = !0;
        }, t.prototype.getDSGroupdef = function () {
          return r["default"];
        }, t.prototype.getDSdef = function () {
          return n["default"];
        }, t;
      }(a["default"]);

      t["default"] = s;
    },
    834: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = i(o(459)),
          r = i(o(835)),
          n = o(125);

      function i(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function l(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var s = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.registerFactory("axis", r["default"], ["canvas"]), o;
        }

        return l(t, e), t.getName = function () {
          return "MsLog";
        }, t.prototype._feedAxesRawData = function () {
          var e,
              t,
              o = this.getFromEnv("dataSource"),
              a = this.getFromEnv("chart-attrib");
          return e = this.getSpecificxAxisConf(), "1" === (t = this.getSpecificyAxisConf()).base && (t.base = 10, t.logBase = 10), t.minorDivlinecolor = (0, n.pluck)(a.minordivlinecolor, t.divLineColor), t.minorDivLineThickness = (0, n.pluck)(a.minordivlinethickness, 1), t.minorDivLineAlpha = (0, n.pluck)(a.minordivlinealpha, t.divLineAlpha / 2), e.vtrendlines = o.vtrendlines, t.trendlines = o.trendlines, {
            yAxisConf: [t],
            xAxisConf: [e]
          };
        }, t.prototype.getSpecificxAxisConf = function () {
          var e = this.getFromEnv("chart-attrib"),
              t = this.getBasexAxisConf();
          return t.showZeroPlane = e.showvzeroplane, t.zeroPlaneThickness = e.vzeroplanethickness, t.zeroPlaneAlpha = e.vzeroplanealpha, t.showAxisLine = (0, n.pluckNumber)(e.showxaxisline, e.showaxislines, e.drawAxisLines, 0), t.axisLineColor = (0, n.pluck)(e.xaxislinecolor, e.axislinecolor, "#000000"), t.isReverse = !1, t.showAlternateGridColor = (0, n.pluckNumber)(e.showalternatevgridcolor, 0), t.numDivLines = e.numvdivlines, t.maxLabelHeight = e.maxlabelheight, t.axisName = e.xaxisname, t.setAdaptiveMin = e.setadaptivexmin, t.showLimits = e.showvlimits, t.showDivLineValues = (0, n.pluckNumber)(e.showvdivlinevalues, e.showvdivlinevalues), t;
        }, t.prototype.getSpecificyAxisConf = function () {
          var e = this.getFromEnv("chart-attrib"),
              t = this.config.is3D ? n.chartPaletteStr.chart3D : n.chartPaletteStr.chart2D,
              o = !!(0, n.pluckNumber)(e.invertyaxis, 0),
              a = this.getFromEnv("color-manager");
          return {
            isVertical: !0,
            isReverse: !o,
            isOpposit: !1,
            outCanfontFamily: (0, n.pluck)(e.outcnvbasefont, e.basefont, "Verdana,sans"),
            outCanfontSize: (0, n.pluckFontSize)(e.outcnvbasefontsize, e.basefontsize, 10),
            outCancolor: (0, n.pluck)(e.outcnvbasefontcolor, e.basefontcolor, a.getColor(t.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi, "#$1"),
            axisNamePadding: e.yaxisnamepadding,
            axisValuePadding: e.yaxisvaluespadding,
            axisNameFont: e.yaxisnamefont,
            axisNameFontSize: e.yaxisnamefontsize,
            axisNameFontColor: e.yaxisnamefontcolor,
            axisNameFontBold: e.yaxisnamefontbold,
            axisNameFontItalic: e.yaxisnamefontitalic,
            axisNameBgColor: e.yaxisnamebgcolor,
            axisNameBorderColor: e.yaxisnamebordercolor,
            axisNameAlpha: e.yaxisnamealpha,
            axisNameFontAlpha: e.yaxisnamefontalpha,
            axisNameBgAlpha: e.yaxisnamebgalpha,
            axisNameBorderAlpha: e.yaxisnameborderalpha,
            axisNameBorderPadding: e.yaxisnameborderpadding,
            axisNameBorderRadius: e.yaxisnameborderradius,
            axisNameBorderThickness: e.yaxisnameborderthickness,
            axisNameBorderDashed: e.yaxisnameborderdashed,
            axisNameBorderDashLen: e.yaxisnameborderdashlen,
            axisNameBorderDashGap: e.yaxisnameborderdashgap,
            axisNameWidth: e.yaxisnamewidth,
            useEllipsesWhenOverflow: e.useellipseswhenoverflow,
            rotateAxisName: (0, n.pluckNumber)(e.rotateyaxisname, 1),
            axisName: e.yaxisname,
            divLineColor: (0, n.pluck)(e.divlinecolor, a.getColor(t.divLineColor)),
            divLineAlpha: (0, n.pluck)(e.divlinealpha, a.getColor("divLineAlpha")),
            divLineThickness: (0, n.pluckNumber)(e.divlinethickness, 2),
            divLineIsDashed: Boolean((0, n.pluckNumber)(e.divlinedashed, e.divlineisdashed, 0)),
            divLineDashLen: (0, n.pluckNumber)(e.divlinedashlen, 4),
            divLineDashGap: (0, n.pluckNumber)(e.divlinedashgap, 2),
            showAlternateGridColor: (0, n.pluckNumber)(e.showalternatehgridcolor, 1),
            alternateGridColor: (0, n.pluck)(e.alternatehgridcolor, a.getColor("altHGridColor")),
            alternateGridAlpha: (0, n.pluck)(e.alternatehgridalpha, a.getColor("altHGridAlpha")),
            numDivLines: e.numdivlines,
            axisMinValue: e.yaxisminvalue,
            axisMaxValue: e.yaxismaxvalue,
            setAdaptiveMin: e.setadaptiveymin,
            adjustDiv: e.adjustdiv,
            labelStep: e.yaxisvaluesstep,
            showAxisValues: (0, n.pluckNumber)(e.showyaxisvalues, e.showyaxisvalue),
            showLimits: (0, n.pluckNumber)(e.showyaxislimits, e.showlimits, this.showLimits),
            showDivLineValues: (0, n.pluckNumber)(e.showdivlinevalues, e.showdivlinevalue),
            showZeroPlane: e.showzeroplane,
            zeroPlaneColor: e.zeroplanecolor,
            zeroPlaneThickness: e.zeroplanethickness,
            zeroPlaneAlpha: e.zeroplanealpha,
            showZeroPlaneValue: e.showzeroplanevalue,
            trendlineColor: e.trendlinecolor,
            trendlineToolText: e.trendlinetooltext,
            trendlineThickness: e.trendlinethickness,
            trendlineAlpha: e.trendlinealpha,
            showTrendlinesOnTop: e.showtrendlinesontop,
            showAxisLine: (0, n.pluckNumber)(e.showyaxisline, e.showaxislines, e.drawAxisLines, 0),
            axisLineThickness: (0, n.pluckNumber)(e.yaxislinethickness, e.axislinethickness, 1),
            axisLineAlpha: (0, n.pluckNumber)(e.yaxislinealpha, e.axislinealpha, 100),
            base: e.base,
            logBase: e.logbase,
            axisLineColor: (0, n.pluck)(e.yaxislinecolor, e.axislinecolor, "#000000"),
            showMinorDivLineValues: (0, n.pluckNumber)(e.showminordivlinevalues, 0),
            numMinorDivLines: e.numminordivlines
          };
        }, t;
      }(a["default"]);

      t["default"] = s;
    },
    835: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = function (e) {
        var t = e.getChildren("canvas")[0],
            o = t.getChildren("axisRefVisualCartesian")[0],
            i = {
          zoomable: !0,
          pannable: !0
        },
            l = e._feedAxesRawData(),
            s = void 0,
            c = void 0,
            u = function u() {
          return o.asyncDraw();
        };

        (0, a.componentFactory)(e, r["default"], "yAxis", 1, l.yAxisConf), (0, a.componentFactory)(e, n["default"], "xAxis", 1, l.xAxisConf), s = e.getChildren("yAxis")[0], c = e.getChildren("xAxis")[0], s.setLinkedItem("canvas", t), c.setLinkedItem("canvas", t), o.setLinkedItem(s.getId(), s), o.setLinkedItem(c.getId(), c), o.addExtEventListener("visiblerangeset", u, c), o.addExtEventListener("visiblerangeset", u, s), t.attachAxis(c, !1, e.zoomX ? i : {}), t.attachAxis(s, !0, e.zoomY ? i : {}), e._setCategories();
      };
      var a = o(125),
          r = i(o(836)),
          n = i(o(422));

      function i(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }
    },
    836: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = s(o(379)),
          r = s(o(736)),
          n = s(o(383)),
          i = o(125),
          l = o(386);

      function s(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function c(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var u = function u(e) {
        return null !== e && e !== i.UNDEF && "" !== e && !isNaN(e);
      },
          p = {
        wrtVisible: !0
      },
          h = i.preDefStr.POSITION_START,
          d = i.preDefStr.POSITION_TOP,
          f = i.preDefStr.POSITION_BOTTOM,
          g = i.preDefStr.POSITION_END,
          m = function m() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [],
            t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        if (0 === e.length) return [];
        var o = e.length - 1,
            a = t.length - 1,
            r = [e[o]];

        for (o--; o >= 0;) {
          t[a] > e[o] ? (r.push(t[a]), a--) : (r.push(e[o]), o--);
        }

        return r;
      },
          v = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.config.scale = new r["default"](), o.config.labelMap = [], o;
        }

        return c(t, e), t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.base = 10, t.showMinorDivLineValues = 1, t.numMinorDivLines = i.UNDEF;
        }, t.prototype.getName = function () {
          return "log";
        }, t.prototype.configureAttributes = function (t) {
          var o,
              a = this.config,
              r = this.getFromEnv("number-formatter"),
              n = this.getFromEnv("color-manager");
          e.prototype.configureAttributes.call(this, t), o = a.rawAttr, a.minorDivlinecolor = (0, i.convertColor)((0, i.pluck)(o.minorDivlinecolor, n.getColor("divLineColor")), (0, i.pluckNumber)(o.minorDivLineAlpha, n.getColor("divLineAlpha") / 2)), a.axisMinValue = r.getCleanValue(o.axisMinValue), a.axisMaxValue = r.getCleanValue(o.axisMaxValue), a.minorTicks = [], a.axisMinValue <= 0 && (a.axisMinValue = i.UNDEF), a.axisMaxValue <= 0 && (a.axisMaxValue = i.UNDEF), this.getScale().setBase(a.base), a.minorDivLineThickness = (0, i.pluckNumber)(o.minorDivLineThickness, 1), a.band.isDraw = 0;
        }, t.prototype.generateTicks = function () {
          var e = this.getScale().ticks();
          return this.config._allTicks = e.slice(), e;
        }, t.prototype.generateMinorTicks = function () {
          return this.getScale().minorTicks(this.config.numMinorDivLines);
        }, t.prototype._setAxisRange = function (e) {
          var t = e.min,
              o = t === undefined ? .1 : t,
              a = e.max,
              r = a === undefined ? 1 : a,
              n = this.getScale().setDomain([o, r]).nice(),
              i = this.config,
              l = i.axisRange;
          i.ticks = this.generateTicks(), i.minorTicks = this.generateMinorTicks();
          var s = n.getDomain();
          o = s[0], r = s[1], l.max = r, l.min = o, this.setVisibleConfig(o, r);
        }, t.prototype.setDataLimit = function (e, t) {
          var o,
              a,
              r = this.config,
              n = r.axisMaxValue,
              l = r.axisMinValue;
          u(l) && Number(l) <= t && (t = l), u(n) && Number(n) >= e && (e = n), 0 === t && (t = 1), 0 === e && (e = r.base);
          var s = this.getTrendLineLimits();
          o = s[0], a = s[1];
          var c = (0, i.extent)([o, a, t, e], function (e) {
            return Number(e);
          });
          t = c[0], e = c[1], this._setAxisRange({
            min: t,
            max: e
          });
        }, t.prototype._parseLabel = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              l,
              s,
              c,
              u,
              v,
              b,
              y,
              x,
              k,
              w,
              C = this.config,
              N = this.getFromEnv("chart").config,
              S = C.axisRange,
              A = C.isOpposit,
              E = C.labels,
              D = E.style,
              _ = C.isVertical,
              T = S.max,
              L = S.min,
              P = N.canvasBottom,
              O = N.canvasLeft,
              V = N.canvasRight,
              M = N.canvasTop,
              F = C.labelPadding,
              I = this.getFromEnv("number-formatter"),
              B = C.labelMaxH,
              R = C.labelMaxW,
              j = C.axisStartPosition,
              G = this.components,
              H = C.minorTicks;
          if (D.lineHeight && -1 !== (n = D.lineHeight).indexOf("px") && (n = n.replace("px", ""), n = parseFloat(n)), C.labels.isDraw) for (w = 1 !== this.getZoom(), k = G.labels, e = C.labels.step ? S.tickInterval * C.labels.step : S.tickInterval, r = C.labels.rotation, a = this.getVisibleConfig(), G.labelIndexArr = [], C.allTicks = c = m(C.ticks, C.minorTicks), x = _ ? B : R, u = c.length, t = 0; t < u; t++) {
            if (v = c[t], b = this.getPixel(v, p), (!(H.indexOf(v) >= 0) || C.showMinorDivLineValues) && !(y && b > y - x && b < y + x) && (!w || !(v < a.minValue || v > a.maxValue)) && (C.labels.drawNormalVal || C.labels.drawLimitVal && (v === L || v === T)) && (C.labels.drawNormalVal || v === L || v === T) && (C.labels.drawLimitVal || v !== L && v !== T) && (0 !== C.showZeroPlaneValue || 0 !== C.showZeroPlane || 0 !== v)) {
              if (1 === C.showZeroPlane && 1 === C.showZeroPlaneValue && (v < 0 && v + e > 0 || v > 0 && v - e < 0)) if (_) {
                if (b + B >= this.getPixel(0, p) && this.getPixel(0, p) >= b - B) continue;
              } else if (b + R >= this.getPixel(0, p) && this.getPixel(0, p) >= b - R) continue;
              s = {
                fill: D.color,
                "font-size": D.fontSize
              }, _ ? (o = "" + (C.numberFormatterFn ? I[C.numberFormatterFn] : C.isPercent ? I.percentValue : I.yAxis).call(I, v), l = C.hasCategory && C.categories.category[t].labelPadding || 0, s["text-anchor"] = A ? h : g, s.text = o, s.x = A ? (j || V) + F : (j || O) - F, s.y = l ? b + l : b, y = s.y) : (o = "" + (C.numberFormatterFn ? I[C.numberFormatterFn] : C.isPercent ? I.percentValue : I.xAxis).call(I, v), l = C.hasCategory && Number(C.categories.category[t].labelPadding) || 0, s.text = o, s.x = b, s.y = A ? (j || M) - F : (j || P) + F, l && (s.y += l), r ? (s["text-anchor"] = A ? h : g, s["vertical-align"] = "middle") : s["vertical-align"] = A ? f : d, y = s.x), E.shiftX && (s.x += E.shiftX), E.shiftY && (s.y += E.shiftY), s.transform = (0, i.getSuggestiveRotation)(r, s.x, s.y), G.labelIndexArr.push(t), k[t] = k[t] || {
                config: {
                  props: {
                    label: {}
                  }
                }
              }, k[t].config.props.label.attr = s, k[t].config.props.label.css = o.css, k[t].config.value = v;
            }
          }
        }, t.prototype._drawLabel = function () {
          var e,
              t,
              o,
              a,
              r,
              i,
              l,
              s,
              c,
              u = this,
              p = u.config,
              h = u.getFromEnv("animationManager"),
              d = p.labels.style,
              f = p.axisContainer,
              g = [],
              m = u.components,
              v = m.labelIndexArr,
              b = {
            fontFamily: d.fontFamily,
            fontSize: d.fontSize,
            fontWeight: d.fontWeight,
            fontStyle: d.fontStyle,
            lineHeight: d.lineHeight
          };

          if (p.labels.isDraw) {
            for (c = m.labels, f.css(b), l = v.length, t = 0; t < l; t++) {
              o = (s = c[e = v[t]].config.value) + "_label", i = u.getGraphicalElement(o), g.push(o), i = this.addGraphicalElement(o, h.setAnimation({
                container: f,
                el: i || "text",
                attr: c[e].config.props.label.attr,
                data: {
                  value: s
                },
                component: this,
                label: "text",
                css: c[e].config.props.label.css
              }));
            }

            a = (0, n["default"])(p.labelMap, g);
          } else a = p.labelMap;

          p.labelMap = g, function (t) {
            for (e = 0; e < t.length; ++e) {
              (r = u.getGraphicalElement(t[e])) && u.removeGraphicalElement(r);
            }
          }(a);
        }, t.prototype._getVMaxLabelDimention = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              i,
              l,
              s = this.config,
              c = this.getFromEnv("chart"),
              u = this.getFromEnv("smartLabel"),
              p = this.getFromEnv("number-formatter"),
              h = s.labels.style,
              d = 0;

          for (u.useEllipsesOnOverflow(c.config.useEllipsesWhenOverflow), u.setStyle({
            fontSize: h.fontSize,
            fontFamily: h.fontFamily,
            lineHeight: h.lineHeight,
            fontWeight: h.fontWeight
          }), i = s.isPercent ? p.percentValue : p.xAxis, s.allTicks = e = m(s.ticks, s.minorTicks), t = e.length, a = 0; a < t; a++) {
            l = e[a], r = "" + i.call(p, l), n = u.getOriSize(r), this.components.labels[a] = {
              config: {
                width: n.width,
                height: n.height,
                props: {
                  label: {}
                }
              }
            }, r.length > d && (o = n, d = r.length);
          }

          return o;
        }, t.prototype._getHMaxLabelDimention = function () {
          return this._getVMaxLabelDimention();
        }, t.prototype.getCleanValue = function (e) {
          var t = null;
          return (e = Math.abs(e)) > 0 && (t = this.getFromEnv("number-formatter").getCleanValue(e)), t;
        }, t;
      }(a["default"]);

      v.prototype.getTrendLineLimits = l.getTrendLineLimits, t["default"] = v;
    },
    837: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(838),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    838: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = i(o(834)),
          r = i(o(449)),
          n = o(551);

      function i(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function l(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var s = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.defaultPlotShadow = 1, o;
        }

        return l(t, e), t.getName = function () {
          return "LogMSLine";
        }, t.prototype.getName = function () {
          return "LogMSLine";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.friendlyName = "Multi-series Line Chart", t.defaultDatasetType = "line", t.zeroplanethickness = 1, t.enablemousetracking = !0, t.zeroplanealpha = 40, t.showzeroplaneontop = 0, t.enablemousetracking = !0, t.defaultcrosslinethickness = 1, n._setDefaultConfig.call(this);
        }, t.prototype.getDSGroupdef = function () {}, t.prototype.getDSdef = function () {
          return r["default"];
        }, t;
      }(a["default"]);

      t["default"] = s;
    },
    839: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(840),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    840: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = n(o(833)),
          r = n(o(525));

      function n(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function i(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var l = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return i(t, e), t.getName = function () {
          return "LogStackedColumn2d";
        }, t.prototype.getName = function () {
          return "LogStackedColumn2d";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.friendlyName = "Stacked Log Column Chart", t.isstacked = !0;
        }, t.prototype.getDSGroupdef = function () {
          return r["default"];
        }, t;
      }(a["default"]);

      t["default"] = l;
    },
    841: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(842),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    842: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = i(o(459)),
          r = i(o(516)),
          n = i(o(843));

      function i(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function l(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var s = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.showValues = 0, o.isErrorChart = !0, o.eiMethods = {}, o;
        }

        return l(t, e), t.getName = function () {
          return "ErrorBar2D";
        }, t.prototype.getName = function () {
          return "ErrorBar2D";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.friendlyName = "Error Bar Chart", t.hasLegend = !0, t.defaultDatasetType = "errorbar2d", t.enablemousetracking = !0;
        }, t.prototype.getDSGroupdef = function () {
          return r["default"];
        }, t.prototype.getDSdef = function () {
          return n["default"];
        }, t;
      }(a["default"]);

      t["default"] = s;
    },
    843: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t._checkPointerOverPlot = t._checkPointerOverErrorBar = t._firePlotEvent = t._rolloutResponseSetter = t._rolloverResponseSetter = t.removePlots = t._getHoveredPlot = undefined;
      var a = o(125),
          r = l(o(432)),
          n = o(132),
          i = l(o(844));

      function l(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var c,
          u,
          p,
          h,
          d,
          f = a.preDefStr.colors.AAAAAA,
          g = a.preDefStr.ROUND,
          m = a.preDefStr.PERCENTAGESTRING,
          v = a.preDefStr.pStr,
          b = a.preDefStr.sStr,
          y = function y(e, t, o, a) {
        var r = t.graphics,
            n = t.errorBarHovered,
            i = r && r.element,
            l = e.getFromEnv("animationManager"),
            s = i && i.getData();
        !n && i && 0 !== s.showHoverEffect && (l.setAnimationState("mouseOver"), l.setAnimation({
          el: i,
          label: "rect",
          component: a,
          attr: i.getData().setRolloverAttr,
          doNotRemove: !0
        })), i && e.plotEventHandler(i, o, "DataPlotRollOver");
      },
          x = function x(e, t, o, a) {
        var r = t.graphics,
            n = t.errorBarHovered,
            i = r && r.element,
            l = e.getFromEnv("animationManager"),
            s = i && i.getData();
        !n && i && 0 !== s.showHoverEffect && (l.setAnimationState("mouseOut"), l.setAnimation({
          el: i,
          label: "rect",
          component: a,
          attr: i.getData().setRolloutAttr,
          doNotRemove: !0
        })), i && e.plotEventHandler(i, o, "DataPlotRollOut");
      };

      (0, n.addDep)({
        name: "errorbar2DColumnAnimation",
        type: "animationRule",
        extension: i["default"].column
      }), (0, n.addDep)({
        name: "errorbar2DErrorAnimation",
        type: "animationRule",
        extension: i["default"].error
      });

      var k = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return s(t, e), t.prototype.getType = function () {
          return "dataset";
        }, t.prototype.getName = function () {
          return "errorBar2D";
        }, t.prototype.ErrorValueConfigure = function () {
          var e,
              t,
              o,
              r,
              n,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              d,
              g,
              y,
              x,
              k,
              w,
              C,
              N,
              S,
              A,
              E,
              D,
              _,
              T,
              L,
              P,
              O = this.config,
              V = O.JSONData,
              M = V.data,
              F = M && M.length,
              I = this.getFromEnv("chart-attrib"),
              B = this.components.data,
              R = (0, a.parseUnsafeString)(I.yaxisname),
              j = (0, a.parseUnsafeString)(I.xaxisname),
              G = (0, a.pluckNumber)(I.seriesnameintooltip, 1),
              H = (0, a.parseUnsafeString)((0, a.pluck)(I.tooltipsepchar, ", ")),
              W = this.getFromEnv("number-formatter"),
              z = -Infinity,
              U = Infinity,
              J = this.getFromEnv("xAxis").getTicksLen(),
              K = Math.min(J, F),
              q = function q(t) {
            var r;
            return O.showTooltip ? null === h ? r = !1 : void 0 !== t ? (l = [1, 2, 3, 4, 5, 6, 7, 99, 100, 101, 102, 120, 121], s = {
              yaxisName: R,
              xaxisName: j,
              formattedValue: o.toolTipValue,
              errorValue: p,
              errorDataValue: o.errorToolTipValue,
              errorPercentValue: o.errorPercentValue,
              errorPercentDataValue: o.errorPercentValue,
              positiveErrorValue: o.positiveErrorToolTipValue,
              negativeErrorValue: o.negativeErrorToolTipValue,
              label: o.label
            }, r = (0, a.parseTooltext)(t, l, s, e, I, V)) : (G && (n = (0, a.getFirstValue)(V && V.seriesname)), r = n ? n + H : "", r += o.label ? o.label + H : "") : r = !1, r;
          };

          for (O.showTooltip = (0, a.pluckNumber)(I.showtooltip, 1), O.errorInPercent = i = (0, a.pluckNumber)(V.errorinpercent, I.errorinpercent), O.showValues = (0, a.pluckNumber)(V.showvalues, I.showvalues, 0), O.errorBarShadow = g = (0, a.pluckNumber)(I.errorbarshadow, I.showshadow, 1), O.ignoreEmptyDatasets = (0, a.pluckNumber)(V.ignoreemptydatasets, 0), N = (0, a.pluckNumber)(I.halferrorbar, 1), O.notHalfErrorBar = !(0, a.pluckNumber)(I.halferrorbar, 1), u = (0, a.getFirstAlpha)((0, a.pluck)(V.errorbaralpha, I.errorbaralpha, O.plotfillalpha)), O.errorBarWidthPercent = (0, a.pluckNumber)(V.errorbarwidthpercent, I.errorbarwidthpercent, 70), O.errorBarColor = (0, a.convertColor)((0, a.getFirstColor)((0, a.pluck)(V.errorbarcolor, I.errorbarcolor, f)), u), O.errorBarThickness = (0, a.pluckNumber)(V.errorbarthickness, I.errorbarthickness, 1), O.shadowOpacity = g ? u / 250 : 0, O.parentYAxis = y = (0, a.pluck)(V.parentyaxis && V.parentyaxis.toLowerCase(), v) === b ? 1 : 0, O.cumulativeValueOnErrorBar = (0, a.pluckNumber)(V.cumulativevalueonerrorbar, I.cumulativevalueonerrorbar, 1), P = 0; P < K; P++) {
            (t = B[P]) && (e = M && M[P], o = t && t.config, T = void 0, L = void 0, void 0 !== (0, a.pluckNumber)(e.value) && (t || (t = B[P] = {
              graphics: {}
            }), t.config || (o = B[P].config = {}), x = o.setValue, o.setErrorValue = p = W.getCleanValue(e.errorvalue), o.errorInPercent = (0, a.pluckNumber)(e.errorinpercent, i, 0), o.errorInPercent && (o.setErrorValue = p = (0, a.pluckNumber)((p / 100 * x).toFixed(2))), o.cumulativeValueOnErrorBar = (0, a.pluckNumber)(e.cumulativevalueonerrorbar, O.cumulativeValueOnErrorBar, 1), o.positiveErrorValue = W.getCleanValue((0, a.pluckNumber)(e.positiveerrorvalue, e.errorvalue)), o.errorInPercent && o.positiveErrorValue && (o.positiveErrorValue = (0, a.pluckNumber)((o.positiveErrorValue / 100 * x).toFixed(2))), o.positiveCumulativeErrorValue = x + (0, a.pluckNumber)(o.positiveErrorValue, o.setErrorValue), o.negativeErrorValue = W.getCleanValue((0, a.pluckNumber)(e.negativeerrorvalue, e.errorvalue)), o.errorInPercent && o.negativeErrorValue && (o.negativeErrorValue = (0, a.pluckNumber)((o.negativeErrorValue / 100 * x).toFixed(2))), o.negativeCumulativeErrorValue = x - (0, a.pluckNumber)(o.negativeErrorValue, o.setErrorValue), o.errorToolTipValue = W.dataLabels(p, y), o.negativeErrorToolTipValue = W.dataLabels(o.negativeErrorValue, y), o.negativeCumulativeErrorTooltipValue = W.dataLabels(o.negativeCumulativeErrorValue, y), o.positiveErrorToolTipValue = W.dataLabels(o.positiveErrorValue, y), o.positiveCumulativeErrorTooltipValue = W.dataLabels(o.positiveCumulativeErrorValue, y), o.errorPercentValue = Math.round(p / x * a.HUNDREDSTRING * a.HUNDREDSTRING) / a.HUNDREDSTRING + m, E = o.cumulativeValueOnErrorBar, o.notHalfErrorBar = O.notHalfErrorBar, o.halfErrorBar = N, o.showValue = (0, a.pluckNumber)(e.showvalue, O.showValues), o.hasErrorValue = void 0 !== (0, a.pluckNumber)(e.errorvalue) ? 1 : 0, k = o.errorValue = p, c = o.errorToolTipValue, h = c, r = q(d = (0, a.getValidValue)((0, a.parseUnsafeString)((0, a.pluck)(e.errorplottooltext, V.errorplottooltext, I.errorplottooltext, h)))), T = L = void 0, (d = (0, a.getValidValue)((0, a.parseUnsafeString)((0, a.pluck)(e.errorplottooltext, V.errorplottooltext, I.errorplottooltext, o.positiveErrorToolTipValue)))) && o.positiveErrorToolTipValue && (T = q(d)), (d = (0, a.getValidValue)((0, a.parseUnsafeString)((0, a.pluck)(e.errorplottooltext, V.errorplottooltext, I.errorplottooltext, o.negativeErrorToolTipValue)))) && o.negativeErrorToolTipValue && (L = q(d)), E && ((d = (0, a.getValidValue)((0, a.parseUnsafeString)((0, a.pluck)(e.errorplottooltext, V.errorplottooltext, I.errorplottooltext, o.positiveCumulativeErrorTooltipValue)))) && o.positiveCumulativeErrorTooltipValue && (D = q(d)), (d = (0, a.getValidValue)((0, a.parseUnsafeString)((0, a.pluck)(e.errorplottooltext, V.errorplottooltext, I.errorplottooltext, o.negativeCumulativeErrorTooltipValue)))) && o.negativeCumulativeErrorTooltipValue && (_ = q(d))), S = o.positiveErrorValue, A = o.negativeErrorValue, (e.positiveerrorvalue || e.negativeerrorvalue) && (o.halfErrorBar = 0, o.notHalfErrorBar = !0), w = x + (null !== S ? S : p), C = x - (o.halfErrorBar ? 0 : A < 0 && x < 0 ? 0 : null !== A ? A : p), z = Math.max(z, w, C), U = Math.min(U, w, C), o.errorValueArr = [], null === o.positiveErrorValue && (o.positiveErrorValue = void 0), k = -o.positiveErrorValue, o.errorValueArr.push({
              errorValue: k,
              tooltext: E ? D : T || r,
              errorEdgeBar: !0
            }), o.errorValueArr.push({
              errorValue: k,
              tooltext: T || r
            }), o.notHalfErrorBar && (k = o.negativeErrorValue, o.errorValueArr.push({
              errorValue: k,
              tooltext: E ? _ : L || r,
              errorEdgeBar: !0
            }), o.errorValueArr.push({
              errorValue: k,
              tooltext: L || r
            })), o.toolText = q(o.setTooltext)));
          }

          O.maxValue = z, O.minValue = U;
        }, t.prototype.drawErrorValue = function () {
          var e,
              t,
              o,
              r,
              n,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              d,
              f,
              m,
              v,
              b,
              y,
              x,
              k,
              w,
              C,
              N,
              S,
              A,
              E,
              D,
              _,
              T,
              L,
              P,
              O,
              V = this.getJSONIndex(),
              M = this.config,
              F = this.getState("visible"),
              I = this.getFromEnv("chart"),
              B = this.getFromEnv("yAxis"),
              R = this.components.data,
              j = M.errorBarThickness,
              G = M.errorBarWidthPercent,
              H = M.errorBarColor,
              W = M.shadowOpacity,
              z = this.getContainer("errorPlotGroup"),
              U = this.getContainer("errorShadowGroup"),
              J = M.scrollMinVal,
              K = M.scrollMaxVal,
              q = function q(e) {
            return function () {
              "disappearing" === e ? this.hide() : this.show();
            };
          },
              Y = this.getFromEnv("animationManager");

          for (t = J; t < K; t++) {
            if ((l = R[t]) && (L = l.trackerConfig, (O = l.errorTrackerConfig = {}).errorTrackerArr = [], s = (c = l && l.config) && c.setValue, void 0 !== l)) if (l && (void 0 === s || null === s || "" === c.errorValue || void 0 === c.errorValue || null === c.errorValue && null === c.positiveErrorValue && null === c.negativeErrorValue)) for (k = l.graphics.error && l.graphics.error.length, o = 0; o < k; o++) {
              l.graphics.error && l.graphics.error[o] && (Y.setAnimation({
                el: l.graphics.error[o],
                label: "path",
                callback: q("disappearing")
              }), l.graphics.error[o].shadow({
                opacity: 0
              }));
            } else {
              for (l.errorBar && delete l.errorBar, v = c.errorValueArr, O.errorLen = k = v.length, !l.graphics.error && (l.graphics.error = []), C = V + "_" + t, r = c.setLink, S = s < 0, A = l._xPos, E = l._yPos, D = l._width, _ = l._height, i = S ? E + _ : E, n = A + D / 2, l.errorBar || (l.errorBar = []); k--;) {
                N = null, O.errorTrackerArr[k] = {}, b = v[k], O.errorTrackerArr[k].tooltext = b.tooltext, T = b.errorStartValue, x = isNaN(T) ? i : B.getPixel(T), null === (y = b.errorValue) || isNaN(y) ? l.graphics.error && l.graphics.error[k] && Y.setAnimation({
                  el: l.graphics.error[k],
                  label: "path",
                  doNotRemove: !0,
                  callback: q("disappearing")
                }).shadow({
                  opacity: 0
                }) : (w = D * (G / 100) / 2, m = F ? -1 : 0, f = B.getPixel(B.getValue(isNaN(T) ? E : x) + y * m, {
                  wrtVisible: !0
                }), S && (f += _), p = f, h = n, P = (j = (0, a.pluckNumber)(b.errorBarThickness, j)) > 5 ? j / 2 : 2.5, p = Math.round(f) + j % 2 / 2, h = Math.round(n) + j % 2 / 2, l.errorBar[k] || (l.errorBar[k] = []), b.errorEdgeBar ? (d = ["M", h - w, p, "H", h + w], l.errorBar[k][1] = {
                  _xPos: h - w - P,
                  _yPos: p - P,
                  _height: 2 * P,
                  _width: 2 * (w + P),
                  _toolText: b.tooltext
                }) : (d = ["M", h, x, "V", p], l.errorBar[k][0] = {
                  _xPos: h - P,
                  _yPos: p < x ? p : x,
                  _height: Math.abs(x - p),
                  _width: 2 * P,
                  _toolText: b.tooltext
                }), e = {
                  path: d,
                  stroke: H = (0, a.pluck)(b.errorBarColor, H),
                  "stroke-width": j,
                  cursor: r ? "pointer" : "",
                  "stroke-linecap": g
                }, u = !l.graphics.error[k] && F ? "appearing" : F ? "updating" : "disappearing", N = l.graphics.error[k] = Y.setAnimation({
                  el: l.graphics.error[k] || "path",
                  container: z,
                  component: this,
                  attr: e,
                  label: "path",
                  state: u,
                  callback: q(u)
                }).shadow({
                  opacity: W
                }, U), I.config.enablemousetracking && N.data("groupId", C).data("eventArgs", L.eventArgs));
              }

              if (!c.notHalfErrorBar) for (o = 2; o < 4; o++) {
                l.graphics.error && l.graphics.error[o] && Y.setAnimation({
                  el: l.graphics.error[o],
                  label: "path",
                  doNotRemove: !0,
                  callback: q("disappearing")
                }).shadow({
                  opacity: 0
                });
              }
            }
          }
        }, t.prototype._firePlotEvent = function (e, t, o) {
          var a = this.getFromEnv("chart"),
              r = this.components.data[t],
              n = this.getFromEnv("toolTipController"),
              i = r.graphics.element,
              l = r.errorBarHovered,
              s = r.config.setLink;
          if (i) switch (e) {
            case "fc-mouseover":
              this._decideTooltipType(t, o), y(a, r, o, this), s && (i.node.style.cursor = "pointer");
              break;

            case "fc-mouseout":
              n.hide(this.config.currentToolTip), x(a, r, o, this), s && (i.node.style.cursor = "default");
              break;

            case "fc-click":
              a.plotEventHandler(i, o);
              break;

            case "fc-mousemove":
              this._decideTooltipType(t, o), l && !r._isRollover ? (0 !== i.showHoverEffect && i.attr(i.getData().setRolloutAttr), r._isRollover = !0, r._isRollout = !1) : l || r._isRollout || (0 !== i.showHoverEffect && i.attr(i.getData().setRolloverAttr), r._isRollover = !1, r._isRollout = !0);
          }
        }, t.prototype._checkPointerOverErrorBar = function (e, t, o) {
          var a,
              r,
              n,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              d = this.components.data,
              f = d[e];
          if (f && (r = f.errorBar)) for (i = r && r.length; i--;) {
            for (l = (n = r[i]) && n.length; l--;) {
              if (n[l] && n[l]._xPos && (c = n[l]._xPos, u = n[l]._yPos, p = n[l]._height, h = n[l]._width, s = n[l]._toolText, a = t >= c && t <= c + h && o >= u && o <= u + p)) return {
                pointIndex: e,
                hovered: a,
                pointObj: d[e],
                toolText: s
              };
            }
          }
        }, t.prototype._checkPointerOverPlot = function (e, t, o) {
          var a,
              r,
              n = this.components.data,
              i = this.getFromEnv("chart-attrib"),
              l = this.config.JSONData,
              s = n[e],
              c = s && s.config;
          if (s) return a = l.plottooltext || i.plottooltext ? "" : c.toolTipValue, (r = this._checkPointerOverErrorBar(e, t, o)) ? (s.errorBarHovered = !0, c.finalTooltext = r.toolText) : (r = this._checkPointerOverColumn(e, t, o), s.errorBarHovered = !1, r && (c.finalTooltext = !1 !== c.toolText && c.toolText + a)), r;
        }, t.prototype._getHoveredPlot = function (e, t) {
          var o, a;
          return o = this.getFromEnv("xAxis").getValue(e), (a = Math.round(o)) - o > 0 ? this._checkPointerOverPlot(a, e, t) || this._checkPointerOverPlot(a - 1, e, t) : this._checkPointerOverPlot(a + 1, e, t) || this._checkPointerOverPlot(a, e, t);
        }, t.prototype.removePlots = function () {
          var e,
              t,
              o,
              a,
              r = this.components,
              n = r.removeDataArr,
              i = r.pool || (r.pool = {
            element: [],
            hotElement: [],
            label: []
          }),
              l = n.length,
              s = this.getFromEnv("animationManager");

          for (o = 0; o < l; o++) {
            if (e = n[0], n.splice(0, 1), e && e.graphics) {
              for ((t = e.graphics).element && t.element.hide() && t.element.shadow({
                opacity: 0
              }), a = 0; a < 4; a++) {
                t.error && t.error[a] && s.setAnimation({
                  el: t.error[a],
                  label: "path"
                });
              }

              e.graphics.element && (i.element = i.element.concat(e.graphics.element)), e.graphics.hotElement && (i.hotElement = i.hotElement.concat(e.graphics.hotElement)), e.graphics.label && (i.label = i.label.concat(e.graphics.label));
            }
          }

          r.pool = i;
        }, t;
      }(r["default"]);

      t.removePlots = c = k.prototype.removePlots, t._getHoveredPlot = u = k.prototype._getHoveredPlot, t._firePlotEvent = p = k.prototype._firePlotEvent, t._checkPointerOverPlot = h = k.prototype._checkPointerOverPlot, t._checkPointerOverErrorBar = d = k.prototype._checkPointerOverErrorBar, t._getHoveredPlot = u, t.removePlots = c, t._rolloverResponseSetter = y, t._rolloutResponseSetter = x, t._firePlotEvent = p, t._checkPointerOverErrorBar = d, t._checkPointerOverPlot = h, t["default"] = k;
    },
    844: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(433),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = {
        column: {
          "initial.dataset.errorBar2D": n["default"]["initial.dataset.column"]
        },
        error: {
          "initial.dataset.errorBar2D": function initialDatasetErrorBar2D() {
            return {
              "path.appearing": [{
                initialAttr: {
                  opacity: 0
                },
                finalAttr: {
                  opacity: 1
                },
                slot: "final"
              }]
            };
          }
        }
      };
    },
    845: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(846),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    846: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = i(o(459)),
          r = o(551),
          n = i(o(847));

      function i(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function l(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var s = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.useErrorGroup = !0, o.isErrorChart = !0, o.hasAnchor = !0, o.defaultPlotShadow = 1, o.axisPaddingLeft = 0, o.axisPaddingRight = 0, o.canvasPaddingModifiers = ["anchor", "errorbar"], o;
        }

        return l(t, e), t.getName = function () {
          return "ErrorLine";
        }, t.prototype.getName = function () {
          return "ErrorLine";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.friendlyName = "Error Line Chart", t.defaultDatasetType = "errorline", r._setDefaultConfig.call(this), this.zeroplanethickness = 1, this.zeroplanealpha = 40, t.showzeroplaneontop = 0, t.defaultcrosslinethickness = 1, t.enablemousetracking = !0;
        }, t.prototype.getDSGroupdef = function () {}, t.prototype.getDSdef = function () {
          return n["default"];
        }, t;
      }(a["default"]);

      t["default"] = s;
    },
    847: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = o(125),
          r = o(843),
          n = c(o(449)),
          i = o(132),
          l = c(o(848)),
          s = c(o(849));

      function c(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function u(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var p = a.preDefStr.colors.AAAAAA,
          h = a.preDefStr.ROUND,
          d = a.preDefStr.PERCENTAGESTRING,
          f = "rgba(192,192,192," + (a.isIE ? .002 : 1e-6) + ")",
          g = Math,
          m = g.round,
          v = g.min,
          b = g.max,
          y = g.abs,
          x = a.hasTouch ? a.TOUCH_THRESHOLD_PIXELS : a.CLICK_THRESHOLD_PIXELS;
      (0, i.addDep)({
        name: "errorlineErrorAnimation",
        type: "animationRule",
        extension: l["default"]
      }), (0, i.addDep)({
        name: "errorlineLineAnimation",
        type: "animationRule",
        extension: s["default"]
      });

      var k = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return u(t, e), t.prototype.getType = function () {
          return "dataset";
        }, t.prototype.getName = function () {
          return "errorLine";
        }, t.prototype.ErrorValueConfigure = function () {
          var e,
              t,
              o,
              r,
              n,
              i,
              l,
              s,
              c,
              u,
              h,
              f,
              g,
              y,
              x,
              k,
              w,
              C,
              N,
              S,
              A,
              E,
              D,
              _,
              T,
              L = this.getFromEnv("chart"),
              P = this.config,
              O = L.config,
              V = P.parentYAxis,
              M = P.JSONData,
              F = M.data,
              I = L.getFromEnv("dataSource").chart,
              B = this.getFromEnv("xAxis").getTicksLen(),
              R = this.components.data,
              j = this.getFromEnv("number-formatter"),
              G = P.linethickness,
              H = -Infinity,
              W = Infinity,
              z = (0, a.parseUnsafeString)(I.yaxisname),
              U = (0, a.parseUnsafeString)(I.xaxisname),
              J = (0, a.pluck)(I.tooltipsepchar, ", "),
              K = (0, a.pluckNumber)(I.seriesnameintooltip, 1),
              q = function q(t) {
            var r;
            return O.showtooltip ? null === s ? r = !1 : void 0 !== t ? (S = [1, 2, 3, 4, 5, 6, 7, 99, 100, 101, 102], A = {
              yaxisName: z,
              xaxisName: U,
              formattedValue: o.toolTipValue,
              errorValue: l,
              errorDataValue: o.errorToolTipValue,
              errorPercentValue: o.errorPercentValue,
              errorPercentDataValue: o.errorPercentValue,
              label: o.label
            }, r = (0, a.parseTooltext)(t, S, A, e, I, M)) : (K && (E = (0, a.getFirstValue)(M && M.seriesname)), r = E ? E + J : "", r += o.label ? o.label + J : "") : r = !1, r;
          };

          for (P.errorBarShadow = y = (0, a.pluckNumber)(I.errorbarshadow, I.showshadow, 1), P.ignoreEmptyDatasets = (0, a.pluckNumber)(M.ignoreemptydatasets, 0), P.notHalfErrorBar = !(0, a.pluckNumber)(I.halferrorbar, 1), n = (0, a.getFirstAlpha)((0, a.pluck)(M.errorbaralpha, I.errorbaralpha, P.alpha)), P.errorBarWidth = (0, a.pluckNumber)(M.errorbarwidth, I.errorbarwidth, 5), P.errorBarColor = (0, a.convertColor)((0, a.getFirstColor)((0, a.pluck)(M.errorbarcolor, I.errorbarcolor, p)), n), i = (0, a.pluckNumber)(M.errorbarthickness, I.errorbarthickness, 1), P.errorBarThickness = i > G ? G : i, P.shadowOpacity = y ? n / 250 : 0, P.errorInPercent = D = (0, a.pluckNumber)(M.errorinpercent, I.errorinpercent), P.cumulativeValueOnErrorBar = (0, a.pluckNumber)(M.cumulativevalueonerrorbar, I.cumulativevalueonerrorbar, 1), T = 0; T < B; T++) {
            e = F && F[T], F && e && (t = R[T], o = t && t.config, t || (t = R[T] = {
              graphics: {}
            }), t.config || (o = R[T].config = {}), w = o.setValue, o.notHalfErrorBar = P.notHalfErrorBar, l = j.getCleanValue(e.errorvalue), o.errorToolTipValue = j.dataLabels(l, V), o.setErrorValue = o.errorValue = C = l, o.hasErrorValue = void 0 !== (0, a.pluckNumber)(e.errorvalue) ? 1 : 0, r = o.errorToolTipValue, s = r, _ = q(c = (0, a.getValidValue)((0, a.parseUnsafeString)((0, a.pluck)(e.errorplottooltext, M.errorplottooltext, I.errorplottooltext, s)))), o.errorInPercent = (0, a.pluckNumber)(e.errorinpercent, D, 0), o.errorInPercent && (o.setErrorValue = l = (0, a.pluckNumber)((l / 100 * w).toFixed(2))), o.cumulativeValueOnErrorBar = N = (0, a.pluckNumber)(e.cumulativevalueonerrorbar, P.cumulativeValueOnErrorBar, 1), o.positiveErrorValue = j.getCleanValue((0, a.pluckNumber)(e.positiveerrorvalue, e.errorvalue)), o.errorInPercent && o.positiveErrorValue && (o.positiveErrorValue = (0, a.pluckNumber)((o.positiveErrorValue / 100 * w).toFixed(2))), o.positiveCumulativeErrorValue = w + (0, a.pluckNumber)(o.positiveErrorValue, o.setErrorValue), o.negativeErrorValue = j.getCleanValue((0, a.pluckNumber)(e.negativeerrorvalue, e.errorvalue)), o.errorInPercent && o.negativeErrorValue && (o.negativeErrorValue = (0, a.pluckNumber)((o.negativeErrorValue / 100 * w).toFixed(2))), o.negativeCumulativeErrorValue = w - (0, a.pluckNumber)(o.negativeErrorValue, o.setErrorValue), o.errorToolTipValue = j.dataLabels(l, V), o.negativeErrorToolTipValue = j.dataLabels(o.negativeErrorValue, V), o.negativeCumulativeErrorTooltipValue = j.dataLabels(o.negativeCumulativeErrorValue, V), o.positiveErrorToolTipValue = j.dataLabels(o.positiveErrorValue, V), o.positiveCumulativeErrorTooltipValue = j.dataLabels(o.positiveCumulativeErrorValue, V), o.errorPercentValue = m(l / w * a.HUNDREDSTRING * a.HUNDREDSTRING) / a.HUNDREDSTRING + d, f = g = void 0, (c = (0, a.getValidValue)((0, a.parseUnsafeString)((0, a.pluck)(e.errorplottooltext, M.errorplottooltext, I.errorplottooltext, o.positiveErrorToolTipValue)))) && o.positiveErrorToolTipValue && (f = q(c)), (c = (0, a.getValidValue)((0, a.parseUnsafeString)((0, a.pluck)(e.errorplottooltext, M.errorplottooltext, I.errorplottooltext, o.negativeErrorToolTipValue)))) && o.negativeErrorToolTipValue && (g = q(c)), (e.positiveerrorvalue || e.negativeerrorvalue) && (o.halfErrorBar = 0, o.notHalfErrorBar = !0), N && ((c = (0, a.getValidValue)((0, a.parseUnsafeString)((0, a.pluck)(e.errorplottooltext, M.errorplottooltext, I.errorplottooltext, o.positiveCumulativeErrorTooltipValue)))) && o.positiveCumulativeErrorTooltipValue && (u = q(c)), (c = (0, a.getValidValue)((0, a.parseUnsafeString)((0, a.pluck)(e.errorplottooltext, M.errorplottooltext, I.errorplottooltext, o.negativeCumulativeErrorTooltipValue)))) && o.negativeCumulativeErrorTooltipValue && (h = q(c))), x = w + (null !== o.positiveErrorValue ? o.positiveErrorValue : l), k = w - (o.halfErrorBar ? 0 : o.negativeErrorValue < 0 && w < 0 ? 0 : null !== o.negativeErrorValue ? o.negativeErrorValue : l), H = b(H, x, k), W = v(W, x, k), null === l && (l = void 0), o.errorValueArr = [], null === o.positiveErrorValue && (o.positiveErrorValue = void 0), C = -o.positiveErrorValue, o.errorValueArr.push({
              errorValue: C,
              tooltext: N ? u : f || _,
              errorEdgeBar: !0
            }), o.errorValueArr.push({
              errorValue: C,
              tooltext: f || _
            }), o.notHalfErrorBar && (C = o.negativeErrorValue, o.errorValueArr.push({
              errorValue: C,
              tooltext: N ? h : g || _,
              errorEdgeBar: !0
            }), o.errorValueArr.push({
              errorValue: C,
              tooltext: g || _
            })), o.toolText = q(o.setTooltext));
          }

          P.maxValue = H, P.minValue = W;
        }, t.prototype._show = function () {
          var e = this.chart,
              t = this.yAxis,
              o = this.graphics && this.graphics.container,
              a = this.graphics && this.graphics.dataLabelContainer,
              r = this.graphics && this.graphics.errorGroupContainer,
              n = this.graphics && this.graphics.errorShadowContainer;
          e._chartAnimation(), o.lineGroup.show(), o.anchorGroup.show(), o.anchorShadowGroup.show(), o.lineShadowGroup.show(), a.show(), this.setState("visible", !0), r && r.show(), n && n.show(), this._conatinerHidden = !1, e._setAxisLimits(), t.draw(), e._drawDataset();
        }, t.prototype._hide = function () {
          var e = this.chart,
              t = this.yAxis;
          e._chartAnimation(), this.setState("visible", !1), e._setAxisLimits(), t.draw(), e._drawDataset();
        }, t.prototype.draw = function () {
          e.prototype.draw.call(this), this.drawErrorValue();
        }, t.prototype.drawErrorValue = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              i,
              l,
              s,
              c,
              u,
              p,
              d,
              g,
              v,
              b,
              k,
              w,
              C,
              N,
              S,
              A,
              E,
              D,
              _,
              T,
              L = this.config,
              P = this.getFromEnv("xAxis").getTicksLen(),
              O = this.getState("visible"),
              V = this.getFromEnv("yAxis"),
              M = this.components.data,
              F = L.errorBarThickness,
              I = L.errorBarWidth,
              B = L.errorBarColor,
              R = L.shadowOpacity,
              j = this.getContainer("errorPlotGroup"),
              G = this.getContainer("errorShadowGroup"),
              H = F > 5 ? F / 2 : 2.5,
              W = this.getFromEnv("animationManager"),
              z = function z(e) {
            return function () {
              "disappearing" === e && this.hide();
            };
          };

          for (t = 0; t < P; t++) {
            if (c = (u = (s = M[t]) && s.config) && u.setValue, void 0 !== s && void 0 !== c && null !== c) {
              if ((T = s.errorTrackerConfig = {}).errorTrackerArr = [], k = u.errorValueArr, T.errorLen = S = k.length, !s.graphics.error && (s.graphics.error = []), !s.graphics.errorTracker && (s.graphics.errorTracker = []), "" === u.errorValue || void 0 === u.errorValue || null === u.errorValue && null === u.positiveErrorValue && null === u.negativeErrorValue) for (a = 0; a < S; a++) {
                s.graphics.error && s.graphics.error[a] && W.setAnimation({
                  el: s.graphics.error[a] || "path",
                  label: "path",
                  component: this,
                  callback: z("disappearing")
                }).shadow({
                  opacity: 0
                });
              } else {
                for (n = u.setLink, D = s._xPos, l = _ = s._yPos, i = D, s.errorBar && delete s.errorBar, s.errorBar = []; S--;) {
                  E = null, T.errorTrackerArr[S] = {}, w = k[S], T.errorTrackerArr[S].tooltext = w.tooltext, N = l, null === (C = w.errorValue) || isNaN(C) ? s.graphics.error && s.graphics.error[S] && (s.graphics.error[S].hide(), s.graphics.error[S].shadow({
                    opacity: 0
                  })) : (A = I / 2, b = O ? 1 : 0, p = v = _ + (V.getPixel(0) - V.getPixel(1)) * C * b, d = i, p = m(v) + F % 2 / 2, d = m(i) + F % 2 / 2, s.errorBar[S] || (s.errorBar[S] = []), w.errorEdgeBar ? (g = ["M", d - A, p, "H", d + A], s.errorBar[S][1] = {
                    _xPos: d - A - H,
                    _yPos: p - H,
                    _height: 2 * H,
                    _width: 2 * (A + H),
                    _toolText: w.tooltext
                  }) : (g = ["M", d, N, "V", p], s.errorBar[S][0] = {
                    _xPos: d - H,
                    _yPos: p < N ? p : N,
                    _height: y(N - p),
                    _width: 2 * H,
                    _toolText: w.tooltext
                  }), e = {
                    path: g,
                    stroke: B,
                    "stroke-width": F,
                    cursor: n ? "pointer" : "",
                    "stroke-linecap": h
                  }, r = !s.graphics.error[S] && O ? "appearing" : O ? "updating" : "disappearing", E = s.graphics.error[S] = W.setAnimation({
                    el: s.graphics.error[S] || "path",
                    state: r,
                    attr: e,
                    label: "path",
                    component: this,
                    container: j,
                    callback: z(r)
                  }), "disappearing" !== r && E.show(), E && E.shadow({
                    opacity: R
                  }, G), T.errorTrackerArr[S].attr = {
                    path: g,
                    stroke: f,
                    "stroke-width": F < x ? x : F,
                    cursor: n ? "pointer" : ""
                  });
                }

                if (!u.notHalfErrorBar) for (a = 2; a < 4; a++) {
                  s.graphics.error && s.graphics.error[a] && W.setAnimation({
                    el: s.graphics.error[a] || "path",
                    label: "path",
                    component: this,
                    doNotRemove: !0,
                    callback: z("disappearing")
                  }).shadow({
                    opacity: 0
                  });
                }
              }
            } else if (s && s.graphics.error) for (o = 0; o < s.graphics.error.length; o++) {
              s.graphics.error && s.graphics.error[o] && W.setAnimation({
                el: s.graphics.error[o] || "path",
                label: "path",
                component: this,
                doNotRemove: !0,
                callback: z("disappearing")
              }).shadow({
                opacity: 0
              });
            }
          }
        }, t.prototype._firePlotEvent = function (e, t, o) {
          r._firePlotEvent.call(this, e, t, o);
        }, t.prototype._checkPointerOverErrorBar = function (e, t, o) {
          return r._checkPointerOverErrorBar.call(this, e, t, o);
        }, t.prototype._checkPointerOverPlot = function (e, t, o) {
          var a,
              r = this.components.data[e],
              n = r && r.config;
          if (r) return (a = this.isWithinShape(r, e, t, o)) ? (r.errorBarHovered = !1, n.finalTooltext = !1 !== n.toolText && n.toolText) : (a = this._checkPointerOverErrorBar(e, t, o)) && (r.errorBarHovered = !0, n.finalTooltext = a.toolText), a;
        }, t.prototype._getHoveredPlot = function (e, t) {
          return r._getHoveredPlot.call(this, e, t);
        }, t.prototype.getCanvasPadding = function () {
          var e,
              t,
              o,
              r,
              n,
              i,
              l = .5 * this.config.errorBarWidth,
              s = this.components || {},
              c = this.getFromEnv("chart"),
              u = c.config.dataLabelStyle,
              p = s.data || [],
              h = p[0],
              d = p[p.length - 1],
              f = {},
              g = c.getFromEnv("smartLabel"),
              m = {
            paddingLeft: 0,
            paddingRight: 0
          };
          return h && (i = (e = h.config).showValue, o = e && e.anchorProps || {}, i && (t = e.displayValue, g.useEllipsesOnOverflow(c.config.useEllipsesWhenOverflow), g.setStyle(u), f = g.getOriSize(t)), e.setValue && (r = b((0, a.pluckNumber)(o.radius, 0), l) + (0, a.pluckNumber)(o.borderThickness, 0), n = (f.width || 0) / 2), m.paddingLeft = b(r, n)), d && (i = (e = d.config).showValue, o = e && e.anchorProps || {}, i && (t = e.displayValue, g.setStyle(u), f = g.getOriSize(t)), e.setValue && (r = b((0, a.pluckNumber)(o.radius, 0), l) + (0, a.pluckNumber)(o.borderThickness, 0), n = (f.width || 0) / 2), m.paddingRight = b(r, n)), m;
        }, t.prototype.removePlots = function () {
          r.removePlots.call(this);
        }, t;
      }(n["default"]);

      t["default"] = k;
    },
    848: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = {
        "initial.dataset.errorLine": function initialDatasetErrorLine() {
          return {
            "path.appearing": function pathAppearing() {
              return [{
                initialAttr: {
                  opacity: 0
                },
                finalAttr: {
                  opacity: 1
                },
                startEnd: {
                  start: .5,
                  end: 1
                },
                slot: "plot"
              }];
            },
            "*": null
          };
        }
      };
    },
    849: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(452),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = {
        "*.dataset.errorLine": n["default"]["*.dataset.line"]
      };
    },
    850: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(851),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    851: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = n(o(534)),
          r = n(o(852));

      function n(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function i(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var l = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.isXY = !0, o.defaultZeroPlaneHighlighted = !1, o.useErrorGroup = !0, o.isErrorChart = !0, o.hasAnchor = !0, o.initAnimation = !0, o;
        }

        return i(t, e), t.getName = function () {
          return "ErrorScatter";
        }, t.prototype.getName = function () {
          return "ErrorScatter";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.friendlyName = "Error Scatter Chart", t.defaultDatasetType = "errorscatter", t.enablemousetracking = !0;
        }, t.prototype.getDSGroupdef = function () {}, t.prototype.getDSdef = function () {
          return r["default"];
        }, t;
      }(a["default"]);

      t["default"] = l;
    },
    852: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = c(o(538)),
          r = o(125),
          n = c(o(539)),
          i = o(132),
          l = c(o(853)),
          s = c(o(854));

      function c(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function u(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var p = r.preDefStr.colors.AAAAAA,
          h = r.preDefStr.ROUND,
          d = r.preDefStr.PERCENTAGESTRING,
          f = "M";
      (0, i.addDep)({
        name: "errorscatterAnimation",
        type: "animationRule",
        extension: l["default"]
      }), (0, i.addDep)({
        name: "errorscatterErrorAnimation",
        type: "animationRule",
        extension: s["default"]
      });

      var g = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return u(t, e), t.prototype.getType = function () {
          return "dataset";
        }, t.prototype.getName = function () {
          return "errorScatter";
        }, t.prototype.ErrorValueConfigure = function () {
          var e,
              t,
              o,
              a,
              n,
              i,
              l,
              s,
              c,
              u,
              h,
              f,
              g,
              m,
              v,
              b,
              y,
              x,
              k,
              w,
              C,
              N,
              S,
              A,
              E,
              D,
              _,
              T,
              L,
              P,
              O,
              V,
              M,
              F,
              I,
              B,
              R,
              j,
              G,
              H,
              W,
              z,
              U,
              J,
              K,
              q,
              Y,
              X,
              Q,
              Z,
              $,
              ee,
              te,
              oe = this.getFromEnv("chart"),
              ae = this.config,
              re = ae.JSONData,
              ne = this.getFromEnv("dataSource").categories && this.getFromEnv("dataSource").categories[0].category,
              ie = this.getFromEnv("chart-attrib"),
              le = re.data,
              se = le && le.length || 0,
              ce = this.components.data,
              ue = this.getFromEnv("number-formatter"),
              pe = (0, r.pluck)(ie.tooltipsepchar, ", "),
              he = (0, r.parseUnsafeString)(ie.yaxisname),
              de = (0, r.parseUnsafeString)(ie.xaxisname),
              fe = ae.parentYAxis,
              ge = -Infinity,
              me = +Infinity,
              ve = ge,
              be = me,
              ye = me,
              xe = ge,
              ke = function ke(t, a) {
            var n;
            return ae.showTooltip ? null === C ? n = !1 : void 0 !== t ? (E = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 99, 100, 101, 102, 103, 104, 105, 106, 107, 109], D = {
              yaxisName: he,
              xaxisName: de,
              yDataValue: C,
              xDataValue: o.label,
              formattedValue: o.toolTipValue,
              horizontalErrorValue: b,
              horizontalErrorDataValue: x,
              verticalErrorValue: y,
              verticalErrorDataValue: k,
              horizontalErrorPercentValue: S,
              verticalErrorPercentValue: A,
              label: o.label,
              errorValue: a,
              errorDataValue: a,
              errorPercentValue: o.errorPercentValue,
              errorPercentDataValue: o.errorPercentValue
            }, n = (0, r.parseTooltext)(t, E, D, e, ie, re)) : null === C ? n = !1 : (ae.seriesNameInTooltip && (_ = (0, r.getFirstValue)(re && re.seriesname)), n = _ ? _ + pe : "", n += w.x ? ue.xAxis(w.x) + pe : "", n += o.toolTipValue) : n = !1, n;
          };

          for (ae.errorBarShadow = n = (0, r.pluckNumber)(ie.errorbarshadow, ie.showshadow, 0), ae.ignoreEmptyDatasets = (0, r.pluckNumber)(re.ignoreemptydatasets, 0), ae.notHalfErrorBar = !(0, r.pluckNumber)(ie.halferrorbar, 1), ae.errorBarAlpha = (0, r.getFirstAlpha)((0, r.pluck)(re.errorbaralpha, ie.errorbaralpha)), ae.errorBarWidth = i = (0, r.pluckNumber)(re.errorbarwidth, ie.errorbarwidth, 5), ae.errorBarColor = l = (0, r.convertColor)((0, r.getFirstColor)((0, r.pluck)(re.errorbarcolor, ie.errorbarcolor, p)), void 0), ae.errorBarThickness = a = (0, r.pluckNumber)(re.errorbarthickness, ie.errorbarthickness, 1), ae.shadowOpacity = n ? NaN : 0, ae.halfHorizontalErrorBar = s = (0, r.pluckNumber)(ie.halfhorizontalerrorbar, 1), ae.halfVerticalErrorBar = c = (0, r.pluckNumber)(ie.halfverticalerrorbar, 1), void 0 === ae.initAnimation && (ae.initAnimation = oe.initAnimation), u = (0, r.pluck)(re.horizontalerrorbaralpha, re.errorbaralpha, ie.horizontalerrorbaralpha, void 0), h = (0, r.pluckNumber)(re.verticalerrorbaralpha, re.errorbaralpha, ie.verticalerrorbaralpha, void 0), f = (0, r.convertColor)((0, r.pluck)(re.horizontalerrorbarcolor, re.errorbarcolor, ie.horizontalerrorbarcolor, l), u), g = (0, r.convertColor)((0, r.pluck)(re.verticalerrorbarcolor, re.errorbarcolor, ie.verticalerrorbarcolor, l), h), m = (0, r.pluckNumber)(re.horizontalerrorbarthickness, re.errorbarthickness, ie.horizontalerrorbarthickness, a), v = (0, r.pluckNumber)(re.verticalerrorbarthickness, re.errorbarthickness, ie.verticalerrorbarthickness, a), ae.horizontalErrorBarWidth = (0, r.pluckNumber)(re.horizontalerrorbarwidth, ie.horizontalerrorbarwidth, i), ae.verticalErrorBarWidth = (0, r.pluckNumber)(re.verticalerrorbarwidth, ie.verticalerrorbarwidth, i), ae.cumulativeValueOnErrorBar = (0, r.pluckNumber)(re.cumulativevalueonerrorbar, ie.cumulativevalueonerrorbar, 1), te = 0; te < se; te++) {
            le && (e = le && le[te], t = ce[te], o = t && t.config, t || (t = ce[te] = {
              graphics: {}
            }), t.config || (o = ce[te].config = {}), w = o.setValue, o.errorValue = e.errorvalue, o.cumulativeValueOnErrorBar = Z = (0, r.pluckNumber)(e.cumulativevalueonerrorbar, ae.cumulativeValueOnErrorBar, 1), o.hErrorValue = b = ue.getCleanValue((0, r.pluck)(e.horizontalerrorvalue, e.errorvalue)), x = ue.xAxis(b), o.vErrorValue = y = ue.getCleanValue((0, r.pluck)(e.verticalerrorvalue, e.errorvalue)), k = ue.dataLabels(y), o.hPositiveErrorValue = F = ue.getCleanValue((0, r.pluck)(e.horizontalpositiveerrorvalue, e.positiveerrorvalue, b)), o.hNegativeErrorValue = M = ue.getCleanValue((0, r.pluck)(e.horizontalnegativeerrorvalue, e.negativeerrorvalue, b)), o.vPositiveErrorValue = V = ue.getCleanValue((0, r.pluck)(e.verticalpositiveerrorvalue, e.positiveerrorvalue, y)), o.vNegativeErrorValue = J = ue.getCleanValue((0, r.pluck)(e.verticalnegativeerrorvalue, e.negativeerrorvalue, y)), S = Math.round(b / w.x * r.HUNDREDSTRING * r.HUNDREDSTRING) / r.HUNDREDSTRING + d, A = Math.round(y / w.y * r.HUNDREDSTRING * r.HUNDREDSTRING) / r.HUNDREDSTRING + d, B = ue.dataLabels(F, fe), I = (0, r.getValidValue)((0, r.parseUnsafeString)((0, r.pluck)(e.errorplottooltext, re.errorplottooltext, ie.errorplottooltext, B))), G = ue.dataLabels(M, fe), z = (0, r.getValidValue)((0, r.parseUnsafeString)((0, r.pluck)(e.errorplottooltext, re.errorplottooltext, ie.errorplottooltext, G))), W = ue.dataLabels(V, fe), Y = (0, r.getValidValue)((0, r.parseUnsafeString)((0, r.pluck)(e.errorplottooltext, re.errorplottooltext, ie.errorplottooltext, W))), ee = ue.dataLabels(J, fe), $ = (0, r.getValidValue)((0, r.parseUnsafeString)((0, r.pluck)(e.errorplottooltext, re.errorplottooltext, ie.errorplottooltext, ee))), R = X = Q = K = void 0, Z && (j = ue.dataLabels(w.x + F, fe), R = (0, r.getValidValue)((0, r.parseUnsafeString)((0, r.pluck)(e.errorplottooltext, re.errorplottooltext, ie.errorplottooltext, j))), H = ue.dataLabels(w.x - M, fe), X = (0, r.getValidValue)((0, r.parseUnsafeString)((0, r.pluck)(e.errorplottooltext, re.errorplottooltext, ie.errorplottooltext, H))), U = ue.dataLabels(w.y + V, fe), Q = (0, r.getValidValue)((0, r.parseUnsafeString)((0, r.pluck)(e.errorplottooltext, re.errorplottooltext, ie.errorplottooltext, U))), q = ue.dataLabels(w.y - J, fe), K = (0, r.getValidValue)((0, r.parseUnsafeString)((0, r.pluck)(e.errorplottooltext, re.errorplottooltext, ie.errorplottooltext, q)))), ne && ne[te] && (o.label = (0, r.getValidValue)((0, r.parseUnsafeString)((0, r.pluck)(ne[te].tooltext, ne[te].label)))), e.horizontalpositiveerrorvalue || e.positiveerrorvalue || e.horizontalnegativeerrorvalue || e.negativeerrorvalue ? o.halfHorizontalErrorBar = s = 0 : o.halfHorizontalErrorBar = s = ae.halfHorizontalErrorBar, e.verticalpositiveerrorvalue || e.positiveerrorvalue || e.verticalnegativeerrorvalue || e.negativeerrorvalue ? o.halfVerticalErrorBar = c = 0 : o.halfVerticalErrorBar = c = ae.halfVerticalErrorBar, null !== w.x && (T = w.x + Number(F), L = w.x - (s ? 0 : Number(M)), xe = Math.max(xe, T, L), ye = Math.min(ye, T, L)), null !== w.y && (T = w.y + Number(V), L = w.y - (c ? 0 : Number(J)), ve = Math.max(ve, T, L), be = Math.min(be, T, L)), o.useHorizontalErrorBar = (0, r.pluckNumber)(e.usehorizontalerrorbar, re.usehorizontalerrorbar, ie.usehorizontalerrorbar, 0), o.useVerticalErrorBar = (0, r.pluckNumber)(e.useverticalerrorbar, re.useverticalerrorbar, ie.useverticalerrorbar, 1), o.errorValueConf = {}, (P = o.errorValueConf.horizontal = {}).mandatory = {}, P.mandatory.marker = {
              errorValue: -(null === F ? void 0 : F),
              tooltext: ke(I, B),
              errorBarColor: f,
              isHorizontal: !0,
              errorBarThickness: m,
              shadowOpacity: n ? u / 250 : 0
            }, P.mandatory.limit = {
              errorValue: -(null === F ? void 0 : F),
              tooltext: Z ? ke(R, j) : ke(I, B),
              errorBarColor: f,
              isHorizontal: !0,
              errorBarThickness: m,
              shadowOpacity: n ? u / 250 : 0,
              errorEdgeBar: !0
            }, P.optional = {}, P.optional.marker = {
              errorValue: M,
              tooltext: ke(z, G),
              errorBarColor: f,
              isHorizontal: !0,
              errorBarThickness: m,
              shadowOpacity: n ? u / 250 : 0
            }, P.optional.limit = {
              errorValue: M,
              tooltext: Z ? ke(X, H) : ke(z, G),
              errorBarColor: f,
              isHorizontal: !0,
              errorBarThickness: m,
              shadowOpacity: n ? u / 250 : 0,
              errorEdgeBar: !0
            }, (O = o.errorValueConf.vertical = {}).mandatory = {}, O.mandatory.marker = {
              errorValue: -(null === V ? void 0 : V),
              tooltext: ke(Y, W),
              errorBarColor: g,
              errorBarThickness: v,
              shadowOpacity: n ? h / 250 : 0
            }, O.mandatory.limit = {
              errorValue: -(null === V ? void 0 : V),
              tooltext: Z ? ke(Q, U) : ke(Y, W),
              errorBarColor: g,
              errorBarThickness: v,
              shadowOpacity: n ? h / 250 : 0,
              errorEdgeBar: !0
            }, O.optional = {}, O.optional.marker = {
              errorValue: J,
              tooltext: ke($, ee),
              errorBarColor: g,
              errorBarThickness: v,
              shadowOpacity: n ? h / 250 : 0
            }, O.optional.limit = {
              errorValue: J,
              tooltext: Z ? ke(K, q) : ke($, ee),
              errorBarColor: g,
              errorBarThickness: v,
              shadowOpacity: n ? h / 250 : 0,
              errorEdgeBar: !0
            }, w = o.setValue, C = o.formatedVal, ae.showTooltip ? void 0 !== o.setTooltext ? (E = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 99, 100, 101, 102, 103, 104, 105, 106, 107, 109], D = {
              yaxisName: he,
              xaxisName: de,
              yDataValue: C,
              xDataValue: o.label,
              formattedValue: o.toolTipValue,
              horizontalErrorValue: b,
              horizontalErrorDataValue: x,
              verticalErrorValue: y,
              verticalErrorDataValue: k,
              horizontalErrorPercentValue: S,
              verticalErrorPercentValue: A,
              label: o.label,
              errorValue: o.errorValue,
              errorDataValue: ue.dataLabels(o.errorValue, ae.parentYAxis)
            }, N = (0, r.parseTooltext)(o.setTooltext, E, D, e, ie, re)) : null === C ? N = !1 : (ae.seriesNameInTooltip && (_ = (0, r.getFirstValue)(re && re.seriesname)), N = _ ? _ + pe : "", N += w.x ? ue.xAxis(w.x) + pe : "", N += o.toolTipValue) : N = !1, o.toolText = N);
          }

          ae.xMax = xe, ae.xMin = ye, ae.yMin = be, ae.yMax = ve;
        }, t.prototype.drawErrorValue = function () {
          var e,
              t,
              o,
              a,
              r,
              i,
              l,
              s,
              c,
              u,
              p,
              d,
              g,
              m,
              v,
              b,
              y,
              x,
              k,
              w,
              C,
              N,
              S,
              A,
              E,
              D,
              _,
              T,
              L,
              P,
              O,
              V,
              M,
              F,
              I,
              B,
              R,
              j,
              G,
              H,
              W,
              z,
              U,
              J = this.config.JSONData,
              K = this.config,
              q = J.data,
              Y = q && q.length,
              X = this.getState("visible"),
              Q = this.getFromEnv("xAxis"),
              Z = this.getFromEnv("yAxis"),
              $ = this.components.data,
              ee = K.shadowOpacity,
              te = this.getContainer("errorPlotGroup"),
              oe = this.getContainer("errorShadowGroup"),
              ae = this.getFromEnv("animationManager"),
              re = [],
              ne = function ne(e) {
            return function () {
              "disappearing" === e && this.hide();
            };
          };

          for (t = 0; t < Y; t++) {
            if ((U = (d = $[t]).errorTrackerConfig = {}).errorTrackerArr = [], g = (v = d && d.config) && v.setValue, G = v.errorValueConf, void 0 !== d && void 0 !== g && null !== g && G) {
              if (z = Object.keys(a = d.graphics), null === v.vErrorValue && null === v.vPositiveErrorValue && null === v.vNegativeErrorValue) for (j = 0; j < z.length; j++) {
                z[j].match(/error-horizontal-/) && (ae.setAnimation({
                  el: a[z[j]],
                  state: "disappearing",
                  callback: ne("disappearing")
                }), a[z[j]].shadow({
                  opacity: 0
                }));
              }
              if (null === v.hErrorValue && null === v.hPositiveErrorValue && null === v.vPositiveErrorValue) for (j = 0; j < z.length; j++) {
                z[j].match(/error-vertical-/) && (ae.setAnimation({
                  el: a[z[j]],
                  state: "disappearing",
                  callback: ne("disappearing")
                }), a[z[j]].shadow({
                  opacity: 0
                }));
              }
              if (!(null === v.hErrorValue && null === v.vErrorValue && v.hPositiveErrorValue && v.hNegativeErrorValue && v.vPositiveErrorValue && v.vNegativeErrorValue)) for (H in c = v.setLink, F = d._xPos, p = d._yPos, u = F, G) {
                if (G.hasOwnProperty(H)) for (E in D = G[H]) {
                  if (D.hasOwnProperty(E)) for (L in _ = D[E]) {
                    if (_.hasOwnProperty(L)) {
                      if (m = void 0, T = _[L], e = {}, M = null, (U.errorTrackerArr[0] = {}).tooltext = T.tooltext, O = p, P = T.errorValue, b = !v.useHorizontalErrorBar && "horizontal" === H, y = !v.useVerticalErrorBar && "vertical" === H, x = v.halfHorizontalErrorBar && "horizontal" === H && "optional" === E, k = v.halfVerticalErrorBar && "vertical" === H && "optional" === E, b || y || x || k) m = "disappearing";else if (null === P || void 0 === P || isNaN(P)) m = "disappearing";else {
                        if (s = T.errorBarColor, r = T.isHorizontal, i = T.errorBarThickness, l = r ? K.horizontalErrorBarWidth : K.verticalErrorBarWidth, V = X ? l / 2 : 0, A = X ? -1 : 0, W = i > 5 ? i / 2 + .5 : 2.75, r) {
                          if (w = S = Q.getPixel(d.config._x + P * A), C = u, w = Math.round(O) + i % 2 / 2, C = Math.round(S) + i % 2 / 2, T.errorEdgeBar) for (N = [f, C, w - V, "V", w + V], I = 2 * V, B = w - V, R = W; R < I; R += 2 * W) {
                            re.push({
                              x: C,
                              y: B + R,
                              r: W,
                              index: t,
                              data: d,
                              toolText: T.tooltext,
                              barType: "h"
                            });
                          } else for (N = [f, u, w, "H", C], I = Math.abs(u - C), B = u > C ? C : u, R = W; R < I; R += 2 * W) {
                            re.push({
                              x: B + R,
                              y: w,
                              r: W,
                              index: t,
                              data: d,
                              toolText: T.tooltext,
                              barType: "h"
                            });
                          }
                        } else if (w = S = Z.getPixel(d.config._y + P * A), C = u, w = Math.round(S) + i % 2 / 2, C = Math.round(u) + i % 2 / 2, T.errorEdgeBar) for (N = [f, C - V, w, "H", C + V], I = 2 * V, B = C - V, R = W; R <= I; R += 2 * W) {
                          re.push({
                            x: B + R,
                            y: w,
                            r: W,
                            index: t,
                            data: d,
                            toolText: T.tooltext,
                            barType: "v"
                          });
                        } else for (N = [f, C, O, "V", w], I = Math.abs(O - w), B = O > w ? w : O, R = W; R <= I; R += 2 * W) {
                          re.push({
                            x: C,
                            y: B + R,
                            r: W,
                            index: t,
                            data: d,
                            toolText: T.tooltext,
                            barType: "v"
                          });
                        }
                        e = {
                          path: N,
                          "stroke-width": X ? i : 0,
                          stroke: s,
                          cursor: c ? "pointer" : "",
                          "stroke-linecap": h
                        };
                      }
                      o = ["error", H, E, L].join("-"), m || (m = a[o] ? "updating" : "appearing"), (a[o] || "disappearing" !== m) && (M = a[o] = ae.setAnimation({
                        el: a[o] || "path",
                        container: te,
                        component: this,
                        attr: e,
                        state: m,
                        label: "path",
                        callback: ne(m)
                      }), "disappearing" !== m && M.show(), M.shadow({
                        opacity: "disappearing" === m ? 0 : ee
                      }, oe));
                    }
                  }
                }
              }
            }
          }

          re.length && (this.config.dataTreeB = new n["default"]().buildKdTree(re)), K.initAnimation = !1;
        }, t.prototype._getHoveredPlot = function (e, t) {
          var o, a, r, n, i, l;
          return (o = this.config.dataTree.getNeighbour({
            x: e,
            y: t
          }, !0)) ? (r = o.data.config.toolText, o.data.config.finalTooltext = r, i = o.data.config.hoverEffects, (l = o.data.graphics.element).data("hoverEnabled", i.enabled), i.enabled && l.attr(l.getData().setRolloverAttr), {
            pointIndex: o.index,
            hovered: !0,
            pointObj: o.data
          }) : (a = this.config.dataTreeB && this.config.dataTreeB.getNeighbour({
            x: e,
            y: t
          }, !0)) ? ("h" === a.barType ? n = a.toolText : "v" === a.barType && (n = a.toolText), a.data.config.finalTooltext = n, (l = a.data.graphics.element).data("hoverEnabled", !1), l.attr(l.getData().setRolloutAttr), {
            pointIndex: a.index,
            hovered: !0,
            pointObj: a.data
          }) : void 0;
        }, t.prototype.removePlots = function () {
          var e,
              t,
              o,
              a,
              r = this.components,
              n = r.removeDataArr,
              i = r.pool || (r.pool = {
            element: [],
            hotElement: [],
            label: []
          }),
              l = this.getFromEnv("animationManager"),
              s = n.length,
              c = function c() {
            this.hide(), this.shadow({
              opacity: 0
            });
          };

          for (o = 0; o < s; o++) {
            if (e = n[0], n.splice(0, 1), e && e.graphics) {
              for (a in t = e.graphics) {
                t.hasOwnProperty(a) && l.setAnimation({
                  el: t[a],
                  component: this,
                  attr: {},
                  state: "disappering",
                  callback: c
                });
              }

              e.graphics.element && (i.element = i.element.concat(e.graphics.element)), e.graphics.label && (i.label = i.label.concat(e.graphics.label));
            }
          }

          r.pool = i;
        }, t;
      }(a["default"]);

      t["default"] = g;
    },
    853: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(452),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = {
        "initial.dataset.errorScatter": n["default"]["initial.dataset.line"]
      };
    },
    854: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(849),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = {
        "initial.dataset.errorScatter": n["default"]["initial.dataset.errorLine"]
      };
    },
    855: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(856),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    856: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = i(o(459)),
          r = i(o(450)),
          n = o(551);

      function i(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function l(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var s = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return l(t, e), t.getName = function () {
          return "InverseMSArea";
        }, t.prototype.getName = function () {
          return "InverseMSArea";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.friendlyName = "Inverted Y-Axis Multi-series Area Chart", t.defaultDatasetType = "area", t.isInverse = !0, t.zeroplanethickness = 2, t.zeroplanealpha = 80, t.showzeroplaneontop = 1, t.enablemousetracking = !0, t.defaultcrosslinethickness = 1, n._setDefaultConfig.call(this);
        }, t.prototype.getDSdef = function () {
          return r["default"];
        }, t.prototype.getDSGroupdef = function () {}, t;
      }(a["default"]);

      t["default"] = s;
    },
    857: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(858),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    858: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = i(o(459)),
          r = i(o(432)),
          n = i(o(516));

      function i(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function l(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var s = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return l(t, e), t.getName = function () {
          return "InverseMSColumn2d";
        }, t.prototype.getName = function () {
          return "InverseMSColumn2d";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.friendlyName = "Inverted Y-Axis Multi-series Column Chart", t.defaultDatasetType = "column", t.isInverse = !0, t.enablemousetracking = !0;
        }, t.prototype.getDSdef = function () {
          return r["default"];
        }, t.prototype.getDSGroupdef = function () {
          return n["default"];
        }, t;
      }(a["default"]);

      t["default"] = s;
    },
    859: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(860),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    860: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = i(o(459)),
          r = i(o(449)),
          n = o(551);

      function i(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function l(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var s = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.defaultPlotShadow = 1, o;
        }

        return l(t, e), t.getName = function () {
          return "InverseMSLine";
        }, t.prototype.getName = function () {
          return "InverseMSLine";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.friendlyName = "Inverted Y-Axis Multi-series Line Chart", t.defaultDatasetType = "line", t.isInverse = !0, t.zeroplanethickness = 1, t.zeroplanealpha = 4, t.showzeroplaneontop = 0, t.enablemousetracking = !0, t.defaultcrosslinethickness = 1, n._setDefaultConfig.call(this);
        }, t.prototype.getDSdef = function () {
          return r["default"];
        }, t.prototype.getDSGroupdef = function () {}, t;
      }(a["default"]);

      t["default"] = s;
    },
    861: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(862),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    862: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = s(o(863)),
          r = s(o(866)),
          n = s(o(868)),
          i = s(o(869)),
          l = s(o(871));

      function s(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function c(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var u = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.registerFactory("limitUpdater", i["default"], ["axis"]), o.registerFactory("dragTracker", l["default"], ["canvas"]), o;
        }

        return c(t, e), t.prototype.getName = function () {
          return "DragColumn2D";
        }, t.getName = function () {
          return "DragColumn2D";
        }, t.prototype.getDSGroupdef = function () {
          return n["default"];
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this), this.config.isDrag = !0;
        }, t.prototype.getDSdef = function () {
          return r["default"];
        }, t;
      }(a["default"]);

      t["default"] = u;
    },
    863: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = c(o(518)),
          r = o(125),
          n = o(132),
          i = c(o(864)),
          l = o(136),
          s = o(865);

      function c(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function u(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var p = (0, n.getDepsByType)("transcoder"),
          h = r.preDefStr.UNDERSCORE,
          d = r.BLANKSTRING,
          f = 0,
          g = function g(e) {
        var t = e.sender.apiInstance,
            o = t.getChildren("canvas")[0].getChildren("vCanvas")[0],
            a = t.config,
            r = void 0,
            n = e.data,
            i = n && n.endValue,
            l = n && n.startValue;
        (i > a.yMax || i < a.yMin || l === a.yMin || l === a.yMax) && (r = o.getDataLimits(), a.yMax = r.max, a.yMin = r.min);
      },
          m = function m(e) {
        return e.toString().toLowerCase();
      },
          v = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.eiMethods.getDataWithId = function () {
            for (var e, t, o, a, r, n, i, l, s, c, u = this.apiInstance && this.apiInstance.getJSONData(), p = [[d]], f = u.dataset, g = u.categories && u.categories[0] && u.categories[0].category, m = f && f.length || 0, v = 0; m--;) {
              if (r = f[m]) for (p[0][m + 1] = r.id || r.seriesname, i = r.id || m + 1, c = (a = r.data) && a.length || 0, s = 0; s < c; s += 1) {
                if (!p[n = s + 1]) {
                  for (o = g && g[s + v] || {}; o.vline;) {
                    o = g[s + (v += 1)] || {};
                  }

                  t = o.label || o.name || d, p[n] = [t];
                }

                e = p[n], l = a[s].id || n + h + i, e[m + 1] = [l, Number(a[s].value)];
              }
            }

            return p;
          }, o.eiMethods.getData = function (e) {
            var t,
                o,
                a = this.apiInstance && this.apiInstance.getJSONData(),
                r = a.dataset,
                n = r && r.length || 0,
                l = 0;
            if (e) o = m(e), t = /^json$/gi.test(o) ? a : p[o]().fromJSON(a, this).data;else for ((t = i["default"].call(this.apiInstance)).unshift([d]); l < n;) {
              t[0][l + 1] = r[l++].seriesname;
            }
            return t;
          }, o.eiMethods.setUpperLimit = function (e, t) {
            var o,
                a = this.apiInstance;
            if (!t) return a.changeUpperLimits(e);
            a.addJob("setUpperLimitId" + f++, function () {
              o = a.changeUpperLimits(e), "function" == typeof t && t(o);
            }, l.priorityList.postRender);
          }, o.eiMethods.setLowerLimit = function (e, t) {
            var o,
                a = this.apiInstance;
            if (!t) return a.changeLowerLimits(e);
            a.addJob("setLowerLimitId" + f++, function () {
              o = a.changeLowerLimits(e), "function" == typeof t && t(o);
            }, l.priorityList.postRender);
          }, o.eiMethods.getLowerLimit = function (e) {
            var t = this.apiInstance,
                o = t.getChildren("yAxis")[0];

            if (o) {
              if (!e) return o.config.axisRange.min;
              t.addJob("getLowerLimitId" + f++, function () {
                "function" == typeof e && e(o.config.axisRange.min);
              }, l.priorityList.postRender);
            }
          }, o.eiMethods.getUpperLimit = function (e) {
            var t = this.apiInstance,
                o = t.getChildren("yAxis")[0];

            if (o) {
              if (!e) return o.config.axisRange.max;
              t.addJob("getUpperLimitId" + f++, function () {
                "function" == typeof e && e(o.config.axisRange.max);
              }, l.priorityList.postRender);
            }
          }, o;
        }

        return u(t, e), t.prototype.getName = function () {
          return "DragBase";
        }, t.prototype.configureAttributes = function (t) {
          e.prototype.configureAttributes.call(this, t), "DragNode" !== this.getName() && this.getFromEnv("chartInstance").addEventListener("dataplotdragend", g);
        }, t.prototype.mouseoutHandler = function (e, t, o) {
          var a = this.config.datasetOrder || this.getDatasets(),
              n = this.getChildren("mouseTracker")[0];
          a[t] && a[t].components.data[o] ? a[t]._firePlotEvent(r.MOUSEOUT, o, e) : this.getFromEnv("toolTipController").hideAll(), delete n._lastDatasetIndex, delete n._lastPointIndex;
        }, t.getName = function () {
          return "DragBase";
        }, t.prototype._mouseEvtHandler = function (e, t) {
          var o,
              a,
              n,
              i,
              l,
              s,
              c,
              u = this,
              p = t.mouseTracker,
              h = e.originalEvent,
              d = u.config.datasetOrder || u.getDatasets(),
              f = (0, r.getMouseCoordinate)(u.getFromEnv("chart-container"), h, u),
              g = f.chartX,
              m = f.chartY,
              v = !1,
              b = d.length,
              y = p._lastDatasetIndex,
              x = p._lastPointIndex;
          if (void 0 !== x && d[y] && d[y].components.data[x] && (s = d[y].components.data[x].config.dragStart), !s) for (; b-- && !v;) {
            (o = d[b]) && o.getState("visible") && (a = o._getHoveredPlot && o._getHoveredPlot(g, m)) && a.hovered && (v = !0, a.datasetIndex = b, l = p.getMouseEvents(e, a.datasetIndex, a.pointIndex));
          }
          if (s && void 0 !== y && (c = e.type === r.MOUSEOUT ? r.MOUSEMOVE : e.type, d[y] && d[y]._firePlotEvent && d[y]._firePlotEvent(c, x, e)), !s && (!v || l && l.fireOut) && void 0 !== y && d[y] && d[y]._firePlotEvent && (l && !l.events.length ? p.mouseoutTimer = setTimeout(function () {
            u.mouseoutHandler(e, y, x);
          }, 20) : (u.mouseoutHandler(e, y, x), clearTimeout(p.mouseoutTimer))), v) for ((i = l.events && l.events.length) && (p._lastDatasetIndex = a.datasetIndex, x = p._lastPointIndex = a.pointIndex), n = 0; n < i; n += 1) {
            o && o._firePlotEvent && o._firePlotEvent(l.events[n], x, e);
          }
        }, t.prototype.parseChartAttr = function (t) {
          e.prototype.parseChartAttr.call(this, t);
          var o,
              a = this.getFromEnv("dataSource").chart;
          (o = this.config).formAction = (0, r.getValidValue)(a.formaction), a.submitdataasxml !== r.ZEROSTRING || a.formdataformat || (a.formdataformat = p.csv().format), o.formDataFormat = (0, r.pluck)(a.formdataformat, p.xml().format), o.formTarget = (0, r.pluck)(a.formtarget, "_self"), o.formMethod = (0, r.pluck)(a.formmethod, "POST"), o.submitFormAsAjax = (0, r.pluckNumber)(a.submitformusingajax, 1), o.restoreBtnTitle = (0, r.pluck)(a.restoretext, a.restorebtntitle, "Restore"), o.submitBtnTitle = (0, r.pluck)(a.submittext, a.formbtntitle, "Submit"), o.showFormBtn = (0, r.pluckNumber)(a.enablesubmit, a.showformbtn, 1) && o.formAction, o.showRestoreBtn = (0, r.pluckNumber)(a.enablerestore, a.showrestorebtn, 1), o.formBtnTitle = (0, r.pluck)(a.formbtntitle, "Submit"), o.formBtnStyle = {
            fontSize: o.style.outCanfontSize,
            fontFamily: o.style.outCanfontFamily,
            fontWeight: "bold"
          }, o.restoreBtnWidth = (0, r.pluckNumber)(a.restorebtnwidth, 0), o.allowAxisChange = (0, r.pluckNumber)(a.allowaxischange, 1), a.toolbary || a.toolbarx ? o.spaceHardCoded = !0 : delete o.spaceHardCoded, o.drawTrendRegion = (0, r.pluckNumber)(a.drawcrossline, 0);
        }, t.prototype._storeIntialLimit = function (e, t) {
          this.config.axisInitialLimit = {
            min: e,
            max: t
          };
        }, t.prototype._createToolBox = function () {
          e.prototype._createToolBox.call(this), this.addConfigureOptions();
        }, t.prototype.addConfigureOptions = function () {
          var e,
              t,
              o = this,
              a = o.getFromEnv("toolbar"),
              r = a.getChild("hamburgerMenu-" + a.getId() + "-" + o.getId() + "-0"),
              n = o.config,
              i = n.allowAxisChange,
              l = n.submitBtnTitle,
              c = n.restoreBtnTitle,
              u = [{
            name: "Increase Upper Limit",
            handler: function handler() {
              var e = o.getChildren("yAxis")[0].getLimit(),
                  t = e.max,
                  a = e.tickInterval;
              o.changeUpperLimits(t + a);
            },
            action: "click"
          }, {
            name: "Increase Lower Limit",
            handler: function handler() {
              var e = o.getChildren("yAxis")[0].getLimit(),
                  t = e.min,
                  a = e.tickInterval;
              o.changeLowerLimits(t + a);
            },
            action: "click"
          }, {
            name: "Decrease Upper Limit",
            handler: function handler() {
              var e = o.getChildren("yAxis")[0].getLimit(),
                  t = e.max,
                  a = e.tickInterval;
              o.changeUpperLimits(t - a);
            },
            action: "click"
          }, {
            name: "Decrease Lower Limit",
            handler: function handler() {
              var e = o.getChildren("yAxis")[0].getLimit(),
                  t = e.min,
                  a = e.tickInterval;
              o.changeLowerLimits(t - a);
            },
            action: "click"
          }];
          n.showFormBtn && (t = {
            name: l,
            handler: function handler() {
              s.submitData.call(o);
            },
            action: "click"
          }, u.push(t)), n.showRestoreBtn && (e = {
            name: c,
            handler: function handler() {
              o.restoreData();
            },
            action: "click"
          }, u.push(e)), i && r.appendInMenu(u);
        }, t.prototype.restoreData = function () {
          var e = this.getChildren("yAxis")[0],
              t = this.getFromEnv("chart-attrib"),
              o = this.config.axisInitialLimit;
          this.iterateComponents(function (e) {
            var t = void 0;
            (t = e.getChildren("dataset")) && t.forEach(function (e) {
              e.restore();
            });
          }), e.resetStoredLimits(), e.setAxisConfig({
            axisMaxValue: t.yaxismaxvalue,
            axisMinValue: t.yaxisminvalue
          }), e.setDataLimit(o.max, o.min), this.fireChartInstanceEvent("dataRestored", {}), this._manageInteractiveSpace();
        }, t.prototype.changeLowerLimits = function (e) {
          var t = this.getChildren("yAxis")[0],
              o = t.getLimit(),
              a = o.min,
              n = o.min,
              i = this.config,
              l = (0, r.safeMin)([i.yMin, t.getTrendLineLimits()[0]]),
              s = !1,
              c = i.allowAxisChange,
              u = o.max;
          return this.getFromEnv("animationManager").setAnimationState("update"), void 0 !== e && e < l && e !== n && c && (a = e, s = !0), s && (t.resetStoredLimits(), t.setAxisConfig({
            axisMaxValue: u,
            axisMinValue: a,
            showLowerLimit: !0
          }), t.setDataLimit(u, a), this._manageInteractiveSpace()), s;
        }, t.prototype.changeUpperLimits = function (e) {
          var t,
              o = this.getChildren("yAxis")[0],
              a = o.getLimit(),
              n = a.min,
              i = a.max,
              l = this.config,
              s = (0, r.safeMax)([l.yMax, o.getTrendLineLimits()[1]]),
              c = !1,
              u = l.allowAxisChange;
          return this.getFromEnv("animationManager").setAnimationState("update"), void 0 !== e && e > s && e !== i && u && (t = e, c = !0), c && (o.resetStoredLimits(), o.setAxisConfig({
            axisMaxValue: t,
            axisMinValue: n,
            showUpperLimit: !0
          }), o.setDataLimit(t, n), this._manageInteractiveSpace()), c;
        }, t.prototype.getJSONData = function () {
          var e,
              t,
              o,
              a,
              n,
              i,
              l,
              s = this.getChildren("canvas")[0].getChildren("vCanvas")[0],
              c = this.getFromEnv("dataSource"),
              u = [];
          if (s.iterateComponents(function (t) {
            "group" === t.getType() && (e = t);
          }), e) u = e.getJSONData && e.getJSONData();else for (i = (o = this.getDatasets()).length, n = 0; n < i; n++) {
            a = {
              seriesname: (t = o[n]).config.seriesname,
              data: t.getJSONData().data
            }, u.push(a);
          }
          return (l = (0, r.extend2)({}, c)).dataset = u, l;
        }, t;
      }(a["default"]);

      v.prototype._manageInteractiveSpace = r._manageInteractiveSpace, t["default"] = v;
    },
    865: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t.submitData = undefined;
      var a,
          r = o(176),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      },
          i = o(132),
          l = o(125);
      var s = void 0,
          c = (0, i.getDepsByType)("transcoder");

      t.submitData = function () {
        var e,
            t,
            o,
            a,
            r,
            i = this,
            u = new n["default"](),
            p = i.config,
            h = c.json(),
            d = c.csv && c.csv() || "csv",
            f = c.xml(),
            g = p.formAction,
            m = i.getFromEnv("chartInstance"),
            v = p.submitFormAsAjax;
        p.formDataFormat === h.format ? (e = h.format, i.getJSONData && (t = JSON.stringify(i.getJSONData())), i.getCollatedData && (t = JSON.stringify(i.getCollatedData()))) : p.formDataFormat && p.formDataFormat === d.format ? (e = d.format, (t = i.getCSVString && i.getCSVString()) !== s && "" !== t || (i.getJSONData && (t = d.fromJSON(i.getJSONData()).data), i.getCollatedData && (t = d.fromJSON(i.getCollatedData()).data))) : (e = f.format, i.getCollatedData && (t = f.fromJSON(i.getCollatedData()).data), i.getJSONData && (t = f.fromJSON(i.getJSONData()).data)), i.fireChartInstanceEvent("beforeDataSubmit", {
          data: t
        }, s, function () {
          v ? (u.onError = function (e, o, a, r) {
            i.fireChartInstanceEvent("dataSubmitError", {
              xhrObject: o.xhr,
              url: r,
              statusText: e,
              httpStatus: o.xhr && o.xhr.status ? o.xhr.status : -1,
              data: t
            }, [m.id, e, o.xhr && o.xhr.status]);
          }, u.onSuccess = function (e, o, a, r) {
            i.fireChartInstanceEvent("dataSubmitted", {
              xhrObject: u,
              response: e,
              url: r,
              data: t
            }, [m.id, e]);
          }, (o = {})["str" + e.toUpperCase()] = t, u.open && u.abort(), u.post(g, o)) : ((a = window.document.createElement("span")).innerHTML = '<form style="display:none" action="' + g + '" method="' + p.formMethod + '" target="' + p.formTarget + '"> <input type="hidden" name="strXML" value="' + (0, l.xssEncode)(t) + '"><input type="hidden" name="dataFormat" value="' + e.toUpperCase() + '" /></form>', r = a.removeChild(a.firstChild), window.document.body.appendChild(r), r.submit && r.submit(), r.parentNode.removeChild(r), a = r = null);
        }, function () {
          i.fireChartInstanceEvent("dataSubmitCancelled", {
            data: t
          });
        });
      };
    },
    866: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t.updateDataValue = t._restore = t._getJSONData = undefined;
      var a = l(o(432)),
          r = o(125),
          n = l(o(867)),
          i = o(132);

      function l(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var c,
          u,
          p = r.preDefStr.setRolloverAttrStr,
          h = r.preDefStr.setRolloutAttrStr,
          d = r.preDefStr.DATAPLOTCLICK,
          f = r.hasSVG ? "ns-resize" : "n-resize",
          g = function g(e, t) {
        var o,
            a = t.getChildren("yAxis")[0],
            n = t.getFromEnv("chart-container"),
            i = this.data("eventArgs");
        o = (0, r.getMouseCoordinate)(n, e, t), i.value = a.getValue(o.chartY), this.data("eventArgs", i);
      };

      (0, i.addDep)({
        name: "dragColumnAnimation",
        type: "animationRule",
        extension: n["default"]
      });

      var m = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return s(t, e), t.prototype.getType = function () {
          return "dataset";
        }, t.prototype.getName = function () {
          return "dragColumn";
        }, t.prototype.configureAttributes = function (t) {
          var o = this.config,
              a = this.getFromEnv("chart-attrib"),
              n = o.JSONData;
          o.allowDrag = (0, r.pluckNumber)(n.allowdrag, 1), o.allowNegDrag = (0, r.pluckNumber)(n.allownegativedrag, 1), o.allowAxisChange = (0, r.pluckNumber)(a.allowaxischange, 1), o.snapToDivOnly = (0, r.pluckNumber)(a.snaptodivonly, 0), o.snapToDiv = o.snapToDivOnly ? 1 : (0, r.pluckNumber)(a.snaptodiv, 1), o.doNotSnap = (0, r.pluckNumber)(a.donotsnap, 0), o.snapToDivRelaxation = (0, r.pluckNumber)(a.snaptodivrelaxation, 10), o.doNotSnap && (o.snapToDiv = o.snapToDivOnly = 0), e.prototype.configureAttributes.call(this, t);
        }, t.prototype._plotConfigure = function (t, o) {
          var a = this.config,
              n = this.components.data,
              i = void 0;
          e.prototype._plotConfigure.call(this, t, o), (i = n[t].config).allowDrag = (0, r.pluckNumber)(o.allowdrag, a.allowDrag), i.allowNegDrag = (0, r.pluckNumber)(o.allownegativedrag, a.allowNegDrag);
        }, t.prototype.drag = function (e, t, o, a) {
          var n,
              i,
              l,
              s,
              c,
              u,
              d,
              m,
              v,
              b,
              y,
              x,
              k,
              w,
              C,
              N,
              S,
              A,
              E,
              D,
              _ = this.config,
              T = this.getFromEnv("chart"),
              L = T.config,
              P = L.canvasTop,
              O = L.canvasBottom,
              V = this.getFromEnv("toolTipController"),
              M = this.getFromEnv("number-formatter"),
              F = this.components.data,
              I = this.getFromEnv("paper").canvas.style,
              B = this.getFromEnv("yAxis"),
              R = B.yBasePos,
              j = L.yaxisname,
              G = {
            xaxisName: L.xaxisname,
            yaxisName: j
          },
              H = L.dragTolerance + 1,
              W = _.JSONData,
              z = this.getFromEnv("chart-attrib"),
              U = L.useplotgradientcolor,
              J = L.useroundedges,
              K = this.getFromEnv("chart-container");

          switch (a = a || (0, r.getMouseCoordinate)(K, t), e) {
            case "dragstart":
              i = (S = F[o]).config, n = S.graphics.element, u = S._yPos, m = S._height, l = i.setValue < 0 ? u + m : u, D = i.allowDrag, y = a.chartY, D && y >= l - H && y <= l + H ? (i.dragStart = !0, i._pointerDy = 0, i._dragStartY = y, i._dragBuffer = l - y, S.startValue = i.setValue, S.name = _.seriesname, S.datasetIndex = _.index, S.dragged = !0) : i.dragStart = !1;
              break;

            case "dragmove":
              (i = (S = F[o]).config).dragStart && (n = S.graphics.element, w = i.plotIndex, b = i.allowNegDrag ? O : R, y = a.chartY, i._rollOverResponseSetterFire = !1, I.cursor = f, i._pointerDy++, (y += i._dragBuffer) < P ? y = P : y > b && (y = b), u = R < y ? R : y, m = (0, r.mathAbs)(R - y), S._yPos = u, S._height = m, l = u >= R ? u + m : u, i._y = s = i.setValue = B.getValue(l), c = M.dataLabels(s), i.toolTipValue = c, i.displayValue = (0, r.pluck)(i.setDisplayValue, c), U && !J && (i.colorArr[0].FCcolor.angle = d = u < R ? 90 : 270), n.attr({
                y: S._yPos,
                height: S._height,
                fill: (0, r.toRaphaelColor)(i.colorArr[0])
              }), this.parseLabelAttributes(S), this.drawLabel(w, w + 1), S.graphics.element = n, V.hide(_.currentToolTip), 1 === i._pointerDy && (C = {
                dataIndex: o,
                datasetIndex: S.datasetIndex,
                startValue: S.startValue,
                datasetName: S.name
              }, T.fireChartInstanceEvent("dataplotDragStart", C)));
              break;

            case "dragend":
              (i = (S = F[o]).config).dragStart && (u = S._yPos, n = S.graphics.element, A = (0, r.getValidValue)((0, r.parseUnsafeString)((0, r.pluck)(S.tooltext, W.plottooltext, z.plottooltext))), y = a.chartY, this.setMaxMin(S), C = {
                dataIndex: o,
                datasetIndex: S.datasetIndex,
                startValue: S.startValue,
                endValue: i.setValue,
                datasetName: S.name
              }, N = [T.getFromEnv("chartInstance").id, C.dataIndex, C.datasetIndex, C.datasetName, C.startValue, C.endValue], g.call(n, t, T), i._pointerDy && (T.fireChartInstanceEvent("dataplotDragEnd", C), T.fireChartInstanceEvent("chartupdated", C, N)), U && !J && (d = u >= R ? 90 : 270, (v = n.data(p)) && v.fill && ((x = (x = v.fill).split("-"))[0] = d, v.fill = x.join("-")), (k = n.data(h)) && k.fill && ((x = (x = k.fill).split("-"))[0] = d, k.fill = x.join("-"))), i._dragBuffer = 0, i._pointerDy = 0, void 0 !== A && (G.formattedValue = i.toolTipValue, G.label = i.label, E = (0, r.parseTooltext)(A, [1, 2, 3, 4, 5, 6, 7], G, {
                value: i.toolTipValue
              }, void 0, W), i.setTooltext = E, A = E, i.toolText = E), E = i.finalTooltext = !1 !== i.toolText ? i.toolText + (A ? "" : i.toolTipValue) : "", y >= l - H && y <= l + H || (I.cursor = "default"), i.dragStart = !1);
          }
        }, t.prototype._firePlotEvent = function (e, o, a) {
          var n,
              i,
              l = this.getFromEnv("chart"),
              s = this.config,
              c = s.currentToolTip,
              u = this.getFromEnv("chartConfig"),
              p = u.drawTrendRegion,
              h = this.getFromEnv("paper").canvas.style,
              g = this.getFromEnv("toolTipController"),
              m = this.components.data[o],
              v = m.config,
              b = m.graphics.element,
              y = v.finalTooltext || v.toolText,
              x = a.originalEvent,
              k = (0, r.getMouseCoordinate)(this.getFromEnv("chart-container"), x).chartY,
              w = m._yPos,
              C = m._height,
              N = this.getFromEnv("yAxis").yBasePos,
              S = v.allowDrag,
              A = w,
              E = w + C;
          if (n = u.dragTolerance + 1, i = w >= N ? w + C : w, b) switch (e) {
            case "fc-mouseover":
              k <= E - n && k >= A + n && !p && y && (c ? g.draw(x, y, c) : c = s.currentToolTip = g.draw(x, y)), !v._rollOverResponseSetterFire && k <= E && k >= A && (t._rolloverResponseSetter(l, b, a, this), v._rollOverResponseSetterFire = !0);
              break;

            case "fc-mouseout":
              h.cursor = "default", v._rollOverResponseSetterFire && t._rolloutResponseSetter(l, b, a, this), v._rollOverResponseSetterFire = !1, g.hide(s.currentToolTip);
              break;

            case "fc-click":
              l.plotEventHandler(b, a, d);
              break;

            case "fc-mousemove":
              v.dragStart || (i = v.setValue < 0 ? w + C : w, S && k >= i - n && k <= i + n ? (h.cursor = f, g.hide(s.currentToolTip)) : (h.cursor = "default", v._rollOverResponseSetterFire && !p && y && (c ? g.draw(x, y, c) : c = s.currentToolTip = g.draw(x, y))), !v._rollOverResponseSetterFire && k <= E && k >= A ? (t._rolloverResponseSetter(l, b, a), v._rollOverResponseSetterFire = !0) : !v._rollOverResponseSetterFire || k <= E && k >= A || (g.hide(s.currentToolTip), v._rollOverResponseSetterFire = !1, t._rolloutResponseSetter(l, b, a, this)));
          }
        }, t._rolloverResponseSetter = function (e, t, o, a) {
          var r = t && t.getData(),
              n = e.getFromEnv("animationManager");
          t && 0 !== r.showHoverEffect && !0 !== r.draged && t && (n.setAnimationState("mouseOver"), n.setAnimation({
            el: t,
            label: "rect",
            component: a,
            attr: t.getData().setRolloverAttr
          }), e.plotEventHandler(t, o, "DataPlotRollOver"));
        }, t._rolloutResponseSetter = function (e, t, o, a) {
          var r = t && t.getData(),
              n = e.getFromEnv("animationManager");
          t && 0 !== r.showHoverEffect && !0 !== r.draged && (n.setAnimationState("mouseOut"), n.setAnimation({
            el: t,
            label: "rect",
            component: a,
            attr: t.getData().setRolloutAttr
          }), e.plotEventHandler(t, o, "DataPlotRollOut"));
        }, t.prototype.getJSONData = function () {
          var e,
              t,
              o,
              a,
              r,
              n = this.config.JSONData.data,
              i = this.components.data,
              l = [],
              s = {};

          for (r = 0, a = n.length; r < a; r++) {
            for (o in t = n[r], e = i[r], s = {}, t) {
              s[o] = "value" === o ? e.config.setValue : t[o];
            }

            l.push(s);
          }

          return {
            data: l
          };
        }, t.prototype.restore = function () {
          this.setData(this.config.JSONData, !0);
        }, t;
      }(a["default"]);

      t._getJSONData = c = m.prototype.getJSONData, t._restore = u = m.prototype.restore, t["default"] = m, t._getJSONData = c, t._restore = u, t.updateDataValue = g;
    },
    867: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(433),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = {
        "initial.dataset.dragColumn": n["default"]["initial.dataset.column"]
      };
    },
    868: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(516),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      },
          i = o(125);

      function l(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var s = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return l(t, e), t.prototype.getJSONData = function () {
          var e,
              t,
              o,
              a,
              r = this.getFromEnv("dataSource").dataset,
              n = this.getChildren("dataset"),
              l = [],
              s = n.length;

          for (a = 0; a < s; a++) {
            e = n[a], delete (o = (0, i.extend2)({}, r[a])).data, t = e.getJSONData(), l.push((0, i.extend2)(o, t));
          }

          return l;
        }, t;
      }(n["default"]);

      t["default"] = s;
    },
    869: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = function (e) {
        var t,
            o = e.config.allowAxisChange,
            a = e.getChildren("yAxis")[0],
            n = void 0;
        (0, r.componentFactory)(a, i["default"], "limitUpdater", o ? 1 : 0), (n = (t = a.getChildren("limitUpdater")) && t[0]) && n.configure();
      };
      var a,
          r = o(125),
          n = o(870),
          i = (a = n) && a.__esModule ? a : {
        "default": a
      };
    },
    870: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(138),
          n = o(127),
          i = (a = n) && a.__esModule ? a : {
        "default": a
      },
          l = o(125);

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var c = 13,
          u = 27,
          p = void 0;

      function h() {
        this.justFocussed && (this.justFocussed = !1, l.hasTouch || this.select());
      }

      function d(e, t, o) {
        var a = p.getLinkedParent();
        if (e !== t + "") return o ? a.changeUpperLimits && a.changeUpperLimits(Number(e)) : a.changeLowerLimits && a.changeLowerLimits(Number(e));
      }

      function f() {
        var e,
            t = {
          opacity: 1,
          filter: "alpha(opacity=100)",
          color: (0, l.rgbaToHex)(this.axisLabel.attr("fill"))
        };

        for (e in t) {
          this.style[e] = t[e];
        }

        this.value = this.dataValue, this.justFocussed = !0, this.hasFocus = !0, this.axisLabel && this.axisLabel.hide();
      }

      function g() {
        d(this.value, this.oldValue, this.isMaxLabel), this.style.opacity = 0, this.style.filter = "alpha(opacity=0)", this.axisLabel && this.axisLabel.show(), l.isIE && document.getElementsByTagName("body")[0].focus && document.getElementsByTagName("body")[0].focus(), this.justFocussed = !1, this.hasFocus = !1;
      }

      function m(e) {
        var t = function (e) {
          return "number" == typeof e.which ? e.which : e.keyCode;
        }(e.originalEvent),
            o = this.value,
            a = this.oldValue,
            r = this.isMaxLabel;

        t === c ? !1 === d(o, a, r) ? this.style.color = "#dd0000" : i["default"].fire(this, "blur", e) : t === u && (this.value = a, i["default"].fire(this, "blur", e));
      }

      function v(e) {
        return function (t) {
          e.parentNode && i["default"].fire(e, "blur", t);
        };
      }

      function b(e) {
        return function (t) {
          t.target !== e && e.hasFocus && i["default"].fire(e, "blur", t);
        };
      }

      function y(e, t) {
        return function () {
          i["default"].unlisten(p.getLinkedParent(), "defaultprevented", t), e.parentNode.removeChild(e);
        };
      }

      function x(e, t) {
        return function () {
          i["default"].unlisten(p.getLinkedParent().getLinkedItem("container"), "mousedown", t), e.parentNode.removeChild(e);
        };
      }

      var k = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return s(t, e), t.prototype.configureAttributes = function () {
          this.config.linkedAxis = this.getLinkedParent(), p = this.config.linkedAxis;
        }, t.prototype.getType = function () {
          return "helper";
        }, t.prototype.getName = function () {
          return "limitUpdater";
        }, t.prototype.draw = function () {
          var e = this.getFromEnv("chartConfig"),
              t = this.config.linkedAxis,
              o = t.getAxisConfig("extremeLabels"),
              a = t.getLimit(),
              r = this.getFromEnv("chart-container"),
              n = this.getFromEnv("style").inCanvasStyle,
              s = (0, l.extend2)({
            outline: "none",
            "-webkit-appearance": "none",
            filter: "alpha(opacity=0)",
            position: "absolute",
            background: "transparent",
            border: "1px solid #cccccc",
            textAlign: "right",
            top: 0,
            left: 0,
            width: 50,
            zIndex: 20,
            opacity: 0,
            borderRadius: 0,
            display: "block"
          }, n),
              c = {
            max: {
              element: o.lastLabel.graphic,
              value: a.max
            },
            min: {
              element: o.firstLabel.graphic,
              value: a.min
            }
          },
              u = void 0,
              p = void 0,
              d = void 0,
              k = void 0,
              w = void 0,
              C = void 0,
              N = void 0,
              S = void 0,
              A = void 0,
              E = void 0,
              D = void 0,
              _ = void 0;

          for (k in s.color = (0, l.hashify)(s.color), s.fontSize = s.fontSize + "px", c) {
            if (c.hasOwnProperty(k)) {
              if (C = (d = c[k].element) && d.getBBox(), S = c[k].value, N = "max" === k, p = k + "Input", u = this.getGraphicalElement(p), !C || !d) {
                u && (u.style.display = "none");
                continue;
              }

              for (w in u || (u = this.addGraphicalElement(p, (0, l.createElement)("input", {
                type: "text",
                value: S,
                id: "fc-updater-" + k
              }, r))), i["default"].listen(u, ["focus", "mouseup", "blur", "keyup"], [f, h, g, m]), l.hasSVG ? (i["default"].listen(r, "defaultprevented", A = v(u)), i["default"].listen(r, "destroy", y(u, A))) : (i["default"].listen(r, "mousedown", _ = b(u)), i["default"].listen(r, "destroy", x(u, _))), E = C.x + C.width - e.marginLeft, D = e.marginLeft, s.top = C.y + "px", s.left = D + "px", s.width = E + "px", s) {
                s.hasOwnProperty(w) && (u.style[w] = s[w]);
              }

              u.dataValue = S, u.value = S, u.oldValue = S, u.name = S || "", u.axisLabel = d, u.isMaxLabel = N;
            }
          }
        }, t.prototype.removingDraw = function () {
          var e = this.getGraphicalElement(),
              t = void 0,
              o = void 0;

          for (t in e) {
            e.hasOwnProperty(t) && ((o = e[t]) && o.parentNode && o.parentNode.removeChild(o), delete e[t]);
          }
        }, t;
      }(r.ComponentInterface);

      t["default"] = k;
    },
    871: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = function (e) {
        (0, i.componentFactory)(e, n["default"], "dragTracker"), e.getChildren("dragTracker")[0].addEvents();
      };
      var a,
          r = o(872),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      },
          i = o(125);
    },
    872: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = o(138),
          r = o(125);

      function n(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var i = function i(e) {
        return function (t) {
          for (var o = e.getFromEnv("chart"), a = o.config, n = e.config, i = a.datasetOrder || o.getDatasets(), l = (0, r.getMouseCoordinate)(o.getFromEnv("chart-container"), t, o), s = l.chartX, c = l.chartY, u = void 0, p = void 0, h = i.length, d = void 0; h-- && !u;) {
            (d = i[h]) && d.getState("visible") && (p = d._getHoveredPlot && d._getHoveredPlot(s, c)) && p.hovered && (u = !0, n.dragStart = !0, n.hoveredInfo = p, n.hoveredDS = d, d.drag("dragstart", t, p.pointIndex, l));
          }
        };
      },
          l = function l(e) {
        return function (t) {
          var o = e.config;
          o.dragStart && o.hoveredDS.drag("dragmove", t, o.hoveredInfo.pointIndex);
        };
      },
          s = function s(e) {
        return function (t) {
          var o = e.config;
          o.dragStart && o.hoveredDS.drag("dragend", t, o.hoveredInfo.pointIndex), o.dragStart = !1;
        };
      },
          c = ["fc-dragstart", "fc-dragmove", "fc-dragend"],
          u = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.config.eventCb = {
            "fc-dragstart": i(o),
            "fc-dragmove": l(o),
            "fc-dragend": s(o)
          }, o;
        }

        return n(t, e), t.prototype.addEvents = function () {
          var e = this.getFromEnv("chart"),
              t = this.config.eventCb,
              o = e.getChildren("canvas");
          this.removeEvents(), o.forEach(function (e) {
            c.forEach(function (o) {
              e.addEventListener(o, t[o]);
            });
          });
        }, t.prototype.removeEvents = function () {
          var e = this.config.eventCb;
          this.getFromEnv("chart").getChildren("canvas").forEach(function (t) {
            c.forEach(function (o) {
              t.removeEventListener(o, e[o]);
            });
          });
        }, t.prototype._dispose = function () {
          this.removeEvents(), e.prototype._dispose.call(this);
        }, t;
      }(a.ComponentInterface);

      t["default"] = u;
    },
    873: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(874),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    874: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = r(o(875));

      function r(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function n(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var i = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.defaultPlotShadow = 1, o;
        }

        return n(t, e), t.prototype.getName = function () {
          return "DragLine";
        }, t.getName = function () {
          return "DragLine";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.isDrag = !0, t.zeroplanethickness = 1, t.zeroplanealpha = 40, t.showzeroplaneontop = 0, t.enablemousetracking = !0, t.defaultcrosslinethickness = 1;
        }, t.prototype.getDSdef = function () {
          return a["default"];
        }, t;
      }(r(o(879))["default"]);

      t["default"] = i;
    },
    875: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = c(o(449)),
          r = o(876),
          n = o(125),
          i = o(866),
          l = o(132),
          s = c(o(878));

      function c(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function u(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      (0, l.addDep)({
        name: "dragLineAnimation",
        type: "animationRule",
        extension: s["default"]
      });

      var p = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return u(t, e), t.prototype._firePlotEvent = function () {
          r.__firePlotEvent.apply(this, arguments);
        }, t.prototype.updateImage = function (e) {
          r._updateImage.call(this, e);
        }, t.prototype.drag = function () {
          r._drag.apply(this, arguments);
        }, t.prototype.configureAttributes = function () {
          r.configurer.apply(this, arguments);
        }, t.prototype._plotConfigure = function (t, o) {
          var a = this.config,
              r = this.components.data,
              i = void 0;
          e.prototype._plotConfigure.call(this, t, o), (i = r[t].config).allowDrag = (0, n.pluckNumber)(o.allowdrag, a.allowDrag), i.allowNegDrag = (0, n.pluckNumber)(o.allownegativedrag, a.allowNegDrag);
        }, t.prototype.getType = function () {
          return "dataset";
        }, t.prototype.getName = function () {
          return "dragLine";
        }, t.prototype.restore = function () {
          i._restore.call(this);
        }, t.prototype.getJSONData = function () {
          return i._getJSONData.call(this);
        }, t;
      }(a["default"]);

      t["default"] = p;
    },
    876: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t._drag = t._updateImage = t.configurer = t.__firePlotEvent = undefined;
      var a = s(o(450)),
          r = o(125),
          n = o(866),
          i = s(o(877)),
          l = o(132);

      function s(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function c(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var u,
          p,
          h,
          d,
          f = "DataPlotRollOut",
          g = r.hasSVG ? "ns-resize" : "n-resize",
          m = Math.min,
          v = Math.max;
      (0, l.addDep)({
        name: "dragAreaAnimation",
        type: "animationRule",
        extension: i["default"]
      });

      var b = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return c(t, e), t.prototype.getType = function () {
          return "dataset";
        }, t.prototype.getName = function () {
          return "dragArea";
        }, t.prototype.configureAttributes = function (t) {
          var o = this.config,
              a = this.getFromEnv("chart-attrib"),
              n = o.JSONData;
          o.allowDrag = (0, r.pluckNumber)(n.allowdrag, 1), o.allowNegDrag = (0, r.pluckNumber)(n.allownegativedrag, 1), o.allowAxisChange = (0, r.pluckNumber)(a.allowaxischange, 1), o.snapToDivOnly = (0, r.pluckNumber)(a.snaptodivonly, 0), o.doNotSnap = (0, r.pluckNumber)(a.donotsnap, 0), o.snapToDiv = (0, r.pluckNumber)(a.snaptodiv, 1), o.snapToDivRelaxation = (0, r.pluckNumber)(a.snaptodivrelaxation, 10), o.doNotSnap && (o.snapToDiv = o.snapToDivOnly = 0), e.prototype.configureAttributes.call(this, t);
        }, t.prototype._plotConfigure = function (t, o) {
          var a = this.config,
              n = this.components.data,
              i = void 0;
          e.prototype._plotConfigure.call(this, t, o), (i = n[t].config).allowDrag = (0, r.pluckNumber)(o.allowdrag, a.allowDrag), i.allowNegDrag = (0, r.pluckNumber)(o.allownegativedrag, a.allowNegDrag);
        }, t.updateImage = function (e) {
          var t,
              o = e.graphics,
              a = o.image || o.element,
              n = e.config,
              i = n.anchorProps,
              l = n.hoverEffects,
              s = a && a.data("imgRef"),
              c = i.imageScale,
              u = s.height * c * .01,
              p = s.width * c * .01,
              h = e._xPos,
              d = e._yPos,
              f = l.imageHoverScale,
              g = s.width * f * .01,
              v = s.height * f * .01,
              b = i.isAnchorRadius,
              y = i.radius = b ? i.radius : m(p, u) / 2,
              x = i.imagePadding,
              k = y - x - .5 * i.borderThickness,
              w = l.radius - x - .5 * l.anchorBorderThickness,
              C = i.symbol[1],
              N = (0, r.polyPathToPath)([C || 2, h, d, w > 0 ? w : 0, l.startAngle, l.dip]),
              S = (0, r.polyPathToPath)([C || 2, h, d, k > 0 ? k : 0, i.startAngle, 0]),
              A = {
            x: h - s.width * c * .005,
            y: d - s.height * c * .005,
            width: p,
            height: u,
            alpha: 100
          };
          A["clip-path"] = S, (t = {
            x: h - s.width * f * .005,
            y: d - s.height * f * .005,
            width: g,
            height: v,
            alpha: 100
          })["clip-path"] = N, a.attr(A), a.data("setRolloverAttr", t), a.data("setRolloutAttr", A);
        }, t.prototype.drag = function (e, o, a, i) {
          var l = this.config,
              s = l.index,
              c = this.getFromEnv("chart"),
              u = c.config,
              p = u.canvasTop,
              h = u.canvasBottom,
              d = void 0,
              f = void 0,
              m = void 0,
              v = this.getFromEnv("toolTipController"),
              b = this.getFromEnv("number-formatter"),
              y = this.components.data,
              x = void 0,
              k = void 0,
              w = void 0,
              C = void 0,
              N = void 0,
              S = void 0,
              A = this.getFromEnv("paper").canvas.style,
              E = this.getFromEnv("yAxis"),
              D = void 0,
              _ = u.yaxisname,
              T = {
            xaxisName: u.xaxisname,
            yaxisName: _
          },
              L = void 0,
              P = this.getGraphicalElement().lineElement,
              O = void 0,
              V = u.dragTolerance + 1,
              M = E.yBasePos,
              F = void 0,
              I = void 0,
              B = void 0,
              R = void 0,
              j = void 0,
              G = void 0,
              H = void 0,
              W = void 0,
              z = void 0,
              U = void 0,
              J = void 0,
              K = void 0,
              q = void 0,
              Y = void 0,
              X = this.getFromEnv("chart-attrib"),
              Q = "dragLine" === this.getName(),
              Z = l.JSONData,
              $ = this.getFromEnv("chart-container");

          switch (i = i || (0, r.getMouseCoordinate)($, o), e) {
            case "dragstart":
              m = (d = y[a]).config, w = d._yPos, R = d._xPos, B = m.allowDrag, S = i.chartY, O = i.chartX, B && S >= w - V && S <= w + V && O <= R + V && O >= R - V ? (m.dragStart = !0, m._pointerDy = 0, m._dragStartY = S, m._dragBuffer = w - S, d.dragged = !0, d.startValue = m.setValue, d.name = l.seriesname, d.datasetIndex = l.index, D = {
                dataIndex: NaN,
                datasetIndex: d.datasetIndex,
                startValue: d.startValue,
                datasetName: d.name
              }, m.dragStart = !0) : m.dragStart = !1;
              break;

            case "dragmove":
              (m = (d = y[a]).config).dragStart && (S = i.chartY, m.allowDrag && (A.cursor = g), f = d.graphics.element, m._pointerDy++, G = d.graphics.image, R = d._xPos, U = f, S += m._dragBuffer, N = m.allowNegDrag ? h : M, q = (L = m.anchorProps).startAngle || 90, K = m.hoverEffects, J = m.hoverEffects && m.hoverEffects.enabled, L.imageUrl, S < p ? S = p : S > N && (S = N), d._yPos = w = S, m._y = x = m.setValue = E.getValue(w), m._Py = E.getPixel(m._y), k = b.dataLabels(x), m.toolTipValue = k, m.displayValue = k, this.parseLabelAttributes(d, void 0), this.drawLabel(void 0, NaN), d.graphics.element = f, v.hide(l.currentToolTip), J && (C = U.data("setRolloverAttr")) && (C.path = (0, r.polyPathToPath)([K.anchorSides || 2, R, w, K.anchorRadius, K.startAngle, K.dip])), J && (j = U.data("setRolloutAttr")) && (j.path = (0, r.polyPathToPath)([L.symbol[1] || 2, R, w, L.radius, L.startAngle, m.dip || 0])), U && U.attr(j || {
                path: (0, r.polyPathToPath)([L.symbol[1] || 2, R, w, L.radius, q, 0])
              }), G && t.updateImage(d), Q && this.drawCommonElements(), P && (l = this.config, H = m.pathStartIndex, W = m.pathEndIndex, z = m.lastPath, z = this.getLinePath(y, {
                begin: H,
                end: W
              }), P.attr({
                path: z.getPathArr()
              })), 1 === m._pointerDy && (D = {
                dataIndex: a,
                datasetIndex: s,
                startValue: d.startValue,
                datasetName: d.name
              }, c.fireChartInstanceEvent("dataplotDragStart", D)));
              break;

            case "dragend":
              (m = (d = y[a]).config).dragStart && (this.setMaxMin(d), D = {
                dataIndex: a,
                datasetIndex: s,
                startValue: d.startValue,
                endValue: m.setValue,
                datasetName: d.name
              }, Y = [c.getFromEnv("chartInstance").id, D.dataIndex, D.datasetIndex, D.datasetName, D.startValue, D.endValue], f && n.updateDataValue.call(f, o, c), m._pointerDy && (c.fireChartInstanceEvent("dataplotDragEnd", D), c.fireChartInstanceEvent("chartupdated", D, Y)), void 0 !== (F = (0, r.getValidValue)((0, r.parseUnsafeString)((0, r.pluck)(d.tooltext, Z.plottooltext, X.plottooltext)))) && (T.formattedValue = m.toolTipValue, T.label = m.label, I = (0, r.parseTooltext)(F, [1, 2, 3, 4, 5, 6, 7], T, {
                value: m.toolTipValue
              }, void 0, Z), m.setTooltext = I, F = I, m.toolText = I), I = m.finalTooltext = !1 !== m.toolText ? F || m.toolText.substring(0, m.toolText.indexOf(m.formatedVal)) + m.toolTipValue : "", S >= w - V && S <= w + V && O <= R + V && O >= R - V || (A.cursor = "default"), m._dragBuffer = 0, m._pointerDy = 0, m.dragStart = !1);
          }
        }, t.prototype._firePlotEvent = function (e, t, o) {
          var a,
              n,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              d,
              m,
              b,
              y,
              x = this.config,
              k = this.getFromEnv("chart"),
              w = this.getFromEnv("chartConfig").drawTrendRegion,
              C = this.getFromEnv("paper"),
              N = this.getFromEnv("toolTipController"),
              S = C.canvas.style,
              A = this.components.data[t],
              E = x.currentToolTip,
              D = o.originalEvent;
          if ("touchend" === e && (b = D.changedTouches[0], D.pageX = b && b.pageX, D.pageY = b && b.pageY), i = (n = (0, r.getMouseCoordinate)(k.getFromEnv("chart-container"), D)).chartY, l = n.chartX, A) switch (u = A.graphics.element, y = (m = A.config).anchorProps, h = m.finalTooltext, p = m.hoverEffects.enabled, d = m.eventArgs, s = A._yPos, c = A._xPos, m.dragTolerance = m.dragTolerance < y.markerRadius ? y.markerRadius + .5 : m.dragTolerance, a = v(m.dragTolerance, m.hoverEffects.anchorRadius || 0) + 1, e) {
            case "fc-mouseover":
              m.allowDrag && (S.cursor = g), m.dragStart || !h || m.dragStart || w || (E ? N.draw(D, h, E) : E = x.currentToolTip = N.draw(D, h)), m.dragStart || (p && this._hoverPlotAnchor(A, "DataPlotRollOver"), u && k.plotEventHandler(u, o, "DataPlotRollOver", d));
              break;

            case "fc-mouseout":
              S.cursor = "default", p && this._hoverPlotAnchor(A, f), u && k.plotEventHandler(u, o, f, d), N.hide(x.currentToolTip);
              break;

            case "fc-mousemove":
              !m.dragStart && h && i >= s - a && i <= s + a && l <= c + a && l >= c - a ? (m.allowDrag && (S.cursor = g), E ? N.draw(D, h, E) : E = x.currentToolTip = N.draw(D, h)) : N.hide(x.currentToolTip);
              break;

            case "fc-click":
              u && k.plotEventHandler(u, o, "dataplotclick", d);
          }
        }, t.prototype.restore = function () {
          n._restore.call(this);
        }, t.prototype.getJSONData = function () {
          return n._getJSONData.call(this);
        }, t;
      }(a["default"]);

      t._updateImage = u = b.prototype.updateImage, t.__firePlotEvent = h = b.prototype._firePlotEvent, t.configurer = p = b.prototype.configureAttributes, t._drag = d = b.prototype.drag, t.__firePlotEvent = h, t.configurer = p, t._updateImage = u, t._drag = d, t["default"] = b;
    },
    877: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(451),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = {
        "*.dataset.dragArea": n["default"]["*.dataset.area"]
      };
    },
    878: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(452),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = {
        "*.dataset.dragLine": n["default"]["*.dataset.line"]
      };
    },
    879: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = l(o(862)),
          r = l(o(876)),
          n = o(125),
          i = o(551);

      function l(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var c = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return s(t, e), t.prototype.getName = function () {
          return "DragArea";
        }, t.getName = function () {
          return "DragArea";
        }, t.prototype.getDSGroupdef = function () {}, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          i._setDefaultConfig.call(this), t.isDrag = !0, t.anchoralpha = n.HUNDREDSTRING, t.enablemousetracking = !0, t.defaultcrosslinethickness = 1;
        }, t.prototype.getDSdef = function () {
          return r["default"];
        }, t;
      }(a["default"]);

      t["default"] = c;
    },
    880: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(881),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    881: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = i(o(882)),
          r = i(o(885)),
          n = o(125);

      function i(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function l(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var s = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return l(t, e), t.getName = function () {
          return "Kagi";
        }, t.prototype.getName = function () {
          return "Kagi";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.friendlyName = "Kagi Chart", t.singleseries = !0, t.hasLegend = !1, t.defaultDatasetType = "kagi", t.setAdaptiveMin = !0, t.anchorborderthickness = 1, t.anchorimageurl = void 0, t.anchorimagepadding = 1, t.anchorsides = 1, t.anchoralpha = void 0, t.anchorbgalpha = "100", t.anchorimagealpha = "100", t.anchorimagescale = 100, t.anchorstartangle = 90, t.anchorshadow = 0, t.anchorbgcolor = void 0, t.anchorbordercolor = void 0, t.anchorradius = 3, t.showvalues = 1, t.plotfillalpha = "70", t.linedashlen = 5, t.linedashgap = 4, t.linedashed = void 0, t.linealpha = "100", t.linethickness = 2, t.drawfullareaborder = 1, t.connectnulldata = 0, t.zeroplanethickness = 1, t.enablemousetracking = !0, t.zeroplanealpha = 40, t.showzeroplaneontop = 0;
        }, t.prototype._getDataset = function () {
          var e = [];
          return this.iterateComponents(function (t) {
            t.getType && "dataset" === t.getType() && e.push(t);
          }), e;
        }, t.prototype._postSpaceManagement = function () {
          var e,
              t = this.config,
              o = this.getChildren("xAxis")[0],
              a = this.getChildren("yAxis")[0],
              r = this.getChildren("canvas")[0],
              i = r.config,
              l = i.canvasBorderWidth,
              s = (0, n.pluckNumber)(i.canvasPadding, 15),
              c = i.canvasPaddingTop,
              u = i.canvasPaddingBottom,
              p = i.canvasPaddingLeft,
              h = i.canvasPaddingRight,
              d = this.getFromEnv("dataSource").chart,
              f = this._getDataset()[0].config,
              g = f && f.shiftCount,
              m = (0, n.pluckNumber)(o.getAxisConfig("axisMinValue"), 0),
              v = (0, n.pluckNumber)(o.getAxisConfig("axisMaxValue"), g - 1),
              b = this.config.canvasWidth,
              y = (0, n.pluckNumber)(d.maxhshiftpercent, 10),
              x = b - 2 * s;

          a && a.setAxisDimention({
            x: t.canvasLeft - l,
            y: t.canvasTop + c,
            opposite: t.canvasRight + l,
            axisLength: t.canvasHeight - c - u
          }), this._setPosition(), f && (y = y <= 0 ? 10 : y, e = f.xShiftLength = Math.min(x / g, y * x / 100), v = Math.max(v, 1)), r.setCanvasPadding(), o && o.setAxisConfig({
            canvasPaddingLeft: Math.max(p, s) + e / 2,
            canvasPaddingRight: Math.max(h, s) + e / 2
          }), o && o.setAxisDimention({
            x: this.config.canvasLeft + s + e / 2,
            axisLength: e * (v - m),
            y: t.canvasBottom + (t.shift || 0) + l,
            opposite: t.canvasTop - l
          }), this.allocateDimensionOfChartMenuBar();
        }, t.prototype._setPosition = function () {
          var e,
              t,
              o,
              a,
              r,
              i,
              l,
              s,
              c = this.getFromEnv("dataSource"),
              u = this._getDataset()[0],
              p = c.data || u && u[0] && u[0].data,
              h = u.components.data,
              d = h && h.length,
              f = this.getChildren("yAxis")[0],
              g = 0,
              m = g,
              v = [];

          for (e = 0; e < d; e++) {
            o = (t = h[e].config).setValue, (c = h[e]) || (c = h[e] = {
              graphics: {}
            }), t.isDefined || (o = t.plotValue), o = (0, n.pluck)(t.plotValue, o), t.plotY = (0, n.toPrecision)(f.getPixel(t.setValue), 2), t.graphY = o && (0, n.toPrecision)(f.getPixel(o), 2), t.plotX = m, t.isShift ? (m = g += 1, p && v.push(p[e])) : e === d - 1 && p && v.push(p[e]), e && (s = h[e - 1].config, a = t && t.objParams && t.objParams.isRally, r = t && t.objParams && t.objParams.lastHigh, i = t && t.objParams && t.objParams.lastLow, l = t && t.objParams && t.objParams.isRallyInitialised, s && l && s.isRally !== t.isRally ? (t.isChanged = !0, t.ty = (0, n.toPrecision)(f.getPixel(a ? r : i), 2)) : t.isChanged = !1);
          }
        }, t.prototype.getDSdef = function () {
          return r["default"];
        }, t;
      }(a["default"]);

      t["default"] = s;
    },
    882: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = n(o(359)),
          r = n(o(883));

      function n(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function i(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var l = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return i(t, e), t.getName = function () {
          return "WaterFall2D";
        }, t.prototype.getName = function () {
          return "WaterFall2D";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.friendlyName = "Waterfall Chart", t.singleseries = !0, t.hasLegend = !1, t.defaultDatasetType = "Waterfall2D", t.enablemousetracking = !0;
        }, t.prototype.getDSdef = function () {
          return r["default"];
        }, t;
      }(a["default"]);

      t["default"] = l;
    },
    883: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = o(125),
          r = l(o(432)),
          n = o(132),
          i = l(o(884));

      function l(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      (0, n.addDep)({
        name: "waterFall2DAnimation",
        type: "animationRule",
        extension: i["default"]
      });

      var c = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return s(t, e), t.prototype.getType = function () {
          return "dataset";
        }, t.prototype.getName = function () {
          return "waterFall2D";
        }, t.prototype.configure = function (e) {
          if (!e) return !1;
          this.trimData(e), this.config.JSONData = e;

          var t,
              o,
              r,
              n,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              d,
              f,
              g,
              m,
              v,
              b,
              y,
              x,
              k,
              w,
              C,
              N,
              S,
              A,
              E,
              D,
              _,
              T,
              L,
              P,
              O,
              V,
              M,
              F,
              I,
              B,
              R,
              j,
              G,
              H,
              W,
              z,
              U,
              J,
              K,
              q,
              Y,
              X,
              Q,
              Z,
              $,
              ee,
              te,
              oe,
              ae,
              re,
              ne,
              ie,
              le = this.getFromEnv("chart"),
              se = this.config,
              ce = this.config.JSONData,
              ue = ce.data,
              pe = ue && ue.length,
              he = this.getFromEnv("xAxis").getTicksLen(),
              de = Math.min(he, pe),
              fe = le.getFromEnv("dataSource").chart,
              ge = this.getFromEnv("color-manager"),
              me = this.index || this.positionIndex,
              ve = ge.getPlotColor(me),
              be = (0, a.pluckNumber)(ce.dashed, fe.plotborderdashed),
              ye = (0, a.pluckNumber)(fe.useplotgradientcolor, 1),
              xe = (0, a.pluckNumber)(fe.showtooltip, 1),
              ke = (0, a.parseUnsafeString)(fe.yaxisname),
              we = (0, a.parseUnsafeString)(fe.xaxisname),
              Ce = (0, a.parseUnsafeString)((0, a.pluck)(fe.tooltipsepchar, ", ")),
              Ne = this.components.data,
              Se = this.getFromEnv("number-formatter"),
              Ae = {},
              Ee = Ae.dataObj || (Ae.dataObj = {}),
              De = Ee.chart || (Ee.chart = {}),
              _e = (0, a.pluck)(fe.connectorthickness, 1),
              Te = -Infinity,
              Le = Infinity,
              Pe = 0,
              Oe = 0,
              Ve = 0;

          for (this.setState("visible", 1 === (0, a.pluckNumber)(ce.visible, !Number(ce.initiallyhidden), 1)), r = se.showplotborder = (0, a.pluckNumber)(fe.showplotborder, 1), se.plotBorderThickness = h = r ? (0, a.pluckNumber)(fe.plotborderthickness, 1) : 0, se.isRoundEdges = d = (0, a.pluckNumber)(fe.useroundedges, 0), se.plotBorderAlpha = y = r ? (0, a.pluck)(fe.plotborderalpha, m, "100") : 0, se.plotBorderColor = x = (0, a.pluck)(fe.plotbordercolor, ge.getColor("plotBorderColor").split(",")[0]), se.plotgradientcolor = b = ye ? (0, a.getDefinedColor)(fe.plotgradientcolor, ge.getColor("plotGradientColor")) : "", se.plotDashLen = u = (0, a.pluckNumber)(fe.plotborderdashlen, 6), se.plotDashGap = p = (0, a.pluckNumber)(fe.plotborderdashgap, 3), se.use3DLighting = (0, a.pluckNumber)(fe.use3dlighting, 1), se.showSum = Y = (0, a.pluckNumber)(fe.showsumatend, 1), se.plotColor = ve = (0, a.pluck)(ce.color, ve), se.plotfillAngle = g = (0, a.pluckNumber)(360 - fe.plotfillangle, 90), se.showShadow = d ? (0, a.pluckNumber)(fe.showshadow, 1) : (0, a.pluckNumber)(fe.showshadow, ge.getColor("showShadow")), se.showHoverEffect = f = (0, a.pluckNumber)(fe.plothovereffect, fe.showhovereffect, void 0), se.plotFillAlpha = m = (0, a.pluck)(ce.alpha, fe.plotfillalpha, "100"), se.plotRadius = (0, a.pluckNumber)(fe.useRoundEdges, se.isRoundEdges ? 1 : 0), se.plotFillRatio = v = (0, a.pluck)(ce.ratio, fe.plotfillratio), se.plotBorderDashStyle = w = be ? (0, a.getDashStyle)(u, p) : "none", se.showValues = (0, a.pluckNumber)(ce.showvalues, fe.showvalues, 1), se.valuePadding = (0, a.pluckNumber)(fe.valuepadding, 2), se.enableAnimation = W = (0, a.pluckNumber)(fe.animation, fe.defaultanimation, 1), se.animation = !!W && {
            duration: 1e3 * (0, a.pluckNumber)(fe.animationduration, 1)
          }, De.transposeAnimation = se.transposeAnimation = (0, a.pluckNumber)(fe.transposeanimation, De.transposeAnimation, W), se.transposeAnimDuration = 1e3 * (0, a.pluckNumber)(fe.transposeanimduration, .2), se.showTooltip = (0, a.pluckNumber)(fe.showtooltip, 1), se.stack100Percent = (0, a.pluckNumber)(le.stack100percent, fe.stack100percent, 0), se.definedGroupPadding = Math.max((0, a.pluckNumber)(fe.plotspacepercent), 0), se.plotSpacePercent = Math.max((0, a.pluckNumber)(fe.plotspacepercent, 20) % 100, 0), se.maxColWidth = (0, a.pluckNumber)(fe.maxcolwidth, 50), se.showPercentValues = (0, a.pluckNumber)(fe.showpercentvalues, 0), se.showPercentInToolTip = (0, a.pluckNumber)(fe.showpercentintooltip, 0), se.plotPaddingPercent = (0, a.pluckNumber)(fe.plotpaddingpercent), se.rotateValues = (0, a.pluckNumber)(fe.rotatevalues) ? 270 : 0, se.placeValuesInside = (0, a.pluckNumber)(fe.placevaluesinside, 0), se.parentYAxis = z = "s" === (0, a.pluck)(ce.parentyaxis && ce.parentyaxis.toLowerCase(), "p") ? 1 : 0, se.defaultPadding = {
            left: .5,
            right: .5
          }, this.setState("dirty", !0), Ne || (Ne = this.components.data = []), se.zLine = te = {
            step: !0,
            data: [],
            dashStyle: "1" === fe.connectordashed ? (0, a.getDashStyle)((0, a.pluckNumber)(fe.connectordashlen, 2), (0, a.pluckNumber)(fe.connectordashgap, 2)) : "none",
            useForwardSteps: !0,
            color: (0, a.convertColor)((0, a.pluck)(fe.connectorcolor, "000000"), (0, a.pluck)(fe.connectoralpha, 100)),
            lineWidth: _e
          }, q = 0; q < de; q += 1) {
            C = ue[q], Z = Se.getCleanValue(C.value), ee = (0, a.pluckNumber)(C.issum, 0), C.vline || ee ? delete C._value : (Pe += Z, C._value = Z);
          }

          for ($ = Se.dataLabels(Pe), Y && (Y = !0, de += 1, re = {
            label: (0, a.getFirstValue)(fe.sumlabel, "Total"),
            _value: Pe,
            value: Pe,
            issum: 1,
            cumulative: 1
          }), q = 0, ne = 0; q < de; q += 1) {
            C = ue[q], A = (S = Ne[q]) && S.config, S || (S = Ne[q] = {
              graphics: {}
            }), S.config || (A = Ne[q].config = {}), !C && Y && (C = ue[q] = re), ve = (0, a.pluck)(C.color, ge.getPlotColor(q)), S.vline || (Z = C._value, delete C._value, A.issum = ee = (0, a.pluckNumber)(C.issum, 0), ae = A.isCumulative = (0, a.pluckNumber)(C.cumulative, 1), ee ? (Z = ae ? Oe : Oe === Ve ? Oe : Oe - Ve, A.lastComTotal = Ve, Ve = Oe, te.data.push({
              y: null,
              x: ne - .5
            })) : Oe += Z, Te = Math.max(Te, Oe), Le = Math.min(Le, Oe), A.total = Oe, Q = A.showLabel = (0, a.pluckNumber)(C.showlabel, fe.showlabels, 1), X = A.dataLabel = (0, a.parseUnsafeString)(Q ? (0, a.getFirstValue)(C.label, C.name) : ""), Z > 0 ? (oe = (0, a.pluck)(C.color, fe.positivecolor, ve), 0 !== f && (D = (0, a.pluck)(C.positivehovercolor, fe.positivehovercolor, fe.plotfillhovercolor, fe.columnhovercolor, oe))) : (oe = (0, a.pluck)(C.color, fe.negativecolor, ve), 0 !== f && (D = (0, a.pluck)(C.negativehovercolor, fe.negativehovercolor, fe.plotfillhovercolor, fe.columnhovercolor, oe))), ie = Z < 0 ? 360 - g : g, m = (0, a.pluck)(C.alpha, se.plotFillAlpha), U = (0, a.pluckNumber)(C.dashed, be), J = (0, a.pluckNumber)(C.dashlen, u), K = p = (0, a.pluckNumber)(C.dashgap, p), A.showValue = (0, a.pluckNumber)(C.showvalue, se.showValues), A.setValue = N = Z, A.setLink = (0, a.pluck)(C.link), A.toolTipValue = G = Se.dataLabels(N, z), A.setDisplayValue = H = (0, a.getValidValue)((0, a.parseUnsafeString)(C.displayvalue)), A.displayValue = (0, a.pluck)(H, G), A.plotBorderDashStyle = k = 1 === U ? (0, a.getDashStyle)(J, K) : 0 === U ? "none" : w, A.shadow = {
              opacity: se.showShadow ? m / 100 : 0
            }, A.colorArr = E = (0, a.getColumnColor)(oe + "," + b.replace(/,+?$/, ""), m, v, ie, d, x, y.toString(), 0, !1), 0 !== f && (_ = (0, a.pluck)(C.alpha, C.hoveralpha, ce.hoveralpha, fe.plotfillhoveralpha, fe.columnhoveralpha, m), !(T = (0, a.pluck)(C.hovergradientcolor, ce.hovergradientcolor, fe.plothovergradientcolor, b)) && (T = ""), L = (0, a.pluck)(C.hoverratio, ce.hoverratio, C.ratio, fe.plothoverratio, v), P = (0, a.pluckNumber)(360 - C.hoverangle, 360 - ce.hoverangle, 360 - fe.plothoverangle, ie), O = (0, a.pluck)(C.borderhovercolor, ce.borderhovercolor, fe.plotborderhovercolor, x), V = (0, a.pluck)(C.borderhoveralpha, ce.borderhoveralpha, fe.plotborderhoveralpha, y, m), M = (0, a.pluckNumber)(C.borderhoverthickness, ce.borderhoverthickness, fe.plotborderhoverthickness, h), F = (0, a.pluckNumber)(C.borderhoverdashed, ce.borderhoverdashed, fe.plotborderhoverdashed), I = (0, a.pluckNumber)(C.borderhoverdashgap, ce.borderhoverdashgap, fe.plotborderhoverdashgap, u), B = (0, a.pluckNumber)(C.borderhoverdashlen, ce.borderhoverdashlen, fe.plotborderhoverdashlen, p), R = F ? (0, a.getDashStyle)(B, I) : k, 1 === f && D === ve && (D = (0, a.getLightColor)(D, 70)), j = (0, a.getColumnColor)(D + "," + T, _, L, P, d, O, V.toString(), 0, !1), A.setRolloutAttr = {
              fill: (0, a.toRaphaelColor)(E[0]),
              stroke: r && (0, a.toRaphaelColor)(E[1]),
              "stroke-width": h,
              "stroke-dasharray": k
            }, A.setRolloverAttr = {
              fill: (0, a.toRaphaelColor)(j[0]),
              stroke: r && (0, a.toRaphaelColor)(j[1]),
              "stroke-width": M,
              "stroke-dasharray": R
            }), n = A.toolTipValue, A.origToolText = l = (0, a.getValidValue)((0, a.parseUnsafeString)((0, a.pluck)(C.tooltext, ce.plottooltext, fe.plottooltext))), xe ? void 0 !== l ? (s = [1, 2, 3, 5, 6, 7, 20, 21, 24, 25], i = {
              formattedValue: n,
              label: X,
              yaxisName: ke,
              xaxisName: we,
              cumulativeValue: Oe,
              cumulativeDataValue: Se.dataLabels(Oe),
              sum: $,
              unformattedSum: Pe
            }, c = (0, a.parseTooltext)(l, s, i, C, fe, ce)) : c = null !== n && ("" !== X ? X + Ce : "") : c = !1, te.data.push({
              y: null === Z ? null : Oe,
              x: ne
            }), ne += 1, A.originalPlotColor = ve, A.toolText = c, A.setTooltext = c, A._x = q, A._y = N);
          }

          for (se.maxValue = Te, se.minValue = Le, se.connectNullData = (0, a.pluckNumber)(fe.connectnulldata, 0), se.showConnectors = (0, a.pluckNumber)(fe.showconnectors, 1), t = ce.catData, q = 0; q < t.length; q += 1) {
            o = t[q], ue.splice(o.index, 0, o.data);
          }

          this.getFromEnv("xAxis").setTickValues(ue), this.config.maxminFlag = !1;
        }, t.prototype.createCoordinates = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              i,
              l,
              s = this.components.data,
              c = this.getFromEnv("chart").isBar,
              u = this.getFromEnv("yAxis"),
              p = this.getFromEnv("xAxis"),
              h = u.getAxisBase(),
              d = u.getPixel(h),
              f = p.config.isVertical,
              g = this.getFromEnv("chartConfig"),
              m = g.xDepth || 0,
              v = g.yDepth || 0,
              b = s.length,
              y = this.components,
              x = this.groupManager,
              k = x && x.stackConf,
              w = y.data;

          for (!c && (m = -m), c && (v = -v), a = 0; a < b; a++) {
            t = (e = w[a]) && e.config, void 0 !== e && (l = t._y, t.issum ? t.isCumulative ? o = null : (o = t.lastComTotal, l += t.lastComTotal) : (o = w[a - 1] && w[a - 1].config.total) && (l += o), r = p.getPixel(k && k[a].x || t._x) + m, n = u.getPixel(l) + v, i = (o ? u.getPixel(o) : d) + v, f ? (t._Px = n, t._Py = r, t._Pby = r, t._Pbx = i) : (t._Px = r, t._Py = n, t._Pby = i, t._Pbx = r));
          }
        }, t.prototype.getDataLimits = function () {
          var e,
              t,
              o = this.components.data,
              a = this.config,
              r = o.length,
              n = -Infinity,
              i = +Infinity;

          for (e = 0; e < r; e++) {
            o[e] && void 0 !== (t = o[e].config.total) && (n = Math.max(n, t), i = Math.min(i, t));
          }

          return a.maxValue = n, a.minValue = i, {
            max: a.maxValue,
            min: a.minValue
          };
        }, t.prototype.drawPlots = function (t) {
          e.prototype.drawPlots.call(this, t), this.config.showConnectors ? this.drawLine() : this.getContainer("commonElemsGroup").hide();
        }, t.prototype.drawLine = function () {
          var e,
              t,
              o,
              r,
              n,
              i,
              l,
              s,
              c = this.config,
              u = this.getFromEnv("xAxis"),
              p = this.getFromEnv("yAxis"),
              h = p.getAxisBase(),
              d = p.getPixel(h),
              f = this.getContainer("commonElemsGroup"),
              g = this.getFromEnv("columnWidth") / 2,
              m = this.getFromEnv("animationManager"),
              v = c.zLine,
              b = c.connectNullData,
              y = v.data,
              x = y.length,
              k = this._graphics,
              w = v.dashStyle,
              C = v.color,
              N = v.lineWidth,
              S = k.zLine,
              A = null,
              E = [],
              D = [];

          for (p.yBasePos = d, f.toFront().show(), e = 0; e < x; e += 1) {
            null === (n = (r = y[e]).y) ? (D.length = 0, 0 === b && (A = null)) : (i = (0, a.pluckNumber)(r.x, e), t = p.getPixel(n), o = u.getPixel(i), o = (0, a.getCrispValue)(o, N, N).position, t = (0, a.getCrispValue)(t, N, N).position, null !== A ? (D.length && (E = E.concat(D), D.length = 0), E.push("M", l, A, "m", -g, 0, "H", o, "h", g, "m", 0, t - A)) : D.push("M", o, t), l = o, A = t);
          }

          s = m.setAnimation({
            el: S || "path",
            attr: {
              path: E,
              "stroke-linecap": "round",
              "stroke-opacity": 1,
              "stroke-dasharray": w,
              stroke: C,
              "stroke-linejoin": N >= 2 ? "round" : "miter",
              "stroke-width": N
            },
            container: f,
            component: this,
            label: "path"
          }), S || this.addGraphicalElement("zLine", s);
        }, t;
      }(r["default"]);

      t["default"] = c;
    },
    884: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(433),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = {
        "initial.dataset.waterFall2D": n["default"]["initial.dataset.column"]
      };
    },
    885: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = l(o(449)),
          r = o(125),
          n = o(132),
          i = l(o(886));

      function l(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var c = function c(e) {
        return void 0 !== e && null !== e;
      },
          u = "M",
          p = r.hasTouch ? r.TOUCH_THRESHOLD_PIXELS : r.CLICK_THRESHOLD_PIXELS;

      (0, n.addDep)({
        name: "kagiAnimation",
        type: "animationRule",
        extension: i["default"]
      });

      var h = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.manageSpace = function () {}, o.drawCommonElements = function () {}, o;
        }

        return s(t, e), t.prototype.getType = function () {
          return "dataset";
        }, t.prototype.getName = function () {
          return "kagi";
        }, t.prototype._parseShadowOptions = function () {
          var e = this.getFromEnv("chart"),
              t = this.config,
              o = e.getFromEnv("dataSource").chart;
          return {
            opacity: (0, r.pluckNumber)(o.showshadow, 1) ? t.alpha / 100 : 0
          };
        }, t.prototype.configureAttributes = function (t) {
          e.prototype.configureAttributes.call(this, t);

          var o,
              a,
              n,
              i,
              l,
              s,
              u,
              p,
              h,
              d,
              f,
              g,
              m,
              v,
              b,
              y,
              x,
              k,
              w,
              C,
              N,
              S,
              A,
              E,
              D,
              _,
              T,
              L,
              P,
              O,
              V,
              M,
              F,
              I,
              B,
              R,
              j,
              G,
              H = this.getFromEnv("chart"),
              W = this.getFromEnv("xAxis"),
              z = 0,
              U = [],
              J = 0;

          for (o = this.components, n = o.data, i = this.config, l = this.config.JSONData.data, s = H.getFromEnv("dataSource").chart, u = i.maxValue, p = i.minValue, a = o.removeDataArr || (o.removeDataArr = []), h = !1, d = 0, f = (0, r.pluckNumber)(s.reversalvalue, -1), g = (0, r.pluckNumber)(s.reversalpercentage, 5), C = 0; C < n.length; C += 1) {
            n[C].config.__nullCount = J, null === n[C].config.setValue && (a.push(n.splice(C, 1)[0]), J++, C -= 1);
          }

          if (n.length) {
            for (i.rallyColor = (0, r.pluck)(s.rallycolor, "FF0000"), i.rallyAlpha = (0, r.pluckNumber)(s.rallyalpha, s.linealpha, 100), i.declineColor = (0, r.pluck)(s.declinecolor, "0000FF"), i.declineAlpha = (0, r.pluckNumber)(s.declinealpha, s.linealpha, 100), i.canvasPadding = (0, r.pluckNumber)(s.canvaspadding, 15), i.maxHShiftPercent = (0, r.pluckNumber)(s.maxhshiftpercent, 10), i.rallyThickness = (0, r.pluckNumber)(s.rallythickness, s.linethickness, 2), m = (0, r.pluckNumber)(s.rallydashlen, s.linedashlen, 5), v = (0, r.pluckNumber)(s.rallydashgap, s.linedashgap, 4), i.declineThickness = (0, r.pluckNumber)(s.declinethickness, s.linethickness, 2), b = (0, r.pluckNumber)(s.declinedashlen, s.linedashlen, 5), y = (0, r.pluckNumber)(s.declinedashgap, s.linedashgap, 4), i.lineDashed = {
              "true": (0, r.pluckNumber)(s.rallydashed, s.linedashed, 0),
              "false": (0, r.pluckNumber)(s.declinedashed, s.linedashed, 0)
            }, i.rallyDashed = (0, r.pluckNumber)(s.rallydashed, s.linedashed, 0) ? (0, r.getDashStyle)(m, v) : "none", i.declineDashed = (0, r.pluckNumber)(s.declinedashed, s.linedashed, 0) ? (0, r.getDashStyle)(b, y) : "none", i.canvasPadding = (0, r.pluckNumber)(s.canvaspadding, this.canvasPadding, 15), f = f > 0 ? f : g * (u - p) / 100, x = n[0].config.setValue, k = function k(e, t) {
              for (var o, a = 1, r = n[0].config.setValue; a < e;) {
                o = n[a].config.setValue, t ? o <= r && (n[a].config.isDefined = !1) : o >= r && (n[a].config.isDefined = !1), a += 1;
              }

              n[0].config.vAlign = t ? "bottom" : "top", n[0].config.align = "center";
            }, w = l.length, C = 0, N = 0; N < w; N += 1, C += 1) {
              if ((!(S = l[N]) || !S.vline) && (_ = n[C] && n[C].config, A && (A = !1), _ && (_.isDefined = !0), C && _)) {
                if (_.isShift = void 0, E = n[C - 1].config, _.vAlign = "middle", _.align = "right", _.showLabel = !1, D = null, P = _.setValue, T = n[C + 1] && n[C + 1].config.setValue, L = Math.abs(x - P), h ? P < V && O ? O = !1 : P > M && !O && (O = !0) : (P > x && L > f ? (V = x, M = null, F = !0, h = !0, k(C, O = !0)) : P < x && L > f ? (V = null, M = x, F = !1, h = !0, k(C, O = !1)) : (O = null, F = null, h = !1), c(E) && (E.isRally = O), null !== O && (n[0].config.isRally = O)), _.isRally = O, (F && P < x || !F && P > x) && (D = x), B = D || P, L = Math.abs(B - T), I = null === F ? null : F ? B > T && L >= f : B < T && L >= f, E && E.isShift) for (F ? (V = x, j = "bottom") : F || (M = x, j = "top"), G = "center", R = C; R > 1; R -= 1) {
                  if (n[R].y == x) {
                    n[R].vAlign = j, n[R].align = G, n[R].showLabel = !0;
                    break;
                  }
                }
                I ? (d += 1, A = !0, F = !F, _.isShift = !0, x = B, U.push(l[C + _.__nullCount]), z = this._appendCategory(z, C, U, 0)) : F && P > x || !F && P < x ? x = P : D = x, _.plotValue = D, _.objParams = {
                  isRally: O,
                  lastHigh: M,
                  lastLow: V,
                  isRallyInitialised: h
                };
              }
            }

            this._appendCategory(z, C, U, 1), U.push(S), W.setTickValues(U), i.shiftCount = d + 1;
          }
        }, t.prototype._appendCategory = function (e, t, o, a) {
          var n,
              i,
              l,
              s,
              c = this.config.JSONData.catData;
          if (e < c.length) for (n = e; n < c.length; e = n += 1) {
            if (l = (i = c[n]).data, (s = i.index - (n + 1)) < t) l.lineposition = (0, r.pluckNumber)(l.lineposition, a);else if (s > t) break;
            o.push(l);
          }
          return e;
        }, t.prototype._getHoveredPlot = function (e, t) {
          var o,
              a,
              r,
              n,
              i,
              l,
              s = this.getFromEnv("xAxis"),
              c = this.config,
              u = c.trackIndex,
              p = this.components.data,
              h = p.length;

          for (e += s.getTranslation(), i = Math.floor(Math.max(s.getValue(e - c.maxRadius), 0)), a = Math.ceil(Math.min(s.getValue(e + c.maxRadius), h - 1)); a >= i; a--) {
            for (o = h = (l = u[a]) && l.length; o >= 0; o--) {
              if (r = l[o], n = this.isWithinShape(p[r], r, e, t)) return n;
            }
          }
        }, t.prototype.getClip = function (e) {
          var t = this.getFromEnv("chart").getChildren("canvas")[0].config,
              o = [t.canvasLeft, t.canvasTop, 0, t.canvasTop + t.canvasHeight];
          return o[2] += "init" === e ? 0 : t.canvasLeft + t.canvasWidth, o;
        }, t.prototype.parsePlotAttributes = function (e, t) {
          var o,
              a,
              n,
              i,
              l,
              s,
              c,
              u = t,
              h = void 0,
              d = this.config.JSONData,
              f = this.config,
              g = this.getFromEnv("xAxis"),
              m = void 0,
              v = this.components.data,
              b = void 0,
              y = void 0,
              x = void 0,
              k = void 0,
              w = void 0,
              C = {},
              N = void 0,
              S = this.getState("visible"),
              A = void 0;
          e = e.config, N = (b = v[u]).config, h = e.trackerConfig = {}, w = N.hoverEffects, l = N.setValue, s = N.displayValue, o = b._xPos = g.getPixel(e.plotX), a = b._yPos = e.plotY, b._index = e.plotX, c = (C = N.anchorProps).symbol, n = e.finalTooltext = e.toolText, i = N.setLink, void 0 !== a && !isNaN(a) && e.isDefined && ((m = e.eventArgs = e.eventArgs || {}).index = u, m.link = i, m.value = l, m.displayValue = s, m.categoryLabel = N.label, m.toolText = n, m.id = f.userID, m.datasetIndex = 0, m.datasetName = d.seriesname, m.visible = S, y = x = {}, C.imageUrl && (N.anchorImageLoaded = !1), A = {
            path: (0, r.polyPathToPath)([c[1] || 2, o, a, C.radius, C.startAngle, 0]),
            fill: (0, r.toRaphaelColor)({
              color: C.bgColor,
              alpha: C.bgAlpha
            }),
            stroke: (0, r.toRaphaelColor)({
              color: C.borderColor,
              alpha: C.borderAlpha
            }),
            "stroke-width": C.borderThickness,
            visibility: C.radius ? S : "hidden"
          }, k = Math.max(C.radius, w && w.anchorRadius || 0, p) + C.borderThickness / 2, h.trackerRadius = k, w.enabled && (x = {
            path: (0, r.polyPathToPath)([w.anchorSides || 2, o, a, w.anchorRadius, w.startAngle, w.dip]),
            fill: (0, r.toRaphaelColor)({
              color: w.anchorColor,
              alpha: w.anchorBgAlpha
            }),
            stroke: (0, r.toRaphaelColor)({
              color: w.anchorBorderColor,
              alpha: w.anchorBorderAlpha
            }),
            "stroke-width": w.anchorBorderThickness
          }, y = {
            path: (0, r.polyPathToPath)([C.sides, o, a, C.radius, C.startAngle, 0]),
            fill: (0, r.toRaphaelColor)({
              color: C.bgColor,
              alpha: C.bgAlpha
            }),
            stroke: (0, r.toRaphaelColor)({
              color: C.borderColor,
              alpha: C.borderAlpha
            }),
            "stroke-width": C.borderThickness
          }, w.attrs = {
            hoverEnabled: w.enabled,
            anchorRadius: C.radius,
            anchorHoverRadius: w.anchorRadius
          }, w.attrs.setRolloverAttr = x, w.attrs.setRolloutAttr = y, C.isAnchorHoverRadius = w.attrs.anchorRadius)), e.props = {
            element: {
              attr: A
            }
          };
        }, t.prototype.parseLabelAttributes = function (e, t) {
          var o,
              a,
              r,
              n,
              i,
              l,
              s,
              u,
              p,
              h,
              d,
              f,
              g,
              m,
              v,
              b,
              y,
              x,
              k = this.getFromEnv("chart"),
              w = k.config,
              C = this.getFromEnv("smartLabel"),
              N = k.config.dataLabelStyle,
              S = w.rotatevalues ? 270 : 0,
              A = w.canvasTop,
              E = A + w.canvasHeight,
              D = {},
              _ = {},
              T = t,
              L = this.components.data.length;
          y = (d = e && e.config) && d.setValue, void 0 !== e && void 0 !== y && null !== y && !0 !== d.labelSkip ? (t > 0 && (_ = {
            x: this.components.data[T - 1]._xPos,
            y: this.components.data[T - 1]._yPos
          }), t < L - 1 && (D = {
            x: this.components.data[T + 1]._xPos,
            y: this.components.data[T + 1]._yPos
          }), h = d.anchorProps, n = e.graphics, m = e._yPos || e.config._Py, g = e._xPos || e.config._Px, b = n.element ? n.image && .5 * n.element.attr("height") || h.radius - 3 : 0, a = w.valuepadding + 2 + b, o = d.displayValue, v = d.showValue, c(o) && "" !== o && v && (x = {
            text: o,
            fill: N.color,
            "text-bound": [N.backgroundColor, N.borderColor, N.borderThickness, N.borderPadding, N.borderRadius, N.borderDash]
          }, r = C.getOriSize(o), S ? (d._state = {
            labelWidth: r.height,
            labelHeight: r.width
          }, d._rotated = !0) : (d._state = {
            labelWidth: r.width,
            labelHeight: r.height
          }, d._rotated = !1), i = l = S ? r.width : r.height, i += a, p = .5 * l + a, s = m, u = g, i += 4, f = Number(S) >= 1 ? r.height : r.width, d._valueBelowPoint = 0, D.y > s ? _.y < s ? u -= a + 3 + .5 * f : m - i < A ? (u -= a + 3 + .5 * f, s = A + i / 2) : s -= p : _.y > s ? u -= a + 3 + .5 * f : m + i > E ? (u -= a + 3 + .5 * f, s = E - i / 2) : (s += p + 2, d._valueBelowPoint = 1), x.x = u, x.y = s), d.props = d.props || {}, d.props.label = {
            attr: x
          }) : d && delete d.labelSkip;
        }, t.prototype.allocatePosition = function () {
          var e,
              t = void 0,
              o = this,
              a = o.config,
              n = o.components.data,
              i = n && n.length,
              l = o.getFromEnv("xAxis"),
              s = o.components.data,
              c = void 0,
              p = void 0,
              h = l.getPixel(0),
              d = l.getPixel(1) - h,
              f = {
            "true": a.rallyThickness,
            "false": a.declineThickness
          },
              g = void 0,
              m = void 0,
              v = l.getPixel(0),
              b = n[0] && !!n[0].isRally,
              y = void 0,
              x = h - d / 2,
              k = void 0,
              w = void 0,
              C = void 0;

          if (a.imagesLoaded = 0, n.length) {
            if (g = a.rallyPath = [], m = a.declinePath = [], s = o.components.data = s || [], n[0].config.setValue) k = n[0].config.plotY;else for (t = 1; t < i; t += 1) {
              if (n[t].config.setValue) {
                k = n[t].config.plotY;
                break;
              }
            }

            for (b = !!n[0].config.isRally, e = Math.round(k) + f[b] % 2 / 2, b ? g.push(u, x, e, "H", v) : m.push(u, x, e, "H", v), (0, r.fcEach)(n, function (e, t) {
              e = e.config, c = s[t], p = c.config, p.setValue, (w = n[t + 1] && n[t + 1].config || {}) && (C = [u, v, k], b = e.isRally, e.isShift && (v += d, k = e.graphY, C.push("H", v), C[2] = Math.round(C[2]) + f[b] % 2 / 2, C = C.toString(), b ? g.push(C) : m.push(C), C = [u, v, k]), w.isChanged && (k = w.ty, C.push("V", k), C[1] = Math.round(C[1]) + f[!!b] % 2 / 2, C = C.toString(), b ? g.push(C) : m.push(C), C = [u, v, k]), y = w.isRally, w.graphY !== C[2] && void 0 !== w.graphY && (C.push("V", w.graphY), C[1] = Math.round(C[1]) + f[!!y] % 2 / 2, C = C.toString(), y ? g.push(C) : m.push(C)), w.graphY && (k = w.graphY)), o.parsePlotAttributes(c, t);
            }), t = 0; t < n.length; t++) {
              o.parseLabelAttributes(s[t], t);
            }
          }
        }, t.prototype.drawPlots = function () {
          var e = void 0,
              t = this,
              o = t.getGraphicalElement(),
              a = t.getFromEnv("animationManager"),
              n = t.config,
              i = n.trackIndex = {},
              l = t.components.data,
              s = void 0,
              c = void 0,
              u = t.components.data,
              p = void 0,
              h = void 0,
              d = n.shadow,
              f = void 0,
              g = {},
              m = void 0,
              v = n.rallyThickness,
              b = n.declineThickness,
              y = {
            stroke: (0, r.toRaphaelColor)({
              color: n.rallyColor,
              alpha: n.rallyAlpha
            }),
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": v,
            "stroke-dasharray": n.rallyDashed
          },
              x = {
            stroke: (0, r.toRaphaelColor)({
              color: n.declineColor,
              alpha: n.declineAlpha
            }),
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": b,
            "stroke-dasharray": n.declineDashed
          },
              k = o.rallyElem,
              w = void 0,
              C = o.declineElem,
              N = void 0,
              S = void 0,
              A = t.getContainer("commonElemsGroup"),
              E = t.getContainer("plotGroup"),
              D = t.getContainer("shadowGroup"),
              _ = void 0;

          if (!l.length) return w && w.hide(), void (N && N.hide());
          w && w.show(), N && N.show(), (0, r.fcEach)(l, function (o, r) {
            o = o.config, p = u[r], m = p.config, e = p.graphics, _ = e.image, h = m.hoverEffects, s = p._yPos, i[o.plotX] || (i[o.plotX] = []), i[o.plotX].push(r), p._index = o.plotX, g = m.anchorProps, f = g.shadow, void 0 !== s && !isNaN(s) && o.isDefined ? (g.imageUrl ? t.drawAnchorImage(p) : (_ && _.hide(), c = e.element, S = o.props.element.attr, (c = e.element = a.setAnimation({
              el: c || "path",
              attr: S,
              container: E,
              component: t,
              label: "anchor"
            })).show().shadow(f, D).data("anchorRadius", g.radius).data("anchorHoverRadius", h.anchorRadius).data("hoverEnabled", h.enabled).data("eventArgs", o.eventArgs)), h.enabled && c && c.data("anchorRadius", g.radius).data("anchorHoverRadius", h.anchorRadius).data("hoverEnabled", h.enabled).data("setRolloverAttr", h.attrs.setRolloverAttr).data("setRolloutAttr", h.attrs.setRolloutAttr).data("eventArgs", o.eventArgs)) : (e.element && e.element.hide(), _ && _.hide());
          }), y.path = n.rallyPath, (w = a.setAnimation({
            el: k || "path",
            attr: y,
            container: A,
            component: t,
            label: "line"
          })).shadow(v && d, D), k || t.addGraphicalElement("rallyElem", w), x.path = n.declinePath, (N = a.setAnimation({
            el: C || "path",
            attr: x,
            container: A,
            component: t,
            label: "line"
          })).shadow(b && d, D), C || t.addGraphicalElement("declineElem", N);
        }, t;
      }(a["default"]);

      t["default"] = h;
    },
    886: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(452),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = {
        "*.dataset.kagi": n["default"]["*.dataset.line"]
      };
    },
    887: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(882),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    888: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(889),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    889: function _(e, t, o) {
      "use strict";

      (function (e) {
        t.__esModule = !0;
        var a = o(125),
            r = c(o(534)),
            n = c(o(890)),
            i = o(132),
            l = o(865),
            s = c(o(251));

        function c(e) {
          return e && e.__esModule ? e : {
            "default": e
          };
        }

        function u(e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
            for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
              var r = o[a],
                  n = Object.getOwnPropertyDescriptor(t, r);
              n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
            }
          }(e, t));
        }

        var p = (0, i.getDep)("redraphael", "plugin"),
            h = ",",
            d = "config",
            f = "rgba(192,192,192," + (a.isIE ? .002 : 1e-6) + ")",
            g = "visible",
            m = "hidden",
            v = "round",
            b = "pointer",
            y = Math.PI / 180,
            x = "M",
            k = "L",
            w = "t";
        (0, s["default"])(p), p.addSymbol({
          resizeIcon: function resizeIcon(e, t, o) {
            var r,
                n = (0, a.pluckNumber)(o, 15) / 3,
                i = [];

            for (n < 0 && (e += (o = -o) - (n = -n) / 2, t += o - n / 2), r = 3; r > 0; r -= 1) {
              i.push(x, e - n * r, t - 3, k, e - 3, t - n * r);
            }

            return i;
          },
          closeIcon: function closeIcon(e, t, o) {
            var a = e,
                r = t,
                n = 1.3 * o,
                i = 43 * y,
                l = 48 * y,
                s = a + n * Math.cos(i),
                c = r + n * Math.sin(i),
                u = .71 * (o - 2),
                p = .71 * (o - 2),
                h = function (e, t, o, a, r, n) {
              return ["A", o, a, 0, n, r, e, t];
            }(a + n * Math.cos(l), r + n * Math.sin(l), n, n, 0, 1);

            return [x, s, c].concat(h).concat([x, e + u, t - p, k, e - u, t + p, x, e - u, t - p, k, e + u, t + p]);
          },
          configureIcon: function configureIcon(e, t, o) {
            var a = .25,
                r = .71 * (o -= 1),
                n = .71 * (o + 2),
                i = e - o,
                l = t - o,
                s = e + o,
                c = t + o,
                u = e + .5,
                p = t + .5,
                h = e - .5,
                d = t - .5,
                f = i - 2,
                g = l - 2,
                m = s + 2,
                v = c + 2,
                b = e + r,
                y = t + r,
                w = e - r,
                C = t - r,
                N = e + n,
                S = t + n,
                A = e - n,
                E = t - n;
            return [x, i, p, k, f, p, f, d, i, d, w - a, C + a, A - a, E + a, A + a, E - a, w + a, C - a, h, l, h, g, u, g, u, l, b - a, C - a, N - a, E - a, N + a, E + a, b + a, C + a, s, d, m, d, m, p, s, p, b + a, y - a, N + a, S - a, N - a, S + a, b - a, y + a, u, c, u, v, h, v, h, c, w + a, y + a, A + a, S + a, A - a, S - a, w - a, y - a, "Z"];
          },
          axisIcon: function axisIcon(e, t, o) {
            var a = .33 * (o -= 1),
                r = o / 2,
                n = e - o,
                i = t - o,
                l = e + r,
                s = t + o,
                c = e - r,
                u = t + a,
                p = t - a;
            return [x, n, i, k, l, i, l, s, n, s, x, c, u, k, l, u, x, c, p, k, l, p];
          },
          loggerIcon: function loggerIcon(e, t, o) {
            var a = (e -= o -= 1) + 2 * o,
                r = e + 2,
                n = a - 2,
                i = (t -= o) + 2,
                l = i + o,
                s = l + 2;
            return [x, e, t, k, a, t, a, i, n, i, n, l, a, l, a, s, e, s, e, l, r, l, r, i, e, i, e, t];
          }
        });

        var C = function (t) {
          function o() {
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, o);

            var e = function (e, t) {
              if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return !t || "object" != typeof t && "function" != typeof t ? e : t;
            }(this, t.call(this));

            return e.isXY = !0, e.defaultZeroPlaneHighlighted = !1, e.eiMethods = {
              getData: function getData(e) {
                var t = this.apiInstance;
                return t && t.getData(e);
              },
              restoreData: function restoreData() {
                var e = this.apiInstance;
                return e && e.restoreData();
              },
              submitData: function submitData() {
                var e = this.apiInstance;
                return e && e.submitData();
              }
            }, e;
          }

          return u(o, t), o.getName = function () {
            return "SelectScatter";
          }, o.prototype.parseChartAttr = function (e) {
            t.prototype.parseChartAttr.call(this, e), this.config.formBtnTitle = (0, a.pluck)(e.chart.submittext, e.chart.formbtntitle, "Submit"), this.config.restoreBtnTitle = (0, a.pluck)(e.chart.restoretext, e.chart.restorebtntitle, "Restore");
          }, o.prototype.getName = function () {
            return "SelectScatter";
          }, o.prototype.configureAttributes = function (e) {
            var o = this.getFromEnv("chart").config,
                r = this.getFromEnv("dataSource").chart || {};
            o.formAction = (0, a.getValidValue)(r.formaction), o.enableSubmit = (0, a.pluckNumber)(r.enablesubmit, r.showformbtn, 1) && o.formAction, o.enableRestore = (0, a.pluckNumber)(r.enablerestore, r.showrestorebtn, 1), t.prototype.configureAttributes.call(this, e);
          }, o.prototype.__setDefaultConfig = function () {
            t.prototype.__setDefaultConfig.call(this);

            var e = this.config;
            e.friendlyName = "Dragable Scatter Chart", e.hasLegend = !0, e.defaultDatasetType = "selectScatter", e.allowreversexaxis = !0, e.enablemousetracking = !0;
          }, o.prototype._createToolBox = function () {
            t.prototype._createToolBox.call(this);

            var e,
                o = this,
                a = o.getFromEnv("chartConfig"),
                r = o.getFromEnv("toolbar"),
                n = r.getChild("hamburgerMenu-" + r.getId() + "-" + o.getId() + "-0"),
                i = [];
            a.enableRestore && i.push({
              name: a.restoreBtnTitle,
              handler: function handler() {
                o.restoreData();
              },
              action: "click"
            }), a.enableSubmit && (e = {
              name: a.formBtnTitle,
              handler: function handler() {
                l.submitData.call(o);
              },
              action: "click"
            }, i.push(e)), i.length > 0 && n.appendInMenu(i);
          }, o.prototype.getData = function (t) {
            var o,
                r,
                n,
                i = this.getCollatedData(),
                l = [],
                s = i.dataset,
                c = s && s.length || 0,
                u = 0,
                p = 0;
            if (t) l = /^json$/gi.test(t) ? i : /^csv$/gi.test(t) ? this.getCSVString() : e.core.transcodeData(i, "json", t);else for (; u < c; u += 1) {
              if (r = s[u]) {
                for ((n = o = (r = s[u] && s[u].data) && r.length || 0) && (l[p] || (l[p] = [(0, a.getValidValue)(s[u].id, "null")])); n--;) {
                  l[p][n + 1] = (0, a.getValidValue)(r[n].id, "null");
                }

                o && (p += 1);
              }
            }
            return l;
          }, o.prototype.getCSVString = function () {
            for (var e = this.getData(), t = e.length; t--;) {
              e[t] = e[t].join(h);
            }

            return e.join("|");
          }, o.prototype.getCollatedData = function (e) {
            var t,
                o,
                r,
                n,
                i,
                l,
                s,
                c,
                u,
                p,
                h,
                d = this.getDatasets(),
                f = this.config._selectEleArr,
                g = f && f.length || 0,
                m = e || this.getFromEnv("dataSource"),
                v = (0, a.extend2)({}, m),
                b = v.dataset,
                y = b && b.length,
                x = !1,
                k = [];
            if (!g || !y) return m;

            for (; g--;) {
              if (n = f[g]) for (c = n.startX, u = n.endX, p = n.startY, h = n.endY, i = y; i--;) {
                if (d[i].getState("visible")) for (k[i] || (k[i] = {
                  data: []
                }), s = (r = b[i].data) && r.length; s--;) {
                  t = (l = r[s]).x, o = l.y, t > c && t < u && o < p && o > h && (k[i].data[s] = x = !0);
                }
              }
            }

            for (; y--;) {
              for (s = (r = b[y].data) && r.length; s--;) {
                k[y] && k[y].data[s] || r.splice(s, 1);
              }
            }

            return x ? v : m;
          }, o.prototype.createSelectionBox = function (e) {
            (function (e) {
              var t,
                  o = e.chart,
                  r = o.getFromEnv("paper"),
                  n = o.config,
                  i = o.getChildren("yAxis")[0],
                  l = o.getChildren("xAxis")[0],
                  s = e.selectionLeft,
                  c = e.selectionTop,
                  u = e.selectionWidth,
                  p = e.selectionHeight,
                  y = s + u,
                  x = c + p,
                  k = u > 15 && p > 15,
                  C = {
                resizeEleRadius: 15,
                canvasTop: n.canvasTop,
                canvasRight: n.canvasLeft + n.canvasWidth,
                canvasLeft: n.canvasLeft,
                canvasBottom: n.canvasTop + n.canvasHeight
              },
                  N = o.getChildContainer("trackerGroup"),
                  S = n._selectEleArr || (n._selectEleArr = []);
              C.index = S.length, C.id = "SELECT_" + C.index, C.selectBoxG = t = r.group("selection-box", N).toFront(), C.selectBoxTracker = r.rect(s, c, u, p, t).attr({
                "stroke-width": 1,
                stroke: (0, a.toRaphaelColor)(n.selectBorderColor),
                fill: n.selectFillColor
              }).css({
                cursor: "move"
              }), C.selectBoxTracker.node._isTrackerElem = !0, C.selectBoxTracker.data(d, {
                position: 6,
                selectEleObj: C,
                chart: o,
                xChange: !0,
                yChange: !0
              }), C.topTracker = r.rect(s, c - 6, u, 12, t).attr({
                "stroke-width": 0,
                fill: f
              }).css("cursor", a.hasSVG ? "ns-resize" : "n-resize"), C.topTracker.node._isTrackerElem = !0, C.topTracker.data(d, {
                position: 1,
                selectEleObj: C,
                yChange: !0,
                chart: o
              }), C.rightTracker = r.rect(s + u - 6, c, 12, p, t).attr({
                "stroke-width": 0,
                fill: f
              }).css("cursor", a.hasSVG ? "ew-resize" : "w-resize"), C.rightTracker.node._isTrackerElem = !0, C.rightTracker.data(d, {
                position: 2,
                chart: o,
                selectEleObj: C,
                xChange: !0
              }), C.bottomTracker = r.rect(s, c + p - 6, u, 12, t).attr({
                "stroke-width": 0,
                fill: f
              }).css("cursor", a.hasSVG ? "ns-resize" : "n-resize"), C.bottomTracker.node._isTrackerElem = !0, C.bottomTracker.data(d, {
                position: 3,
                chart: o,
                selectEleObj: C,
                yChange: !0
              }), C.leftTracker = r.rect(s - 6, c, 12, p, t).attr({
                "stroke-width": 0,
                fill: f
              }).css("cursor", a.hasSVG ? "ew-resize" : "e-resize"), C.leftTracker.node._isTrackerElem = !0, C.leftTracker.data(d, {
                position: 4,
                chart: o,
                selectEleObj: C,
                xChange: !0
              }), C.cornerInnerSymbol = r.symbol("resizeIcon", 0, 0, 15, t).attr({
                transform: w + y + h + x,
                "stroke-width": 1,
                visibility: k ? g : m,
                stroke: "#999999"
              }), C.cornerInnerSymbol.node._isTrackerElem = !0, C.cornerOuterSymbol = r.symbol("resizeIcon", 0, 0, -12, t).attr({
                transform: w + y + h + x,
                strokeWidth: 1,
                visibility: k ? m : g,
                stroke: "#777777"
              }), C.cornerOuterSymbol.node._isTrackerElem = !0, C.resizeTracker = r.circle(y, x, 12, t).attr({
                "stroke-width": 1,
                stroke: f,
                fill: f
              }).css("cursor", a.hasSVG ? "nwse-resize" : "nw-resize"), C.resizeTracker.node._isTrackerElem = !0, C.resizeTracker.data(d, {
                position: 5,
                chart: o,
                selectEleObj: C,
                yChange: !0,
                xChange: !0
              }), C.closeButton = r.symbol("closeIcon", 0, 0, 6, t).attr({
                transform: "t" + y + h + c,
                "stroke-width": 2,
                stroke: n.selectionCancelButtonBorderColor,
                fill: n.selectionCancelButtonFillColor,
                "stroke-linecap": v,
                "stroke-linejoin": v
              }).css({
                cursor: b,
                _cursor: "hand"
              }).on("fc-click", function () {
                o.deleteSelection(this, o);
              }), C.closeButton.node._isTrackerElem = !0, C.closeButton.data(d, {
                chart: o,
                index: C.index
              }), C.startX = l.getValue(s), C.startY = i.getValue(c), C.endX = l.getValue(y), C.endY = i.getValue(x), C.isVisible = !0, S.push(C), o.bindDragEvent(C);
            }).call(this, e);
          }, o.prototype._deleteAllSelection = function () {
            var e,
                t,
                o,
                a,
                r,
                n = this.config._selectEleArr;

            if (n) {
              for (t = 0, o = n.length; t < o; t++) {
                for (r in e = n[t]) {
                  e.hasOwnProperty(r) && ((a = e[r]).remove && a.remove(), delete e[r]);
                }
              }

              delete this.config._selectEleArr;
            }
          }, o.prototype.deleteSelection = function (e, t) {
            (function (e, t) {
              var o,
                  a,
                  r,
                  n,
                  i,
                  l = e.data(d).index,
                  s = t.config._selectEleArr,
                  c = t.getChildren("xAxis")[0],
                  u = t.getChildren("yAxis")[0];

              for (r in i = {
                selectionLeft: (n = (o = s.find(function (e) {
                  return e.index === l;
                })).selectBoxTracker.getBBox()).x,
                selectionTop: n.y,
                selectionWidth: n.width,
                selectionHeight: n.height,
                startXValue: c.getValue(n.x, 1),
                startYValue: u.getValue(n.y, 1),
                endXValue: c.getValue(n.x + n.width, 1),
                endYValue: u.getValue(n.y + n.height, 1),
                data: t.getCollatedData(),
                id: o.id
              }, o) {
                o.hasOwnProperty(r) && ((a = o[r]).remove && a.remove(), delete o[r]);
              }

              s = s.filter(function (e) {
                return Object.keys(e).length;
              }), t.fireChartInstanceEvent("selectionRemoved", i);
            }).call(this, e, t);
          }, o.prototype.bindDragEvent = function (e) {
            var t;

            for (t in e) {
              /Tracker/.test(t) && e[t].drag(this.move, this.start, this.up);
            }
          }, o.prototype.start = function () {
            var e = this.data(d).selectEleObj,
                t = e.topTracker,
                o = e.rightTracker,
                a = e.bottomTracker,
                r = e.leftTracker,
                n = e.resizeTracker,
                i = t.data(d),
                l = o.data(d),
                s = a.data(d),
                c = r.data(d),
                u = n.data(d),
                p = e.selectBoxTracker.data(d),
                h = e.selectBoxTracker.getBBox();
            i.ox = h.x, i.oy = h.y, l.ox = h.x2, l.oy = h.y, s.ox = h.x, s.oy = h.y2, c.ox = h.x, c.oy = h.y, i.ox = h.x, i.oy = h.y, u.ox = h.x2, u.oy = h.y2, p.ox = h.x, p.oy = h.y, p.ow = h.width, p.oh = h.height, p.ox2 = h.x2, p.oy2 = h.y2, e.selectBoxG.toFront(), t.hide(), o.hide(), a.hide(), r.hide(), n.hide(), this.show();
          }, o.prototype.move = function (e) {
            var t,
                o,
                a,
                r,
                n = this.data(d),
                i = n.selectEleObj,
                l = n.chart,
                s = i.topTracker,
                c = i.rightTracker,
                u = i.bottomTracker,
                p = i.leftTracker,
                h = i.resizeTracker,
                f = i.selectBoxTracker,
                g = i.canvasLeft,
                m = i.canvasRight,
                v = i.canvasTop,
                b = i.canvasBottom,
                y = l.getChildren("xAxis")[0],
                x = l.getChildren("yAxis")[0],
                k = f.data(d),
                w = {},
                C = e.data[0],
                N = e.data[1];

            switch (C = n.xChange ? C : 0, N = n.yChange ? N : 0, a = C + n.ox, r = N + n.oy, a = Math.min(m - (n.ow || 0), Math.max(a, g)), r = Math.min(b - (n.oh || 0), Math.max(r, v)), n.position) {
              case 1:
                w.y = Math.min(k.oy2, r), w.height = Math.abs(k.oy2 - r) || 1, s.attr({
                  y: r + -6
                });
                break;

              case 2:
                w.x = Math.min(k.ox, a), w.width = Math.abs(k.ox - a) || 1, c.attr({
                  x: a + -6
                });
                break;

              case 3:
                w.y = Math.min(k.oy, r), w.height = Math.abs(k.oy - r) || 1, u.attr({
                  y: r + -6
                });
                break;

              case 4:
                w.x = Math.min(k.ox2, a), w.width = Math.abs(k.ox2 - a) || 1, p.attr({
                  x: a + -6
                });
                break;

              case 5:
                w.x = Math.min(k.ox, a), w.width = Math.abs(k.ox - a) || 1, w.y = Math.min(k.oy, r), w.height = Math.abs(k.oy - r) || 1, h.attr({
                  cx: a,
                  cy: r
                });
                break;

              default:
                w.x = a, w.y = r;
            }

            this.data("dragStarted") || (o = {
              selectionLeft: (t = f.getBBox()).x,
              selectionTop: t.y,
              selectionWidth: t.width,
              selectionHeight: t.height,
              startXValue: y.getValue(t.x),
              startYValue: x.getValue(t.y),
              endXValue: y.getValue(t.x + t.width),
              endYValue: x.getValue(t.y + t.height),
              id: i.id
            }, l.fireChartInstanceEvent("BeforeSelectionUpdate", o), this.data("dragStarted", 1)), f.animate(w), i.isVisible && (i.closeButton.hide(), i.cornerInnerSymbol.hide(), i.cornerOuterSymbol.hide(), i.isVisible = !1);
          }, o.prototype.up = function () {
            var e,
                t,
                o = this,
                a = o.data(d),
                r = a.selectEleObj,
                n = a.chart,
                i = n.getChildren("xAxis")[0],
                l = n.getChildren("yAxis")[0],
                s = r.topTracker,
                c = r.rightTracker,
                u = r.bottomTracker,
                p = r.leftTracker,
                f = r.resizeTracker,
                g = r.selectBoxTracker;
            setTimeout(function () {
              e = g.getBBox(), r.startX = i.getValue(e.x), r.startY = l.getValue(e.y), r.endX = i.getValue(e.x2), r.endY = l.getValue(e.y2), s.attr({
                x: e.x,
                y: e.y + -6,
                width: e.width
              }), c.attr({
                x: e.x2 + -6,
                y: e.y,
                height: e.height
              }), u.attr({
                x: e.x,
                y: e.y2 + -6,
                width: e.width
              }), p.attr({
                x: e.x + -6,
                y: e.y,
                height: e.height
              }), f.attr({
                cx: e.x2,
                cy: e.y2
              }), r.closeButton.transform(w + e.x2 + h + e.y), r.cornerInnerSymbol.transform(w + e.x2 + h + e.y2), r.cornerOuterSymbol.transform(w + e.x2 + h + e.y2), r.closeButton.show(), e.width < 15 || e.height < 15 ? (r.cornerInnerSymbol.hide(), r.cornerOuterSymbol.show()) : (r.cornerInnerSymbol.show(), r.cornerOuterSymbol.hide()), r.isVisible = !0, s.show(), c.show(), u.show(), p.show(), f.show(), o.data("dragStarted") && (t = {
                selectionLeft: e.x,
                selectionTop: e.y,
                selectionWidth: e.width,
                selectionHeight: e.height,
                startXValue: i.getValue(e.x),
                startYValue: l.getValue(e.y),
                endXValue: i.getValue(e.x + e.width),
                endYValue: l.getValue(e.y + e.height),
                data: n.getCollatedData(),
                id: r.id
              }, n.fireChartInstanceEvent("SelectionUpdated", t), o.data("dragStarted", 0));
            }, 100);
          }, o.prototype.restoreData = function () {
            var e,
                t = [];

            for (this.iterateComponents(function (e) {
              e.getType && "dataset" === e.getType() && t.push(e);
            }), this._deleteAllSelection(), e = 0; e < t.length; e++) {
              t[e].asyncDraw();
            }

            return this.fireChartInstanceEvent("dataRestored", {}), !0;
          }, o.prototype._postSpaceManagement = function () {
            t.prototype._postSpaceManagement.call(this), this._deleteAllSelection();
          }, o.prototype.getDSdef = function () {
            return n["default"];
          }, o.prototype.getDSGroupdef = function () {}, o;
        }(r["default"]);

        t["default"] = C;
      }).call(this, o(118));
    },
    890: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = l(o(538)),
          r = o(125),
          n = o(132),
          i = l(o(891));

      function l(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var c = r.preDefStr.altHGridColorStr,
          u = r.preDefStr.altHGridAlphaStr;
      (0, n.addDep)({
        name: "selectScatterAnimation",
        type: "animationRule",
        extension: i["default"]
      });

      var p = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return s(t, e), t.prototype.getType = function () {
          return "dataset";
        }, t.prototype.getName = function () {
          return "selectScatter";
        }, t.prototype.configure = function (t) {
          e.prototype.configure.call(this, t);
          var o = this.getFromEnv("chart"),
              a = o.config,
              i = o.getFromEnv("dataSource").chart,
              l = this.getFromEnv("color-manager"),
              s = (0, r.pluck)(i.selectbordercolor, l.getColor("canvasBorderColor")),
              p = (0, r.pluckNumber)(i.selectborderalpha, l.getColor("canvasBorderAlpha"));
          a.selectBorderColor = {
            FCcolor: {
              color: s,
              alpha: p
            }
          }, a.selectFillColor = (0, r.convertColor)((0, r.pluck)(i.selectfillcolor, l.getColor(c)), (0, r.pluckNumber)(i.selectfillalpha, l.getColor(u))), a.selectionCancelButtonBorderColor = (0, r.convertColor)((0, r.pluck)(i.selectioncancelbuttonbordercolor, s), (0, r.pluckNumber)(i.selectioncancelbuttonborderalpha, p)), a.selectionCancelButtonFillColor = (0, r.convertColor)((0, r.pluck)(i.selectioncancelbuttonfillcolor, "FFFFFF"), (0, r.pluckNumber)(i.selectioncancelbuttonfillalpha, 100)), a.connativeZoom = !1, a.zoomType = "xy", i.submitdataasxml !== r.ZEROSTRING || i.formdataformat || (i.formdataformat = (0, n.getDepsByType)("transcoder").csv && "csv"), a.formDataFormat = (0, r.pluck)(i.formdataformat), a.formTarget = (0, r.pluck)(i.formtarget, "_self"), a.formMethod = (0, r.pluck)(i.formmethod, "POST"), a.submitFormAsAjax = (0, r.pluckNumber)(i.submitformusingajax, 1);
        }, t.prototype.draw = function () {
          e.prototype.draw.call(this);
          var t = this.getFromEnv("chart"),
              o = t.getFromEnv("chart-container"),
              a = this.getFromEnv("xAxis"),
              n = this.getFromEnv("yAxis");
          (0, r.bindSelectionEvent)(t, {
            selectionStart: function selectionStart(e) {
              var t = (0, r.getMouseCoordinate)(o, e.originalEvent),
                  i = (0, r.extend2)({
                selectionLeft: e.selectionLeft,
                selectionTop: e.selectionTop,
                selectionWidth: e.selectionWidth,
                selectionHeight: e.selectionHeight,
                startXValue: a.getValue(e.selectionLeft, 1),
                startYValue: n.getValue(e.selectionTop, 1)
              }, t);
              e.chart.fireChartInstanceEvent("selectionStart", i);
            },
            selectionEnd: function selectionEnd(e) {
              var t = (0, r.getMouseCoordinate)(o, e.originalEvent),
                  i = (0, r.extend2)({
                selectionLeft: e.selectionLeft,
                selectionTop: e.selectionTop,
                selectionWidth: e.selectionWidth,
                selectionHeight: e.selectionHeight,
                startXValue: a.getValue(e.selectionLeft, 1),
                startYValue: n.getValue(e.selectionTop, 1),
                endXValue: a.getValue(e.selectionLeft + e.selectionWidth, 1),
                endYValue: n.getValue(e.selectionTop + e.selectionHeight, 1)
              }, t);
              e.chart.fireChartInstanceEvent("selectionEnd", i), e.chart.createSelectionBox(e);
            }
          });
        }, t;
      }(a["default"]);

      t["default"] = p;
    },
    891: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(452),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = {
        "*.dataset.selectScatter": n["default"]["*.dataset.line"]
      };
    },
    892: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(893),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    893: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = n(o(362)),
          r = n(o(894));

      function n(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function i(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var l = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.defaultPaletteOptions = null, o.registerFactory("dataset", r["default"], ["canvas"]), o;
        }

        return i(t, e), t.getName = function () {
          return "MultilevelPie";
        }, t.prototype.getName = function () {
          return "MultilevelPie";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.is3D = !1, t.friendlyName = "Multi-level Pie Chart", t.hasLegend = !1, t.defaultDatasetType = "multiLevelPie", t.valuefontbold = 0, t.skipCanvasDrawing = !0;
        }, t.prototype._checkInvalidSpecificData = function () {
          var e = this.getFromEnv("dataSource").category,
              t = e && e[0] && e[0].category;
          if (!e || !t || !Array.isArray(t)) return !0;
        }, t.prototype._spaceManager = function () {
          var e,
              t = this.config;
          this._allocateSpace(this._manageActionBarSpace && this._manageActionBarSpace(.225 * t.availableHeight) || {}), e = .7 * t.canvasHeight, this._manageChartMenuBar(e), this.allocateDimensionOfChartMenuBar();
        }, t;
      }(a["default"]);

      t["default"] = l;
    },
    894: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = function (e) {
        var t,
            o,
            a = e.getFromEnv("dataSource"),
            n = void 0,
            l = {};
        o = (t = e.config.categories = a.category || []).length, !n && o && (l = t, n = o), o ? (0, r.datasetFactory)(e, i["default"], "dataset", n, [l]) : e.setChartMessage();
      };
      var a,
          r = o(125),
          n = o(895),
          i = (a = n) && a.__esModule ? a : {
        "default": a
      };
    },
    895: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = c(o(476)),
          r = o(125),
          n = o(132),
          i = c(o(896)),
          l = o(136),
          s = c(o(216));

      function c(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function u(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var p = (0, n.getDep)("redraphael", "plugin"),
          h = /^[0-9]+\%?$|^([0-9]+[.][0-9]+)\%?$/;
      (0, n.addDep)({
        name: "multilevelpieAnimation",
        type: "animationRule",
        extension: i["default"]
      }), (0, s["default"])(p);

      var d = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.components = {
            data: []
          }, o.graphics = {}, o;
        }

        return u(t, e), t.prototype.getType = function () {
          return "dataset";
        }, t.prototype.getName = function () {
          return "multiLevelPie";
        }, t.prototype.configureAttributes = function (e) {
          if (!e) return !1;
          this.config.JSONData = e;

          var t,
              o,
              a,
              n = this.getFromEnv("chart"),
              i = n.config,
              l = this.config || (this.config = {}),
              s = l.dataLabelOptions || (l.dataLabelOptions = {}),
              c = l.piePlotOptions,
              u = n.config.style,
              p = this.config.JSONData,
              d = n.getFromEnv("dataSource").chart,
              f = l.enableAnimation = (0, r.pluckNumber)(d.animation, d.defaultanimation, 1),
              g = (0, r.pluckNumber)(-d.centerangle, 180),
              m = (0, r.pluckNumber)(d.totalangle, 360),
              v = function v(e, t) {
            for (var o = this.data("plotItem"); e.graphics.element;) {
              e.graphics.element.attr({
                fill: "mouseover" === t ? l.hoverFillColor : (e.config || o).color
              }), e = e.config.parent;
            }
          },
              b = function x(e, t) {
            var o,
                a = this.data("plotItem");

            for (e.graphics.element.attr({
              fill: "mouseover" === t ? l.hoverFillColor : (e.config || a).color
            }), o = 0; o < (e.components.data && e.components.data.length); o++) {
              x.call(this, e.components.data[o], t);
            }
          },
              y = function y(e) {
            if (l.useHoverColor) {
              var t = this.data("plotItem"),
                  o = t.selfRef;
              l.highlightParentPieSlices || l.highlightChildPieSlices ? !l.highlightParentPieSlices && l.highlightChildPieSlices ? b.call(this, o, e) : l.highlightParentPieSlices && !l.highlightChildPieSlices ? v.call(this, o, e) : l.highlightParentPieSlices && l.highlightChildPieSlices && (v.call(this, o, e), b.call(this, o, e)) : o.graphics.element.attr({
                fill: "mouseover" === e ? l.hoverFillColor : (o.config || t).color
              });
            }
          };

          l.animation = !!f && {
            duration: 1e3 * (0, r.pluckNumber)(d.animationduration, d.moveduration, 1)
          }, l.showShadow = (0, r.pluckNumber)(d.showshadow, 0), l.useHoverColor = Boolean((0, r.pluckNumber)(d.usehovercolor, 1)), l.hoverFillColor = (0, r.convertColor)((0, r.pluck)(d.hoverfillcolor, "FF5904"), (0, r.pluckNumber)(d.hoverfillalpha, 100)), t = (t = (0, r.getFirstValue)(d.valuebordercolor, "")) ? (0, r.convertColor)(t, (0, r.pluckNumber)(d.valueborderalpha, d.valuebgalpha, d.valuealpha, 100)) : "", !s.style && (s.style = {
            fontFamily: (0, r.pluck)(d.valuefont, u.fontFamily),
            fontSize: (0, r.pluckNumber)(d.valuefontsize, (o = u.fontSize, a = 10, parseInt(o, a || 10))) + "px",
            color: (0, r.convertColor)((0, r.pluck)(d.valuefontcolor, u.color), (0, r.pluckNumber)(d.valuefontalpha, d.valuealpha, 100)),
            fontWeight: (0, r.pluckNumber)(d.valuefontbold) ? "bold" : "normal",
            fontStyle: (0, r.pluckNumber)(d.valuefontitalic) ? "italic" : "normal",
            backgroundColor: d.valuebgcolor ? (0, r.convertColor)(d.valuebgcolor, (0, r.pluckNumber)(d.valuebgalpha, d.valuealpha, 100)) : "",
            border: t || d.valuebgcolor ? (0, r.pluckNumber)(d.valueborderthickness, 1) + "px solid" : "",
            borderPadding: (0, r.pluckNumber)(d.valueborderpadding, 2),
            borderThickness: (0, r.pluckNumber)(d.valueborderthickness, u.borderThickness, 1),
            borderRadius: (0, r.pluckNumber)(d.valueborderradius, u.borderRadius, 0),
            borderColor: t,
            borderDash: (0, r.pluckNumber)(d.valueborderdashed, 0) ? (0, r.getDashStyle)((0, r.pluckNumber)(d.valueborderdashlen, 4), (0, r.pluckNumber)(d.valueborderdashgap, 2)) : "none"
          }), !c && (c = l.piePlotOptions = {}), c.allowPointSelect = !1, l.borderColor = (0, r.convertColor)((0, r.pluck)(d.plotbordercolor, d.piebordercolor, "FFFFFF"), d.showplotborder != r.ZEROSTRING ? (0, r.pluck)(d.plotborderalpha, d.pieborderalpha, 100) : 0), l.showTooltip = (0, r.pluckNumber)(d.showtooltip, 1), l.borderWidth = (0, r.pluckNumber)(d.pieborderthickness, d.plotborderthickness, 1), c.startingAngle = 0, c.size = "100%", l.highlightParentPieSlices = (0, r.pluckNumber)(d.highlightparentpieslices, d.highlightparentpienodes, 1), l.highlightChildPieSlices = (0, r.pluckNumber)(d.highlightchildpieslices, d.highlightchildpienodes, 0), l.showLabels = (0, r.pluckNumber)(d.showlabels, 1), l.showValues = (0, r.pluckNumber)(d.showvalues, 0), l.showValuesInTooltip = (0, r.pluckNumber)(d.showvaluesintooltip, d.showvalues, 0), l.showPercentValues = (0, r.pluckNumber)(d.showpercentvalues, d.showpercentagevalues, 0), l.showPercentInTooltip = (0, r.pluckNumber)(d.showpercentintooltip, 0), l.toolTipSepChar = (0, r.pluck)(d.tooltipsepchar, d.hovercapsepchar, r.COMMASPACE), l.labelSepChar = (0, r.pluck)(d.labelsepchar, l.toolTipSepChar), l.tooltext = d.plottooltext, l.alpha = (0, r.pluck)(d.plotfillalpha, d.piefillalpha, 100), l.startAngle = (g - m / 2) * (Math.PI / 180), l.endtAngle = (g + m / 2) * (Math.PI / 180), l.initialAngle = l.endtAngle, l.originX = (0, r.pluckNumber)(d.originx), l.originY = (0, r.pluckNumber)(d.originy), l.events = {
            mouseOver: function mouseOver() {
              y.call(this, "mouseover");
            },
            mouseOut: function mouseOut() {
              y.call(this, "mouseout");
            }
          }, i.plotBorderWidth = 0, i.plotBorderWidth = 0, l.maxLevel = this.addMSPieCat(p, 1, this, l.startAngle, l.endtAngle), l.pieRadius = parseInt(d.pieradius, 10), l.innerRadius = "0", h.test(d.innerradius) && (l.innerRadius = (0, r.pluck)(d.innerradius)), s.distance = 0, s.placeLabelsInside = !0;
        }, t.prototype.removalFn = function (e, t) {
          this.getFromEnv("animationManager").setAnimation({
            el: e,
            label: "element" === t ? "ringpath" : "label",
            component: this,
            callback: function callback() {
              this.remove();
            }
          });
        }, t.prototype.removeGraphics = function (e) {
          var t,
              o,
              a,
              r = e.components && e.components.data,
              n = e.graphics;
          if (r) for (a = r.length, t = 0; t < a; t += 1) {
            this.removeGraphics(r[t]);
          }
          if (e.graphics) for (o in n) {
            n.hasOwnProperty(o) && this.removalFn(e.graphics[o], o);
          }
        }, t.prototype.removeChild = function (e, t, o) {
          var a, r;
          if (e.length) for (a = 0; a < e.length; a += 1) {
            r = e[a], o ? this.removalFn(r, t, o) : this.removeGraphics(r, t);
          } else for (a in e) {
            this.removeChild(e[a], t, a);
          }
        }, t.prototype.addMSPieCat = function (e, t, o, a, n) {
          var i,
              l,
              s,
              c,
              u,
              p,
              h,
              d,
              f,
              g,
              m,
              v,
              b,
              y,
              x,
              k = (0, r.extend2)([], e),
              w = k.length,
              C = this,
              N = o.components.data,
              S = C.config,
              A = S.borderWidth,
              E = S.borderColor,
              D = C.getFromEnv("number-formatter"),
              _ = C.getFromEnv("color-manager"),
              T = 0,
              L = S.labelSepChar,
              P = t,
              O = N.length,
              V = function V() {
            C.removeChild.apply(C, arguments);
          },
              M = k.length,
              F = n - a,
              I = 0;

          for (h = 0; h < w; h += 1) {
            (u = k[h])._userValue = D.getCleanValue(u.value, !0), u._value = (0, r.pluckNumber)(u._userValue, 1), T += u._value;
          }

          for (c = F / (T = T || 1), h = w - 1; h >= 0; h -= 1) {
            p = c * (u = k[h])._value, d = (0, r.parseUnsafeString)((0, r.pluck)(u.label, u.name)), g = null !== u._userValue ? D.dataLabels(u._userValue) : "", m = D.percentValue(u._value / T * 100), f = (0, r.pluckNumber)(u.alpha, S.alpha), b = S.showLabels ? d : "", S.showValues && (S.showPercentValues ? b += "" !== b ? L + m : m : void 0 !== g && "" !== g && (b += "" !== b ? L + g : g)), "" === (v = S.showTooltip ? (0, r.parseUnsafeString)((0, r.pluck)(u.tooltext, u.hovertext, S.tooltext)) : void 0) ? (v = d, S.showValuesInTooltip && (S.showPercentInTooltip ? v += "" !== v ? L + m : m : void 0 !== g && "" !== g && (v += "" !== v ? L + g : g))) : v = (0, r.parseTooltext)(v, [1, 2, 3, 14], {
              percentValue: m,
              label: d,
              formattedValue: g
            }, u), y = a + I, I += p, (i = N[h]) || (i = N[h] = {
              components: {
                data: []
              },
              config: {},
              graphics: {}
            }), i.graphics.element && (x = i.config.startAngle + i.config.angleStrech), i.config = {
              initialAngle: x || (o.config || o.config).initialAngle,
              startAngle: y,
              angleStrech: p,
              level: t,
              displayValue: b,
              toolText: v,
              link: (0, r.getValidValue)(u.link),
              doNotSlice: !0,
              color: (0, r.convertColor)(u.color || _.getPlotColor(), f),
              borderWidth: (0, r.pluckNumber)(u.borderwidth, A),
              borderColor: (0, r.pluck)(u.bordercolor, E),
              dashStyle: (0, r.pluckNumber)(u.valueborderdashed, 0) ? (0, r.getDashStyle)((0, r.pluckNumber)(u.borderdashlen, 4), (0, r.pluckNumber)(u.borderdashgap, 2)) : "none",
              shadow: {
                opacity: .01 * Math.round(f > 50 ? f * f * f * 1e-4 : f * f * .01)
              },
              isSingleTon: !(w > 1)
            }, i.config.parent = o, u.category ? (P = Math.max(P, C.addMSPieCat(u.category, t + 1, i, y, p + y)), (l = i.components.data.length) > (s = u.category.length) && V(i.components.data.splice(l - 1, s))) : (l = i.components.data.length) && V(i.components.data.splice(0, l));
          }

          return O > M && V(N.splice(M)), P;
        }, t.prototype.parsePlotAttributes = function (e) {
          var t,
              o,
              a,
              n,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              d,
              f,
              g,
              m,
              v,
              b = this.config || {},
              y = this.getFromEnv("chart"),
              x = y.config,
              k = this.components.data.length,
              w = x.dataLabelStyle,
              C = x.textDirection,
              N = x.canvasWidth,
              S = x.canvasHeight,
              A = (0, r.pluckNumber)(b.originX, x.canvasLeft + .5 * N),
              E = (0, r.pluckNumber)(b.originY, x.canvasTop + .5 * S),
              D = (0, r.pluckNumber)(2 * b.pieRadius, Math.min(N, S)),
              _ = function (e, t) {
            var o = e && e.length,
                a = void 0;
            return e && (a = "%" === e.charAt(o - 1) ? (0, r.pluckNumber)(t) * ((0, r.pluckNumber)(e.split("%")[0]) / 100) : (0, r.pluckNumber)(e)) < t ? a : 0;
          }(b.innerRadius, D / 2),
              T = this.config.pool || (this.config.pool = {}),
              L = (D - 2 * _) / (2 * b.maxLevel);

          for (b.innerSize = 2 * _, e || (e = this), k = e.components.data.length, f = 0; f < k; f += 1) {
            this.parsePlotAttributes(e.components.data[f]);
          }

          (n = (m = e.config).level) && (i = n * L + _, l = (n - 1) * L + _, g = e.graphics, c = m.angleStrech, u = m.displayValue, p = !!m.link, s = m.color, d = (h = m.startAngle) + m.angleStrech, v = g.element, T.element && T.element.length && (v = g.element = v || T.element.shift()), m.plotItem = {
            chart: y,
            link: m.link,
            value: c,
            color: s,
            labelText: u,
            graphics: {
              element: v
            },
            selfRef: e
          }, m.eventArgs = {
            link: m.link,
            label: m.displayValue,
            toolText: m.toolText
          }, m.props = {
            element: {
              attr: {
                ringpath: [A, E, i, l, h, d],
                "stroke-width": m.borderWidth,
                stroke: m.borderColor,
                fill: (0, r.toRaphaelColor)(m.color),
                "stroke-dasharray": m.dashStyle,
                cursor: p ? "pointer" : r.BLANKSTRING
              }
            }
          }, void 0 !== u && u !== r.BLANKSTRING && (t = (h + d) / 2, a = 0 === l && m.isSingleTon ? 0 : l + (i - l) / 2, (o = m._textAttrs) || (o = m._textAttrs = {}), o.text = u, o.fill = w.color || "000000", o.direction = C, o.cursor = p ? "pointer" : r.BLANKSTRING, o.x = A + a * Math.cos(t), o.y = E + a * Math.sin(t), o["text-bound"] = [w.backgroundColor, w.borderColor, w.borderThickness, w.borderPadding, w.borderRadius, w.borderDash]));
        }, t.prototype.parseLabelAttributes = function (e) {
          var t,
              o,
              a,
              n,
              i = this.components.data.length;

          for (!e && (e = this), i = e.components.data.length, a = 0; a < i; a += 1) {
            this.parseLabelAttributes(e.components.data[a]);
          }

          o = (n = e.config).displayValue, t = n._textAttrs, n.level && void 0 !== o && o !== r.BLANKSTRING && (n.props.label = {
            attr: t
          });
        }, t.prototype.draw = function (e) {
          var t,
              o,
              a,
              r,
              n = this.config || {},
              i = this.getFromEnv("chart"),
              s = this.getFromEnv("animationManager"),
              c = this.getFromEnv("toolTipController"),
              u = i.config,
              p = this.components,
              h = p.data.length,
              d = u.dataLabelStyle,
              f = n.showShadow,
              g = i.getChildContainer("plotGroup"),
              m = i.getChildContainer("datalabelsGroup"),
              v = n.events || {},
              b = this.config.pool || (this.config.pool = {}),
              y = p.removeDataArr;

          for (y && y.length && this.removeElement(), e || (e = this, m.css(d)), h = e.components.data.length, t = 0; t < h; t += 1) {
            this.draw(e.components.data[t]);
          }

          (a = e.config).level ? (r = (o = e.graphics).element, b.element && b.element.length && (r = o.element = r || b.element.shift()), (r = o.element = s.setAnimation({
            el: o.element || "ringpath",
            attr: a.props.element.attr,
            container: g,
            component: this,
            state: "appearing",
            label: "ringpath"
          })).shadow(f && !!a.shadow).data("plotItem", a.plotItem).data("eventArgs", a.eventArgs).on("fc-mouseover", function (e) {
            var t = this,
                o = v.mouseOver,
                r = t.plotItem || t.data("plotItem"),
                n = r.chart,
                i = n.getDatasets()[0];
            n.plotEventHandler(t, e, "DataPlotRollOver"), o && o.call(t), i.fireEvent("datasetrollover", {
              pValue: r.pValue,
              value: r.value,
              displayValue: a.displayValue
            });
          }).on("fc-mouseout", function (e) {
            var t = this,
                o = v.mouseOut,
                r = t.plotItem || t.data("plotItem"),
                n = r.chart,
                i = n.getDatasets()[0];
            n.plotEventHandler(t, e, "DataPlotRollOut"), o && o.call(t), i.fireEvent("datasetrollout", {
              pValue: r.pValue,
              value: r.value,
              displayValue: a.displayValue
            });
          }).on("fc-click", function (e) {
            i.plotEventHandler(this, e);
          }), c.enableToolTip(r, a.toolText), t || n._drawn || (n._drawn = !0, m.show(), this.addJob("labelJob", this.drawLabel.bind(this), l.priorityList.label))) : (n._drawn && this.drawLabel(), this.removeChild(this.config.pool, !0));
        }, t.prototype.drawLabel = function (e) {
          var t,
              o,
              a,
              n,
              i,
              l,
              s = this.config || {},
              c = this.getFromEnv("chart"),
              u = this.getFromEnv("animationManager"),
              p = c.config,
              h = this.components.data.length,
              d = p.dataLabelStyle,
              f = this.getFromEnv("toolTipController"),
              g = p.tooltip || {},
              m = g && !1 !== g.enabled,
              v = s.events || {},
              b = this.config.pool || (this.config.pool = {}),
              y = c.getChildContainer("datalabelsGroup");

          for (y.show(), !e && (e = this), h = e.components.data.length, a = 0; a < h; a += 1) {
            this.drawLabel(e.components.data[a]);
          }

          t = (i = e.config).plotItem, o = i.displayValue, i.level ? (l = (n = e.graphics).label, void 0 !== o && o !== r.BLANKSTRING ? (l = n.label, b.label && b.label.length && (l = n.label = l || b.label.shift()), (l = n.label = u.setAnimation({
            el: l || "text",
            attr: i.props.label.attr,
            container: y,
            component: this,
            state: "appearing",
            label: "text"
          })).on("fc-click", function (e) {
            c.plotEventHandler(this, e);
          }).on("fc-mouseout", function (e) {
            var t = v.mouseOut;
            c.plotEventHandler(this, e, "DataPlotRollOut"), t && t.call(this);
          }).on("fc-mouseover", function (e) {
            var t = v.mouseOver;
            c.plotEventHandler(this, e, "DataPlotRollOver"), t && t.call(this);
          }).css(d).show().data("plotItem", t).data("eventArgs", i.eventArgs), m && f.enableToolTip(l, void 0)) : l && u.setAnimation({
            el: l,
            component: this,
            callback: function callback() {
              this.hide();
            },
            label: "text"
          })) : this.removeChild(this.config.pool, !0);
        }, t;
      }(a["default"]);

      t["default"] = d;
    },
    896: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = {
        "initial.dataset.multiLevelPie": function initialDatasetMultiLevelPie() {
          var e = this.config,
              t = void 0;
          return {
            "ringpath.appearing": function ringpathAppearing(o) {
              return [{
                initialAttr: {
                  ringpath: [(t = o.attr.ringpath)[0], t[1], t[2], t[3], e.initialAngle, e.initialAngle]
                },
                slot: "plot"
              }];
            },
            "text.appearing": function textAppearing() {
              return [{
                initialAttr: {
                  opacity: 0
                },
                finalAttr: {
                  opacity: 1
                },
                slot: "final"
              }];
            }
          };
        }
      };
    },
    897: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(898),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    898: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = u(o(551)),
          r = u(o(899)),
          n = u(o(901)),
          i = u(o(902)),
          l = o(132),
          s = u(o(251)),
          c = o(125);

      function u(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function p(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var h = c.preDefStr.defaultFontStr,
          d = c.preDefStr.divLineAlphaStr,
          f = c.preDefStr.altVGridColorStr,
          g = c.preDefStr.altVGridAlphaStr,
          m = c.preDefStr.colors.c000000,
          v = c.preDefStr.POSITION_BOTTOM,
          b = c.preDefStr.divLineAlpha3DStr,
          y = (0, l.getDep)("redraphael", "plugin");
      (0, s["default"])(y);

      var x = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this)),
              a = o;

          return a.friendlyName = "Multi-axis Line Chart", a.defaultPlotShadow = 1, a.axisPaddingLeft = 0, a.axisPaddingRight = 0, o.registerFactory("axis", r["default"], ["canvas"]), o.registerFactory("vCanvas", n["default"], ["axis"]), o.registerFactory("dataset", i["default"], ["vCanvas"]), o;
        }

        return p(t, e), t.getName = function () {
          return "MultiAxisLine";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.defaultDatasetType = "multiaxisline", t.defaultcrosslinethickness = 1;
        }, t.prototype.getName = function () {
          return "MultiAxisLine";
        }, t.prototype._checkInvalidSpecificData = function () {
          var e = this.getFromEnv("dataSource"),
              t = e.axis,
              o = e.categories;
          if (!t || !o) return !0;
        }, t.prototype._feedAxesRawData = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              i,
              l,
              s,
              u,
              p,
              v,
              y,
              x,
              k,
              w,
              C = this.config,
              N = this.getFromEnv("color-manager"),
              S = this.getFromEnv("number-formatter"),
              A = this.getFromEnv("dataSource"),
              E = A.chart,
              D = this.config.is3D,
              _ = D ? c.chartPaletteStr.chart3D : c.chartPaletteStr.chart2D,
              T = [],
              L = {},
              P = [];

          for (e = {
            isVertical: !1,
            isReverse: !1,
            isOpposit: !1,
            outCanfontFamily: (0, c.pluck)(E.outcnvbasefont, E.basefont, h),
            outCanfontSize: (0, c.pluckFontSize)(E.outcnvbasefontsize, E.basefontsize, 10),
            outCancolor: (0, c.pluck)(E.outcnvbasefontcolor, E.basefontcolor, N.getColor(_.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi, "#$1"),
            axisNamePadding: E.xaxisnamepadding,
            axisValuePadding: E.labelpadding,
            axisNameFont: E.xaxisnamefont,
            axisNameFontSize: E.xaxisnamefontsize,
            axisNameFontColor: E.xaxisnamefontcolor,
            axisNameFontBold: E.xaxisnamefontbold,
            axisNameFontItalic: E.xaxisnamefontitalic,
            axisNameBgColor: E.xaxisnamebgcolor,
            axisNameBorderColor: E.xaxisnamebordercolor,
            axisNameAlpha: E.xaxisnamealpha,
            axisNameFontAlpha: E.xaxisnamefontalpha,
            axisNameBgAlpha: E.xaxisnamebgalpha,
            axisNameBorderAlpha: E.xaxisnameborderalpha,
            axisNameBorderPadding: E.xaxisnameborderpadding,
            axisNameBorderRadius: E.xaxisnameborderradius,
            axisNameBorderThickness: E.xaxisnameborderthickness,
            axisNameBorderDashed: E.xaxisnameborderdashed,
            axisNameBorderDashLen: E.xaxisnameborderdashlen,
            axisNameBorderDashGap: E.xaxisnameborderdashgap,
            useEllipsesWhenOverflow: E.useellipseswhenoverflow,
            divLineColor: (0, c.pluck)(E.vdivlinecolor, E.divlinecolor, N.getColor(_.divLineColor)),
            divLineAlpha: (0, c.pluck)(E.vdivlinealpha, E.divlinealpha, D ? N.getColor(b) : N.getColor(d)),
            divLineThickness: (0, c.pluckNumber)(E.vdivlinethickness, E.divlinethickness, 1),
            divLineIsDashed: Boolean((0, c.pluckNumber)(E.vdivlinedashed, E.vdivlineisdashed, E.divlinedashed, E.divlineisdashed, 0)),
            divLineDashLen: (0, c.pluckNumber)(E.vdivlinedashlen, E.divlinedashlen, 4),
            divLineDashGap: (0, c.pluckNumber)(E.vdivlinedashgap, E.divlinedashgap, 2),
            showAlternateGridColor: (0, c.pluckNumber)(E.showalternatevgridcolor, 0),
            alternateGridColor: (0, c.pluck)(E.alternatevgridcolor, N.getColor(f)),
            alternateGridAlpha: (0, c.pluck)(E.alternatevgridalpha, N.getColor(g)),
            numDivLines: E.numvdivlines,
            labelFont: E.labelfont,
            labelFontSize: E.labelfontsize,
            labelFontColor: E.labelfontcolor,
            labelFontBold: E.labelfontbold,
            labelFontItalic: E.labelfontitalic,
            labelFontAlpha: E.labelalpha,
            maxLabelHeight: E.maxlabelheight,
            axisName: E.xaxisname,
            axisMinValue: E.xaxisminvalue,
            axisMaxValue: E.xaxismaxvalue,
            setAdaptiveMin: E.setadaptivexmin,
            adjustDiv: E.adjustvdiv,
            labelDisplay: E.labeldisplay,
            showLabels: E.showlabels,
            rotateLabels: E.rotatelabels,
            slantLabel: (0, c.pluckNumber)(E.slantlabels, E.slantlabel),
            labelStep: (0, c.pluckNumber)(E.labelstep, E.xaxisvaluesstep),
            showAxisValues: (0, c.pluckNumber)(E.showxaxisvalues, E.showxaxisvalue),
            showLimits: E.showvlimits,
            showDivLineValues: (0, c.pluckNumber)(E.showvdivlinevalues, E.showvdivlinevalues),
            showZeroPlane: E.showvzeroplane,
            zeroPlaneColor: E.vzeroplanecolor,
            zeroPlaneThickness: E.vzeroplanethickness,
            zeroPlaneAlpha: E.vzeroplanealpha,
            showZeroPlaneValue: E.showvzeroplanevalue,
            trendlineColor: E.trendlinecolor,
            trendlineToolText: E.trendlinetooltext,
            trendlineThickness: E.trendlinethickness,
            trendlineAlpha: E.trendlinealpha,
            showTrendlinesOnTop: E.showtrendlinesontop,
            showAxisLine: (0, c.pluckNumber)(E.showxaxisline, E.showaxislines, E.drawAxisLines, 0),
            axisLineThickness: (0, c.pluckNumber)(E.xaxislinethickness, E.axislinethickness, 1),
            axisLineAlpha: (0, c.pluckNumber)(E.xaxislinealpha, E.axislinealpha, 100),
            axisLineColor: (0, c.pluck)(E.xaxislinecolor, E.axislinecolor, m)
          }, P.push(e), t = {
            outCanfontFamily: (0, c.pluck)(E.outcnvbasefont, E.basefont, h),
            outCanfontSize: (0, c.pluckFontSize)(E.outcnvbasefontsize, E.basefontsize, 10),
            outCancolor: (0, c.pluck)(E.outcnvbasefontcolor, E.basefontcolor, N.getColor(_.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi, "#$1"),
            useEllipsesWhenOverflow: E.useellipseswhenoverflow,
            showAlternateGridColor: 0,
            axisNameFont: E.yaxisnamefont,
            axisNameFontSize: E.yaxisnamefontsize,
            axisNameFontColor: E.yaxisnamefontcolor,
            axisNameFontBold: E.yaxisnamefontbold,
            axisNameFontItalic: E.yaxisnamefontitalic,
            axisNameBgColor: E.yaxisnamebgcolor,
            axisNameBorderColor: E.yaxisnamebordercolor,
            axisNameAlpha: E.yaxisnamealpha,
            axisNameFontAlpha: E.yaxisnamefontalpha,
            axisNameBgAlpha: E.yaxisnamebgalpha,
            axisNameBorderAlpha: E.yaxisnameborderalpha,
            axisNameBorderPadding: E.yaxisnameborderpadding,
            axisNameBorderRadius: E.yaxisnameborderradius,
            axisNameBorderThickness: E.yaxisnameborderthickness,
            axisNameBorderDashed: E.yaxisnameborderdashed,
            axisNameBorderDashLen: E.yaxisnameborderdashlen,
            axisNameBorderDashGap: E.yaxisnameborderdashgap
          }, s = {
            side: "l",
            axesConf: []
          }, u = {
            side: "r",
            axesConf: []
          }, a = 0, r = (o = A.axis || []).length; a < r; a++) {
            for (L = {}, i = o[a], L.checkBoxChecked = !1, k = 0, w = i.dataset ? i.dataset.length : 0; k < w; k += 1) {
              0 !== Number(i.dataset[k].visible) && (L.checkBoxChecked = !0);
            }

            l = N.getPlotColor(a), p = (0, c.pluck)(i.color, E.axiscolor, l), v = (0, c.pluckNumber)(i.divlinethickness, E.divlinethickness, 1), y = (0, c.pluckNumber)(i.tickwidth, E.axistickwidth, 2), x = (0, c.pluckNumber)(i.axislinethickness, E.axislinethickness, 2), n = !(0, c.pluckNumber)(i.axisonleft, 1), t.isVertical = !0, t.isReverse = !0, t.isOpposit = n, t.labelStep = (0, c.pluckNumber)(i.yaxisvaluesstep, i.yaxisvaluestep, E.yaxisvaluesstep, E.yaxisvaluestep), t.axisMaxValue = i.maxvalue, t.axisMinValue = i.minvalue, t.setAdaptiveMin = (0, c.pluckNumber)(i.setadaptiveymin, E.setadaptiveymin), t.numDivLines = (0, c.pluckNumber)(i.numdivlines, E.numdivlines, 4), t.adjustDiv = (0, c.pluckNumber)(i.adjustdiv, E.adjustdiv), t.showAxisValues = (0, c.pluckNumber)(i.showyaxisvalues, i.showyaxisvalue, E.showyaxisvalues, E.showyaxisvalue, 1), t.showLimits = (0, c.pluckNumber)(i.showlimits, E.showyaxislimits, E.showlimits, t.showAxisValues), t.showDivLineValues = (0, c.pluckNumber)(i.showdivlinevalue, E.showdivlinevalues, i.showdivlinevalues, t.showAxisValues), t.showZeroPlane = (0, c.pluckNumber)(i.showzeroplane, E.showzeroplane), t.showZeroPlaneValue = (0, c.pluckNumber)(i.showzeroplanevalue, E.showzeroplanevalue), t.zeroPlaneColor = i.zeroplanecolor, t.zeroPlaneThickness = (0, c.pluckNumber)(i.zeroplanethickness, i.divlinethickness, C.zeroplanethickness, 2), t.zeroPlaneAlpha = (0, c.pluckNumber)(i.zeroplanealpha, i.divlinealpha, C.zeroplanealpha), t.showZeroPlaneOnTop = C.showzeroplaneontop, t.divLineColor = (0, c.pluck)(i.divlinecolor, p), t.divLineAlpha = (0, c.pluckNumber)(i.divlinealpha, E.divlinealpha, N.getColor(d), 100), t.divLineThickness = v, t.divLineIsDashed = Boolean((0, c.pluckNumber)(i.divlinedashed, i.divlineisdashed, E.divlinedashed, E.divlineisdashed, 0)), t.divLineDashLen = (0, c.pluckNumber)(i.divlinedashlen, E.divlinedashlen, 4), t.divLineDashGap = (0, c.pluckNumber)(i.divlinedashgap, E.divlinedashgap, 2), t.showAxisLine = 1, t.axisLineThickness = x, t.axisLineAlpha = 100, t.axisLineColor = p, t.tickLength = y, t.tickColor = p, t.tickAlpha = 100, t.tickWidth = x, t.axisName = i.title, t.rotateAxisName = 1, t.axisNameAlignCanvas = !0, t.drawAxisNameFromBottom = !0, (0, c.extend2)(L, t), S.parseMLAxisConf(i, a), 0 === (0, c.pluckNumber)(i.showaxis) ? (0, c.extend2)(L, {
              axisIndex: a,
              drawAxisLineWRTCanvas: !1,
              drawLabels: !1,
              drawPlotlines: !1,
              drawAxisLine: !1,
              drawPlotBands: !1,
              drawAxisName: !1,
              drawTrendLines: !1,
              drawTrendLabels: !1,
              drawTick: !1,
              drawTickMinor: !1,
              showAxis: 0
            }) : (0, c.extend2)(L, {
              axisIndex: a,
              drawAxisLineWRTCanvas: !1,
              drawLabels: !0,
              drawPlotlines: !0,
              drawAxisLine: !0,
              drawPlotBands: !0,
              drawAxisName: !0,
              drawTrendLines: !0,
              drawTrendLabels: !0,
              drawTick: !0,
              drawTickMinor: !0,
              showAxis: 1
            }), n ? u.axesConf.push(L) : s.axesConf.push(L);
          }

          return s.axesConf.length && T.push(s), u.axesConf.length && T.push(u), {
            xAxisConfigure: P,
            yAxisConfigure: T
          };
        }, t.prototype._postSpaceManagement = function () {
          var e = this.getFromEnv("legend"),
              t = this.config.showLegend,
              o = this.getChildren("yAxisSelectorUI"),
              a = this.getChildren("canvas")[0];
          this.setAxisDimention(), o.forEach(function (e) {
            e.setAxisDimention();
          }), a.setCanvasPadding(), this.setAxisDimention(), t && e.postSpaceManager(), this.allocateDimensionOfChartMenuBar();
        }, t.prototype.setAxisDimention = function () {
          var e = this.config,
              t = this.getChildren("xAxis")[0],
              o = e.xDepth,
              a = this.getChildren("canvas")[0].config,
              r = a.canvasBorderWidth,
              n = a.canvasPadding,
              i = a.canvasPaddingLeft,
              l = a.canvasPaddingRight;
          t && t.setAxisDimention({
            x: e.canvasLeft + (o || 0) + Math.max(i, n),
            y: e.canvasBottom + (e.shift || 0) + r,
            opposite: e.canvasTop - r,
            axisLength: e.canvasWidth - (o || 0) - Math.max(i, n) - Math.max(l, n)
          });
        }, t.prototype._spaceManager = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              i,
              l,
              s,
              u,
              p = this.getChildren("canvas")[0],
              h = this.config,
              d = h.showLegend,
              f = h.legendPosition,
              g = this.getChildren("xAxis"),
              m = this.getChildren("yAxisSelectorUI"),
              b = h.hasLegend,
              y = h.yDepth,
              x = this.getFromEnv("legend"),
              k = 0,
              w = 0,
              C = m.length || 0,
              N = this.config.is3D,
              S = this.getFromEnv("dataSource").chart,
              A = (0, c.pluckNumber)(S.showborder, N ? 0 : 1),
              E = this.getChildren("canvas")[0].config.canvasBorderWidth,
              D = h.borderWidth = A ? (0, c.pluckNumber)(S.borderthickness, 1) : 0,
              _ = h.canvasMarginTop,
              T = h.canvasMarginBottom,
              L = h.canvasMarginLeft,
              P = h.canvasMarginRight,
              O = (h.minCanvasHeight, h.minCanvasWidth, h.height),
              V = h.width;
          h.origCanvasTopMargin, h.origCanvasBottomMargin, h.origCanvasLeftMargin, h.origCanvasRightMargin;

          for (this._allocateSpace({
            top: D,
            bottom: D,
            left: D,
            right: D
          }), this._allocateSpace({
            left: h.canvasMarginLeft,
            right: h.canvasMarginRight
          }), n = "right" === f ? .3 * h.canvasWidth : .3 * h.canvasHeight, !1 !== b && g && d && this._allocateSpace(x._manageLegendPosition(n)), a = 0; a < C; a++) {
            k += (r = m[a].placeAxis(h.canvasWidth)).rightPadding, w += r.leftPadding, this._allocateSpace(r.dimension);
          }

          e = .225 * h.availableHeight, t = this._manageActionBarSpace && this._manageActionBarSpace(e) || {}, this._allocateSpace(t), o = f === v ? .6 * h.canvasHeight : .6 * h.canvasWidth, this._manageChartMenuBar(o), .7 * h.canvasWidth > k + w && this._allocateSpace({
            left: w,
            right: k
          }), o = .6 * h.canvasHeight, g[0] && this._allocateSpace(g[0].placeAxis(o)), o = .325 * h.canvasHeight, this._getDSspace && this._allocateSpace(this._getDSspace(o)), y && this._allocateSpace({
            bottom: y
          }), this._allocateSpace({
            top: E,
            bottom: E,
            left: E,
            right: E
          }), i = _ > h.canvasTop ? _ - h.canvasTop : 0, l = T > O - h.canvasBottom ? T + h.canvasBottom - O : 0, s = L > h.canvasLeft ? L - h.canvasLeft : 0, u = P > V - h.canvasRight ? P + h.canvasRight - V : 0, this._allocateSpace({
            top: i,
            bottom: l,
            left: s,
            right: u
          }), h.actualCanvasMarginTop = i, h.actualCanvasMarginLeft = s, h.actualCanvasMarginRight = u, h.actualCanvasMarginBottom = l, p.setDimension({
            top: h.canvasTop,
            left: h.canvasLeft,
            width: h.canvasWidth,
            height: h.canvasHeight
          });
        }, t.prototype.configure = function (t) {
          e.prototype.configure.call(this, t);
          var o = this.config,
              a = this.getFromEnv("dataSource").chart;
          o.axesPadding = 5, o.allowAxisShift = (0, c.pluckNumber)(a.allowaxisshift, 1), o.allowSelection = (0, c.pluckNumber)(a.allowselection, 1), o.checkBoxColor = (0, c.pluck)(a.checkboxcolor, "#2196f3"), o.axisConfigured = !0;
        }, t;
      }(a["default"]);

      t["default"] = x;
    },
    899: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = function (e) {
        var t,
            o = e.getChildren("canvas")[0],
            i = o.getChildren("axisRefVisualCartesian")[0],
            l = void 0;
        t = e._feedAxesRawData(), n["default"].resetAxisCount(), (0, a.componentFactory)(e, n["default"], "yAxisSelectorUI", t.yAxisConfigure && t.yAxisConfigure.length, t.yAxisConfigure), (0, a.componentFactory)(e, r["default"], "xAxis", 1, t.xAxisConfigure), (l = e.getChildren("xAxis")[0]).setLinkedItem("canvas", o), i.setLinkedItem(l.getId(), l), i.addExtEventListener("visiblerangeset", function () {
          return i.asyncDraw();
        }, l), o.attachAxis(l, !1), o.setPrimaryAxis("xAxis", l), e._setCategories();
      };
      var a = o(125),
          r = i(o(422)),
          n = i(o(900));

      function i(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }
    },
    900: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = o(138),
          r = o(125),
          n = s(o(377)),
          i = s(o(768)),
          l = s(o(236));

      function s(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function c(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var u = function u(e) {
        var t = e.config.axesConf,
            o = void 0,
            a = void 0,
            l = void 0,
            s = void 0,
            c = e.config.axisMapById,
            u = c && Array.from(c.keys()) || [],
            h = void 0,
            d = !0,
            f = e.getFromEnv("chart").getChildren("canvas")[0],
            g = f.getChildren("axisRefVisualCartesian")[0],
            m = function m() {
          return g.asyncDraw();
        };

        (0, r.componentFactory)(e, n["default"], "yAxis", t.length, t), o = (e.getChildren("yAxis") || []).slice(0), a = e.config.axisMapById = new i["default"](), ("l" === e.config.side ? o.reverse() : o).forEach(function (t) {
          if (!t.getState("removed") && 0 !== t.config.showaxis) {
            var o,
                r,
                n = t.getId();
            (h = {}).axis = t, s = c && c.get(n), h.checkbox = s && s.checkbox, a.set(n, h), 0 === t.config.showaxis ? t.hide() : t.show(), f.attachAxis(t, !0), d && (e.config.besideCanvas = n), d = !1, p || (l = t), t.setLinkedItem("canvas", f), g.setLinkedItem(t.getId(), t), g.addExtEventListener("visiblerangeset", m, t), p++, o = n, -1 !== (r = u.indexOf(o)) && u.splice(r, 1);
          }
        }), l && f.setPrimaryAxis("yAxis", l), function (e, t) {
          var o = void 0,
              a = void 0,
              r = void 0;

          for (r = e.length - 1; r > -1; r--) {
            o = e[r], (a = t.get(o)).checkbox && a.checkbox.remove(), a.axis && a.axis.remove(), t["delete"](o);
          }
        }(u, c);
      },
          p = 0,
          h = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.registerFactory("axis", u), o;
        }

        return c(t, e), t.resetAxisCount = function () {
          p = 0;
        }, t.prototype.configureAttributes = function () {
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              t = this.config;
          t.axesConf = e.axesConf || [], t.checkboxesConf = e.checkboxesConf || [], t.side = e.side;
        }, t.prototype.placeAxis = function (e) {
          var t = this.config.side,
              o = this.getAxesDetails(),
              a = this.getFromEnv("chartConfig").axesPadding,
              r = 0,
              n = 0,
              i = void 0,
              l = {
            right: 0,
            left: 0
          };
          return o.forEach(function (o) {
            var s = o.value || (o.value = {}),
                c = o.axis;
            c.getState("removed") || 0 === c.config.showaxis || (i = c.placeAxis(.7 * e), "r" === t ? (e -= s.width = i.right, l.right += i.right, r += a) : (e -= s.width = i.left, l.left += i.left, n += a));
          }), {
            dimension: l,
            rightPadding: r,
            leftPadding: n
          };
        }, t.prototype.setAxisDimention = function () {
          var e = this.config,
              t = this.getAxesDetails(),
              o = this.getFromEnv("chart"),
              a = this.getFromEnv("chartConfig").axesPadding,
              r = o.getChildren("canvas")[0].config,
              n = r.canvasBorderWidth,
              i = r.canvasPaddingTop,
              l = r.canvasPaddingBottom,
              s = r.canvasLeft,
              c = r.canvasTop,
              u = r.canvasHeight,
              p = s + r.canvasWidth,
              h = "r" === e.side,
              d = "r" === e.side ? s - n : p + n,
              f = 0;
          t.forEach(function (e) {
            var t = e.value || (e.value = {}),
                o = e.axis;
            0 === o.config.showaxis || o.getState("removed") || (t.x = h ? p + n + f + a : s - n - f - a, t.y = c + i, t.height = u - i - l, t.opposite = d, f += t.width + a, o.setAxisDimention({
              x: t.x,
              y: t.y,
              opposite: t.opposite,
              axisLength: t.height
            }));
          });
        }, t.prototype.drawHotElements = function () {
          var e,
              t = this,
              o = t.config,
              a = "r" === o.side,
              n = t.getFromEnv("chartConfig").allowAxisShift,
              i = t.getFromEnv("chart"),
              l = t.getFromEnv("paper"),
              s = i.getChildContainer("trackerGroup"),
              c = o.axisMapById,
              u = t.getGraphicalElement("axisHotElement") || [],
              p = i.getChildren("canvas")[0],
              h = void 0,
              d = -1,
              f = {
            cursor: "col-resize",
            stroke: r.TRACKER_FILL,
            fill: r.TRACKER_FILL,
            visibility: !0
          };

          for (n && c.forEach(function (e, o) {
            var r = void 0,
                n = e.value;
            f.x = n.x + (a ? 0 : -n.width), f.y = n.y, f.width = n.width, f.height = n.height, (r = u[++d]) || (r = t.addGraphicalElement("axisHotElement", l.rect(s), !0)).on("fc-click", t._resuffelAxis), r.attr(f).data("axisDetails", {
              axisSelectorUI: t,
              canvas: p,
              axisId: o
            });
          }), h = d + 1, e = u.length; h < e; h++) {
            t.removeGraphicalElement(u[h]);
          }
        }, t.prototype.drawCheckBoxes = function () {
          var e = this,
              t = e.config,
              o = e.getFromEnv("chartConfig"),
              a = o.allowSelection,
              r = "r" === t.side,
              n = t.axisMapById;
          a ? n.forEach(function (t, a) {
            var n = t.value,
                i = t.checkbox,
                s = t.axis.config,
                c = r ? t.axis.getAxisConfig("axisNamePadding") : -n.width;
            i || (i = t.checkbox = new l["default"](), e.attachChild(i, "checkbox", !0), i.configure({
              isChecked: !0,
              text: "",
              stroke: o.checkBoxColor,
              symbolStroke: o.checkBoxColor,
              strokeWidth: 1,
              symbolStrokeWidth: 1,
              containerInfo: {
                id: "buttonGroup",
                label: "group",
                isParent: !0
              }
            }), i.addEventListener("fc-click", function () {
              var t = this.getFromEnv("chart");
              this.toggle(), e._dolegendInteraction.call(this, a, t), s.checkBoxChecked = !s.checkBoxChecked;
            })), i.setDimension({
              x: n.x + c,
              y: n.y + n.height + 4
            });
          }) : n.forEach(function (e, t) {
            e.checkbox && e.checkbox.remove(), delete e.checkbox;
          });
        }, t.prototype._createLayers = function () {
          var e = this.getFromEnv("chart").getContainer("parentgroup");
          this.createContainer("axisBottomGroup", {
            name: "axis-bottom-group"
          }, e), this.createContainer("axisTopGroup", {
            name: "axis-top-group"
          }, e), this.createContainer("buttonGroup", {
            name: "buttons"
          }, e);
        }, t.prototype.createContainer = function (e, t, o) {
          var a = this.getFromEnv("animationManager");
          return this.addChildContainer(e, a.setAnimation({
            container: o,
            attr: t,
            el: this.getChildContainer(e) || "group",
            component: this,
            label: "group"
          }));
        }, t.prototype.draw = function () {
          this._createLayers(), this.drawHotElements(), this.drawCheckBoxes();
        }, t.prototype._resuffelAxis = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              l = this.data("axisDetails"),
              s = l.axisSelectorUI,
              c = s.config,
              u = l.canvas,
              p = l.axisId,
              h = s.getAxesDetails();
          c.besideCanvas !== p && (h = s.config.axisMapById = (e = c.besideCanvas, t = p, a = [e, (o = h).get(e)], r = [t, o.get(t)], n = Array.from(o.entries()).map(function (o) {
            var n = o[0],
                i = o[1];
            return n === e ? r : n === t ? a : [n, i];
          }), new i["default"](n))), c.besideCanvas = p, u.setPrimaryAxis("yAxis", h.get(p).axis), s.setAxisDimention(), s.asyncDraw(), u.getChildren("axisRefVisualCartesian")[0].asyncDraw();
        }, t.prototype._dolegendInteraction = function (e, t) {
          var o,
              a,
              r = [];

          for (o in t.iterateComponents(function (e) {
            "dataset" === e.getType() && r.push(e);
          }), r) {
            r.hasOwnProperty(o) && (a = r[o]).getFromEnv("yAxis").getId() === e && (!a.getState("visible") && this.config.checked ? (a.config.legendInteractivity = !0, a.show()) : a.getState("visible") && !this.config.checked && (a.config.legendInteractivity = !0, a.hide()));
          }
        }, t.prototype.manipulateCheckBox = function (e) {
          var t,
              o,
              a,
              r = e.data,
              n = r.dataset,
              i = n.getFromEnv("yAxis").getId(),
              l = n.getLinkedParent().getChildren().dataset,
              s = r.state,
              c = !0;
          if (a = this.getAxesDetails().get(i)) if ("hide" === s) {
            for (t = 0, o = l.length; t < o; t++) {
              l[t].getState("visible") && (c = !1);
            }

            c && a.checkbox && a.checkbox.uncheck();
          } else a.checkbox && a.checkbox.check();
        }, t.prototype.getAxesDetails = function () {
          return this.config.axisMapById;
        }, t.prototype.getType = function () {
          return "customAxisUI";
        }, t.prototype.getName = function () {
          return "multiAxisSelectorUI";
        }, t.prototype.getAxes = function () {
          return Array.from(this.config.axisMapById.values()).map(function (e) {
            return e.axis;
          });
        }, t;
      }(a.ComponentInterface);

      t["default"] = h;
    },
    901: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = function (e) {
        var t,
            o = e.getChildren("canvas")[0],
            a = e.getFromEnv("dataSource"),
            r = e.getChildren("yAxisSelectorUI"),
            l = a.axis,
            s = void 0,
            c = [],
            u = [],
            p = void 0,
            h = void 0,
            d = void 0,
            f = void 0;

        for (s = e.getChildren("xAxis"), d = 0; d < (s && s.length); d++) {
          s[d].getState("removed") || c.push(s[d]);
        }

        for (r.forEach(function (e) {
          for (s = e.getChildren("yAxis"), d = 0; d < (s && s.length); d++) {
            s[d].getState("removed") || u.push(s[d]);
          }
        }), (0, i.componentFactory)(o, n["default"], "vCanvas", c.length * u.length), t = o.getChildren("vCanvas"), h = 0, d = 0; h < (c && c.length); h++) {
          for (f = 0; f < (u && u.length); f++, d++) {
            (p = t[d]).configure(), p.xAxis(c[h]).yAxis(u[f]).canvas(o), p.addToEnv("axisData", l[d]), p.addToEnv("vCanvas", t[d]);
          }
        }
      };
      var a,
          r = o(428),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      },
          i = o(125);
    },
    902: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = function (e) {
        for (var t = void 0, o = void 0, a = void 0, n = void 0, l = e.getChildren(), s = l.yAxisSelectorUI, c = l.canvas[0].getChildren("vCanvas"), u = 0, p = c.length; u < p; u++) {
          (n = c[u]).getState("removed") || (t = n.getFromEnv("axisData").dataset) && (o = t.length, a = Array(o).fill(n.getFromEnv("yAxis").config.axisIndex).map(function (e, t) {
            return e + Number("." + (t + 1));
          }), (0, r.datasetFactory)(n, i["default"], "dataset", o, t, a), (l = n.getChildren("dataset")).forEach(function (e) {
            e.addEventListener("datasetVisibilityChanged", function (e) {
              s.forEach(function (t) {
                t.manipulateCheckBox(e);
              });
            });
          }));
        }
      };
      var a,
          r = o(125),
          n = o(903),
          i = (a = n) && a.__esModule ? a : {
        "default": a
      };
    },
    903: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = l(o(449)),
          r = o(125),
          n = o(132),
          i = l(o(904));

      function l(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      (0, n.addDep)({
        name: "multiAxislineAnimation",
        type: "animationRule",
        extension: i["default"]
      });

      var c = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return s(t, e), t.prototype.getType = function () {
          return "dataset";
        }, t.prototype.getName = function () {
          return "multiaxisline";
        }, t.prototype.configure = function (t) {
          if (!t) return !1;
          this.trimData(t), this.config.JSONData = t, e.prototype.configure.call(this, t);
        }, t.prototype.parseAttributes = function () {
          var t,
              o,
              a = this.config.JSONData,
              n = this.config,
              i = this.getFromEnv("chart-attrib"),
              l = this.getFromEnv("axisData");
          e.prototype.parseAttributes.call(this), n.linethickness = (0, r.pluckNumber)(a.linethickness, l.linethickness, i.linethickness, 2), n.lineDashLen = (0, r.pluckNumber)(a.linedashlen, l.linedashlen, i.linedashlen, 5), n.lineDashGap = (0, r.pluckNumber)(a.linedashgap, l.linedashgap, i.linedashgap, 4), n.alpha = (0, r.pluckNumber)(a.alpha, l.linealpha, i.linealpha, r.HUNDREDSTRING), n.linecolor = (0, r.pluck)(a.color, l.linecolor, l.color, i.linecolor, n.plotColor), n.legendSymbolColor = "line" === this.getName() ? n.lineColor : n.plotFillColor, o = (0, r.pluckNumber)(a.dashed, l.linedashed, i.linedashed), t = (0, r.getDashStyle)(n.lineDashLen, n.lineDashGap), n.anchorbordercolor = (0, r.pluck)(a.anchorbordercolor, a.color, l.color, i.anchorbordercolor, n.lineColor, n.plotColor), n.lineDashStyle = o ? t : "none";
        }, t;
      }(a["default"]);

      t["default"] = c;
    },
    904: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(452),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = {
        "*.dataset.multiaxisline": n["default"]["*.dataset.line"]
      };
    },
    905: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(906),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    906: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = i(o(459)),
          r = o(551),
          n = i(o(907));

      function i(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function l(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var s = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.defaultPlotShadow = 1, o;
        }

        return l(t, e), t.getName = function () {
          return "MSStepLine";
        }, t.prototype.getName = function () {
          return "MSStepLine";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.friendlyName = "Multi-series Step Line Chart", t.defaultDatasetType = "msstepline", t.drawverticaljoins = 1, t.useforwardsteps = 1, t.zeroplanethickness = 1, t.zeroplanealpha = 40, t.showzeroplaneontop = 0, t.enablemousetracking = !0, t.defaultcrosslinethickness = 1, r._setDefaultConfig.call(this);
        }, t.prototype.getDSGroupdef = function () {}, t.prototype.getDSdef = function () {
          return n["default"];
        }, t;
      }(a["default"]);

      t["default"] = s;
    },
    907: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = o(125),
          r = l(o(449)),
          n = o(132),
          i = l(o(908));

      function l(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      (0, n.addDep)({
        name: "stepLineAnimation",
        type: "animationRule",
        extension: i["default"]
      });

      var c = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return s(t, e), t.prototype.getType = function () {
          return "dataset";
        }, t.prototype.getName = function () {
          return "stepLine";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.drawverticaljoins = void 0, t.useforwardsteps = void 0;
        }, t.prototype._addLegend = function () {
          var e,
              t = this.config,
              o = this.getFromEnv("legend"),
              r = (0, a.pluckNumber)(t.drawanchors, 1),
              n = {
            enabled: t.includeinlegend,
            type: "line",
            drawLine: (0, a.pluck)(t.drawLine, !0),
            anchorSide: r ? t.anchorsides : 0,
            label: (0, a.getFirstValue)(this.config.JSONData.seriesname)
          };
          t.includeinlegend ? ((e = o.getItem(this.config.legendItemId)) || (this.config.legendItemId = o.createItem(this), e = o.getItem(this.config.legendItemId), this.addExtEventListener("fc-click", function () {
            e.itemClickFn();
          }, e)), e.configure(n), e.setStateCosmetics("default", {
            symbol: {
              fill: (0, a.toRaphaelColor)({
                color: t.anchorbgcolor,
                alpha: t.anchorbgalpha
              }),
              rawFillColor: t.anchorbgcolor,
              rawStrokeColor: t.anchorbordercolor,
              stroke: (0, a.toRaphaelColor)({
                color: t.anchorbordercolor,
                alpha: "100"
              }),
              "stroke-width": t.anchorborderthickness
            }
          }), this.getState("visible") ? e.removeLegendState("hidden") : e.setLegendState("hidden")) : this.config.legendItemId && o.disposeItem(this.config.legendItemId);
        }, t.prototype.getLinePath = function (e, t) {
          var o,
              r,
              n,
              i,
              l,
              s,
              c,
              u = this.config,
              p = this.getFromEnv("chartConfig"),
              h = (0, a.pluckNumber)(p.connectnulldata),
              d = {},
              f = this.getFromEnv("xAxis"),
              g = (0, a.pluckNumber)(u.drawverticaljoins),
              m = (0, a.pluckNumber)(u.useforwardsteps),
              v = (0, a.pluckNumber)(p.stepatmiddle) ? .5 * f.getPVR() : 0,
              b = d.lastValidValue || !1,
              y = d.temp || [],
              x = d.temp2 || [],
              k = d.pathArr || [],
              w = d.path2Arr || [],
              C = e.length,
              N = d.pointsJoined || 0,
              S = t && t.begin || 0,
              A = t && t.end || C,
              E = p.viewPortConfig.step || 1,
              D = [];

          for (D = D.concat(e), r = S; r < A; r += E) {
            (s = D[r]) && (void 0 === (c = (n = s.config).setValue) || n && !0 === n.isSkipped ? n && delete n.isSkipped : (i = n._Px, l = n._Py, null === c || c.isNull ? h || (y = [], x = [], b = !1) : b ? (y.length && (k = k.concat(y), y = [], N++), m ? (k.push(["H", i - v]), g ? k.push(["V", l]) : k.push(["M", i - v, l]), v && k.push(["H", i])) : (g ? k.push(["V", l]) : k.push(["M", o, l]), k.push(["H", i]), o = i)) : (y.push(["M", i, l]), o = i, N = 0, b = !0)));
          }

          return {
            pathArr: k,
            path2Arr: w,
            lastValidValue: b,
            pointsJoined: N,
            temp: y,
            temp2: x,
            getPathArr: function getPathArr() {
              var e = this.pathArr,
                  t = this.path2Arr;
              return e.length || t.length ? e.concat(t) : [];
            }
          };
        }, t;
      }(r["default"]);

      t["default"] = c;
    },
    908: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(452),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = {
        "*.dataset.stepLine": n["default"]["*.dataset.line"]
      };
    },
    909: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(910),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    910: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t.configurer = undefined;
      var a = p(o(863)),
          r = o(911),
          n = o(125),
          i = o(132),
          l = p(o(919)),
          s = o(865),
          c = p(o(537)),
          u = o(161);

      function p(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function h(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var d,
          f = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this)),
              a = o;

          return a.fireGroupEvent = !0, a.usesXYinCategory = !0, a.dontShowLegendByDefault = !0, o.registerFactory("dataset", l["default"], ["vCanvas"]), o.registerFactory("axis", c["default"], ["canvas"]), o;
        }

        return h(t, e), t.getName = function () {
          return "DragNode";
        }, t.prototype.getName = function () {
          return "DragNode";
        }, t.prototype._checkInvalidSpecificData = function () {
          if (!this.getFromEnv("dataSource").dataset) return !0;
        }, t.prototype._mouseEvtHandler = function (e, t) {
          (0, u._mouseEvtHandler)(this, e, t);
        }, t.prototype.parseChartAttr = function (t) {
          var o,
              a = this.getFromEnv("dataSource").chart,
              r = (0, i.getDepsByType)("transcoder");
          e.prototype.parseChartAttr.call(this, t), (o = this.config).formAction = (0, n.getValidValue)(a.formaction), o.showLegend = (0, n.pluckNumber)(a.showlegend, 0), a.submitdataasxml !== n.ZEROSTRING || a.formdataformat || (a.formdataformat = r.csv().format), o.formDataFormat = (0, n.pluck)(a.formdataformat, r.xml().format), o.formTarget = (0, n.pluck)(a.formtarget, "_self"), o.formMethod = (0, n.pluck)(a.formmethod, "POST"), o.submitFormAsAjax = (0, n.pluckNumber)(a.submitformusingajax, 1), o.viewMode = (0, n.pluckNumber)(a.viewmode, 0), o.drawTrendRegion = 0;
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.hasLegend = !0, t.friendlyName = "Dragable Node Chart", t.defaultDatasetType = "dragnode", t.limitUpdaterEnabled = !1, t.skipClipping = !0, t.numVDivLines = 0, t.numDivLines = 0, t.setadaptivexmin = 1, t.showLimits = 0, t.showdivlinevalues = 0, t.showzeroplane = 0, t.showyaxisvalues = 0, t.enablemousetracking = !0, t.showzeroplaneontop = 0;
        }, t.prototype.addConfigureOptions = function () {
          var e,
              t,
              o = this,
              a = o.config,
              r = a.restoreBtnTitle,
              n = a.submitBtnTitle,
              i = o.getFromEnv("toolbar"),
              l = i.getChild("hamburgerMenu-" + i.getId() + "-" + o.getId() + "-0"),
              c = o.config.viewMode,
              u = [{
            name: "Add Node",
            handler: function handler() {
              o.getChildren("canvas")[0].getChildren("vCanvas")[0].getChildren("datasetGroup_dragNode")[0].showNodeAddUI();
            },
            action: "click"
          }, {
            name: "Add Connector",
            handler: function handler() {
              o.getChildren("canvas")[0].getChildren("vCanvas")[0].getChildren("datasetGroup_dragNode")[0].showConnectorAddUI();
            },
            action: "click"
          }, {
            name: "Add Label",
            handler: function handler() {
              o.getChildren("canvas")[0].getChildren("vCanvas")[0].getChildren("datasetGroup_dragNode")[0].showLabelUpdateUI();
            },
            action: "click"
          }];
          a.showRestoreBtn && (e = {
            name: r,
            handler: function handler() {
              o.getChildren("canvas")[0].getChildren("vCanvas")[0].getChildren("datasetGroup_dragNode")[0].restoreData();
            },
            action: "click"
          }, u.push(e)), a.showFormBtn && (t = {
            name: n,
            handler: function handler() {
              s.submitData.call(o);
            },
            action: "click"
          }, u.push(t)), c || l.appendInMenu(u);
        }, t.prototype.getDSdef = function (e) {
          switch (e) {
            case "connector":
              return r.DragNodeConnector;

            case "dragnode":
              return r.DragNodeDataset;

            case "dragableLabels":
              return r.DragNodeLabels;
          }
        }, t.prototype.getDSGroupdef = function () {
          return r.DragNodeGroup;
        }, t.prototype._setCategories = function () {
          var e,
              t,
              o = this.getFromEnv("dataSource"),
              a = this.getChildren("xAxis"),
              r = o.categories && o.categories[0].category || [],
              n = r.length,
              i = [];

          for (e = 0; e < n; e++) {
            (t = r[e] || {}).x !== undefined && i.push(t);
          }

          a && a[0].setTickValues(i);
        }, t.prototype.getJSONData = function () {
          var e,
              t = this.getChildren("canvas")[0].getChildren("vCanvas")[0].getChildren("datasetGroup_dragNode")[0],
              o = this.getFromEnv("dataSource"),
              a = {};
          return t && (a = t.getJSONData()), (e = (0, n.extend2)({}, o)).dataset = a.dataset, e.connectors = a.connectors, e.labels = a.labels, e;
        }, t;
      }(a["default"]);

      t.configurer = d = f.prototype.configure, t["default"] = f, t.configurer = d;
    },
    911: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t.DragNodeGroup = t.DragNodeConnector = t.DragNodeLabels = t.DragNodeDataset = undefined;
      var a = l(o(912)),
          r = l(o(914)),
          n = l(o(916)),
          i = l(o(918));

      function l(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      t.DragNodeDataset = a["default"], t.DragNodeLabels = r["default"], t.DragNodeConnector = n["default"], t.DragNodeGroup = i["default"];
    },
    912: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = c(o(450)),
          r = o(125),
          n = o(132),
          i = c(o(913)),
          l = c(o(216)),
          s = c(o(539));

      function c(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function u(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var p = (0, n.getDep)("redraphael", "plugin"),
          h = Math.max,
          d = Math.min,
          f = r.preDefStr.CIRCLE,
          g = r.preDefStr.POLYGON,
          m = r.preDefStr.RECTANGLE,
          v = r.preDefStr.UNDERSCORE,
          b = r.preDefStr.GROUPID,
          y = r.preDefStr.EVENTARGS,
          x = r.preDefStr.OBJECTBOUNDINGBOX,
          k = r.preDefStr.DEFAULT,
          w = r.preDefStr.COMMA,
          C = r.preDefStr.POSITION_TOP,
          N = !!r.hasSVG,
          S = function S() {
        this.hide();
      },
          A = function A(e) {
        return e !== undefined && null !== e;
      },
          E = function E(e, t, o, a) {
        return t.setAnimation({
          el: "group",
          attr: {
            name: e
          },
          container: o,
          component: a
        });
      },
          D = function D(e, t, o) {
        var a, n, i;
        return e = (0, r.getFirstColor)(e), t = (0, r.getFirstAlpha)(t), n = (0, r.getLightColor)(e, 80), i = (0, r.getDarkColor)(e, 65), a = {
          FCcolor: {
            gradientUnits: x,
            color: n + w + i,
            alpha: t + w + t,
            ratio: r.BGRATIOSTRING
          }
        }, o ? a.FCcolor.angle = 1 === o ? 0 : 180 : (a.FCcolor.cx = .4, a.FCcolor.cy = .4, a.FCcolor.r = "50%", a.FCcolor.radialGradient = !0), a;
      },
          _ = function _(e, t, o) {
        var a,
            n = e.setTooltext,
            i = e.formatedVal,
            l = t.seriesname,
            s = e.label,
            c = e.xValue,
            u = e.pointLabel,
            p = t.tooltipSepChar;
        return n !== undefined ? a = (0, r.parseTooltext)(n, [3, 4, 5, 6, 8, 9, 10, 11], {
          yaxisName: (0, r.parseUnsafeString)(o.yaxisname),
          xaxisName: (0, r.parseUnsafeString)(o.xaxisname),
          yDataValue: i,
          xDataValue: c,
          label: s
        }, e, o, t) : u !== undefined ? a = s : null === i ? a = !1 : (t.seriesNameInToolTip && (l = (0, r.getFirstValue)(t.seriesname)), a = l ? l + p : r.BLANK, a += c ? c + p : r.BLANK, a += i), a;
      };

      (0, n.addDep)({
        name: "dragNodeAnimation",
        type: "animationRule",
        extension: i["default"]
      }), (0, l["default"])(p);

      var T = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return u(t, e), t.prototype.getName = function () {
          return "dragNode";
        }, t.prototype.getType = function () {
          return "dataset";
        }, t.prototype.hide = function () {
          var e = this.getLinkedParent(),
              t = {
            hide: !0
          };
          this.setState("dirty", !0), this.setState("visible", !1), e.childChanged(t), this.getFromEnv("chart").getChildren("legend")[0].getItem(this.config.legendItemId).setLegendState("hidden"), this.asyncDraw();
        }, t.prototype.show = function () {
          var e = this.getLinkedParent(),
              t = this.getFromEnv("legend").getItem(this.config.legendItemId),
              o = {
            show: !0
          };
          this.setState("visible", !0), this.setState("dirty", !0), e.childChanged(o), t && t.removeLegendState("hidden"), this.asyncDraw();
        }, t.prototype._setDatasetIndex = function () {
          var e = this.getLinkedParent().getChildren("dataset");
          this.config.datasetIndex = e.indexOf(this);
        }, t.prototype.pointInShape = function (e, t, o) {
          var a,
              r,
              n,
              i,
              l,
              s = this.getFromEnv("chart").getChildren("canvas")[0].config,
              c = o.symbol,
              u = o._xPos,
              p = o._yPos;
          return !(e < s.canvasLeft || e > s.canvasLeft + s.canvasWidth || t < s.canvasTop || t > s.canvasTop + s.canvasHeight) && ("rectangle" === c ? (i = o._plotWidth, p -= (l = o._plotHeight) / 2, e >= (u -= i / 2) && t >= p && e <= u + i && t <= p + l) : (a = (e - u) * (e - u), r = (t - p) * (t - p), n = Number(o.radius), a + r <= (n *= n)));
        }, t.prototype._firePlotEvent = function (e, t, o) {
          var a,
              n,
              i,
              l = this.getFromEnv("chart"),
              s = this.components,
              c = this.getFromEnv("toolTipController"),
              u = s.data[t] || {},
              p = this.getGraphicalElement("sharedAnchor"),
              h = u.graphics && u.graphics.element || void 0 !== (u.config && u.config.setValue) && p,
              d = this.config.currentToolTip,
              f = this.config.viewMode,
              g = this.getLinkedParent(),
              m = u.graphics.element;
          if (h) switch (i = (a = u.config).setLink, n = a.eventArgs, e) {
            case "fc-mouseover":
              this._decideTooltipType(t, o), this._rolloverResponseSetter(l, u, o), i && (h.node.style.cursor = r.POINTER);
              break;

            case "fc-mouseout":
              c.hide(d), this._rolloutResponseSetter(l, u, o), i && (h.node.style.cursor = k);
              break;

            case "fc-click":
              m.data("fire_click_event") && l.plotEventHandler(h, o, "dataplotclick", n);
              break;

            case "fc-mousemove":
              g.hideWaitElem(), this._decideTooltipType(t, o);
              break;

            case "fc-mousedown":
              clearTimeout(m._longpressactive), m.data("fire_click_event", 1), f || g.drawWaitingRing(u, this.config.datasetIndex);
              break;

            case "fc-mouseup":
              g.hideWaitElem(), g.clearLongPress();
          }
        }, t.prototype.dragUp = function (e) {
          this.data("drag-options").dataset._dragUp.call(this, e);
        }, t.prototype.dragMove = function (e, t) {
          var o = this.data("drag-options").dataset,
              a = t[0],
              r = t[1],
              n = t[2],
              i = t[3];

          o._dragMove.call(this, a, r, n, i);
        }, t.prototype.dragStart = function (e) {
          this.data("drag-options").dataset._dragStart.call(this, e);
        }, t.prototype._dragStart = function () {
          var e,
              t = this.data("drag-options"),
              o = t.dataObj,
              a = o.graphics.element,
              r = a.getBBox(),
              n = o.config,
              i = t.dataset,
              l = i.getFromEnv("chart"),
              s = n.dragStart || (n.dragStart = {}),
              c = o.graphics.cloneGraphic,
              u = i.getContainer("cloneGraphicGroup"),
              p = o.graphics.cloneText,
              h = o.graphics.image,
              d = o.graphics.cloneImage,
              f = o.graphics.label;
          N && (a._.dirty = 1), n.allowDrag && (!c && o.graphics.element && (c = o.graphics.cloneGraphic = o.graphics.element.clone(), u.appendChild(c)), f && !p && ((p = o.graphics.cloneText = o.graphics.label.clone()).followers[0] && p.followers[0].el && u.appendChild(p.followers[0].el), u.appendChild(p)), h && !d && (d = o.graphics.cloneImage = o.graphics.image.clone(), u.appendChild(d)), p && p.show(), d && d.show(), c && c.show()), s.xPos = n._xPos, s.yPos = n._yPos, s.x = n.x, s.y = n.y, s.bBox = r, s.origX = s.lastDx || (s.lastDx = 0), s.origY = s.lastDy || (s.lastDy = 0), e = a.data(y), l.fireChartInstanceEvent("dataplotdragstart", e), c && c.show(), p && p.show(), d && d.show();
        }, t.prototype._dragMove = function (e, t) {
          var o,
              a = this.data("drag-options"),
              r = a.dataObj,
              n = r.graphics.element,
              i = r.graphics.cloneGraphic,
              l = r.graphics.cloneImage,
              s = r.graphics.cloneText,
              c = r.config,
              u = c.dragStart,
              p = u.bBox.x + e,
              h = u.bBox.x2 + e,
              d = u.bBox.y + t,
              f = u.bBox.y2 + t,
              g = a.dataset,
              m = g.getFromEnv("animationManager"),
              v = g.getLinkedParent(),
              b = g.getFromEnv("chartConfig"),
              y = b.canvasLeft,
              x = b.canvasRight,
              k = b.canvasTop,
              C = b.canvasBottom;
          p < y && (e += y - p), h > x && (e -= h - x), d < k && (t += k - d), f > C && (t -= f - C), (e || t) && (n.data("fire_click_event", 0), v.hideWaitElem(), v.clearLongPress()), c.allowDrag && (u.draged = !0, u.lastDx = e, u.lastDy = t, o = a._transformObj = {
            transform: "t" + (u.origX + e) + w + (u.origY + t)
          }, i && m.setAnimation({
            el: i,
            attr: o,
            component: g
          }), l && m.setAnimation({
            el: l,
            attr: o,
            component: g
          }), s && m.setAnimation({
            el: s,
            attr: {
              x: c._xPos + e,
              y: c._yPos + t
            },
            component: g
          }));
        }, t.prototype._getHoveredPlot = function (e, t) {
          var o = this.config.tree.getNeighbour({
            x: e,
            y: t
          }, !1);
          if (o) return {
            pointIndex: o.index || o.i,
            hovered: !0,
            pointObj: o.data
          };
        }, t.prototype._rolloutResponseSetter = function (e, t, o) {
          var a = this.getFromEnv("animationManager"),
              n = t.config,
              i = t.graphics.element,
              l = n.dragStart,
              s = i.data("unHoverAttr");
          l && Object.keys(l).length || ("poly" !== n.shapeType && n.shapeType !== f || (s.path = (0, r.polyPathToPath)([n.shapeArg.sides, n._xPos, n._yPos, s.r, n.startAngle, 0])), n.rollOverProperties.enabled && a.setAnimation({
            el: i,
            attr: s,
            component: this
          }), e && e.plotEventHandler(i, o, "DataPlotRollOut"));
        }, t.prototype._rolloverResponseSetter = function (e, t, o) {
          var a = this.getFromEnv("animationManager"),
              n = t.config,
              i = t.graphics.element,
              l = n.dragStart,
              s = i.data("hoverAttr");
          l && Object.keys(l).length || ("poly" !== n.shapeType && n.shapeType !== f || (s.path = (0, r.polyPathToPath)([n.shapeArg.sides, n._xPos, n._yPos, s.r, n.startAngle, 0])), n.rollOverProperties.enabled && a.setAnimation({
            el: i,
            attr: s,
            component: this
          }), e && e.plotEventHandler(i, o, "DataPlotRollOver"));
        }, t.prototype._dragUp = function (e) {
          var t,
              o,
              a,
              n,
              i,
              l,
              s = this.data("drag-options"),
              c = s.dataset,
              u = c.getFromEnv("chart"),
              p = c.components.data,
              h = s.dataObj,
              d = h.graphics.element,
              f = c.getLinkedParent(),
              g = h.config,
              m = h.config.dragStart || {},
              v = c.getFromEnv("yAxis"),
              b = h.graphics.cloneText,
              x = c.getFromEnv("xAxis"),
              k = {},
              w = c.config.datasetIndex,
              C = h.graphics.cloneGraphic,
              N = h.graphics.cloneImage;

          if (f.hideWaitElem(), f.clearLongPress(), m.draged) {
            for (m.origX += m.lastDx, m.origY += m.lastDy, h.config._xPos = m.xPos + m.lastDx, h.config._yPos = m.yPos + m.lastDy, k.x = x.getValue(h.config._xPos), k.y = v.getValue(h.config._yPos), k.update = !0, a = 0, i = p.length; a < i && (n = p[a], h.config.id !== n.config.id); a++) {
              ;
            }

            c.updatePointConfig(k, a), (l = d.data(y)).x = k.x, l.y = k.y, c.parsePlotAttributes(a), c._drawNode(a), t = h.config.startConnectors, o = h.config.endConnectors, f.drawNodeConnectors(t, w), f.drawNodeConnectors(o, w), (0, r.getMouseCoordinate)(u.getFromEnv("chart-container"), e).sourceEvent = "dataplotdragend", u.fireChartInstanceEvent("chartupdated", (0, r.extend2)({
              sourceEvent: "dataplotdragend"
            }, l), e), u.fireChartInstanceEvent("dataplotdragend", l, e), m.draged = !1, c._setupKdTree();
          }

          b && b.hide(), C && C.hide(), N && N.hide(), delete g.dragStart;
        }, t.prototype.updatePointConfig = function (e, t) {
          var o,
              a = this.components.data,
              n = this.config,
              i = (a[t] || {}).config,
              l = this.getFromEnv("number-formatter"),
              s = this.getFromEnv("chart-attrib");
          i !== undefined && (i.y = l.getCleanValue((0, r.pluck)(e.y)), i.x = l.getCleanValue((0, r.pluck)(e.x)), i._options.x = i.x, i._options.y = i.y, o = l.xAxis(i.x), i.formatedVal = null === i.y ? i.y : l.dataLabels(i.y), i.xValue = o, n.showTooltip ? i.toolText = _(i, n, s) : i.toolText = !1, i.update = e.update);
        }, t.prototype.getNode = function (e) {
          return e ? this.components.nodes[e] : this.components.nodes;
        }, t.prototype.configureAttributes = function (e) {
          if (e) this.trimData(e), this.config.JSONData = e;else if (!e && !this.config.JSONData) return !1;
          var t,
              o,
              a,
              n,
              i,
              l,
              s,
              c = this.config.datasetIndex,
              u = this.config.JSONData,
              p = u.data || [],
              h = this.getFromEnv("chart-attrib"),
              d = this.getFromEnv("chartConfig"),
              f = p.length,
              g = this.config,
              m = r.ZEROSTRING,
              v = this.getFromEnv("color-manager"),
              b = r.HUNDREDSTRING;

          for (g.context = {}, this.components.nodes = {}, g.showValues = (0, r.pluckNumber)(u.showvalues, h.showvalues, 1), s = g.useRoundEdges = (0, r.pluckNumber)(h.useroundedges), g.zIndex = 1, g.name = (0, r.getValidValue)(u.seriesname), g.viewMode = (0, r.pluckNumber)(h.viewmode, 0), g.id = (0, r.pluck)(u.id, this.index), 0 !== (0, r.pluckNumber)(u.includeinlegend) && g.name !== undefined || (g.showInLegend = !1), g.seriesname = (0, r.parseUnsafeString)(u.seriesname), g.includeinlegend = (0, r.pluckNumber)(u.includeinlegend, g.seriesname ? 1 : 0), g.showTooltip = (0, r.pluckNumber)(h.showtooltip, 1), g.seriesNameInTooltip = (0, r.pluckNumber)(h.seriesnameintooltip, 1), g.tooltipSepChar = (0, r.pluck)(h.tooltipsepchar, " - "), o = g.plotFillAlpha = (0, r.pluck)(h.plotfillalpha, b), a = g.showPlotBorder = (0, r.pluckNumber)(h.showplotborder, 1), n = g.plotBorderColor = (0, r.getFirstColor)((0, r.pluck)(h.plotbordercolor, "666666")), i = g.plotBorderThickness = (0, r.pluckNumber)(h.plotborderthickness, s ? 2 : 1), l = g.plotBorderAlpha = (0, r.pluck)(h.plotborderalpha, h.plotfillalpha, s ? "35" : "95"), g.use3DLighting = Boolean((0, r.pluckNumber)(h.use3dlighting, h.is3d, s ? 1 : 0)), g.color = (0, r.getFirstColor)((0, r.pluck)(u.color, v.getPlotColor(c))), g.alpha = (0, r.pluck)(u.plotfillalpha, u.nodeFillAlpha, u.alpha, o), g.datasetShowPlotBorder = Boolean((0, r.pluckNumber)(u.showplotborder, a)), g.datasetPlotBorderColor = (0, r.getFirstColor)((0, r.pluck)(u.plotbordercolor, u.nodebordercolor, n)), g.datasetPlotBorderThickness = (0, r.pluckNumber)(u.plotborderthickness, u.nodeborderthickness, i), g.datasetPlotBorderAlpha = g.datasetShowPlotBorder ? (0, r.pluck)(u.plotborderalpha, u.nodeborderalpha, u.alpha, l) : m, g.datasetAllowDrag = Boolean((0, r.pluckNumber)(u.allowdrag, 1)), g.colorObj = {
            fillColor: (0, r.convertColor)(g.color, g.alpha),
            lineColor: {
              FCcolor: {
                color: g.datasetPlotBorderColor,
                alpha: g.datasetPlotBorderAlpha
              }
            }
          }, g.lineWidth = void 0, g.symbol = "poly_4", this.components.data || (this.components.data = []), this.setState("visible", 1 === (0, r.pluckNumber)(u.visible, !Number(u.initiallyhidden), 1)), g.yMin = g.yMax = g.xMax = g.xMin = 0, this._refreshData = !0, t = 0; t < f; t += 1) {
            this._setConfigure(t);
          }

          this._refreshData = !1, d.showLegend && this._addLegend(), this._setDatasetIndex(), this.setState("dirty", !0);
        }, t.prototype._setConfigure = function (e, t) {
          var o,
              a,
              n,
              i,
              l,
              s,
              c = this.config.JSONData,
              u = c.data,
              p = t || u[e],
              m = this.components.data,
              v = this.config,
              b = m[e] = m[e] || (m[e] = {}),
              y = b.config = b.config || (b.config = {}),
              x = v.id,
              k = v.yMin || +Infinity,
              w = v.yMax || -Infinity,
              N = v.xMax || -Infinity,
              S = v.xMin || +Infinity,
              E = v.use3DLighting,
              T = v.datasetPlotBorderThickness,
              L = v.datasetPlotBorderColor,
              P = v.datasetPlotBorderAlpha,
              O = this.getFromEnv("chart-attrib"),
              V = v.color,
              M = v.alpha,
              F = v.datasetAllowDrag,
              I = this.getFromEnv("number-formatter");

          if (!b.graphics && (b.graphics = {}), y._options = (0, r.extend2)({}, p), p || t) {
            if (a = y.y = I.getCleanValue((0, r.pluck)(p.y)), n = y.x = I.getCleanValue((0, r.pluck)(p.x)), y.index = e, y.dragStart || (y.dragStart = {}), w = h(w, y.y), k = d(k, y.y), N = h(N, y.x), S = d(S, y.x), null === a) y.value = null;else {
              switch (i = I.xAxis(n), y.formatedVal = null === a ? a : I.dataLabels(a), y.setTooltext = (0, r.getValidValue)((0, r.parseUnsafeString)((0, r.pluck)(p.tooltext, c.plottooltext, O.plottooltext))), y.pointLabel = (0, r.pluck)(p.label, p.name), l = (0, r.parseUnsafeString)(y.pointLabel), y.label = l, y.name = l, y.displayValue = l, y.xValue = i, t || (y.startConnectors = {}, y.endConnectors = {}), v.showTooltip ? y.toolText = _(y, v, O) : y.toolText = !1, y.link = p.link, y.id = (0, r.pluck)(p.id, x + r.preDefStr.UNDERSCORE + e), y.allowDrag = Boolean((0, r.pluckNumber)(p.allowdrag, F)), o = y.shape = (0, r.getValidValue)((0, r.pluck)(p.shape), r.preDefStr.RECTANGLE).toLowerCase(), y.height = (0, r.getValidValue)((0, r.pluck)(p.height), 10), y.width = (0, r.getValidValue)((0, r.pluck)(p.width), 10), y.radius = (0, r.getValidValue)((0, r.pluck)(p.radius), 10), y.numSides = (0, r.getValidValue)((0, r.pluck)(p.numsides), 4), y.color = (0, r.getFirstColor)((0, r.pluck)(p.color, V)), y.borderColor = (0, r.getFirstColor)((0, r.pluck)(p.bordercolor, L)), y.alpha = (0, r.pluck)(p.alpha, M), y.imageURL = (0, r.getValidValue)(p.imageurl), y.imageNode = Boolean((0, r.pluckNumber)(p.imagenode)), y.imageWidth = p.imagewidth, y.imageHeight = p.imageheight, y.imageAlign = (0, r.getValidValue)(p.imagealign, r.BLANK).toLowerCase(), y.labelAlign = (0, r.pluck)(p.labelalign, y.imageNode && A(y.imageURL) ? C : r.preDefStr.POSITION_MIDDLE), y.hovercolor = (0, r.pluck)(p.hovercolor, c.hovercolor), y.borderhoveralpha = (0, r.pluck)(p.borderhoveralpha, c.borderhoveralpha), y.borderhovercolor = (0, r.pluck)(p.borderhovercolor, c.borderhovercolor), y.borderhoverthickness = (0, r.pluck)(p.borderhoverthickness, c.borderhoverthickness), y.hoveralpha = (0, r.pluck)(p.hoveralpha, c.hoveralpha), y.hoverheight = (0, r.pluck)(p.hoverheight, c.hoverheight), y.hoverradius = (0, r.pluck)(p.hoverradius, c.hoverradius), y.hoverwidth = (0, r.pluck)(p.hoverwidth, c.hoverwidth), y.shape) {
                case f:
                  s = 0;
                  break;

                case g:
                  s = 2, o = (0, r.mapSymbolName)(y.numSides);
                  break;

                default:
                  s = 1;
              }

              y.symbol = o, E ? (y.fillColor = D(y.color, y.alpha, s), y.cloneFillColor = D(y.color, 50, s)) : (y.fillColor = {
                color: y.color,
                alpha: y.alpha
              }, y.cloneFillColor = (0, r.convertColor)(y.color, 50)), y.colorArr = [{
                FCcolor: {
                  color: y.color,
                  alpha: y.alpha
                }
              }, {
                FCcolor: {
                  color: y.borderColor,
                  alpha: P
                }
              }], y.rollOverProperties = this.pointHoverOptions(b, O, {
                shapeType: s,
                use3D: E,
                height: y.height,
                width: y.width,
                radius: y.radius,
                color: y.color,
                alpha: y.alpha,
                borderColor: y.borderColor,
                borderAlpha: P,
                borderThickness: T
              });
            }
            !y.update && t && (y.update = t.update), !y.add && t && (y.add = t.add), !0 === this._refreshData && delete b.removed;
          }

          b.dataset = this, v.xMax = N, v.xMin = S, v.yMin = k, v.yMax = w;
        }, t.prototype.pointHoverOptions = function (e, t, o) {
          var a,
              n,
              i,
              l = (0, r.pluckNumber)(e.config.showhovereffect, this.config.showhovereffect, t.plothovereffect, t.showhovereffect),
              s = {},
              c = !!(0, r.pluck)(e.config.hovercolor, this.config.hovercolor, t.plotfillhovercolor, e.config.hoveralpha, this.config.hoveralpha, t.plotfillhoveralpha, e.config.borderhovercolor, this.config.borderhovercolor, t.plotborderhovercolor, e.config.borderhoveralpha, this.config.borderhoveralpha, t.plotborderhoveralpha, e.config.borderhoverthickness, this.config.borderhoverthickness, t.plotborderhoverthickness, e.config.hoverheight, this.config.hoverheight, t.plothoverheight, e.config.hoverwidth, this.config.hoverwidth, t.plothoverwidth, e.config.hoverradius, this.config.hoverradius, t.plothoverradius, l),
              u = !1;
          return (l === undefined && c || l) && (u = !0, a = (0, r.pluck)(e.config.hovercolor, this.config.hovercolor, t.plotfillhovercolor, (0, r.getLightColor)(o.color, 70)), n = (0, r.pluck)(e.config.hoveralpha, this.config.hoveralpha, t.plotfillhoveralpha, o.alpha), s = {
            stroke: (0, r.convertColor)((0, r.pluck)(e.config.borderhovercolor, this.config.borderhovercolor, t.plotborderhovercolor, o.borderColor), (0, r.pluckNumber)(e.config.borderhoveralpha, this.config.borderhoveralpha, t.plotborderhoveralpha, n, o.borderAlpha)),
            "stroke-width": (0, r.pluckNumber)(e.config.borderhoverthickness, this.config.borderhoverthickness, t.plotborderhoverthickness, o.borderThickness),
            height: (0, r.pluckNumber)(e.config.hoverheight, this.config.hoverheight, t.plothoverheight, o.height),
            width: (0, r.pluckNumber)(e.config.hoverwidth, this.config.hoverwidth, t.plothoverwidth, o.width),
            r: (0, r.pluckNumber)(e.config.hoverradius, this.config.hoverradius, t.plothoverradius, o.radius)
          }, i = o.use3D ? D((0, r.getFirstColor)((0, r.pluck)(e.config.hovercolor, this.config.hovercolor, t.plotfillhovercolor, (0, r.getLightColor)(o.color, 70))), (0, r.pluck)(e.config.hoveralpha, this.config.hoveralpha, t.plotfillhoveralpha, o.alpha), o.shapeType) : (0, r.convertColor)(a, n), s.fill = (0, r.toRaphaelColor)(i)), {
            enabled: u,
            rollOverAttrs: s
          };
        }, t.prototype._addLegend = function () {
          var e,
              t = this.config,
              o = this.getFromEnv("legend"),
              a = {
            enabled: t.includeInLegend,
            type: this.type,
            anchorSide: 4,
            label: (0, r.getFirstValue)(this.config.JSONData.seriesname)
          };
          t.includeinlegend ? ((e = o.getItem(this.config.legendItemId)) ? e.configure({
            style: o.config.itemStyle,
            hiddenStyle: o.config.itemHiddenStyle,
            datasetVisible: o.config.datasetVisible,
            hoverStyle: o.config.itemHoverStyle
          }) : (this.config.legendItemId = o.createItem(this), e = o.getItem(this.config.legendItemId), this.addExtEventListener("fc-click", function () {
            e.itemClickFn();
          }, e)), e.configure(a), e.setStateCosmetics("default", {
            symbol: {
              fill: (0, r.toRaphaelColor)({
                color: t.color,
                alpha: t.alpha
              }),
              rawFillColor: t.color,
              stroke: (0, r.toRaphaelColor)({
                color: t.plotBorderColor,
                alpha: r.HUNDREDSTRING
              }),
              "stroke-width": t.anchorBorderThickness
            }
          }), this.getState("visible") ? e.removeLegendState("hidden") : e.setLegendState("hidden")) : this.config.legendItemId && o.disposeItem(this.config.legendItemId);
        }, t.prototype.createContainer = function () {
          var e = this.getFromEnv("animationManager"),
              t = this.getLinkedParent().getChildContainer();
          !this.getContainer("nodesGroup") && this.addContainer("nodesGroup", E("nodesGroup", e, t.defaultVcanvasGroup, this)), !this.getContainer("dataLabelsGroup") && this.addContainer("dataLabelsGroup", E("dataLabelsGroup", e, t.vcanvasLabelGroup, this)), !this.getContainer("cloneGraphicGroup") && this.addContainer("cloneGraphicGroup", E("cloneGraphicGroup", e, t.defaultVcanvasGroup, this));
        }, t.prototype.draw = function () {
          var e,
              t,
              o,
              a = this.components,
              r = this.getFromEnv("smartLabel"),
              n = a.data,
              i = this.components.removeDataArr || [],
              l = i.length,
              s = this.getFromEnv("dataLabelStyle"),
              c = {
            fontFamily: s.fontFamily,
            fontSize: s.fontSize,
            lineHeight: s.lineHeight,
            fontWeight: s.fontWeight,
            fontStyle: s.fontStyle
          };

          if (this.getState("dirty") || this._contextChanged()) {
            for (this.createContainer(), o = this.getContainer("nodesGroup"), this.getFromEnv("animationManager").setAnimation({
              el: this.getContainer("cloneGraphicGroup"),
              attr: {
                opacity: .3
              },
              component: this
            }), o.css(c), r.useEllipsesOnOverflow(this.getFromEnv("chartConfig").useEllipsesWhenOverflow), e = 0, t = n.length; e < t; e += 1) {
              !n[e].removed && this._drawNode(e);
            }

            for (this.config.drawn = !0, e = 0; e < l; e++) {
              this._removeDataVisuals(i.shift());
            }

            this._setupKdTree();
          }
        }, t.prototype._setupKdTree = function () {
          var e,
              t,
              o,
              a,
              n,
              i = this.config,
              l = this.components.data,
              c = -Infinity;

          for (n = i.searchDataArr = [], e = l.length, t = 0; t < e; t++) {
            o = l[t].config, l[t].removed || o._yPos === undefined || isNaN(o._yPos) || (a = o.props.element.attr, c = Math.max(c, (0, r.pluckNumber)(o.radius, 0)), n.push({
              x: (0, r.pluckNumber)(a.x, o._xPos),
              y: (0, r.pluckNumber)(a.y, o._yPos),
              index: t,
              data: l[t],
              shapeInfo: {
                type: o.shape,
                radius: (0, r.pluck)(o.radius, 0),
                width: (0, r.pluckNumber)(o.width),
                height: (0, r.pluckNumber)(o.height),
                sides: (0, r.pluckNumber)(o.numSides)
              }
            }));
          }

          i.tree = new s["default"](!0).buildKdTree(n), i.tree._setSearchLimit(c, c);
        }, t.prototype.drawLabel = function (e) {
          var t,
              o,
              a,
              n,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              d,
              f,
              g,
              m,
              v,
              x,
              k,
              w,
              N,
              S,
              E,
              D,
              _ = this.getFromEnv("chart"),
              T = this.config.datasetIndex,
              L = this.getFromEnv("animationManager"),
              P = this.components.data,
              O = P.length,
              V = this.getContainer("nodesGroup"),
              M = this.getFromEnv("chartConfig"),
              F = this.getFromEnv("dataLabelStyle"),
              I = this.dragUp,
              B = this.dragMove,
              R = this.dragStart,
              j = this.getFromEnv("smartLabel"),
              G = this.getState("visible");

          for (j.setStyle(F), e !== undefined ? O = (t = e) + 1 : t = 0; t < O; t++) {
            if (v = (n = (p = P[t]).config)._plotWidth, x = n._plotHeight, i = n.displayValue, k = n.labelAlign, m = (w = p.graphics).cloneText, N = p.config.rollOverProperties, S = n.shapeType, G && (A(i) || i !== r.BLANK)) {
              switch (j.useEllipsesOnOverflow(M.useEllipsesWhenOverflow), c = .5 * x - .5 * (s = j.getSmartText(i, v - 1, x - 1)).height, k) {
                case C:
                  c = -c;
                  break;

                case r.POSITION_BOTTOM:
                  break;

                default:
                  c = 0;
              }

              d = n._xPos, E = n._yPos, p._yAdjustment = h = c, f = E + h, l = n.link ? r.POINTER : n.allowDrag ? "move" : r.BLANKSTRING, o = {
                text: s.text,
                title: s.tooltext || r.BLANKSTRING,
                fill: F.color,
                "text-bound": [F.backgroundColor, F.borderColor, F.borderThickness, F.borderPadding, F.borderRadius, F.borderDash],
                x: d,
                y: f,
                cursor: l
              }, a = w.label, a = L.setAnimation({
                el: a || "text",
                attr: o,
                container: V,
                component: this
              }), w.label ? a.show() : (a = this.addGraphicalElement("plotLabel", a, !0), w.label = a, a.drag(B, R, I)), (D = w && (w.image || w.element)) && a.insertAfter(D), m && L.setAnimation({
                el: m,
                attr: {
                  transform: r.BLANKSTRING,
                  x: d,
                  y: f,
                  text: s.text,
                  title: s.tooltext || r.BLANKSTRING,
                  fill: F.color,
                  "text-bound": [F.backgroundColor, F.borderColor, F.borderThickness, F.borderPadding, F.borderRadius, F.borderDash]
                },
                component: this
              }), a.data("drag-options", {
                dataObj: p,
                dataset: this,
                datasetIndex: T,
                pointIndex: p.config.index,
                cursor: l,
                chart: _,
                link: p.link
              }), u = {
                index: t,
                link: n.link,
                y: n.y,
                x: n.x,
                shape: (0, r.pluck)(S, "rect"),
                width: n.width,
                height: n.height,
                radius: n.radius,
                sides: n.numSides,
                label: n.displayValue,
                toolText: n.toolText,
                id: n.id,
                datasetIndex: T,
                datasetName: this.config.JSONData.seriesname,
                sourceType: "dataplot"
              }, g = T + "_" + t, a.data(b, g), a.data(y, u), a.data("hoverAttr", N && N.rollOverAttrs), a.data("unHoverAttr", D.data("unHoverAttr"));
            } else w.label && w.label.hide();
          }
        }, t.prototype.parsePlotAttributes = function (e) {
          var t,
              o,
              a,
              n,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              d,
              g,
              b,
              y,
              x,
              k,
              w,
              C,
              N,
              S,
              A,
              E,
              D = this.config.datasetIndex,
              _ = this.components,
              T = _.nodes,
              L = this.getFromEnv("xAxis"),
              P = this.getFromEnv("yAxis"),
              O = _.data[e],
              V = O.config,
              M = this.config,
              F = O.graphics || (O.graphics = {}),
              I = V.symbol,
              B = M.colorObj.lineColor,
              R = M.datasetPlotBorderThickness,
              j = O.config.rollOverProperties,
              G = V.shape,
              H = V.link ? r.POINTER : V.allowDrag ? "move" : r.BLANKSTRING,
              W = F.cloneImage;

          if (V._yPos = o = P.getPixel(V.y), V._xPos = t = L.getPixel(V.x), o !== undefined && !isNaN(o)) {
            if (V.shapeArg = {}, c = V.shapeArg, n = (0, r.pluckNumber)(V.height), a = (0, r.pluckNumber)(V.width), i = (0, r.pluckNumber)(V.radius), g = I === m, l = V.id, s = V.imageNode, u = V.imageURL, p = V.imageAlign, h = g ? a : 1.4 * i, b = (0, r.pluckNumber)(V.imageWidth, h), d = g ? n : 1.4 * i, y = (0, r.pluckNumber)(V.imageHeight, d), w = (0, r.toRaphaelColor)(V.fillColor), V._plotWidth = h, V._plotHeight = d, k = {
              fill: w,
              "stroke-width": R,
              stroke: (0, r.toRaphaelColor)(B)
            }, N = [(I = (I = c.symbol = (0, r.pluck)(V.symbol, M.symbol, r.BLANK)).split(v))[1], t, o, V.radius, V.startAngle, 0], "poly" === I[0] || I[0] === f ? (V.shapeType = I[0], V.elemType = "path", S = {
              path: (0, r.polyPathToPath)(N)
            }, c.x = t, c.y = o, c.radius = V.radius, c.sides = I[1], k.r = V.radius, delete k.width, delete k.x, delete k.y, delete k.height, j && j.enabled && (delete (C = j.rollOverAttrs).x, delete C.y, delete C.width, delete C.height)) : (V.shapeType = r.SHAPE_RECT, V.elemType = "rect", c.x = t - a / 2, c.y = o - n / 2, c.r = 0, c.width = a, c.height = n, S = {
              x: c.x,
              y: c.y,
              width: a,
              height: n,
              r: 0
            }, k.width = a, k.height = n, k.x = t - a / 2, k.y = o - n / 2, j && j.enabled && ((C = j.rollOverAttrs).x = t - C.width / 2, C.y = o - C.height / 2, delete C.r)), S.fill = w, S["stroke-width"] = R, S.stroke = (0, r.toRaphaelColor)(B), V.eventArgs = {
              index: e,
              link: V.link,
              y: V.y,
              x: V.x,
              shape: (0, r.pluck)(G, "rect"),
              width: a,
              height: n,
              radius: i,
              sides: V.numSides,
              label: V.displayValue,
              toolText: V.toolText,
              id: V.id,
              datasetIndex: D,
              datasetName: this.config.JSONData.seriesname,
              sourceType: "dataplot"
            }, s && u) {
              switch (y > d && (y = d), b > h && (b = h), p) {
                case r.POSITION_MIDDLE:
                  x = o - y / 2;
                  break;

                case r.POSITION_BOTTOM:
                  x = d > y ? o + d / 2 - y : o - y / 2;
                  break;

                default:
                  x = d > y ? o - .5 * d : o - y / 2;
              }

              V.imageX = t - b / 2, V.imageY = x, V.imageWidth = b, V.imageHeight = y, E = {
                src: u,
                x: V.imageX,
                y: x,
                width: b,
                height: y,
                cursor: H
              }, W && (A = {
                transform: r.BLANKSTRING,
                src: u,
                x: V.imageX,
                y: x,
                width: b,
                height: y
              });
            }

            V.pointAttr = k, T[l] = O, V.props = {
              element: {
                attr: S
              },
              imageElement: {
                attr: E
              },
              cloneImage: {
                attr: A
              },
              cloneGraphic: {
                attr: S
              }
            };
          }
        }, t.prototype.allocatePosition = function (e) {
          var t, o;
          if (o = this.components.data.length, e !== undefined) this.parsePlotAttributes(e);else for (t = 0; t < o; t++) {
            this.parsePlotAttributes(t);
          }
        }, t.prototype._drawNode = function (e) {
          var t,
              o,
              a = this.getFromEnv("chart"),
              n = this.config.datasetIndex,
              i = this.getLinkedParent(),
              l = this.components,
              s = this.getFromEnv("animationManager"),
              c = l.data[e],
              u = c.config,
              p = c.graphics || (c.graphics = {}),
              h = u.imageNode,
              d = u.imageURL,
              f = this.getContainer("nodesGroup"),
              g = c.config.rollOverProperties,
              m = this.dragUp,
              v = this.dragMove,
              x = this.dragStart,
              k = u.link ? r.POINTER : u.allowDrag ? "move" : r.BLANKSTRING,
              w = p.graphic,
              C = p.cloneText,
              N = p.cloneGraphic,
              A = p.cloneImage,
              E = p.image,
              D = p.label,
              _ = this.getState("visible");

          u._yPos === undefined || isNaN(u._yPos) ? (p.element && (p.element = s.setAnimation({
            el: p.element,
            component: this
          })), p.image && (p.image = s.setAnimation({
            el: p.image,
            component: this
          })), p.label && (p.label = s.setAnimation({
            el: p.label,
            component: this
          }))) : (o = (w = p.element) && w.type, -1 === u.elemType.indexOf(o) && w && (w.remove(), w = p.element = null, D && D.remove(), E && E.remove(), delete p.label, delete p.image, E = null, D = null), w = s.setAnimation({
            el: w || u.elemType,
            label: "node",
            attr: u.props.element.attr,
            container: f,
            component: this
          }), p.graphic || w.drag(v, x, m), p.element = w, w.show(), i.animationDone = !0, t = n + "_" + e, N && (N.type === w.type ? s.setAnimation({
            el: N,
            attr: u.props.element.attr,
            component: this
          }).transform(r.BLANKSTRING) : (N.remove(), delete c.graphics.cloneGraphic, C && (C.remove(), delete c.graphics.cloneText))), h && d ? (E = s.setAnimation({
            el: p.image || "image",
            attr: _ && u.props.imageElement.attr,
            doNotRemove: !0,
            container: f,
            component: this,
            callback: !_ && S
          }), !p.image && E && E.drag(v, x, m), p.image = E, _ && E.show(), E.data("drag-options", {
            dataObj: c,
            dataset: this,
            datasetIndex: this.index,
            pointIndex: c.config.index,
            cursor: k,
            link: c.link
          }), E.data(b, t), E.data(y, u.eventArgs), E.data("hoverAttr", g && g.rollOverAttrs), E.data("unHoverAttr", u.pointAttr), A && s.setAnimation({
            el: A,
            attr: u.props.cloneImage.attr,
            component: this
          })) : p.image && (p.image = s.setAnimation({
            el: p.image,
            component: this
          })), this.drawLabel(e), s.setAnimation({
            el: w,
            attr: {
              cursor: k
            },
            component: this
          }), w.data("drag-options", {
            dataObj: c,
            dataset: this,
            datasetIndex: this.index,
            pointIndex: c.config.index,
            cursor: k,
            chart: a,
            link: c.link
          }), w.data(b, t), w.data(y, u.eventArgs), w.data("hoverAttr", g && g.rollOverAttrs), w.data("unHoverAttr", u.pointAttr), _ ? w.show() : w.hide());
        }, t.prototype.trimData = function (e) {
          if (this.config.JSONData) {
            var t = this.components,
                o = t.data && t.data.length,
                a = e.data && e.data.length || 0,
                r = o - a;
            r > 0 && this.removeData(a, r);
          }
        }, t.prototype.removeData = function (e, t) {
          var o = this.components,
              a = this.getLinkedParent(),
              r = o.data,
              n = o.removeDataArr || (o.removeDataArr = []);
          t = t || 1, (e = e || 0) < 0 && (e = 0), o.removeDataArr = n = n.concat(r.splice(e, t)), a._clearConnectors();
        }, t.prototype._removeDataVisuals = function (e) {
          var t, o, a;
          if (e) for (t in o = e.graphics) {
            (a = o[t]).hide && "function" == typeof a.hide && (this.getFromEnv("animationManager").setAnimation({
              el: a,
              attr: {
                "text-bound": []
              },
              component: this
            }), a.hide(), a.transform && a.transform(r.BLANKSTRING));
          }
        }, t.prototype.getJSONData = function () {
          var e,
              t,
              o = this.components.data,
              a = o.length,
              r = [];

          for (t = 0; t < a; t++) {
            (e = o[t]).removed || e.config._options && (delete e.config._options.update, delete e.config._options.add, r.push(e.config._options));
          }

          return r;
        }, t;
      }(a["default"]);

      t["default"] = T;
    },
    913: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = {
        "initial.dataset.dragNode": function initialDatasetDragNode() {
          return {
            "node.appearing": function nodeAppearing() {
              return [{
                initialAttr: {
                  opacity: 0
                },
                finalAttr: {
                  opacity: 1
                },
                slot: "axis"
              }];
            }
          };
        }
      };
    },
    914: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = l(o(912)),
          r = o(125),
          n = o(132),
          i = l(o(915));

      function l(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var c = r.preDefStr.PX,
          u = "rgba(192,192,192," + (r.isIE ? .002 : 1e-6) + ")",
          p = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return (0, n.addDep)({
            name: "draggablelabelAnimation",
            type: "animationRule",
            extension: i["default"]
          }), o;
        }

        return s(t, e), t.prototype.getType = function () {
          return "dataset";
        }, t.prototype.getName = function () {
          return "dragNodeLabels";
        }, t.prototype.configure = function (e) {
          if (e) this.trimData(e), this.config.JSONData = e.label;else if (!e && !this.config.JSONData) return !1;
          var t,
              o = this.getFromEnv("chart-attrib"),
              a = this.config,
              n = (this.config.JSONData || []).length,
              i = this.components.data;

          for (a.viewMode = (0, r.pluckNumber)(o.viewmode, 0), i || (i = this.components.data = []), t = 0; t < n; t++) {
            this._setConfigure(t);
          }
        }, t.prototype._setConfigure = function (e, t) {
          var o,
              a,
              n,
              i,
              l = this.config.JSONData,
              s = t || l[e],
              u = this.components.data,
              p = this.getFromEnv("style").inCanvasStyle,
              h = p.fontSize;
          !(o = u[e]) && (o = u[e] = {}), !o.graphics && (o.graphics = {}), n = o.config = o.config || (o.config = {}), a = (0, r.parseUnsafeString)((0, r.pluck)(s.text, s.label)), n._options = s, n.add = s.add, a && (n.text = a, n.x = s.x || 0, n.y = s.y || 0, n.labelFontSize = i = (0, r.pluckNumber)(s.fontsize, h), n.labelColor = (0, r.hashify)((0, r.pluck)(s.color, p.color)), n.alpha = (0, r.pluckNumber)(s.alpha, 100) / 100, n.allowDrag = (0, r.pluckNumber)(s.allowdrag, 1), n.padding = (0, r.pluckNumber)(s.padding, 5), s.fontsize ? n.labelCSS = {
            fontSize: i + c
          } : n.labelCSS = {}, n.labelBGColor = (0, r.pluck)(s.bgcolor && s.bgcolor.replace(r.dropHash, r.HASHSTRING)), n.labelBDColor = (0, r.pluck)(s.bordercolor && s.bordercolor.replace(r.dropHash, r.HASHSTRING)), n.link = s.link, n.borderThickness = s.borderthickness, n.dashLen = s.dashlen, n.dashGap = s.dashgap, n.dashed = s.dashed, n.radius = s.radius);
        }, t.prototype.getJSONData = function () {
          var e,
              t,
              o = this.components.data,
              a = o.length,
              r = [];

          for (t = 0; t < a; t++) {
            (e = o[t]).removed || e.config._options && r.push(e.config._options);
          }

          return r;
        }, t.prototype.createContainer = function () {
          var e = this.getFromEnv("animationManager"),
              t = this.getLinkedParent().getChildContainer();
          !this.getContainer("dragLabelGroup") && this.addContainer("dragLabelGroup", e.setAnimation({
            el: "group",
            attr: {
              name: "dragLabelGroup"
            },
            label: "group",
            component: this,
            container: t.defaultVcanvasGroup
          }));
        }, t.prototype.allocatePosition = function () {
          this.parsePlotAttributes();
        }, t.prototype.parsePlotAttributes = function () {
          var e,
              t,
              o,
              a,
              n,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              d,
              f,
              g,
              m,
              v,
              b,
              y,
              x,
              k,
              w = this.components.data,
              C = this.getFromEnv("yAxis"),
              N = this.getFromEnv("xAxis"),
              S = this.getFromEnv("smartLabel"),
              A = this.getFromEnv("dataLabelStyle"),
              E = w && w.length,
              D = this.getFromEnv("chartConfig");

          for (x = 0; x < E; x++) {
            (d = w[x]).removed || (p = d.config, !d.graphics && (d.graphics = {}), p.index = x, a = N.getPixel(p.x), n = C.getPixel(p.y), l = p.text, s = p.labelBGColor, c = p.labelBDColor, u = p.padding, f = p.allowDrag, g = p.labelFontSize, i = p.labelColor, m = p.radius, o = p.dashed, b = p.borderThickness, e = p.dashLen, t = p.dashGap, b = p.borderThickness, k = p.labelCSS, h = {
              x: a,
              y: n,
              text: l,
              align: r.POSITION_CENTER,
              fill: i,
              "text-bound": [s || r.BLANKSTRING, c || r.BLANKSTRING, (0, r.pluckNumber)(b, 1), u, (0, r.pluckNumber)(m, 0), (0, r.pluckNumber)(o, 0) ? (0, r.getDashStyle)((0, r.pluckNumber)(e, 5), (0, r.pluckNumber)(t, 4)) : r.DASH_DEF],
              visibility: r.visibleStr
            }, y = {
              backgroundColor: s,
              borderColor: c,
              borderPadding: u,
              fontSize: g + r.PXSTRING,
              fontStyle: A.fontStyle,
              fontWeight: A.fontWeight,
              borderRadius: 0,
              borderDash: r.DASH_DEF,
              fontFamily: A.fontFamily
            }, (0, r.setLineHeight)(y), S.useEllipsesOnOverflow(D.useEllipsesWhenOverflow), S.setStyle(y), k["line-height"] = y.lineHeight, p.eventArgs = {
              link: p.link,
              text: l,
              x: a,
              y: n,
              allowdrag: f,
              sourceType: "labelnode"
            }, p.props = {
              element: {
                attr: h
              }
            }, p.labelCSSApplied = k, v = S.getOriSize(l), p.width = v.width, p.height = v.height, p.xPos = a, p.yPos = n);
          }
        }, t.prototype.draw = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              i = this.components.data,
              l = this.getFromEnv("animationManager"),
              s = this.getFromEnv("dataLabelStyle"),
              c = i && i.length,
              u = this.components.removeDataArr || [],
              p = u.length;

          for (this.createContainer(), (n = this.getContainer("dragLabelGroup")).css({
            "font-weight": s.fontWeight,
            "font-style": s.fontStyle,
            "font-size": s.fontSize,
            "font-family": s.fontFamily
          }), r = 0; r < c; r++) {
            (t = i[r]).removed || (e = t.config, a = t.graphics.element, o = l.setAnimation({
              el: a || "text",
              container: n,
              css: e.labelCSS,
              attr: e.props.element.attr,
              component: this
            }), a ? (e.labelCSSApplied && o.removeCSS(), o.show().css(e.labelCSS)) : t.graphics.element = o, o.data("eventArgs", e.eventArgs));
          }

          for (this.drawTracker(), r = 0; r < p; r++) {
            this._removeDataVisuals(u.shift());
          }
        }, t.prototype.drawTracker = function () {
          var e,
              t,
              o,
              a,
              n,
              i,
              l,
              s,
              c,
              p,
              h,
              d,
              f,
              g,
              m = this,
              v = m.components.data,
              b = m.getFromEnv("animationManager"),
              y = m.getFromEnv("chart"),
              x = m.getLinkedParent(),
              k = m.config,
              w = m.getContainer("dragLabelGroup"),
              C = v && v.length,
              N = function N() {
            var e = this.data("drag-options"),
                t = e.dataset,
                o = e.index,
                a = t.components.data[o];
            this.data("fire_click_event", 1), x.clearLongPress(), x.triggerLabelUI(this, a);
          },
              S = function S() {
            this.data("fire_click_event") && (this.data("fire_click_event", 0), x.clearLongPress());
          },
              A = function A(e) {
            var t = this.data("fire_click_event");
            x.clearLongPress(), t && y.plotEventHandler(this, e, "LabelClick");
          },
              E = function E(e) {
            y.plotEventHandler(this, e, "LabelRollover");
          },
              D = function D(e) {
            y.plotEventHandler(this, e, "LabelRollout");
          },
              _ = function _(e, t) {
            m._labelDragMove.call(this, e, t, y);
          },
              T = function T(e) {
            m._labelDragStart.call(this, e, y);
          },
              L = function L(e) {
            m._labelDragUp.call(this, e);
          };

          for (g = 0; g < C; g++) {
            (e = v[g]).removed || (o = (t = e.config).padding || 0, d = t.width, f = t.height, p = t.xPos - d / 2, h = t.yPos - f / 2, i = t.allowDrag, l = t.text, c = e.graphics.trackerElement, n = {
              x: p - o,
              y: h - o,
              width: d + 2 * o,
              height: f + 2 * o,
              cursor: t.allowDrag ? "move" : r.BLANKSTRING,
              fill: u,
              stroke: u
            }, a = {
              link: t.link,
              text: l,
              x: p,
              y: h,
              allowdrag: i,
              sourceType: "labelnode"
            }, s = b.setAnimation({
              el: c || "rect",
              container: w,
              attr: n,
              component: m
            }), c || (e.graphics.trackerElement = s, s.on("fc-mousedown", N).on("fc-mousemove", S).on("fc-mouseup", A).data("viewMode", k.viewMode).data(r.preDefStr.EVENTARGS, a).hover(E, D), t.allowDrag && s.drag(_, T, L)), s.data("drag-options", {
              index: g,
              dataset: m
            }));
          }
        }, t.prototype._labelDragStart = function () {
          var e = this.getBBox(),
              t = this.data("drag-options"),
              o = t.dataset,
              a = o.getLinkedParent(),
              r = t.index,
              n = o.components.data[r],
              i = n.graphics.element,
              l = n.dragStart = n.dragStart || (n.dragStart = {});
          t.ox = i.attr("x"), t.oy = i.attr("y"), t.bBox = e, l.xPos = n.config.xPos, l.yPos = n.config.yPos, l.bBox = e, this.data("fire_click_event", 1), this.data("fire_dragend", 0), a.clearLongPress(), a.triggerLabelUI(this, n);
        }, t.prototype._labelDragMove = function (e, t) {
          var o,
              a,
              r = this.data("drag-options"),
              n = r.index,
              i = r.dataset,
              l = i.getFromEnv("chart"),
              s = i.getFromEnv("chartConfig"),
              c = s.canvasLeft,
              u = s.canvasRight,
              p = s.canvasBottom,
              h = s.canvasTop,
              d = i.getLinkedParent(),
              f = i.components.data[n],
              g = f.graphics.element,
              m = f.dragStart,
              v = m.bBox,
              b = t[0],
              y = t[1],
              x = m.bBox.x + b,
              k = m.bBox.x2 + b,
              w = m.bBox.y + y,
              C = m.bBox.y2 + y,
              N = i.getFromEnv("yAxis"),
              S = i.getFromEnv("xAxis");
          x < c && (b += c - x), k > u && (b -= k - u), w < h && (y += h - w), C > p && (y -= C - p), m.draged = !0, this.attr({
            x: v.x + b,
            y: v.y + y
          }), o = r.ox + b, a = r.oy + y, g.attr({
            x: r.ox + b,
            y: r.oy + y
          }), f.config.x = S.getValue(o), f.config.y = N.getValue(a), this.data("fire_dragend") || (l.plotEventHandler(this, e, "LabelDragStart"), this.data("fire_dragend", 1)), this.data("fire_click_event") && (this.data("fire_click_event", 0), d.clearLongPress());
        }, t.prototype._labelDragUp = function (e) {
          var t = this.data("drag-options"),
              o = t.index,
              a = t.dataset,
              n = a.getFromEnv("chart"),
              i = n.getChildren("xAxis")[0],
              l = n.getChildren("yAxis")[0],
              s = a.getLinkedParent(),
              c = a.components.data[o].dragStart,
              u = this.data("eventArgs");
          u.x = i.getValue(this.attr("x")), u.y = l.getValue(this.attr("y")), c.draged = !1, this.data("fire_dragend") && (n.fireChartInstanceEvent("chartupdated", (0, r.extend2)({
            sourceEvent: "labeldragend"
          }, u), e), n.fireChartInstanceEvent("chartupdated", u, e), n.plotEventHandler(this, e, "labeldragend")), s.clearLongPress();
        }, t.prototype.removeData = function (e, t) {
          var o = this.components,
              a = o.data;
          o.removeDataArr = a.splice(e, t);
        }, t.prototype.trimData = function (e) {
          if (this.config.JSONData) {
            var t = this.config.JSONData,
                o = t && t.length,
                a = e.label && e.label.length || 0,
                r = o - a;
            r > 0 && this.removeData(a, r);
          }
        }, t;
      }(a["default"]);

      t["default"] = p;
    },
    915: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = {
        "initial.dataset.dragNodeLabels": function initialDatasetDragNodeLabels() {
          return {
            "group.appearing": function groupAppearing() {
              return [{
                initialAttr: {
                  opacity: 0
                },
                finalAttr: {
                  opacity: 1
                },
                slot: "plot"
              }];
            }
          };
        }
      };
    },
    916: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = l(o(912)),
          r = o(125),
          n = o(132),
          i = l(o(917));

      function l(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var c = r.preDefStr.EVENTARGS,
          u = r.preDefStr.configStr,
          p = function p(e) {
        var t,
            o = e.config,
            a = o.fromPointObj,
            n = o.toPointObj,
            i = o.fromX,
            l = o.fromY,
            s = o.toX,
            c = o.toY,
            u = ["M", i, l];
        return o.arrowAtStart && (u = (t = a.config).shapeType === r.SHAPE_RECT ? u.concat(d._drawArrow(i, l, s, c, t.shapeArg.width, t.shapeArg.height)) : u.concat(d._drawArrow(i, l, s, c, t.shapeArg.radius))), o.arrowAtEnd && (u = (t = n.config).shapeType === r.SHAPE_RECT ? u.concat(d._drawArrow(s, c, i, l, t.shapeArg.width, t.shapeArg.height)) : u.concat(d._drawArrow(s, c, i, l, t.shapeArg.radius))), u.push("L", s, c), u;
      },
          h = function h(e, t, o) {
        return o.getFromEnv("animationManager").setAnimation({
          el: "group",
          attr: {
            name: e
          },
          container: t,
          component: o,
          label: "group"
        });
      };

      (0, n.addDep)({
        name: "connectorAnimation",
        type: "animationRule",
        extension: i["default"]
      });

      var d = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return s(t, e), t.prototype.getType = function () {
          return "dataset";
        }, t.prototype.getName = function () {
          return "dragNodeConnector";
        }, t.prototype._setDatasetIndex = function () {
          var e = this.getLinkedParent().getChildren("connector");
          this.config.datasetIndex = e.indexOf(this);
        }, t.prototype.configureAttributes = function (e) {
          if (e) this.trimData(e), this.config.JSONData = e;else if (!e && !this.config.JSONData) return !1;
          var t,
              o = this.getFromEnv("chart-attrib"),
              a = this.config,
              n = this.config.JSONData,
              i = n.connector,
              l = i && i.length,
              s = r.HUNDREDSTRING;

          for (a.connectorsTooltext = (0, r.getValidValue)((0, r.parseUnsafeString)((0, r.pluck)(n.connectortooltext, o.connectortooltext))), a.stdThickness = (0, r.pluckNumber)(n.stdthickness, 1), a.conColor = (0, r.getFirstColor)((0, r.pluck)(n.color, "FF5904")), a.conAlpha = (0, r.pluck)(n.alpha, s), a.conDashGap = (0, r.pluckNumber)(n.dashgap, 5), a.conDashLen = (0, r.pluckNumber)(n.dashlen, 5), a.conDashed = Boolean((0, r.pluckNumber)(n.dashed, 0)), a.arrowAtStart = Boolean((0, r.pluckNumber)(n.arrowatstart, 1)), a.arrowAtEnd = Boolean((0, r.pluckNumber)(n.arrowatend, 1)), a.conStrength = (0, r.pluckNumber)(n.strength, 1), a.toolTipSepChar = (0, r.pluck)(o.tooltipsepchar, " - "), a.showTooltip = (0, r.pluckNumber)(o.showtooltip, 1), a.viewMode = (0, r.pluckNumber)(o.viewmode, 1), a._refreshData = !0, this._setDatasetIndex("connector"), t = 0; t < l; t += 1) {
            this._setConfigure(t, i[t]);
          }

          a._refreshData = !0;
        }, t.prototype._setConfigure = function (e, t) {
          var o,
              a,
              n,
              i = this.components.data || (this.components.data = []),
              l = i[e] || (i[e] = i[e] = {}),
              s = this.config,
              c = (0, r.parseUnsafeString)((0, r.pluck)(t.label, t.name)),
              u = (0, r.pluck)(t.alpha, s.conAlpha),
              p = this.getFromEnv("smartLabel"),
              h = "$fromLabel" + s.toolTipSepChar + "$toLabel",
              d = {
            FCcolor: {
              color: (0, r.getFirstColor)((0, r.pluck)(t.color, s.conColor)),
              alpha: u
            }
          },
              f = s.connectorsTooltext,
              g = (0, r.getValidValue)((0, r.parseUnsafeString)((0, r.pluck)(t.tooltext, f))),
              m = Boolean((0, r.pluckNumber)(t.dashed, s.conDashed));
          p.setStyle(this.getFromEnv("dataLabelStyle")), p.useEllipsesOnOverflow(this.getFromEnv("chartConfig").useEllipsesWhenOverflow), n = p.getOriSize(c), a = l.config = l.config || (l.config = {}), !l.graphics && (l.graphics = {}), o = !!s.showTooltip && (0, r.pluck)(g, c ? "$label" : h), (a = l.config = {
            _options: t,
            id: (0, r.pluck)(t.id, e).toString(),
            from: (0, r.pluck)(t.from, r.BLANK),
            to: (0, r.pluck)(t.to, r.BLANK),
            label: c,
            toolText: o,
            customToolText: g,
            color: d,
            index: e,
            dashStyle: m ? (0, r.getDashStyle)((0, r.pluckNumber)(t.dashlen, s.conDashLen), (0, r.pluckNumber)(t.dashgap, s.conDashGap)) : r.DASH_DEF,
            dashed: t.dashed,
            dashlen: t.dashlen,
            dashgap: t.dashgap,
            arrowAtStart: Boolean((0, r.pluckNumber)(t.arrowatstart, s.arrowAtStart)),
            arrowAtEnd: Boolean((0, r.pluckNumber)(t.arrowatend, s.arrowAtEnd)),
            conStrength: (0, r.pluckNumber)(t.strength, s.conStrength),
            link: t.link,
            stdThickness: s.stdThickness,
            labelWidth: n.widht,
            labelHeight: n.height
          }).datasetIndex = this.config.datasetIndex, a.add = t.add, a.update = t.update, s._refreshData && delete l.removed;
        }, t.prototype.createContainer = function () {
          var e = this.getLinkedParent().getChildContainer();
          !this.getContainer("connectorGroup") && this.addContainer("connectorGroup", h("connectorGroup", e.connectorGroup, this)), !this.getContainer("connectorDataLabelGroup") && this.addContainer("connectorDataLabelGroup", h("connectorDataLabelGroup", e.connectorGroup, this));
        }, t.prototype.draw = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              i,
              l = this.getLinkedParent(),
              s = this.config,
              c = this.components.data,
              u = this.getFromEnv("dataLabelStyle"),
              p = c.length,
              h = this.components.removeDataArr || [],
              d = h.length;

          for (this.createContainer(), s.cleared = !1, this.getContainer("connectorDataLabelGroup").css(u), n = 0; n < p; n++) {
            t = (i = (e = c[n]).config).from, o = i.to, a = l.getNode(t), r = l.getNode(o), a && r && !0 !== i.deleted && this.drawConnector(e, a, r, n);
          }

          for (this.config.drawn = !0, n = 0; n < d; n++) {
            this._removeDataVisuals(h.shift());
          }
        }, t.prototype.parsePlotAttributes = function (e, t, o) {
          var a,
              n,
              i,
              l,
              s,
              c,
              u,
              h,
              d,
              f,
              g,
              m,
              v = this.getFromEnv("number-formatter"),
              b = e.config,
              y = b.eventArgs || (b.eventArgs = {});
          b.fromPointObj = t, b.toPointObj = o, d = t.config, f = o.config, b.fromX = a = d._xPos, b.fromY = i = d._yPos, b.toX = n = f._xPos, b.toY = l = f._yPos, b._labelX = (a + n) / 2, b._labelY = (i + l) / 2, b.strokeWidth = s = b.conStrength * b.stdThickness, g = b.color, b.textBgColor = g && g.FCcolor && g.FCcolor.color, y.label = b.label, y.arrowAtStart = b.arrowAtStart, y.arrowAtEnd = b.arrowAtEnd, y.link = b.link, y.id = b.id, y.fromNodeId = d.id, y.toNodeId = f.id, b.toolText = (0, r.parseTooltext)(b.toolText, [3, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92], {
            label: b.label,
            fromXValue: v.dataLabels(t.config.x),
            fromYValue: v.dataLabels(t.config.y),
            fromXDataValue: t.config.x,
            fromYDataValue: t.config.y,
            fromLabel: (0, r.pluck)(t.config.displayValue, t.config.id),
            toXValue: v.dataLabels(o.config.x),
            toYValue: v.dataLabels(o.config.y),
            toXDataValue: o.config.x,
            toYDataValue: o.config.y,
            toLabel: (0, r.pluck)(o.config.displayValue, o.config.id)
          }), d = t.config, f = o.config, u = d.startConnectors || (d.startConnectors = {}), h = f.endConnectors || (f.endConnectors = {}), u[m = e.config.id + "-" + d.id + "-" + f.id] = e, h[m] = e, c = p(e), b.props = {
            element: {
              attr: {
                path: c,
                "stroke-width": s,
                "stroke-dasharray": b.dashStyle,
                cursor: b.link ? r.POINTER : r.BLANKSTRING,
                stroke: (0, r.toRaphaelColor)(g)
              }
            }
          };
        }, t.prototype.allocatePosition = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              i,
              l = this.getLinkedParent(),
              s = this.components.data,
              c = s.length;

          for (e = 0; e < c; e++) {
            a = (o = (t = s[e]).config).from, r = o.to, n = l.getNode(a), i = l.getNode(r), n && i && !0 !== o.deleted && this.parsePlotAttributes(t, n, i, e);
          }
        }, t.prototype.drawConnector = function (e) {
          var t,
              o,
              a = this.getFromEnv("toolTipController"),
              r = this.getFromEnv("animationManager"),
              n = e.graphics,
              i = this.getContainer("connectorGroup"),
              l = e.config,
              s = l.toolText,
              p = l.eventArgs || (l.eventArgs = {}),
              h = this.config,
              d = this.components.pool || {};
          e.removed || (t = o = n.graphic, n.graphic || d.graphic && d.graphic.path && d.graphic.path.length && (o = n.graphic = d.graphic.path.shift()), t = r.setAnimation({
            el: o || "path",
            container: i,
            attr: l.props.element.attr,
            label: "path",
            component: this
          }), o || (n.graphic = t, t.on("fc-mousedown", this.mouseDown).on("fc-mousemove", this.mousemove).on("fc-mouseup", this.mouseup).hover(this.hoverIn, this.hoverOut)), t.show().data(c, p).data("viewMode", h.viewMode).data(u, l).data("dataset", this), h.showTooltip ? a.enableToolTip(t, s) : a.disableToolTip(t), this.drawLabel(e));
        }, t.prototype.drawLabel = function (e) {
          var t,
              o,
              a,
              n,
              i,
              l,
              s,
              p,
              h,
              d,
              f,
              g = this,
              m = g.getFromEnv("toolTipController"),
              v = g.config,
              b = g.getFromEnv("animationManager"),
              y = g.getContainer("connectorDataLabelGroup"),
              x = g.getFromEnv("dataLabelStyle"),
              k = g.components.data,
              w = g.components.pool || {},
              C = k.length,
              N = function N(e) {
            t = e.config, a = t.toolText, s = e.graphics, o = t.label, h = t._labelX, d = t._labelY, f = t.textBgColor, o ? (l = s.text = s.text || w.element && w.element.text && w.element.text.shift(), n = {
              text: o,
              fill: x.color,
              direction: r.BLANKSTRING,
              cursor: t.link ? r.POINTER : r.BLANKSTRING,
              "text-bound": [(0, r.pluck)(x.backgroundColor, f), (0, r.pluck)(x.borderColor, f), 1, "2"],
              x: h,
              y: d
            }, (i = b.setAnimation({
              el: l || "text",
              attr: n,
              container: y,
              label: "text",
              component: g
            })).show(), l || (s.text = i, i.on("fc-mousedown", g.mouseDown).on("fc-mousemove", g.mousemove).on("fc-mouseup", g.mouseup).hover(g.hoverIn, g.hoverOut)), i.data(c, t.eventArgs).data("viewMode", v.viewMode).data(u, t).data("dataset", g), v.showTooltip ? m.enableToolTip(i, a) : m.disableToolTip(i)) : s.text && s.text.hide();
          };

          if (e) N(e);else for (p = 0; p < C; p++) {
            N(k[p]);
          }
        }, t.prototype.mouseDown = function () {
          var e = this.data("dataset").getLinkedParent();
          e.clearLongPress(), this.data("fire_click_event", 1), e.triggerConnectorUI(this);
        }, t.prototype.mousemove = function () {
          var e = this.data("dataset").getLinkedParent();
          this.data("fire_click_event", 0), e.clearLongPress();
        }, t.prototype.mouseup = function () {
          this.data("dataset").getLinkedParent().clearLongPress();
        }, t.prototype.hoverIn = function (e) {
          this.data("dataset").getFromEnv("chart").plotEventHandler(this, e, "ConnectorRollover");
        }, t.prototype.hoverOut = function (e) {
          this.data("dataset").getFromEnv("chart").plotEventHandler(this, e, "ConnectorRollout");
        }, t._drawArrow = function (e, t, o, a, r, n) {
          var i,
              l,
              s,
              c,
              u = (t - a) / (e - o),
              p = Math.atan(u),
              h = [];
          return p < 0 && (p = 2 * Math.PI + p), a > t ? (o >= e && p > Math.PI || o < e && p > Math.PI) && (p -= Math.PI) : (o >= e && p < Math.PI && 0 !== p || o < e && p < Math.PI) && (p += Math.PI), void 0 === n ? (i = e + r * Math.cos(p), l = t + r * Math.sin(p)) : (s = Math.abs(r) / 2, c = Math.abs(n) / 2, i = e + (s = e < o ? s : -s), l = t + s * Math.tan(p), Math.abs(t - l) > Math.abs(c) && (l = t + (c = t < a ? c : -c), i = e + c / Math.tan(p))), h.push("L", i, l, i + 10 * Math.cos(p + .79), l + 10 * Math.sin(p + .79), "M", i + 10 * Math.cos(p - .79), l + 10 * Math.sin(p - .79), "L", i, l), h;
        }, t.prototype.removeData = function (e, t) {
          var o = this.components,
              a = o.data;
          e < 0 && (e = 0), o.removeDataArr = a.splice(e, t);
        }, t.prototype.trimData = function (e) {
          if (this.config.JSONData) {
            var t = this.components,
                o = t.data && t.data.length,
                a = e.connector && e.connector.length || 0,
                r = o - a;
            r > 0 && this.removeData(a, r);
          }
        }, t;
      }(a["default"]);

      t["default"] = d;
    },
    917: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = {
        "initial.dataset.dragNodeConnector": function initialDatasetDragNodeConnector() {
          return {
            "path.appearing": function pathAppearing() {
              return [{
                initialAttr: {
                  opacity: 0
                },
                finalAttr: {
                  opacity: 1
                },
                slot: "plot"
              }];
            },
            "text.appearing": function textAppearing() {
              return [{
                initialAttr: {
                  opacity: 0,
                  "text-bound": "none"
                },
                finalAttr: {
                  opacity: 1
                },
                slot: "final"
              }];
            },
            "*": null
          };
        }
      };
    },
    918: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(138),
          n = o(914),
          i = (a = n) && a.__esModule ? a : {
        "default": a
      },
          l = o(125);

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var c,
          u,
          p,
          h = {
        circle: "circ",
        rectangle: "rect",
        polygon: "poly"
      },
          d = void 0,
          f = l.preDefStr.INPUT,
          g = l.preDefStr.BLANKSPACE,
          m = l.preDefStr.BLANK,
          v = l.preDefStr.PX,
          b = l.preDefStr.LABEL,
          y = l.preDefStr.DATASET,
          x = l.preDefStr.COMMA,
          k = "appearing",
          w = function w(e) {
        return e !== d && null !== e;
      },
          C = function C(e, t) {
        switch (e.shape) {
          case l.preDefStr.CIRCLE:
            e.radius = t.radius;
            break;

          case l.preDefStr.POLYGON:
            e.radius = t.radius, e.sides = t.numsides;
            break;

          default:
            e.width = t.width, e.height = t.height;
        }
      },
          N = (c = function c() {
        for (var e, t = this.getGraphicalElement("cacheUpdateUI"), o = t.fields.shape, a = ["rectWidth", "rectHeight", "circPolyRadius", "polySides"], r = a.length; r--;) {
          /rect|poly|circ/gi.test(e = a[r]) && (t.labels[e].hide(), t.fields[e].hide()), new RegExp((0, l.pluck)(o.val(), "rect"), "ig").test(e) && (t.labels[e].show(), t.fields[e].show());
        }
      }, u = function u() {
        var e = this.getGraphicalElement("cacheUpdateUI").fields,
            t = (0, l.getValidColor)(e.color.val());
        t && e.colorOut.css({
          background: (0, l.parseColor)(t)
        });
      }, p = function p(e) {
        var t,
            o,
            a,
            r = this.getGraphicalElement("cacheUpdateUI"),
            n = this.getFromEnv("animationManager"),
            i = r.fields.image,
            l = this.getFromEnv("chartConfig").height,
            s = i.val(),
            c = ["imgWidth", "imgHeight", "imgAlign", "imgUrl"];

        for (t = s ? 250 : 215, e && (r.ok.hide(), r.cancel.hide(), r.removeItem.hide(), r.error.hide()), o = c.length; !s && o--;) {
          a = c[o], r.labels[a].hide(), r.fields[a].hide();
        }

        e && n.setAnimationState("uichange"), n.setAnimation({
          el: r.dialog,
          state: "updating",
          attr: {
            top: (l - t) / 2,
            height: t
          },
          component: this,
          label: "uidialog",
          callback: function callback() {
            for (o = c.length; o-- && s;) {
              a = c[o], r.labels[a].show(), r.fields[a].show();
            }

            r.ok.attr({
              y: t - 23 - 5
            }).show(), r.cancel.attr({
              y: t - 23 - 5
            }).show(), r.removeItem.attr({
              y: t - 23 - 5
            }), r.error.attr({
              y: t - 23 - 5 + 4
            }).show(), r.edit ? r.removeItem.show() : r.removeItem.hide();
          }
        });
      }, function (e, t) {
        var o,
            a,
            r = this,
            n = r.getGraphicalElement("cacheUpdateUI"),
            i = r.getFromEnv("style").inCanvasStyle || {},
            s = r.getFromEnv("paper"),
            h = {
          width: 80 + v,
          border: "1px solid #cccccc",
          fontSize: 10 + v,
          lineHeight: 15 + v,
          padding: 2 + v,
          fontFamily: i.fontFamily
        },
            f = {
          textAlign: "right"
        },
            g = n && n.fields,
            y = n && n.labels;
        r.getFromEnv("animationManager").setAnimationState("uichange"), n || (o = !0), n = r.addGraphicalElement("cacheUpdateUI", r.createHtmlDialog(350, 215, function (e) {
          e.stopPropagation();
          var t,
              o,
              a,
              i,
              s,
              c = n && n.fields,
              u = n.edit,
              p = c.shape.val();

          if (t = r.getFromEnv("xAxis").getLimit().min, o = r.getFromEnv("yAxis").getLimit().min, c) {
            switch (s = {
              x: (0, l.getFirstValue)(c.x.val(), t),
              y: (0, l.getFirstValue)(c.y.val(), o),
              id: i = c.id.val(),
              datasetId: c.dataset.val(),
              name: c.label.val(),
              tooltext: c.tooltip.val(),
              color: c.color.val(),
              alpha: c.alpha.val(),
              labelalign: c.labelalign.val(),
              allowdrag: c.draggable.val(),
              imagenode: c.image.val(),
              imagewidth: c.imgWidth.val(),
              imageheight: c.imgHeight.val(),
              imagealign: c.imgAlign.val(),
              imageurl: c.imgUrl.val(),
              link: c.link.val()
            }, p) {
              case "circ":
                s.shape = l.preDefStr.CIRCLE, s.radius = c.circPolyRadius.val();
                break;

              case "poly":
                s.shape = l.preDefStr.POLYGON, s.radius = c.circPolyRadius.val(), s.numsides = c.polySides.val();
                break;

              default:
                s.shape = l.preDefStr.RECTANGLE, s.width = c.rectWidth.val(), s.height = c.rectHeight.val();
            }

            if (r.getNode(s.id) && (a = !0), !a || u !== d) return void (((i = s.datasetId) !== l.BLANKSTRING || u) && (i = Number(i), u ? r.updateNode(s) : r.addNode(s), n.hide(), n.visible = !1));
            n.error.attr({
              text: "ID already exist."
            }), c.label.focus();
          }

          n.enableFields();
        }, function (e) {
          e.stopPropagation(), n.hide(), n.visible = !1, n.enableFields(), n.error.attr({
            text: m
          }), n.visible = !1;
        }, function (e) {
          e.stopPropagation(), r.deleteNode(n.fields.id.val()), n.hide(), n.visible = !1;
        }, n)), o && (a = n.dialog, y = n.labels = {}, g = n.fields = {}), n.config = e, n.edit = t, n.error || (n.error = s.html("span", {
          color: "ff0000",
          x: 30,
          y: 228
        }, d, a)), n.enableFields || (n.enableFields = function () {
          var t;

          for (t in e) {
            e[t] && e[t].disabled && g[t] && g[t].element.removeAttribute("disabled");
          }
        }), n.clearFields || (n.clearFields = function () {
          var e,
              t = n.fields;

          for (e in t) {
            t[e].element.disabled || (t[e].element.value = l.BLANKSTRING);
          }
        }), (0, l.fcEach)(this.nodeUpdateUIDefinition, function (t) {
          var o,
              i,
              d,
              v = t.key,
              x = {},
              k = e[v] || {};
          !y[v] && (y[v] = s.html(b, {
            x: t.x,
            y: t.y,
            width: t.labelWidth || 45,
            text: t.text
          }, f, a)), t.noInput || ((o = g[v]) || (h.border = "checkbox" == t.type ? m : "1px solid #cccccc", o = g[v] = s.html(t.inputType || "input", {
            x: t.labelWidth && t.labelWidth + 5 || 50,
            y: -2 + (t.inputPaddingTop || 0),
            width: t.inputWidth || 50,
            name: v || l.BLANKSTRING
          }, h), "select" !== t.inputType && o.attr({
            type: t.type || "text"
          }).on("keyup", n.handleKeyPress), o.add(y[v])), w(i = (0, l.getFirstValue)(k.innerHTML, t.innerHTML)) && (x.innerHTML = i), k.disabled ? x.disabled = "disabled" : o.element && (o.element.disabled = !1), o.attr(x), w(d = (0, l.getFirstValue)(k.value, t.value)) && o.val(d), "shape" === v && o.on("change", function () {
            c.call(r);
          }), "image" === v && o.on("click", function () {
            p.call(r, !0);
          }), "color" === v && o.on("keyup", function () {
            u.call(r);
          }));
        }), u.call(this), p.call(this), c.call(this), n.visible = !0, n.fields[t ? b : "id"].focus();
      }),
          S = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this)),
              a = o;

          return a.setState("visible", !0), a.connectorUpdateUIDefinition = [{
            key: "fromid",
            text: "Connect From",
            inputType: "select",
            x: 10,
            y: 15,
            labelWidth: 80,
            inputWidth: 100
          }, {
            key: "toid",
            text: "Connect To",
            inputType: "select",
            x: 10,
            y: 40,
            labelWidth: 80,
            inputWidth: 100
          }, {
            key: "arratstart",
            text: "Arrow At Start",
            x: 200,
            y: 15,
            type: "checkbox",
            inputPaddingTop: 3,
            labelWidth: 80,
            inputWidth: 15
          }, {
            key: "arratend",
            text: "Arrow At End",
            x: 200,
            y: 40,
            type: "checkbox",
            inputPaddingTop: 3,
            labelWidth: 80,
            inputWidth: 15
          }, {
            key: b,
            text: "Label",
            x: 10,
            y: 75,
            labelWidth: 40,
            inputWidth: 120
          }, {
            key: "id",
            text: "Node ID",
            x: 190,
            y: 75,
            inputWidth: 55
          }, {
            key: "color",
            text: "Color",
            x: 10,
            y: 100,
            labelWidth: 40,
            inputWidth: 35
          }, {
            key: "alpha",
            text: "Alpha",
            x: 110,
            y: 100,
            inputWidth: 25,
            labelWidth: 35
          }, {
            key: "strength",
            text: "Strength",
            x: 190,
            y: 100,
            inputWidth: 55,
            val: "0.1"
          }, {
            key: "url",
            text: "Link",
            x: 10,
            y: 125,
            labelWidth: 40,
            inputWidth: 120
          }, {
            key: "tooltext",
            text: "Tooltip",
            x: 190,
            y: 125,
            labelWidth: 40,
            inputWidth: 60
          }, {
            key: "dashed",
            text: "Dashed",
            x: 10,
            y: 150,
            type: "checkbox",
            inputPaddingTop: 3,
            inputWidth: 15,
            labelWidth: 40
          }, {
            key: "dashgap",
            text: "Dash Gap",
            x: 85,
            y: 150,
            labelWidth: 60,
            inputWidth: 25
          }, {
            key: "dashlen",
            text: "Dash Length",
            x: 190,
            y: 150,
            labelWidth: 70,
            inputWidth: 30
          }], a.nodeUpdateUIDefinition = [{
            key: "id",
            text: "Id",
            inputWidth: 60,
            x: 10,
            y: 15
          }, {
            key: y,
            text: y,
            inputType: "select",
            inputWidth: 110,
            innerHTML: d,
            x: 170,
            y: 15
          }, {
            key: "x",
            text: "Value",
            x: 10,
            y: 40,
            inputWidth: 21
          }, {
            key: "y",
            text: x,
            x: 88,
            y: 40,
            inputWidth: 21,
            labelWidth: 5
          }, {
            text: "(x, y)",
            x: 125,
            y: 40,
            labelWidth: 33,
            noInput: !0
          }, {
            key: "tooltip",
            text: "Tooltip",
            inputWidth: 105,
            x: 170,
            y: 40
          }, {
            key: b,
            text: "Label",
            inputWidth: 92,
            x: 10,
            y: 65
          }, {
            key: "labelalign",
            text: "Align",
            labelWidth: 70,
            inputWidth: 110,
            inputType: "select",
            innerHTML: '<option></option><option value="top">Top</option><option value="middle">Middle</option><option value="bottom">Bottom</option>',
            x: 145,
            y: 63
          }, {
            key: "color",
            text: "Color",
            x: 10,
            y: 90,
            inputWidth: 60
          }, {
            key: "colorOut",
            innerHTML: "&nbsp;",
            x: 85,
            y: 90,
            inputWidth: 15,
            inputType: "span"
          }, {
            key: "alpha",
            text: "Alpha",
            x: 170,
            y: 90,
            inputWidth: 20
          }, {
            key: "draggable",
            text: "Allow Drag",
            value: !0,
            inputWidth: 20,
            x: 250,
            y: 90,
            labelWidth: 58,
            inputPaddingTop: 3,
            type: "checkbox"
          }, {
            key: "shape",
            text: "Shape",
            inputType: "select",
            inputWidth: 97,
            innerHTML: '<option value="rect">Rectangle</option><option value="circ">Circle</option><option value="poly">Polygon</option>',
            x: 10,
            y: 115
          }, {
            key: "rectHeight",
            text: "Height",
            x: 170,
            y: 115,
            inputWidth: 20
          }, {
            key: "rectWidth",
            text: "Width",
            x: 255,
            y: 115,
            inputWidth: 20
          }, {
            key: "circPolyRadius",
            text: "Radius",
            x: 170,
            y: 115,
            inputWidth: 20
          }, {
            key: "polySides",
            text: "Sides",
            x: 255,
            y: 115,
            inputWidth: 20
          }, {
            key: "link",
            text: "Link",
            x: 10,
            y: 140,
            inputWidth: 92
          }, {
            key: "image",
            text: "Image",
            type: "checkbox",
            inputPaddingTop: 4,
            inputWidth: 20,
            x: 10,
            y: 170
          }, {
            key: "imgUrl",
            text: "URL",
            inputWidth: 105,
            x: 170,
            y: 170
          }, {
            key: "imgWidth",
            text: "Width",
            inputWidth: 20,
            x: 10,
            y: 195
          }, {
            key: "imgHeight",
            text: "Height",
            inputWidth: 20,
            x: 82,
            y: 195
          }, {
            key: "imgAlign",
            text: "Align",
            inputType: "select",
            inputWidth: 75,
            innerHTML: '<option value="top">Top</option><option value="middle">Middle</option><option value="bottom">Bottom</option>',
            x: 170,
            y: 195
          }], a.labelUpdateUIDefinition = [{
            key: b,
            text: "Label*",
            x: 10,
            y: 15,
            inputWidth: 235
          }, {
            key: "size",
            text: "Size",
            x: 10,
            y: 40
          }, {
            key: "padding",
            text: "Padding",
            x: 10,
            y: 65
          }, {
            key: "x",
            text: "Position",
            x: 120,
            y: 65,
            labelWidth: 70,
            inputWidth: 25
          }, {
            key: "y",
            text: x,
            x: 225,
            y: 65,
            labelWidth: 10,
            inputWidth: 25
          }, {
            key: "xy",
            text: "(x, y)",
            x: 260,
            y: 65,
            noInput: !0
          }, {
            key: "allowdrag",
            text: "Allow Drag",
            x: 120,
            y: 40,
            inputType: "checkbox",
            inputPaddingTop: 3,
            inputWidth: 15,
            labelWidth: 70,
            val: 1
          }, {
            key: "color",
            text: "Color",
            x: 10,
            y: 90
          }, {
            key: "alpha",
            text: "Alpha",
            x: 145,
            y: 90,
            inputWidth: 30,
            val: l.preDefStr.HUNDREDSTRING
          }, {
            key: "bordercolor",
            text: "Border Color",
            x: 10,
            y: 125,
            labelWidth: 100
          }, {
            key: "bgcolor",
            text: "Background Color",
            x: 10,
            y: 150,
            labelWidth: 100
          }], o;
        }

        return s(t, e), t.prototype.configure = function () {
          this.setState("configured", !0);
        }, t.prototype.getType = function () {
          return "group";
        }, t.prototype.getName = function () {
          return "dragNodeGroup";
        }, t.prototype.showLabelUpdateUI = function () {
          var e,
              t,
              o,
              a,
              r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
              n = this,
              i = n.getFromEnv("paper"),
              s = n.getFromEnv("style").inCanvasStyle || {},
              c = n.getGraphicalElement("cacheLabelUpdateUI"),
              u = {
            border: "1px solid #cccccc",
            fontSize: 10 + v,
            lineHeight: 15 + v,
            fontFamily: s.fontFamily,
            padding: 2 + v
          },
              p = {
            textAlign: "right"
          },
              h = c && c.fields,
              g = c && c.labels;
          n.getFromEnv("animationManager").setAnimationState("uichange"), c || (e = !0), c = n.addGraphicalElement("cacheLabelUpdateUI", n.createHtmlDialog(315, 205, function () {
            var e,
                t = c && c.fields;
            t && ((e = {
              text: t.label.val(),
              x: t.x.val(),
              y: t.y.val(),
              color: t.color.val(),
              alpha: t.alpha.val(),
              bgcolor: t.bgcolor.val(),
              bordercolor: t.bordercolor.val(),
              fontsize: t.size.val(),
              allowdrag: t.allowdrag.val(),
              padding: t.padding.val()
            }).text ? (n.addLabel && n.addLabel(e), c.hide()) : (c.error.attr({
              text: "Label cannot be blank."
            }), t.label.focus()));
          }, function () {
            c.error.attr({
              text: l.BLANKSTRING
            }), c.hide();
          }, d, c)), e && (a = c.dialog, g = c.labels = {}, h = c.fields = {}), (0, l.fcEach)(n.labelUpdateUIDefinition, function (e) {
            var n = e.key;
            g[n] || (g[n] = i.html(b, {
              x: e.x,
              y: e.y,
              width: e.labelWidth || 45,
              text: e.text
            }, p, a)), e.noInput || ((t = h[n]) || (t = h[n] = i.html(f, {
              y: -2 + (e.inputPaddingTop || 0),
              x: e.labelWidth && e.labelWidth + 5 || 50,
              width: e.inputWidth || 50,
              type: e.inputType || "text",
              name: n || l.BLANKSTRING
            }, u, g[n]).on("keyup", c.handleKeyPress)), w(o = (0, l.getFirstValue)(r[n], e.val)) && t.val(o));
          }), c.error || (c.error = i.html("span", {
            color: "ff0000",
            x: 10,
            y: 180
          }, d, a)), c.fields.label.focus();
        }, t.prototype.restoreData = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              i,
              s = this.getChildren("dataset"),
              c = this.getFromEnv("chart"),
              u = this.getFromEnv("legend"),
              p = (0, l.pluckNumber)(c.config.showlegend, 0),
              h = this.getChildren("connector"),
              d = c.getFromEnv("dataSource"),
              f = d.dataset,
              g = d.connectors,
              m = d.labels,
              v = this.getChildren("labels"),
              b = function b(e) {
            var t, o;

            for (t = 0; t < (e && e.length); t++) {
              if (delete (a = e[t]).removed, a.config.add) {
                for (o in r = e[t].graphics) {
                  r[o].remove();
                }

                e.splice(t, 1), t--;
              }
            }
          },
              y = function y(e, a, r) {
            t = a[e], o = t.components.data, b(o), t.drawn = !1, t.configure(r[e]);
          };

          for (e = 0, i = s && s.length; e < i; e++) {
            y(e, s, f);
          }

          for (e = 0, i = h && h.length; e < i; e++) {
            y(e, h, g);
          }

          v && v.length && (n = v[0], (o = n.components.data) && b(o), n.configure(m)), c.fireChartInstanceEvent("dataRestored"), this.asyncDraw(), p && u.asyncDraw();
        }, t.prototype.addLabel = function (e) {
          var t,
              o,
              a = this.getChildren("labels"),
              r = this.getFromEnv("chart");
          e.add = !0, a ? a = a[0] : ((0, l.componentFactory)(this, i["default"], "labels", 1, [{}]), a = this.getChildren("labels")[0]), o = (a.components.data || (a.components.data = [])).length, a._setConfigure(o, e), t = {
            text: e.text,
            x: e.x,
            y: e.y,
            allowdrag: e.allowdrag,
            sourceType: "labelnode",
            link: e.link
          }, r.fireChartInstanceEvent("chartupdated", (0, l.extend2)({
            sourceEvent: "labeladded"
          }, t)), r.fireChartInstanceEvent("labeladded", t), a.asyncDraw();
        }, t.prototype.showNodeAddUI = function () {
          var e,
              t,
              o,
              a = this.getChildren("dataset"),
              r = l.BLANKSTRING;

          for (o = 0; o < a.length; o++) {
            e = (t = a[o] || {}).config, "dragNode" === t.getName() && (r += '<option value="' + t.config.datasetIndex + '">' + (e.name !== m && e.name !== d && e.name + l.COMMASTRING + g || m) + t.config.datasetIndex + "</option>");
          }

          this.showNodeUpdateUI({
            dataset: {
              innerHTML: r
            }
          });
        }, t.prototype.showConnectorAddUI = function () {
          var e,
              t,
              o = this.getNode(),
              a = l.BLANKSTRING;

          for (t in o) {
            a += '<option value="' + (e = o[t].config.id) + '">' + e + "</option>";
          }

          this.showConnectorUpdateUI({
            fromid: {
              innerHTML: a
            },
            toid: {
              innerHTML: a
            }
          });
        }, t.prototype.showConnectorUpdateUI = function (e, t) {
          var o,
              a,
              r,
              n,
              i,
              s = this,
              c = s.getFromEnv("paper"),
              u = s.getFromEnv("style").inCanvasStyle || {},
              p = "cacheConnectorUpdateUI" + (t ? "edit" : "new"),
              h = s.getGraphicalElement(p),
              g = {
            border: "1px solid #cccccc",
            fontSize: 10 + v,
            lineHeight: 15 + v,
            fontFamily: u.fontFamily,
            padding: 2 + v
          },
              m = {
            textAlign: "right"
          },
              y = h && h.fields,
              x = h && h.labels;
          s.getFromEnv("animationManager").setAnimationState("uichange"), h || (o = !0), h = s.addGraphicalElement(p, s.createHtmlDialog(315, 215, function () {
            var e,
                o = h && h.fields;
            o && ((e = {
              from: o.fromid.val(),
              to: o.toid.val(),
              id: o.id.val(),
              label: o.label.val(),
              color: o.color.val(),
              alpha: o.alpha.val(),
              link: o.url.val(),
              tooltext: o.tooltext.val(),
              strength: o.strength.val(),
              arrowatstart: o.arratstart.val(),
              arrowatend: o.arratend.val(),
              dashed: o.dashed.val(),
              dashlen: o.dashlen.val(),
              dashgap: o.dashgap.val()
            }).from ? e.to ? e.from != e.to ? (t ? s.editConnector(e) : s.addConnector(e), h.enableFields(), h.hide(), h.clearFields()) : (h.error.attr({
              text: "Connector cannot start and end at the same node!"
            }), o.fromid.focus()) : (h.error.attr({
              text: "Please select a valid connector end."
            }), o.toid.focus()) : (h.error.attr({
              text: "Please select a valid connector start."
            }), o.fromid.focus()));
          }, function () {
            h.error.attr({
              text: l.BLANKSTRING
            }), h.enableFields(), h.hide();
          }, function () {
            var e = h && h.fields,
                t = {
              from: e.fromid.val(),
              to: e.toid.val(),
              id: e.id.val()
            };
            s.deleteConnector(t), h.hide();
          }, h)), o && (i = h.dialog, x = h.labels = {}, y = h.fields = {}), h.config = e, h.enableFields || (h.enableFields = function () {
            var t;

            for (t in e) {
              e[t] && e[t].disabled && y[t] && y[t].element.removeAttribute("disabled");
            }
          }), h.clearFields || (h.clearFields = function () {
            var e,
                t = h.fields;

            for (e in t) {
              t[e].element.disabled || (t[e].element.value = l.BLANKSTRING);
            }
          }), (0, l.fcEach)(s.connectorUpdateUIDefinition, function (t) {
            var o = t.key,
                s = e[o] || {};
            x[o] || (x[o] = c.html(b, {
              x: t.x,
              y: t.y,
              width: t.labelWidth || 45,
              text: t.text
            }, m, i)), t.noInput || ((r = y[o]) || (r = y[o] = c.html(t.inputType || f, {
              y: -2 + (t.inputPaddingTop || 0),
              x: t.labelWidth && t.labelWidth + 5 || 50,
              width: t.inputWidth || 50,
              name: o || l.BLANKSTRING
            }, g), "select" !== t.inputType && r.attr({
              type: t.type || "text"
            }).on("keyup", h.handleKeyPress), r.add(x[o])), (a = (0, l.pluck)(s.innerHTML, t.innerHTML)) && r.attr({
              innerHTML: a
            }), (n = (0, l.pluck)(s.val, t.val)) !== d && r.val(n), s.disabled ? r.attr({
              disabled: "disabled"
            }) : r.element && (r.element.disabled = !1));
          }), h.checkDash = function () {
            var e = y.dashed && y.dashed.val() ? "show" : "hide";
            x.dashgap && x.dashgap[e](), y.dashgap && y.dashgap[e](), x.dashlen && x.dashlen[e](), y.dashlen && y.dashlen[e]();
          }, h.checkDash(), y.dashed.on("click", h.checkDash), h.error || (h.error = c.html("span", {
            color: "ff0000",
            x: 10,
            y: 170
          }, d, i)), h.removeItem[t ? "show" : "hide"]();
        }, t.prototype.showNodeUpdateUI = function () {
          return N.apply(this, arguments);
        }, t.prototype.addNode = function (e) {
          var t,
              o,
              a,
              r,
              n,
              i,
              s,
              c = this.getChildren("dataset"),
              u = e.datasetId,
              p = c.length,
              h = this.getFromEnv("chart");

          for (n = 0; n < p; n++) {
            if ((r = (t = c[n] || {}).config.datasetIndex) !== d && (r = r.toString()), r === u) {
              a = !0;
              break;
            }
          }

          t && a && (s = t.components.data, e.add = !0, i = {
            index: o = s.length,
            dataIndex: o,
            link: e.link,
            y: e.y,
            x: e.x,
            shape: e.shape,
            label: e.name,
            toolText: e.tooltext,
            id: e.id,
            datasetIndex: t.config.datasetIndex,
            datasetName: t.config.seriesname,
            sourceType: "dataplot"
          }, C(i, e), t._setConfigure(o, e), t.parsePlotAttributes(o), t._drawNode(o), t.setState("dirty", !0), h.fireChartInstanceEvent("chartupdated", (0, l.extend2)({
            sourceEvent: "nodeAdded"
          }, i)), h.fireChartInstanceEvent("nodeAdded", i), t._setupKdTree());
        }, t.prototype.updateNode = function (e) {
          var t,
              o,
              a,
              r,
              n,
              i,
              s,
              c = this.getChildren("dataset"),
              u = c.length,
              p = this.getFromEnv("chart");

          for (e.update = !0, r = 0; r < u; r++) {
            for (t = (n = (a = c[r]).components.data || []).length, s = 0; s < t; s++) {
              if (n[s].config.id === e.id) {
                o = !0;
                break;
              }
            }
          }

          a && o && (i = {
            index: s,
            dataIndex: s,
            link: e.link,
            y: e.y,
            x: e.x,
            shape: e.shape,
            label: e.name,
            toolText: e.tooltext,
            id: e.id,
            datasetIndex: a.config.datasetIndex,
            datasetName: a.config.seriesname,
            sourceType: "dataplot"
          }, C(i, e), a._setConfigure(s, e), a.parsePlotAttributes(s), a._drawNode(s), a.setState("dirty", !0), p.fireChartInstanceEvent("chartupdated", (0, l.extend2)({
            sourceEvent: "nodeupdated"
          }, i)), p.fireChartInstanceEvent("nodeupdated", i), a._setupKdTree());
        }, t.prototype.deleteNode = function (e) {
          var t,
              o,
              a,
              r,
              n,
              i,
              s,
              c,
              u,
              p,
              h,
              d,
              f = this.getNode(e),
              g = this.getFromEnv("chart"),
              m = function m(e) {
            for (var t in e) {
              e[t].remove();
            }
          };

          if (f) {
            for (o = (t = f.dataset).components.data, a = f.config.startConnectors, r = f.config.endConnectors, u = o.length, n = 0; n < u; n++) {
              if ((s = o[n]).config.id === e) {
                d = !0;
                break;
              }
            }

            if (!0 === d) {
              for (c in m(s.graphics), a) {
                m((i = a[c] || {}).graphics), delete i.graphics, i.removed = !0;
              }

              for (c in r) {
                m((i = r[c] || {}).graphics), delete i.graphics, i.removed = !0;
              }

              s.removed = !0, p = {
                index: n,
                dataIndex: n,
                link: (h = s.config || {}).link,
                y: h.y,
                x: h.x,
                shape: h.shape,
                label: h.displayValue,
                toolText: h.toolText,
                id: h.id,
                datasetIndex: t.config.datasetIndex,
                datasetName: t.config.seriesname,
                sourceType: "dataplot"
              }, C(p, {
                width: h.width,
                height: h.height,
                radius: h.radius,
                numsides: h.numSides
              }), g.fireChartInstanceEvent("chartupdated", (0, l.extend2)({
                sourceEvent: "nodedeleted"
              }, p)), g.fireChartInstanceEvent("nodedeleted", p), t._setupKdTree();
            }
          }
        }, t.prototype.addConnector = function (e) {
          var t,
              o = this.getChildren("connector")[0],
              a = o.components.data,
              r = this.getFromEnv("chart"),
              n = a.length;
          e.add = !0, o._setConfigure(n, e), t = {
            arrowAtEnd: Boolean(e.arrowatend),
            arrowAtStart: Boolean(e.arrowatstart),
            fromNodeId: e.from,
            id: e.id,
            label: e.label,
            link: e.connectorLink,
            sourceType: "connector",
            toNodeId: e.to
          }, r.fireChartInstanceEvent("chartupdated", (0, l.extend2)({
            sourceEvent: "connectoradded"
          }, t)), r.fireChartInstanceEvent("connectoradded", t), o.asyncDraw();
        }, t.prototype.editConnector = function (e) {
          var t,
              o,
              a,
              r,
              n,
              i,
              s,
              c,
              u,
              p,
              h = e.from,
              d = e.to,
              f = this.getChildren("connector"),
              g = this.getFromEnv("chart"),
              m = f.length;

          for (t = 0; t < m; t++) {
            for (o = (a = (c = f[t]) && c.components.data || []).length, i = 0; i < o; i++) {
              if (r = (u = a[i].config).from, n = u.to, r === h && n === d) {
                s = !0;
                break;
              }
            }
          }

          e.update = !0, s && (c._setConfigure(i, e), p = {
            arrowAtEnd: Boolean(e.arrowatend),
            arrowAtStart: Boolean(e.arrowatstart),
            fromNodeId: e.from,
            id: e.id,
            label: e.label,
            link: e.link,
            sourceType: "connector",
            toNodeId: e.to
          }, g.fireChartInstanceEvent("chartupdated", (0, l.extend2)({
            sourceEvent: "connectorupdated"
          }, p)), g.fireChartInstanceEvent("connectorupdated", p), c.asyncDraw());
        }, t.prototype.deleteConnector = function (e) {
          var t,
              o,
              a,
              r,
              n,
              i,
              s,
              c = e.from,
              u = e.to,
              p = this.getChildren("connector"),
              h = !1,
              d = p.length,
              f = this.getFromEnv("chart");

          for (t = 0; t < d; t++) {
            for (n = (r = p[t].components.data).length, o = 0; o < n; o++) {
              if ((a = r[o]).config.from === c && a.config.to === u) {
                h = !0;
                break;
              }
            }
          }

          h && (i = {
            arrowAtEnd: (s = a.config || {}).arrowAtEnd,
            arrowAtStart: s.arrowAtStart,
            fromNodeId: s.from,
            id: s.id,
            label: s.label,
            link: s.connectorLink,
            sourceType: "connector",
            toNodeId: s.to
          }, function (e) {
            var t;

            for (t in e) {
              e[t].remove();
            }
          }(a.graphics), delete a.graphics, a.removed = !0, f.fireChartInstanceEvent("chartupdated", (0, l.extend2)({
            sourceEvent: "connectordeleted"
          }, i)), f.fireChartInstanceEvent("connectordeleted", i));
        }, t.prototype.createHtmlDialog = function (e, t, o, a, r, n) {
          var i,
              s,
              c,
              u,
              p,
              h,
              d,
              f,
              g = this.getFromEnv("chartConfig"),
              m = this.getFromEnv("chart-container"),
              b = this.getFromEnv("style").inCanvasStyle || {},
              y = Number(g.width),
              x = Number(g.height),
              w = this.getFromEnv("animationManager"),
              C = {
            color: (0, l.hashify)(b.color),
            textAlign: "center",
            paddingTop: 1 + v,
            border: "1px solid #cccccc",
            borderRadius: 4 + v,
            cursor: l.preDefStr.POINTER,
            _cursor: "hand",
            backgroundColor: l.HASHSTRING + "ffffff",
            zIndex: 21,
            "-webkit-border-radius": 4 + v
          },
              N = n;
          return f = {
            width: y,
            height: x
          }, n || (f.fill = "transparent", f.type = "div"), N = w.setAnimation({
            el: n || "html",
            attr: f,
            component: this,
            label: "ui",
            state: k,
            css: {
              fontSize: 10 + v,
              lineHeight: 15 + v,
              fontFamily: b.fontFamily,
              display: "block"
            },
            container: !n && m
          }), f = {
            width: y,
            height: x,
            opacity: .3
          }, N.veil || (f.fill = "000000", f.type = "div"), N.veil = w.setAnimation({
            el: N.veil || "html",
            attr: f,
            component: this,
            state: k,
            label: "uiveil",
            container: !N.veil && N
          }), u = {
            x: (y - e) / 2,
            y: (x - t) / 2,
            width: e,
            height: t
          }, N.dialog || (u.fill = "efefef", u.strokeWidth = 1, u.stroke = "000000", u.type = "div"), N.dialog = w.setAnimation({
            el: N.dialog || "html",
            attr: u,
            component: this,
            state: k,
            label: "uidialog",
            container: !N.dialog && N,
            css: {
              borderRadius: 5 + v,
              boxShadow: "1px 1px 3px #000000",
              "-webkit-border-radius": 5 + v,
              "-webkit-box-shadow": "1px 1px 3px #000000",
              filter: 'progid:DXImageTransform.Microsoft.Shadow(Strength=4, Direction=135, Color="#000000")'
            }
          }), p = {
            x: e - 70 - 5,
            y: t - 23 - 5,
            width: 65,
            height: 17
          }, N.ok || (p.text = "Submit", p.tabIndex = 1, p.type = "div"), i = w.setAnimation({
            el: N.ok || "html",
            state: k,
            attr: p,
            component: this,
            label: "uiok",
            css: C,
            container: !N.ok && N.dialog
          }), !N.ok && (N.ok = i) && i.on("mousedown", o), h = {
            x: e - 140 - 5,
            y: t - 23 - 5,
            width: 65,
            height: 17
          }, N.cancel || (h.text = "Cancel", h.tabIndex = 2, h.type = "div"), s = w.setAnimation({
            el: N.cancel || "html",
            state: k,
            attr: h,
            component: this,
            label: "uicancel",
            css: C,
            container: !N.cancel && N.dialog
          }), !N.cancel && (N.cancel = s) && s.on("mousedown", a), d = {
            x: e - 210 - 5,
            y: t - 23 - 5,
            width: 65,
            height: 17
          }, N.removeItem || (d.text = "Delete", d.tabIndex = 3, d.type = "div"), c = w.setAnimation({
            el: N.removeItem || "html",
            state: k,
            attr: d,
            component: this,
            label: "uiremove",
            css: C,
            container: !N.removeItem && N.dialog
          }), !N.removeItem && (N.removeItem = c) && c.on("mousedown", r), N.handleKeyPress || (N.handleKeyPress = function (e) {
            13 === e.keyCode ? N.ok.element && N.ok.element.onmousedown && N.ok.element.onmousedown(e) : 27 === e.keyCode && N.cancel.element && N.cancel.element.onmousedown && N.cancel.element.onmousedown(e);
          }), N;
        }, t.prototype.getNode = function (e) {
          for (var t, o = {}, a = this.getChildren("dataset"), r = 0, n = a.length; r < n; r++) {
            if (e) {
              if (t = a[r].getNode(e)) return t;
            } else Object.assign(o, a[r].getNode());
          }

          return !e && o;
        }, t.prototype.createContainer = function () {
          var e = this,
              t = e.getFromEnv("animationManager"),
              o = e.getLinkedParent().getChildContainer();
          ["connectorGroup", "defaultVcanvasGroup", "vcanvasLabelGroup", "cloneGroup"].forEach(function (a) {
            !e.getChildContainer(a) && e.addChildContainer(a, t.setAnimation({
              el: "group",
              attr: {
                name: "manager-" + a
              },
              component: e,
              container: o[a] || o.defaultVcanvasGroup
            }));
          }), !e.getContainer("waitContainer") && e.addContainer("waitContainer", t.setAnimation({
            el: "group",
            attr: {
              name: "manager-waitContainer"
            },
            container: o.defaultVcanvasGroup,
            component: e
          }));
        }, t.prototype.draw = function () {
          var e,
              t,
              o = {
            cacheUpdateUI: [350, 215],
            cacheLabelDeleteUI: [250, 100],
            cacheLabelUpdateUI: [350, 205],
            cacheConnectorUpdateUIedit: [315, 215],
            cacheConnectorUpdateUInew: [315, 215]
          };

          if (!this.getState("configured")) {
            for (e in k = "update", o) {
              if ((t = this.getGraphicalElement(e)) && t.isVisible()) {
                if ("cacheUpdateUI" === e) {
                  var a = t.fields.image.val();
                  o[e][1] = a ? 250 : 215;
                }

                this.createHtmlDialog(o[e][0], o[e][1], d, d, d, t);
              }
            }

            k = "appearing";
          }

          this.setState("configured", !1), this.createContainer();
        }, t.prototype.getDataLimits = function () {
          var e,
              t,
              o = this.getChildren("dataset"),
              a = +Infinity,
              r = -Infinity,
              n = -Infinity,
              i = +Infinity;

          for (e = 0; e < o.length; e++) {
            t = o[e].config, r = Math.max(r, t.yMax), a = Math.min(a, t.yMin), n = Math.max(n, t.xMax), i = Math.min(i, t.xMin);
          }

          return {
            max: r,
            min: a,
            xMax: n,
            xMin: i
          };
        }, t.prototype.isVisible = function () {
          return !this.isNotVisible;
        }, t.prototype.childChanged = function () {
          return this;
        }, t.prototype.hideWaitElem = function () {
          this.getGraphicalElement("waitElement") && this.getGraphicalElement("waitElement").hide();
        }, t.prototype.clearLongPress = function () {
          clearTimeout(this.config._longpressactive), delete this.config._longpressactive;
        }, t.prototype.triggerLabelUI = function (e, t) {
          var o = this;
          o.config._longpressactive = setTimeout(function () {
            e.data("fire_click_event", 0), e.data("viewMode") || o.showLabelDeleteUI(t);
          }, 1e3);
        }, t.prototype.triggerConnectorUI = function (e) {
          var t = this,
              o = e.data("dataset"),
              a = o.config,
              r = e.data(l.preDefStr.configStr),
              n = r || {};
          t.config._longpressactive = setTimeout(function () {
            e.data("fire_click_event", 0), e.data("viewMode") || t.showConnectorUpdateUI({
              fromid: {
                val: n.from,
                innerHTML: "<option>" + n.from + "</option>",
                disabled: !0
              },
              toid: {
                val: n.to,
                innerHTML: "<option>" + n.to + "</option>",
                disabled: !0
              },
              datasetIndex: o.config.datasetIndex,
              index: r.index,
              arratstart: {
                val: Boolean((0, l.pluckNumber)(n.arrowatstart, 1))
              },
              arratend: {
                val: Boolean((0, l.pluckNumber)(n.arrowatend, 1))
              },
              dashed: {
                val: (0, l.pluckNumber)(n.dashed)
              },
              dashgap: {
                val: n.dashgap
              },
              dashlen: {
                val: n.dashlen
              },
              label: {
                val: n.label
              },
              tooltext: {
                val: n.tooltext
              },
              id: {
                val: a.id,
                disabled: !0
              },
              strength: {
                val: n.conStrength
              },
              alpha: {
                val: n.alpha
              },
              color: {
                val: n.color.FCcolor.color
              }
            }, !0);
          }, 1e3);
        }, t.prototype.deleteLabel = function (e) {
          var t,
              o,
              a,
              r = this.getChildren("labels")[0],
              n = (0, l.pluckNumber)(e, r.config.lastTappedLabelIndex),
              i = r.components.data[n],
              s = this.getFromEnv("chart");
          t = i.graphics.element, o = i.graphics.trackerElement, t && (a = t.data("eventArgs"), t.remove(), o && o.remove(), delete i.graphics), s.fireChartInstanceEvent("chartupdated", (0, l.extend2)({
            sourceEvent: "labeldeleted"
          }, a)), s.fireChartInstanceEvent("labeldeleted", a), i.removed = !0;
        }, t.prototype.showLabelDeleteUI = function (e) {
          var t = this,
              o = t.getChildren("labels")[0],
              a = t.getFromEnv("paper"),
              r = t.getGraphicalElement("cacheLabelDeleteUI");
          o.config.lastTappedLabelIndex = e.config.index, r ? r.show() : ((r = t.addGraphicalElement("cacheLabelDeleteUI", t.createHtmlDialog(250, 100, d, function () {
            r.hide();
          }, function () {
            t.deleteLabel(), r.hide();
          }))).message = a.html("span", {
            x: 10,
            y: 10,
            width: 230,
            height: 80
          }).add(r.dialog), r.ok.hide(), r.removeItem.translate(175).show()), r.message.attr({
            text: 'Would you really like to delete the label: "' + e.config.text + '"?'
          });
        }, t.prototype.drawWaitingRing = function (e, t) {
          var o = this,
              a = o.config,
              r = o.getFromEnv("animationManager"),
              n = o.getContainer("waitContainer"),
              i = e.config,
              s = o.getChildren("dataset")[t].config,
              c = o.getGraphicalElement("waitElement");
          o.clearLongPress(), c = r.setAnimation({
            el: c || "ringpath",
            attr: {
              ringpath: [i._xPos, i._yPos, 8, 11, 0, 0],
              fill: (0, l.toRaphaelColor)({
                alpha: "100,100",
                angle: 120,
                color: "CCCCCC,FFFFFF",
                ratio: "30,50"
              }),
              "stroke-width": 0
            },
            container: n,
            component: o
          }), o.getGraphicalElement("waitElement") || o.addGraphicalElement("waitElement", c), c.show().animate({
            ringpath: [i._xPos, i._yPos, 8, 11, 0, 6.28]
          }, 1e3), a._longpressactive = setTimeout(function () {
            var e = s.name !== m && s.name !== d ? s.name + l.preDefStr.BLANKSPACE : m,
                a = s.id !== d ? (e ? l.COMMASTRING : e) + s.id : m;
            c && c.hide(), o.showNodeUpdateUI({
              x: {
                value: i.x
              },
              y: {
                value: i.y
              },
              draggable: {
                value: (0, l.getFirstValue)(i.allowdrag, 1)
              },
              color: {
                value: i.color
              },
              alpha: {
                value: i.alpha
              },
              label: {
                value: (0, l.getFirstValue)(i.label, i.name)
              },
              tooltip: {
                value: i.toolText
              },
              shape: {
                value: h[i.shape]
              },
              rectWidth: {
                value: i.width
              },
              rectHeight: {
                value: i.height
              },
              circPolyRadius: {
                value: i.radius
              },
              polySides: {
                value: i.numsides
              },
              image: {
                value: i.imageNode
              },
              imgWidth: {
                value: i.imageWidth
              },
              imgHeight: {
                value: i.imageHeight
              },
              imgAlign: {
                value: i.imageAlign
              },
              imgUrl: {
                value: i.imageURL
              },
              id: {
                value: i.id,
                disabled: !0
              },
              link: {
                value: i.link
              },
              dataset: {
                innerHTML: '<option value="' + a + '">' + e + a + "</option>",
                disabled: !0
              },
              datasetIndex: t
            }, !0);
          }, 1e3);
        }, t.prototype.drawNodeConnectors = function (e) {
          var t,
              o,
              a,
              r,
              n,
              i,
              l = this.getChildren("connector");
          if (e) for (t in e) {
            (r = e[t]) && (o = r.config.datasetIndex, n = r.config.fromPointObj, i = r.config.toPointObj, (a = l[o]) && (a && a.parsePlotAttributes(r, n, i), a && a.drawConnector(r, n, i)));
          }
        }, t.prototype._clearConnectors = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              i = this.getNode();

          for (e in i) {
            if (n = i[e]) {
              for (r in t = n.config.startConnectors || {}, o = n.config.endConnectors || {}, t) {
                a = {
                  graphics: t[r].graphics || {}
                }, l.componentDispose.call(a);
              }

              for (r in o) {
                a = {
                  graphics: o[r].graphics || {}
                }, l.componentDispose.call(a);
              }
            }
          }
        }, t.prototype.getJSONData = function () {
          var e,
              t,
              o,
              a = this.getChildren(),
              r = a.dataset,
              n = a.connector,
              i = a.labels,
              s = {};

          for (s.dataset = [], s.connectors = [], s.labels = [], e = 0, t = r && r.length; e < t; e++) {
            o = r[e], s.dataset[e] || (s.dataset[e] = (0, l.extend2)({}, o.JSONData)), s.dataset[e].data = o.getJSONData();
          }

          for (e = 0, t = n && n.length; e < t; e++) {
            o = n[e], s.connectors[e] || (s.connectors[e] = (0, l.extend2)({}, o.JSONData)), s.connectors[e].connector = o.getJSONData();
          }

          for (e = 0, t = i && i.length; e < t; e++) {
            o = i[e], s.labels[e] || (s.labels[e] = {
              label: []
            }), s.labels[e].label = o.getJSONData();
          }

          return s;
        }, t;
      }(r.ComponentInterface);

      t["default"] = S;
    },
    919: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = function (e) {
        var t,
            o,
            n = e.getFromEnv("dataSource"),
            i = n.dataset,
            l = n.connectors,
            s = n.labels,
            c = void 0,
            u = c = e.getChildren().canvas[0].getChildren("vCanvas")[0],
            p = [];
        s && (s = [s]), i || l || s ? (t = e.getDSGroupdef(), (0, a.componentFactory)(c, t, "datasetGroup_dragNode"), (o = c.getChildren("datasetGroup_dragNode")) && (u = o[0]), i && i.length ? (0, a.componentFactory)(u, e.getDSdef("dragnode"), "dataset", i.length, i) : p.push("dataset"), l && l.length ? (0, a.componentFactory)(u, e.getDSdef("connector"), "connector", l.length, l) : p.push("connector"), s && s.length ? (0, a.componentFactory)(u, e.getDSdef("dragableLabels"), "labels", s.length, s) : p.push("labels"), p.length && r(u, p)) : e.setChartMessage();
      };

      var a = o(125),
          r = function r(e, t) {
        var o = e.getChildren(),
            a = void 0,
            r = void 0,
            n = void 0;
        if (t && t.length) for (n = t.length - 1; n > -1; n--) {
          for (r = (a = o[t[n]]) && a.length - 1; r > -1; a[r].remove(), r--) {
            ;
          }
        }
      };
    },
    920: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(921),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    921: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = o(125),
          r = c(o(459)),
          n = c(o(427)),
          i = c(o(922)),
          l = c(o(932)),
          s = o(923);

      function c(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function u(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var p = a.preDefStr.altHGridColorStr,
          h = a.preDefStr.altHGridAlphaStr,
          d = Math,
          f = d.max,
          g = d.round,
          m = a.preDefStr.POSITION_BOTTOM,
          v = a.preDefStr.divLineAlpha3DStr,
          b = a.preDefStr.defaultFontStr,
          y = a.preDefStr.divLineAlphaStr,
          x = a.preDefStr.altVGridColorStr,
          k = a.preDefStr.altVGridAlphaStr,
          w = a.preDefStr.colors.c000000,
          C = {
        chart2D: {
          bgColor: "bgColor",
          bgAlpha: "bgAlpha",
          bgAngle: "bgAngle",
          bgRatio: "bgRatio",
          canvasBgColor: "canvasBgColor",
          canvasBaseColor: "canvasBaseColor",
          divLineColor: "divLineColor",
          legendBgColor: "legendBgColor",
          legendBorderColor: "legendBorderColor",
          toolTipbgColor: "toolTipbgColor",
          toolTipBorderColor: "toolTipBorderColor",
          baseFontColor: "baseFontColor",
          anchorBgColor: "anchorBgColor"
        },
        chart3D: {
          bgColor: "bgColor3D",
          bgAlpha: "bgAlpha3D",
          bgAngle: "bgAngle3D",
          bgRatio: "bgRatio3D",
          canvasBgColor: "canvasBgColor3D",
          canvasBaseColor: "canvasBaseColor3D",
          divLineColor: "divLineColor3D",
          divLineAlpha: v,
          legendBgColor: "legendBgColor3D",
          legendBorderColor: "legendBorderColor3D",
          toolTipbgColor: "toolTipbgColor3D",
          toolTipBorderColor: "toolTipBorderColor3D",
          baseFontColor: "baseFontColor3D",
          anchorBgColor: "anchorBgColor3D"
        }
      },
          N = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.isDual = !0, o.paletteIndex = 3, o.canvasborderthickness = 1, o.hasInteractiveLegend = !1, o.numOfCanvas = 2, o.registerFactory("vCanvas", n["default"], ["axis"]), o.registerFactory("axis", l["default"], ["canvas"]), o.registerFactory("dataset", i["default"], ["vCanvas"]), o;
        }

        return u(t, e), t.prototype.getName = function () {
          return "candlestick";
        }, t.getName = function () {
          return "candlestick";
        }, t.prototype.getDSdef = function (e) {
          return "bar" === e ? s.CandleStickBarDataset : "line" === e ? s.CandleStickLineDataset : s.CandleStickDataset;
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.hasLegend = !0, t.defaultDatasetType = "candlestick", t.drawanchors = 0, t.enablemousetracking = !0, t.iscandlestick = !0;
        }, t.prototype.configureAttributes = function (t) {
          e.prototype.configureAttributes.call(this, t);
        }, t.prototype.parseChartAttr = function (t) {
          e.prototype.parseChartAttr.call(this, t);
          var o,
              r = this.config,
              n = this.getFromEnv("chart-attrib"),
              i = this.getFromEnv("color-manager");
          r.showVolumeChart = (0, a.pluckNumber)(n.showvolumechart, function (e) {
            if (!e || !e.dataset) return 0;
            var t = e.dataset[0].data;
            return !!(Array.isArray(t) && t.filter(function (e) {
              return e.volume;
            }) || []).length;
          }(t), 1), r.rollOverBandColor = (0, a.convertColor)((0, a.pluck)(n.rolloverbandcolor, i.getColor(p)), (0, a.pluck)(n.rolloverbandalpha, i.getColor(h))), r.crosslinecolor = (0, a.pluck)(n.crosslinecolor, n.rolloverbandcolor, i.getColor(p)), r.drawcrosslineontop = 0, r.crosslinealpha = (0, a.pluckNumber)(n.crosslinealpha, n.rolloverbandalpha, i.getColor(h)), r.drawcrossline = 1, r.skipClipping = !0, n = this.getFromEnv("chart-attrib"), r.vplotbordercolor = (0, a.getFirstValue)(n.vplotbordercolor, ""), r.vplotborderalpha = (0, a.getFirstValue)(n.vplotborderalpha, ""), r.vplotborderthickness = (0, a.pluckNumber)(n.vplotborderthickness, 1), r.showplotborder = (0, a.pluckNumber)(n.showvplotborder, 1), o = (0, a.pluckNumber)(n.volumeheightpercent, 40), r.volumeHeightPercent = o < 20 ? 20 : o > 80 ? 80 : o, r.canvasBorderWidth = (0, a.pluckNumber)(n.canvasborderthickness, 1);
        }, t.prototype._spaceManager = function () {
          var e,
              t,
              o,
              r,
              n,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              d,
              v,
              b,
              y,
              x,
              k,
              w,
              C,
              N,
              S,
              A,
              E = this.config,
              D = this.getChildren(),
              _ = E.legendPosition,
              T = D.xAxis && D.xAxis[0],
              L = D.yAxis && D.yAxis[0],
              P = D.yAxis && D.yAxis[1],
              O = E.hasLegend,
              V = this.getFromEnv("legend"),
              M = this.config.showVolumeChart,
              F = M ? E.volumeHeightPercent : 0,
              I = D.canvas[0],
              B = I.config,
              R = E.width,
              j = E.height,
              G = {},
              H = E.chartBorderWidth,
              W = B.canvasBorderWidth,
              z = E.minCanvasHeight,
              U = E.minCanvasWidth,
              J = E.canvasMarginLeft,
              K = E.canvasMarginRight,
              q = E.canvasMarginTop,
              Y = E.canvasMarginBottom,
              X = E.origCanvasTopMargin,
              Q = E.origCanvasBottomMargin,
              Z = E.origCanvasLeftMargin,
              $ = E.origCanvasRightMargin;
          this._allocateSpace({
            top: H,
            bottom: H,
            left: H,
            right: H
          }), e = .225 * E.availableHeight, t = this._manageActionBarSpace && this._manageActionBarSpace(e) || {}, this._allocateSpace(t), d = _ === a.POSITION_RIGHT ? .225 * E.canvasWidth : .3 * E.canvasHeight, !1 !== O && T && E.showLegend && this._allocateSpace(V._manageLegendPosition(d)), o = .7 * E.canvasWidth, p = L.placeAxis(o), h = M ? P.placeAxis(o) : {}, G.left = f(p.left, h.left || 0), G.right = f(p.right, h.right || 0), this._allocateSpace(G), U > R - J - K && (S = !0, v = E.canvasWidth - U, A = J + K, J = E.canvasMarginLeft = v * J / A, K = E.canvasMarginRight = v * K / A), k = J > E.canvasLeft ? J - E.canvasLeft : 0, w = K > R - E.canvasRight ? K + E.canvasRight - R : 0, this._allocateSpace({
            left: k,
            right: w
          }), S && (A = Z + $, (y = E.canvasWidth) > U && (k = (v = y - U) * Z / A, w = v * $ / A), this._allocateSpace({
            left: k,
            right: w
          })), r = .225 * E.canvasHeight, r = _ === m ? .6 * E.canvasHeight : .6 * E.canvasWidth, this._manageChartMenuBar(r), this._allocateSpace({
            top: E.canvasMarginTop,
            bottom: E.canvasMarginBottom
          }), r = .3 * E.canvasHeight, i = T.placeAxis(r), T && this._allocateSpace(i), i.bottom += 6, B.intermediarySpace = i.bottom, M && this._allocateSpace({
            bottom: 10
          }), this._allocateSpace({
            top: W,
            bottom: 2 * W,
            left: W,
            right: W
          }), z > j - q - Y && (x = !0, v = E.canvasHeight - z, A = q + Y, q = E.canvasMarginTop = v * q / A, Y = E.canvasMarginBottom = v * Y / A), C = q > E.canvasTop ? q - E.canvasTop : 0, N = Y > j - E.canvasBottom ? Y + E.canvasBottom - j : 0, this._allocateSpace({
            top: C,
            bottom: N
          }), x && (A = X + Q, (b = E.canvasHeight) > z && (C = (v = b - z) * X / A, N = v * Q / A), this._allocateSpace({
            top: C,
            bottom: N
          })), n = E.canvasHeight, B.canvasHeight = g((100 - F) / 100 * n), B.canvasTop = E.canvasTop, B.canvasLeft = E.canvasLeft, B.canvasBottom = B.canvasTop + B.canvasHeight, B.canvasWidth = E.canvasWidth, B.canvasRight = E.canvasRight, u = E.canvasTop + B.canvasHeight + W, B.canvasY = u, I.setDimension({
            top: B.canvasTop,
            left: B.canvasLeft,
            width: B.canvasWidth,
            height: B.canvasHeight
          }), M && ((s = (l = D.canvas[1]).config).canvasHeight = F / 100 * n, s.canvasTop = B.canvasBottom + i.bottom + 2 * W, s.canvasLeft = E.canvasLeft, s.canvasBottom = s.canvasTop + s.canvasHeight + 2 * W, s.canvasRight = E.canvasRight, s.canvasWidth = E.canvasWidth, c = E.canvasTop + B.canvasHeight + i.bottom + 2 * W, s.canvasY = c, l.setDimension({
            top: s.canvasTop,
            left: s.canvasLeft,
            width: s.canvasWidth,
            height: s.canvasHeight
          }));
        }, t.prototype._postSpaceManagement = function () {
          e.prototype._postSpaceManagement.call(this);
        }, t.prototype.setAxisDimention = function () {
          var e = this.getChildren(),
              t = this.config.showVolumeChart,
              o = e.xAxis && e.xAxis[0],
              a = e.yAxis && e.yAxis[0],
              r = e.yAxis && e.yAxis[1],
              n = e.canvas,
              i = n[0].config,
              l = void 0,
              s = i.canvasBorderWidth;
          o && o.setAxisDimention({
            x: i.canvasLeft,
            y: i.canvasY,
            opposite: i.canvasTop - s,
            axisLength: i.canvasWidth
          }), a && a.setAxisDimention({
            x: i.canvasLeft - s,
            y: i.canvasTop,
            opposite: i.canvasRight + s,
            axisLength: i.canvasHeight
          }), o.setCanvas(i), a.setCanvas(i), t && (l = n[1].config, r && r.setAxisDimention({
            x: i.canvasLeft - s,
            y: l.canvasTop,
            opposite: l.canvasRight + s,
            axisLength: l.canvasHeight
          }), r && r.setCanvas(l));
        }, t.prototype._feedAxesRawData = function () {
          var e,
              t,
              o,
              r = this.getFromEnv("color-manager"),
              n = this.getFromEnv("dataSource"),
              i = this.getFromEnv("chart-attrib"),
              l = [],
              s = [],
              c = this.config.is3D,
              u = c ? C.chart3D : C.chart2D;
          return (e = {
            isVertical: !1,
            isReverse: !1,
            isOpposit: !1,
            drawTrendLabels: !0,
            outCanfontFamily: (0, a.pluck)(i.outcnvbasefont, i.basefont, b),
            outCanfontSize: (0, a.pluckFontSize)(i.outcnvbasefontsize, i.basefontsize, 10),
            outCancolor: (0, a.pluck)(i.outcnvbasefontcolor, i.basefontcolor, r.getColor(u.baseFontColor)).replace(/^#?([a-f0-9]+)/gi, "#$1"),
            axisNamePadding: i.xaxisnamepadding,
            axisValuePadding: i.labelpadding,
            axisNameFont: i.xaxisnamefont,
            axisNameFontSize: i.xaxisnamefontsize,
            axisNameFontColor: i.xaxisnamefontcolor,
            axisNameFontBold: i.xaxisnamefontbold,
            axisNameFontItalic: i.xaxisnamefontitalic,
            axisNameBgColor: i.xaxisnamebgcolor,
            axisNameBorderColor: i.xaxisnamebordercolor,
            axisNameAlpha: i.xaxisnamealpha,
            axisNameFontAlpha: i.xaxisnamefontalpha,
            axisNameBgAlpha: i.xaxisnamebgalpha,
            axisNameBorderAlpha: i.xaxisnameborderalpha,
            axisNameBorderPadding: i.xaxisnameborderpadding,
            axisNameBorderRadius: i.xaxisnameborderradius,
            axisNameBorderThickness: i.xaxisnameborderthickness,
            axisNameBorderDashed: i.xaxisnameborderdashed,
            axisNameBorderDashLen: i.xaxisnameborderdashlen,
            axisNameBorderDashGap: i.xaxisnameborderdashgap,
            useEllipsesWhenOverflow: i.useellipseswhenoverflow,
            divLineColor: (0, a.pluck)(i.vdivlinecolor, i.divlinecolor, r.getColor(u.divLineColor)),
            divLineAlpha: (0, a.pluck)(i.vdivlinealpha, i.divlinealpha, c ? r.getColor(v) : r.getColor(y)),
            divLineThickness: (0, a.pluckNumber)(i.vdivlinethickness, i.divlinethickness, 1),
            divLineIsDashed: Boolean((0, a.pluckNumber)(i.vdivlinedashed, i.vdivlineisdashed, i.divlinedashed, i.divlineisdashed, 0)),
            divLineDashLen: (0, a.pluckNumber)(i.vdivlinedashlen, i.divlinedashlen, 4),
            divLineDashGap: (0, a.pluckNumber)(i.vdivlinedashgap, i.divlinedashgap, 2),
            showAlternateGridColor: (0, a.pluckNumber)(i.showalternatevgridcolor, 0),
            alternateGridColor: (0, a.pluck)(i.alternatevgridcolor, r.getColor(x)),
            alternateGridAlpha: (0, a.pluck)(i.alternatevgridalpha, r.getColor(k)),
            numDivLines: i.numvdivlines,
            labelFont: i.labelfont,
            labelFontSize: i.labelfontsize,
            labelFontColor: i.labelfontcolor,
            labelFontAlpha: i.labelalpha,
            labelFontBold: i.labelfontbold,
            labelFontItalic: i.labelfontitalic,
            axisName: i.xaxisname,
            axisMinValue: i.xaxisminvalue,
            axisMaxValue: i.xaxismaxvalue,
            setAdaptiveMin: i.setadaptivexmin,
            adjustDiv: i.adjustvdiv,
            labelDisplay: i.labeldisplay,
            showLabels: i.showlabels,
            rotateLabels: i.rotatelabels,
            slantLabel: (0, a.pluckNumber)(i.slantlabels, i.slantlabel),
            labelStep: (0, a.pluckNumber)(i.labelstep, i.xaxisvaluesstep),
            showAxisValues: (0, a.pluckNumber)(i.showxaxisvalues, i.showxaxisvalue),
            showLimits: i.showvlimits,
            showDivLineValues: (0, a.pluckNumber)(i.showvdivlinevalues, i.showvdivlinevalues),
            showZeroPlane: i.showvzeroplane,
            zeroPlaneColor: i.vzeroplanecolor,
            zeroPlaneThickness: i.vzeroplanethickness,
            zeroPlaneAlpha: i.vzeroplanealpha,
            showZeroPlaneValue: i.showvzeroplanevalue,
            trendlineColor: i.trendlinecolor,
            trendlineToolText: i.trendlinetooltext,
            trendlineThickness: i.trendlinethickness,
            trendlineAlpha: i.trendlinealpha,
            showTrendlinesOnTop: i.showtrendlinesontop,
            showAxisLine: (0, a.pluckNumber)(i.showxaxisline, i.showaxislines, i.drawAxisLines, 0),
            axisLineThickness: (0, a.pluckNumber)(i.xaxislinethickness, i.axislinethickness, 1),
            axisLineAlpha: (0, a.pluckNumber)(i.xaxislinealpha, i.axislinealpha, 100),
            axisLineColor: (0, a.pluck)(i.xaxislinecolor, i.axislinecolor, w),
            freezeLimit: !0
          }).vtrendlines = n.vtrendlines, s.push(e), (t = {
            isVertical: !0,
            isReverse: !0,
            isOpposit: !1,
            drawLabelsOpposit: 1,
            axisNameAlignCanvas: 1,
            outCanfontFamily: (0, a.pluck)(i.outcnvbasefont, i.basefont, b),
            outCanfontSize: (0, a.pluckFontSize)(i.outcnvbasefontsize, i.basefontsize, 10),
            outCancolor: (0, a.pluck)(i.outcnvbasefontcolor, i.basefontcolor, r.getColor(u.baseFontColor)).replace(/^#?([a-f0-9]+)/gi, "#$1"),
            axisNamePadding: i.yaxisnamepadding,
            axisValuePadding: i.yaxisvaluespadding,
            axisNameFont: i.pyaxisnamefont,
            axisNameFontSize: i.pyaxisnamefontsize,
            axisNameFontColor: i.pyaxisnamefontcolor,
            axisNameFontBold: i.pyaxisnamefontbold,
            axisNameFontItalic: i.pyaxisnamefontitalic,
            axisNameBgColor: i.pyaxisnamebgcolor,
            axisNameBorderColor: i.pyaxisnamebordercolor,
            axisNameAlpha: i.pyaxisnamealpha,
            axisNameFontAlpha: i.pyaxisnamefontalpha,
            axisNameBgAlpha: i.pyaxisnamebgalpha,
            axisNameBorderAlpha: i.pyaxisnameborderalpha,
            axisNameBorderPadding: i.pyaxisnameborderpadding,
            axisNameBorderRadius: i.pyaxisnameborderradius,
            axisNameBorderThickness: i.pyaxisnameborderthickness,
            axisNameBorderDashed: i.pyaxisnameborderdashed,
            axisNameBorderDashLen: i.pyaxisnameborderdashlen,
            axisNameBorderDashGap: i.pyaxisnameborderdashgap,
            axisNameWidth: i.yaxisnamewidth,
            useEllipsesWhenOverflow: i.useellipseswhenoverflow,
            rotateAxisName: (0, a.pluckNumber)(i.rotateyaxisname, 1),
            axisName: i.pyaxisname,
            divLineColor: (0, a.pluck)(i.divlinecolor, r.getColor(u.divLineColor)),
            divLineAlpha: (0, a.pluck)(i.divlinealpha, r.getColor(y)),
            divLineThickness: (0, a.pluckNumber)(i.divlinethickness, 1),
            divLineIsDashed: Boolean((0, a.pluckNumber)(i.divlinedashed, i.divlineisdashed, 1)),
            divLineDashLen: (0, a.pluckNumber)(i.divlinedashlen, 4),
            divLineDashGap: (0, a.pluckNumber)(i.divlinedashgap, 2),
            showAlternateGridColor: (0, a.pluckNumber)(i.showalternatehgridcolor, 1),
            alternateGridColor: (0, a.pluck)(i.alternatehgridcolor, r.getColor(p)),
            alternateGridAlpha: (0, a.pluck)(i.alternatehgridalpha, r.getColor(h)),
            numDivLines: (0, a.pluckNumber)(i.numpdivlines, 5),
            axisMinValue: i.pyaxisminvalue,
            axisMaxValue: i.pyaxismaxvalue,
            setAdaptiveMin: (0, a.pluckNumber)(i.setadaptiveymin, 1),
            adjustDiv: i.adjustdiv,
            labelStep: i.yaxisvaluesstep,
            showAxisValues: (0, a.pluckNumber)(i.showyaxisvalues, i.showyaxisvalue),
            showLimits: (0, a.pluckNumber)(i.showyaxislimits, i.showlimits, this.showLimits),
            showDivLineValues: (0, a.pluckNumber)(i.showdivlinevalues, i.showdivlinevalue),
            showZeroPlane: i.showzeroplane,
            zeroPlaneColor: i.zeroplanecolor,
            zeroPlaneThickness: i.zeroplanethickness,
            zeroPlaneAlpha: i.zeroplanealpha,
            showZeroPlaneValue: i.showzeroplanevalue,
            trendlineColor: i.trendlinecolor,
            trendlineToolText: i.trendlinetooltext,
            trendlineThickness: i.trendlinethickness,
            trendlineAlpha: i.trendlinealpha,
            showTrendlinesOnTop: i.showtrendlinesontop,
            showAxisLine: (0, a.pluckNumber)(i.showyaxisline, i.showaxislines, i.drawAxisLines, 0),
            axisLineThickness: (0, a.pluckNumber)(i.yaxislinethickness, i.axislinethickness, 1),
            axisLineAlpha: (0, a.pluckNumber)(i.yaxislinealpha, i.axislinealpha, 100),
            axisLineColor: (0, a.pluck)(i.yaxislinecolor, i.axislinecolor, w)
          }).trendlines = n.trendlines, l.push(t), this.config.showVolumeChart && (o = {
            isVertical: !0,
            isReverse: !0,
            isOpposit: !1,
            axisIndex: 1,
            drawLabelsOpposit: 1,
            axisNameAlignCanvas: 1,
            uniqueClassName: 1,
            outCanfontFamily: (0, a.pluck)(i.outcnvbasefont, i.basefont, b),
            outCanfontSize: (0, a.pluckFontSize)(i.outcnvbasefontsize, i.basefontsize, 10),
            outCancolor: (0, a.pluck)(i.outcnvbasefontcolor, i.basefontcolor, r.getColor(u.baseFontColor)).replace(/^#?([a-f0-9]+)/gi, "#$1"),
            axisNamePadding: i.yaxisnamepadding,
            axisValuePadding: i.yaxisvaluespadding,
            axisNameFont: i.vyaxisnamefont,
            axisNameFontSize: i.vyaxisnamefontsize,
            axisNameFontColor: i.vyaxisnamefontcolor,
            axisNameFontBold: i.vyaxisnamefontbold,
            axisNameFontItalic: i.vyaxisnamefontitalic,
            axisNameBgColor: i.vyaxisnamebgcolor,
            axisNameBorderColor: i.vyaxisnamebordercolor,
            axisNameAlpha: i.vyaxisnamealpha,
            axisNameFontAlpha: i.vyaxisnamefontalpha,
            axisNameBgAlpha: i.vyaxisnamebgalpha,
            axisNameBorderAlpha: i.vyaxisnameborderalpha,
            axisNameBorderPadding: i.vyaxisnameborderpadding,
            axisNameBorderRadius: i.vyaxisnameborderradius,
            axisNameBorderThickness: i.vyaxisnameborderthickness,
            axisNameBorderDashed: i.vyaxisnameborderdashed,
            axisNameBorderDashLen: i.vyaxisnameborderdashlen,
            axisNameBorderDashGap: i.vyaxisnameborderdashgap,
            axisNameWidth: i.yaxisnamewidth,
            useEllipsesWhenOverflow: i.useellipseswhenoverflow,
            rotateAxisName: (0, a.pluckNumber)(i.rotateyaxisname, 1),
            axisName: i.vyaxisname,
            divLineColor: (0, a.pluck)(i.divlinecolor, r.getColor(u.divLineColor)),
            divLineAlpha: (0, a.pluck)(i.divlinealpha, r.getColor(y)),
            divLineThickness: (0, a.pluckNumber)(i.divlinethickness, 1),
            divLineIsDashed: Boolean((0, a.pluckNumber)(i.divlinedashed, i.divlineisdashed, 1)),
            divLineDashLen: (0, a.pluckNumber)(i.divlinedashlen, 4),
            divLineDashGap: (0, a.pluckNumber)(i.divlinedashgap, 2),
            showAlternateGridColor: (0, a.pluckNumber)(i.showalternatehgridcolor, 1),
            alternateGridColor: (0, a.pluck)(i.alternatehgridcolor, r.getColor(p)),
            alternateGridAlpha: (0, a.pluck)(i.alternatehgridalpha, r.getColor(h)),
            numDivLines: i.numdivlines,
            axisMinValue: i.vyaxisminvalue,
            axisMaxValue: i.vyaxismaxvalue,
            setAdaptiveMin: i.setadaptiveymin,
            adjustDiv: i.adjustdiv,
            labelStep: i.yaxisvaluesstep,
            showAxisValues: (0, a.pluckNumber)(i.showyaxisvalues, i.showyaxisvalue),
            showLimits: (0, a.pluckNumber)(i.showsecondarylimits, i.showlimits),
            showDivLineValues: (0, a.pluckNumber)(i.showdivlinevalues, i.showdivlinevalue),
            showZeroPlane: i.showzeroplane,
            zeroPlaneColor: i.zeroplanecolor,
            zeroPlaneThickness: i.zeroplanethickness,
            zeroPlaneAlpha: i.zeroplanealpha,
            showZeroPlaneValue: i.showzeroplanevalue,
            trendlineColor: i.trendlinecolor,
            trendlineToolText: i.trendlinetooltext,
            trendlineThickness: i.trendlinethickness,
            trendlineAlpha: i.trendlinealpha,
            showTrendlinesOnTop: i.showtrendlinesontop,
            showAxisLine: (0, a.pluckNumber)(i.showyaxisline, i.showaxislines, i.drawAxisLines, 0),
            axisLineThickness: (0, a.pluckNumber)(i.yaxislinethickness, i.axislinethickness, 1),
            axisLineAlpha: (0, a.pluckNumber)(i.yaxislinealpha, i.axislinealpha, 100),
            axisLineColor: (0, a.pluck)(i.yaxislinecolor, i.axislinecolor, w)
          }, l.push(o)), {
            xAxisConfigure: s,
            yAxisConfigure: l
          };
        }, t.prototype.mouseoutHandler = function (e, t, o) {
          var a = this.config.datasetOrder || this.getDatasets(),
              r = this.getChildren("mouseTracker")[0];
          a[t] && a[t].components.data[o] ? a[t]._firePlotEvent("fc-mouseout", o, e) : this.getFromEnv("toolTipController").hideAll(), delete r._lastDatasetIndex, delete r._lastPointIndex;
        }, t.prototype._mouseEvtHandler = function (e, t) {
          var o,
              r,
              n,
              i,
              l,
              s,
              c,
              u = this,
              p = t.mouseTracker,
              h = e.originalEvent,
              d = u.getChildren("canvas").length,
              f = h && (0, a.getMouseCoordinate)(u.getFromEnv("chart-container"), h, u),
              g = f && f.chartX || 0,
              m = f && f.chartY || 0,
              v = !1,
              b = p._lastDatasetIndex,
              y = p._lastPointIndex;

          for (i = 0; i < d; i++) {
            for (l = (o = u.getDatasets()).length; l-- && !v;) {
              (r = o[l]) && r.getState("visible") && (n = r._getHoveredPlot && r._getHoveredPlot(g, m)) && n.hovered && (v = !0, n.datasetIndex = l, c = p.getMouseEvents(e, n.datasetIndex, n.pointIndex));
            }
          }

          if ((!v || c && c.fireOut) && void 0 !== b && o[b] && o[b]._firePlotEvent && (c && !c.events.length ? p.mouseoutTimer = setTimeout(function () {
            u.mouseoutHandler(e, b, y);
          }, 20) : (u.mouseoutHandler(e, b, y), clearTimeout(p.mouseoutTimer))), v) for ((s = c.events && c.events.length) && (p._lastDatasetIndex = n.datasetIndex, y = p._lastPointIndex = n.pointIndex), l = 0; l < s; l += 1) {
            r && r._firePlotEvent && r._firePlotEvent(c.events[l], y, e, n.datasetIndex);
          }
        }, t.prototype._allocateSpace = function (e) {
          var t,
              o,
              a = this.getChildren("canvas"),
              r = a && a[0].config,
              n = this.config,
              i = n.canvasHeight,
              l = n.canvasWidth,
              s = n.availableHeight,
              c = n.availableWidth;
          o = n.canvasLeft += e.left || 0, t = n.canvasTop += e.top || 0, l = n.canvasWidth = f(l - ((e.left || 0) + (e.right || 0)), 0), i = n.canvasHeight = f(i - ((e.top || 0) + (e.bottom || 0)), 0), n.availableHeight = f(s - ((e.top || 0) + (e.bottom || 0)), 0), n.availableWidth = f(c - ((e.left || 0) + (e.right || 0)), 0), n.canvasRight = o + l, n.canvasBottom = t + i, r && (r.canvasPaddingLeft = f(r.canvasPaddingLeft, e.paddingLeft || 0), r.canvasPaddingRight = f(r.canvasPaddingRight, e.paddingRight || 0), r.canvasPaddingTop = f(r.canvasPaddingTop, e.paddingTop || 0), r.canvasPaddingBottom = f(r.canvasPaddingBottom, e.paddingBottom || 0));
        }, t.prototype._checkInvalidSpecificData = function () {
          var e = this.getFromEnv("dataSource").dataset,
              t = e && e[0] && e[0].data;
          if (!e || !t || !Array.isArray(t)) return !0;
        }, t;
      }(r["default"]);

      t["default"] = N;
    },
    922: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = function (e) {
        var t,
            o = e.getFromEnv("dataSource"),
            l = o.dataset,
            s = o.trendset,
            c = e.getFromEnv("chart-attrib"),
            u = e.getFromEnv("chartConfig").showVolumeChart,
            p = (0, a.pluck)((0, a.parseUnsafeString)(c.plotpriceas).toLowerCase(), "candlestick"),
            h = e.getChildren(),
            d = h.canvas[0].getChildren("vCanvas")[0],
            f = void 0,
            g = void 0,
            m = ["candlestick", "candlestickbar", "candlestickline", "trendset"];
        l ? ((g = l.slice(0))[0] && g[0].data && g[0].data.sort(function (e, t) {
          return e.x - t.x;
        }), t = e.getDSdef(p), (0, a.datasetFactory)(d, t, "dataset_" + p, l.length, g), n(m, "bar" === p ? "candlestickbar" : "line" === p ? "candlestickline" : "candlestick"), u && (f = h.canvas[1].getChildren("vCanvas")[0], (0, a.datasetFactory)(f, r.VolumeDataset, "dataset_volume", l.length, l)), s && ((0, a.datasetFactory)(d, r.TrendSet, "dataset_trendset", s.length, s), n(m, "trendset")), i(d, m)) : e.setChartMessage();
      };

      var a = o(125),
          r = o(923),
          n = function n(e, t) {
        var o = e.indexOf(t);
        -1 !== o && e.splice(o, 1);
      },
          i = function i(e, t) {
        var o = void 0;
        e && e.iterateComponents(function (e) {
          for (o = 0; o < t.length; o++) {
            e.getName() === t[o] && e.remove();
          }
        });
      };
    },
    923: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t.TrendSet = t.VolumeDataset = t.CandleStickLineDataset = t.CandleStickBarDataset = t.CandleStickDataset = undefined;
      var a = s(o(924)),
          r = s(o(926)),
          n = s(o(928)),
          i = s(o(929)),
          l = s(o(930));

      function s(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      t.CandleStickDataset = a["default"], t.CandleStickBarDataset = r["default"], t.CandleStickLineDataset = n["default"], t.VolumeDataset = i["default"], t.TrendSet = l["default"];
    },
    924: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t._parseToolText = t._firePlotEvent = t.getPlotIndices = undefined;
      var a = o(125),
          r = s(o(843)),
          n = o(132),
          i = s(o(925)),
          l = o(432);

      function s(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function c(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var u = a.preDefStr.colors,
          p = u.B90000,
          h = u.FFFFFF,
          d = function d(e, t, o) {
        var a,
            r,
            n,
            i = this.getFromEnv("chart"),
            l = this.components.data[t],
            s = this.config.currentToolTip,
            c = l.graphics.element,
            u = o.originalEvent,
            p = i.getFromEnv("paper").canvas.style,
            h = this.getFromEnv("toolTipController");
        if (c) switch (a = (r = l.config).toolText, n = r.setLink, e) {
          case "fc-mouseover":
            a && (s ? h.draw(u, a, s) : s = this.config.currentToolTip = h.draw(u, a)), i.plotEventHandler(c, o, "DataPlotRollOver"), n && (p.cursor = "pointer");
            break;

          case "fc-mouseout":
            h.hide(s), i.plotEventHandler(c, o, "DataPlotRollOut"), n && (p.cursor = "default");
            break;

          case "fc-click":
            i.plotEventHandler(c, o);
            break;

          case "fc-mousemove":
            a && (s ? h.draw(u, a, s) : s = this.config.currentToolTip = h.draw(u, a));
        }
      },
          f = function f(e) {
        var t,
            o,
            a = Math.floor(e),
            r = Math.ceil(e),
            n = [],
            i = this.config.JSONData && this.config.JSONData.data;

        for (t = i.length; t--;) {
          (o = i[t]).x >= a && o.x <= r && n.push(t);
        }

        return n;
      },
          g = function g(e) {
        var t,
            o = this.config,
            r = o.JSONData.data,
            n = this.components.data,
            i = this.getFromEnv("xAxis"),
            l = this.getFromEnv("chart-attrib"),
            s = "line" === o.plotType ? 1 : 0,
            c = r[e],
            u = n[e].config,
            p = i.getLabel(u.x).label,
            h = u.open,
            d = u.close,
            f = this.getFromEnv("yAxis"),
            g = u.high,
            m = u.low,
            v = u.volume,
            b = void 0 !== v ? c.volumetooltext : void 0;
        return o.showTooltip ? void 0 !== (t = (0, a.getValidValue)((0, a.parseUnsafeString)((0, a.pluck)(b, c.tooltext, o.volumeToolText, o.toolText)))) ? t = (0, a.parseTooltext)(t, [3, 5, 6, 10, 54, 55, 56, 57, 58, 59, 60, 61, 81, 82], {
          label: p,
          yaxisName: (0, a.parseUnsafeString)(l.yaxisname),
          xaxisName: (0, a.parseUnsafeString)(l.xaxisname),
          openValue: c.open,
          openDataValue: f.dataLabels(h),
          closeValue: c.close,
          closeDataValue: f.dataLabels(d),
          highValue: c.high,
          highDataValue: f.dataLabels(g),
          lowValue: c.low,
          lowDataValue: f.dataLabels(m),
          volumeValue: c.volume,
          volumeDataValue: f.dataLabels(v)
        }, c, l) : (t = null === h || s ? "" : "<b>Open:</b> " + f.dataLabels(h) + "<br />", t += null !== d ? "<b>Close:</b> " + f.dataLabels(d) + "<br />" : "", t += null === g || s ? "" : "<b>High:</b> " + f.dataLabels(g) + "<br />", t += null === m || s ? "" : "<b>Low:</b> " + f.dataLabels(m) + "<br />", t += null !== v ? "<b>Volume:</b> " + f.dataLabels(v) : "") : t = "", t;
      };

      (0, n.addDep)({
        name: "candlestickAnimation",
        type: "animationRule",
        extension: i["default"]
      });

      var m = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return c(t, e), t.prototype.trimData = function (e) {
          if (this.components || !this.components.data || !this.components.data.length) {
            var t = this.components,
                o = t && t.data,
                a = o && o.length,
                r = e.data,
                n = Array.isArray(r) && r.filter(function (e) {
              return e.high || e.open || e.close || e.low;
            }).length || 0,
                i = a - n;
            i > 0 && this.removeData(n, i, !1);
          }
        }, t.prototype.removePlots = function () {
          var e = this.components,
              t = e && e.removeDataArr;
          (0, l._removePlots)(t, this.__removeElem);
        }, t.prototype.configureAttributes = function (e) {
          if (!e) return !1;
          this.trimData(e), this.config.JSONData = e;

          var t,
              o,
              r,
              n,
              i,
              l,
              s,
              c,
              u,
              d,
              f,
              g,
              m,
              v,
              b,
              y,
              x,
              k,
              w,
              C,
              N,
              S = this.config,
              A = this.getFromEnv("chart"),
              E = A.getFromEnv("dataSource"),
              D = this.config.JSONData,
              _ = D.data || [],
              T = E.chart,
              L = _.length,
              P = this.getFromEnv("number-formatter"),
              O = this.getFromEnv("color-manager"),
              V = S.bearBorderColor = (0, a.getFirstColor)((0, a.pluck)(T.bearbordercolor, p)),
              M = S.bearFillColor = (0, a.getFirstColor)((0, a.pluck)(T.bearfillcolor, p)),
              F = S.bullBorderColor = (0, a.getFirstColor)((0, a.pluck)(T.bullbordercolor, O.getColor("canvasBorderColor"))),
              I = S.bullFillColor = (0, a.getFirstColor)((0, a.pluck)(T.bullfillcolor, h)),
              B = S.linethickness = S.plotBorderThickness = (0, a.pluckNumber)(T.plotlinethickness, 1),
              R = S.plotLineDashLen = (0, a.pluckNumber)(T.plotlinedashlen, 5),
              j = S.plotLineDashGap = (0, a.pluckNumber)(T.plotlinedashgap, 4),
              G = -Infinity,
              H = +Infinity,
              W = -Infinity,
              z = +Infinity;

          for (this.setState("visible", 1 === (0, a.pluckNumber)(D.visible, 1)), this._conatinerHidden = !!this.getState("visible"), S.defaultPadding = {
            left: .5,
            right: .5
          }, S.parentYAxis = 0, S.toolText = (0, a.getValidValue)((0, a.parseUnsafeString)((0, a.pluck)(D.tooltext, T.plottooltext))), S.name = (0, a.getValidValue)(D.seriesname), S.showTooltip = (0, a.pluck)(T.showtooltip, 1), S.showShadow = (0, a.pluckNumber)(T.showshadow, O.getColor("showShadow")), S.showErrorValue = !0, S.errorBarWidthPercent = 0, !0, N = (0, a.pluck)(T.maxcolwidth), S.maxColWidth = Math.abs((0, a.pluckNumber)(N, 50)) || 1, C = Math.max((0, a.pluckNumber)(T.plotspacepercent, 20) % 100, 0), S.plotSpacePercent = S.groupPadding = C / 200, x = this.components.data = this.components.data || (this.components.data = []), S.valuePadding = (0, a.pluckNumber)(D.valuepadding, T.valuepadding, 2), S.plotBorderThickness = B, i = 0; i < L; i += 1) {
            k = _[i], (l = x[i]) || (l = x[i] = {}), !l.config && (l.config = {}), !l.graphics && (l.graphics = {}), w = l.config, k && !k.vline && (w.setLink = (0, a.pluck)(k.link), s = w.open = P.getCleanValue(k.open), c = w.close = P.getCleanValue(k.close), u = w.high = P.getCleanValue(k.high), d = w.low = P.getCleanValue(k.low), null !== (w.volume = P.getCleanValue(k.volume, !0)) && (A.config.drawVolume = !0), m = w.x = P.getCleanValue(k.x), v = w.closeVal = Math.min(s, c), y = w.yVal = Math.max(s, c), f = Math.min(s, c, u, d), g = Math.max(s, c, u, d), o = (0, a.getFirstColor)((0, a.pluck)(k.bordercolor, c < s ? V : F)), r = (0, a.pluckNumber)(k.alpha, 100), t = (0, a.getFirstColor)((0, a.pluck)(k.color, c < s ? M : I)), w.plotBorderDashStyle = (0, a.pluckNumber)(k.dashed) ? (0, a.getDashStyle)(R, j) : "none", n = {
              opacity: S.showShadow ? r / 100 : 0
            }, w.color = t, w.alpha = r, w.setColor = w.color, w.setAlpha = w.alpha, w.anchorImageUrl = (0, a.pluck)(k.anchorimageurl, D.anchorimageurl, T.anchorimageurl), b = w.borderColor = o, w.borderAlpha = w.plotLineAlpha, w.colorArr = [{
              color: w.color,
              alpha: w.alpha
            }, {
              color: w.borderColor,
              alpha: w.borderAlpha
            }], w.showValue = 1, w.hoverEffects = {}, w.y = Math.abs(c - s), w.previousY = v, w.link = (0, a.pluck)(k.link), w.errorValueArr = [], u - y > 0 && (w.errorValue = !0, w.errorValueArr.push({
              errorValue: y - u,
              errorStartValue: y,
              errorBarColor: b,
              errorBarThickness: B,
              opacity: 1
            })), d - v < 0 && (w.errorValue = !0, w.errorValueArr.push({
              errorValue: v - d,
              errorStartValue: v,
              errorBarColor: b,
              errorBarThickness: B,
              opacity: 1
            })), w.setValue = y, null !== f && (G = Math.max(G, f), H = Math.min(H, f)), null !== g && (G = Math.max(G, g), H = Math.min(H, g)), null !== m && (W = Math.max(W, m), z = Math.min(z, m)), m = null !== m ? m : i + 1, w._x = m, w._y = y, w._b = v, w.high = Math.max(s, c, u, d), w.low = Math.min(s, c, u, d), w.shadow = n, w.toolText = this._parseToolText(i), w.toolTipValue = "", w.displayValue = (0, a.parseUnsafeString)((0, a.pluck)(k.displayvalue, k.valuetext, "")));
          }

          S.yMax = G, S.yMin = H, S.xMax = W, S.xMin = z, this.setState("dirty", !0);
        }, t.prototype._parseToolText = function (e) {
          return g.call(this, e);
        }, t.prototype.calculateScrollRange = function () {
          var e = this.config,
              t = this.components.data && this.components.data.length;
          e.scrollMinVal = e.scrollMinValForLabel = 0, e.scrollMaxVal = e.scrollMaxValForLabel = t;
        }, t.prototype.getPlotIndices = function (e) {
          return f.call(this, e);
        }, t.prototype._getHoveredPlot = function (e, t) {
          var o, a, r, n, i;

          for (o = this.getFromEnv("xAxis").getValue(e), a = (n = this.getPlotIndices(o)).length - 1; a > -1 && !(r = (i = n[a]) - o > 0 ? this._checkPointerOverPlot(i, e, t) || this._checkPointerOverPlot(i - 1, e, t) : this._checkPointerOverPlot(i + 1, e, t) || this._checkPointerOverPlot(i, e, t)); a--) {
            ;
          }

          return r;
        }, t.prototype._firePlotEvent = function (e, t, o) {
          d.call(this, e, t, o);
        }, t.prototype.getDataLimits = function () {
          var e = this.config;
          return {
            max: e.yMax,
            min: e.yMin,
            xMax: e.xMax,
            xMin: e.xMin
          };
        }, t.prototype.getName = function () {
          return "candlestick";
        }, t;
      }(r["default"]);

      t["default"] = m, t.getPlotIndices = f, t._firePlotEvent = d, t._parseToolText = g;
    },
    925: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = {
        "initial.dataset.candlestick": function initialDatasetCandlestick() {
          return {
            "rect.appearing": function rectAppearing(e) {
              return [{
                initialAttr: {
                  y: e.attr.y + e.attr.height,
                  height: 0
                },
                slot: "plot"
              }];
            },
            "group.appearing": function groupAppearing(e) {
              return "label-group" === e.attr.name ? [{
                initialAttr: {
                  opacity: 0
                },
                finalAttr: {
                  opacity: 1
                },
                slot: "final"
              }] : [{
                initialAttr: {
                  opacity: 1
                },
                finalAttr: {
                  opacity: 1
                },
                slot: "final"
              }];
            },
            "*": null
          };
        },
        "initial.dataset.volume": function initialDatasetVolume() {
          return {
            "rect.appearing": function rectAppearing(e) {
              return [{
                initialAttr: {
                  y: e.attr.y + e.attr.height,
                  height: 0
                },
                slot: "plot"
              }];
            },
            "*": null
          };
        }
      };
    },
    926: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = o(125),
          r = c(o(432)),
          n = o(843),
          i = o(924),
          l = o(132),
          s = c(o(927));

      function c(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function u(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var p = a.preDefStr.colors,
          h = p.B90000,
          d = p.FFFFFF,
          f = a.preDefStr.ROUND,
          g = a.preDefStr.visibleStr;
      (0, l.addDep)({
        name: "candlestickbarAnimation",
        type: "animationRule",
        extension: s["default"]
      });

      var m = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return u(t, e), t.prototype.trimData = function (e) {
          if (this.components || !this.components.data || !this.components.data.length) {
            var t = this.components,
                o = t && t.data,
                a = o && o.length,
                r = e.data,
                n = Array.isArray(r) && r.filter(function (e) {
              return e.high || e.open || e.close || e.low;
            }).length || 0,
                i = a - n;
            i > 0 && this.removeData(n, i, !1);
          }
        }, t.prototype.configureAttributes = function (e) {
          if (!e) return !1;
          this.trimData(e), this.config.JSONData = e;

          var t,
              o,
              r,
              n,
              i,
              l,
              s,
              c,
              u,
              p,
              f,
              g,
              m,
              v,
              b,
              y,
              x,
              k,
              w,
              C = this.config,
              N = this.getFromEnv("chart").getFromEnv("dataSource"),
              S = this.config.JSONData,
              A = S.data || [],
              E = N.chart,
              D = A.length,
              _ = this.getFromEnv("number-formatter"),
              T = this.getFromEnv("color-manager"),
              L = C.bearBorderColor = (0, a.getFirstColor)((0, a.pluck)(E.bearbordercolor, h)),
              P = C.bearFillColor = (0, a.getFirstColor)((0, a.pluck)(E.bearfillcolor, h)),
              O = C.bullBorderColor = (0, a.getFirstColor)((0, a.pluck)(E.bullbordercolor, T.getColor("canvasBorderColor"))),
              V = C.bullFillColor = (0, a.getFirstColor)((0, a.pluck)(E.bullfillcolor, d)),
              M = -Infinity,
              F = +Infinity,
              I = -Infinity,
              B = +Infinity;

          for (this.setState("visible", 1 === (0, a.pluckNumber)(S.visible, 1)), this._conatinerHidden = !!this.getState("visible"), C.defaultPadding = {
            left: .5,
            right: .5
          }, C.linethickness = (0, a.pluckNumber)(E.plotlinethickness, 2), C.toolText = (0, a.getValidValue)((0, a.parseUnsafeString)((0, a.pluck)(S.tooltext, E.plottooltext))), C.name = (0, a.getValidValue)(S.seriesname), C.showTooltip = (0, a.pluck)(E.showtooltip, 1), C.showErrorValue = !0, C.errorBarWidthPercent = 0, !0, k = (0, a.pluck)(E.maxcolwidth), C.maxColWidth = Math.abs((0, a.pluckNumber)(k, 50)) || 1, C.enableAnimation = w = (0, a.pluckNumber)(E.animation, E.defaultanimation, 1), C.animation = !!w && {
            duration: 1e3 * (0, a.pluckNumber)(E.animationduration, 1)
          }, m = C.plotLineDashLen = (0, a.pluckNumber)(E.plotlinedashlen, 5), v = C.plotLineDashGap = (0, a.pluckNumber)(E.plotlinedashgap, 4), b = this.components.data = this.components.data || (this.components.data = []), C.valuePadding = (0, a.pluckNumber)(S.valuepadding, E.valuepadding, 2), C.showShadow = (0, a.pluckNumber)(E.showshadow, T.getColor("showShadow")), n = 0; n < D; n++) {
            y = A[n], (i = b[n]) || (i = b[n] = {}), !i.config && (i.config = {}), !i.graphics && (i.graphics = {}), x = i.config, y && !y.vline && (x.setLink = (0, a.pluck)(y.link), l = x.open = _.getCleanValue(y.open), s = x.close = _.getCleanValue(y.close), c = _.getCleanValue(y.high), u = _.getCleanValue(y.low), x.volume = _.getCleanValue(y.volume, !0), g = x.x = _.getCleanValue(y.x), x.high = Math.max(l, s, c, u), x.low = Math.min(l, s, c, u), x.yVal = Math.max(l, s), p = Math.min(l, s, c, u), f = Math.max(l, s, c, u), o = (0, a.getFirstColor)((0, a.pluck)(y.bordercolor, s < l ? L : O)), r = (0, a.pluckNumber)(y.alpha, 100), t = (0, a.getFirstColor)((0, a.pluck)(y.color, s < l ? P : V)), x.color = t, x.alpha = r, x.setColor = x.color, x.setAlpha = x.alpha, x.borderColor = o, x.borderAlpha = x.plotLineAlpha, x.colorArr = [{
              color: x.color,
              alpha: x.alpha
            }, {
              color: x.borderColor,
              alpha: x.borderAlpha
            }], x.showValue = 1, x.hoverEffects = {}, x.link = (0, a.pluck)(y.link), x.setValue = x.y, null !== p && (M = Math.max(M, p), F = Math.min(F, p)), null !== f && (M = Math.max(M, f), F = Math.min(F, f)), null !== g && (I = Math.max(I, g), B = Math.min(B, g)), x.dashStyle = (0, a.pluckNumber)(y.dashed) ? (0, a.getDashStyle)(m, v) : "none", x.shadow = {
              opacity: C.showShadow ? r / 100 : 0
            }, g = null !== g ? g : n + 1, x.toolText = this._parseToolText(n), x.toolTipValue = "", x._x = g, x.y = l, x.previousY = s);
          }

          C.yMax = M, C.yMin = F, C.xMax = I, C.xMin = B, this.setState("dirty", !0);
        }, t.prototype.drawPlots = function () {
          var e,
              t,
              o,
              r,
              n,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              d,
              m,
              v,
              b,
              y,
              x = this.getFromEnv("animationManager"),
              k = this.config,
              w = this.components.data,
              C = w.length,
              N = this.getFromEnv("xAxis"),
              S = this.getFromEnv("yAxis"),
              A = function A(e) {
            return function () {
              this.shadow(e);
            };
          },
              E = k.linethickness > 5 ? k.linethickness / 2 : 2.5,
              D = this.getContainer("plotGroup"),
              _ = this.getState("visible");

          for (x.setAnimation({
            el: D,
            attr: {
              opacity: _ ? 1 : 0
            },
            component: this
          }), this.setColumnPosition(), t = this.getFromEnv("columnXShift"), o = 0; o < C; o += 1) {
            e = (r = w[o]).config, y = r.graphics, h = null, null === (l = e.y) ? h = y.element : (i = e._x, n = e.link, e.setLink = e.link, c = N.getPixel(i), s = e.previousY, p = S.getPixel(s), u = S.getPixel(l), d = S.getPixel(e.high), m = S.getPixel(e.low), v = t, r.errorBar = [], r.errorBar.push([{
              _xPos: c - E,
              _yPos: d,
              _height: Math.abs(d - m),
              _width: 2 * E
            }, {
              _xPos: c + v,
              _yPos: u,
              _height: 2 * E,
              _width: Math.abs(v)
            }, {
              _xPos: c,
              _yPos: p,
              _height: 2 * E,
              _width: Math.abs(v)
            }]), b = ["M", c, m, "L", c, d, "M", c, u, "L", c + v, u, "M", c, p, "L", c - v, p], h = y.element, h = x.setAnimation({
              el: h || "path",
              container: D,
              attr: {
                path: b,
                cursor: n ? "pointer" : "",
                fill: (0, a.toRaphaelColor)(e.color),
                stroke: (0, a.toRaphaelColor)(e.borderColor),
                "stroke-width": k.linethickness,
                "stroke-dasharray": e.dashStyle,
                "stroke-linecap": f,
                "stroke-linejoin": f,
                "shape-rendering": "crisp",
                visibility: g
              },
              label: "path",
              component: this,
              callback: A.call(h, e.shadow)
            }), y.element = h);
          }
        }, t.prototype._parseToolText = function (e) {
          return i._parseToolText.call(this, e);
        }, t.prototype._firePlotEvent = function (e, t, o) {
          i._firePlotEvent.call(this, e, t, o);
        }, t.prototype._checkPointerOverColumn = function () {}, t.prototype._getHoveredPlot = function (e, t) {
          var o, a, r, n, l;

          for (o = this.getFromEnv("xAxis").getValue(e), a = (n = i.getPlotIndices.call(this, o)).length - 1; a > -1 && !(r = (l = n[a]) - o > 0 ? this._checkPointerOverPlot(l, e, t) || this._checkPointerOverPlot(l - 1, e, t) : this._checkPointerOverPlot(l + 1, e, t) || this._checkPointerOverPlot(l, e, t)); a--) {
            ;
          }

          return r;
        }, t.prototype._checkPointerOverPlot = function (e, t, o) {
          return n._checkPointerOverPlot.call(this, e, t, o);
        }, t.prototype._checkPointerOverErrorBar = function (e, t, o) {
          return n._checkPointerOverErrorBar.call(this, e, t, o);
        }, t.prototype.drawLabel = function () {}, t.prototype.getDataLimits = function () {
          var e = this.config;
          return {
            max: e.yMax,
            min: e.yMin,
            xMax: e.xMax,
            xMin: e.xMin
          };
        }, t.prototype.getName = function () {
          return "candlestickbar";
        }, t;
      }(r["default"]);

      t["default"] = m;
    },
    927: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = {
        "initial.dataset.candlestickbar": function initialDatasetCandlestickbar() {
          return {
            "path.appearing": function pathAppearing() {
              return [{
                initialAttr: {
                  opacity: 1,
                  "stroke-width": 1
                },
                finalAttr: {
                  opacity: 1
                }
              }];
            },
            "*": null
          };
        }
      };
    },
    928: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(125),
          n = o(449),
          i = (a = n) && a.__esModule ? a : {
        "default": a
      },
          l = o(924);

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var c = r.preDefStr.colors,
          u = c.B90000,
          p = c.FFFFFF,
          h = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return s(t, e), t.prototype.configureAttributes = function (e) {
          if (!e) return !1;
          this.trimData(e), this.config.JSONData = e;

          var t,
              o,
              a,
              n,
              i,
              l,
              s,
              c,
              h,
              d,
              f,
              g,
              m,
              v,
              b,
              y,
              x,
              k,
              w,
              C = this.config,
              N = this.config.JSONData,
              S = N.data || [],
              A = this.getFromEnv("chart-attrib"),
              E = S.length,
              D = this.getFromEnv("number-formatter"),
              _ = this.getFromEnv("color-manager"),
              T = C.bearBorderColor = (0, r.getFirstColor)((0, r.pluck)(A.bearbordercolor, u)),
              L = C.bearFillColor = (0, r.getFirstColor)((0, r.pluck)(A.bearfillcolor, u)),
              P = C.bullBorderColor = (0, r.getFirstColor)((0, r.pluck)(A.bullbordercolor, _.getColor("canvasBorderColor"))),
              O = C.bullFillColor = (0, r.getFirstColor)((0, r.pluck)(A.bullfillcolor, p)),
              V = C.linethickness = C.plotBorderThickness = (0, r.pluckNumber)(A.plotlinethickness, 2),
              M = C.plotLineDashLen = (0, r.pluckNumber)(A.plotlinedashlen, 5),
              F = C.plotLineDashGap = (0, r.pluckNumber)(A.plotlinedashgap, 4),
              I = !!(0, r.pluckNumber)(A.drawanchors, 0),
              B = (0, r.pluckNumber)(A.anchorstartangle, 90),
              R = (0, r.pluckNumber)(A.anchorradius, this.anchorRadius, 3),
              j = (0, r.getFirstColor)((0, r.pluck)(A.anchorbordercolor, P)),
              G = (0, r.pluckNumber)(A.anchorborderthickness, this.anchorBorderThickness, 1),
              H = (0, r.getFirstColor)((0, r.pluck)(A.anchorbgcolor, _.getColor("anchorBgColor"))),
              W = (0, r.pluck)(A.anchoralpha, "0"),
              z = (0, r.pluck)(A.anchorbgalpha, W),
              U = -Infinity,
              J = +Infinity,
              K = -Infinity,
              q = +Infinity;

          for (this.setState("visible", 1 === (0, r.pluckNumber)(N.visible, 1)), this._conatinerHidden = !!this.getState("visible"), C.defaultPadding = {
            left: .5,
            right: .5
          }, C.plotType = "line", C.parentYAxis = 0, C.toolText = (0, r.getValidValue)((0, r.parseUnsafeString)((0, r.pluck)(N.tooltext, A.plottooltext))), C.name = (0, r.getValidValue)(N.seriesname), C.showTooltip = (0, r.pluck)(A.showtooltip, 1), k = (0, r.pluck)(A.maxcolwidth), C.maxColWidth = Math.abs((0, r.pluckNumber)(k, 50)) || 1, C.enableAnimation = w = (0, r.pluckNumber)(A.animation, A.defaultanimation, 1), C.animation = !!w && {
            duration: 1e3 * (0, r.pluckNumber)(A.animationduration, 1)
          }, C.lineAlpha = (0, r.pluck)(A.plotlinealpha, "100"), x = Math.max((0, r.pluckNumber)(A.plotspacepercent, 20) % 100, 0), C.plotSpacePercent = C.groupPadding = x / 200, v = this.components.data = this.components.data || (this.components.data = []), C.valuePadding = (0, r.pluckNumber)(N.valuepadding, A.valuepadding, 2), C.plotBorderThickness = V, C.showvalues = 1, C.showShadow = (0, r.pluckNumber)(A.showshadow, _.getColor("showShadow")), i = 0; i < E; i += 1) {
            b = S[i], (l = v[i]) || (l = v[i] = {}), !l.config && (l.config = {}), !l.graphics && (l.graphics = {}), y = l.config, b && !b.vline && (y.setLink = (0, r.pluck)(b.link), s = y.open = D.getCleanValue(b.open), c = y.close = D.getCleanValue(b.close), h = y.high = D.getCleanValue(b.high), d = y.low = D.getCleanValue(b.low), y.volume = D.getCleanValue(b.volume, !0), m = y.x = D.getCleanValue(b.x), y.closeVal = Math.min(s, c), y.yVal = Math.max(s, c), f = Math.min(s, c, h, d), g = Math.max(s, c, h, d), t = (0, r.getFirstColor)((0, r.pluck)(b.bordercolor, c < s ? T : P)), o = (0, r.pluck)(b.alpha, C.lineAlpha), (0, r.getFirstColor)((0, r.pluck)(b.color, c < s ? L : O)), a = (0, r.pluckNumber)(b.dashed) ? (0, r.getDashStyle)(M, F) : "none", y.dashStyle = a, n = {
              opacity: C.showShadow ? o / 100 : 0
            }, y.color = t, y.alpha = o, y.setColor = y.color, y.setAlpha = y.alpha, y.anchorImageUrl = (0, r.pluck)(b.anchorimageurl, N.anchorimageurl, A.anchorimageurl), y.borderColor = t, y.borderAlpha = y.plotLineAlpha, y.colorArr = [{
              color: y.color,
              alpha: y.alpha
            }, {
              color: y.borderColor,
              alpha: y.borderAlpha
            }], y.anchorSides = (0, r.pluckNumber)(b.anchorsides, N.anchorsides, A.anchorsides), y.symbol = (0, r.mapSymbolName)(y.anchorSides).split("_"), y.anchorProps = {
              enabled: I,
              bgColor: H,
              symbol: y.symbol,
              bgAlpha: z * W / 100 + "",
              borderColor: j,
              borderAlpha: W,
              anchorAlpha: W,
              borderThickness: G,
              imageUrl: y.anchorImageUrl,
              radius: R,
              imageScale: (0, r.pluckNumber)(b.imagescale, N.imagescale, A.imagescale, 100),
              imagePadding: (0, r.pluckNumber)(b.anchorimagepadding, N.anchorimagepadding, A.anchorimagepadding, 1),
              imageAlpha: (0, r.pluckNumber)(N.anchorimagealpha, A.anchorimagealpha, 100),
              startAngle: B
            }, y.showValue = b.displayvalue ? 1 : 0, y.hoverEffects = {}, y.anchorSides = (0, r.pluckNumber)(b.anchorsides, N.anchorsides, A.anchorsides), y.symbol = (0, r.mapSymbolName)(y.anchorSides).split("_"), y.hoverEffects = {}, y.y = c, y.link = (0, r.pluck)(b.link), y.toolText = this._parseToolText(i), y.toolTipValue = "", y.setValue = y._y = y.y, y.displayValue = (0, r.parseUnsafeString)((0, r.pluck)(b.displayvalue, b.valuetext, "")), null !== f && (U = Math.max(U, f), J = Math.min(J, f)), null !== g && (U = Math.max(U, g), J = Math.min(J, g)), null !== m && (K = Math.max(K, m), q = Math.min(q, m)), m = m || i + 1, y._x = y.x = m, y.high = Math.max(s, c, h, d), y.low = Math.min(s, c, h, d), y.shadow = n);
          }

          C.yMax = U, C.yMin = J, C.xMax = K, C.xMin = q, this.setState("dirty", !0);
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this), this.config.drawLine = 1;
        }, t.prototype.trimData = function (e) {
          if (this.components || !this.components.data || !this.components.data.length) {
            var t = this.components,
                o = t && t.data,
                a = o && o.length,
                r = e.data,
                n = Array.isArray(r) && r.filter(function (e) {
              return e.high || e.open || e.close || e.low;
            }).length || 0,
                i = a - n;
            i > 0 && this.removeData(n, i, !1);
          }
        }, t.prototype.calculateScrollRange = function () {
          var e = this.config,
              t = this.components.data && this.components.data.length;
          e.scrollMinVal = e.scrollMinValForLabel = 0, e.scrollMaxVal = e.scrollMaxValForLabel = t;
        }, t.prototype.getDataLimits = function () {
          var e = this.config;
          return {
            max: e.yMax,
            min: e.yMin,
            xMax: e.xMax,
            xMin: e.xMin
          };
        }, t.prototype.getPlotIndices = function (e) {
          var t,
              o,
              a = Math.floor(e),
              r = Math.ceil(e),
              n = [],
              i = this.config.JSONData && this.config.JSONData.data;

          for (t = i.length; t--;) {
            (o = i[t]).x >= a && o.x <= r && n.push(t);
          }

          return n;
        }, t.prototype._parseToolText = function (e) {
          return l._parseToolText.call(this, e);
        }, t.prototype._getHoveredPlot = function (e, t) {
          var o,
              a,
              r,
              n,
              i,
              l,
              s = this.getFromEnv("xAxis"),
              c = this.components.data,
              u = c.length,
              p = this.config,
              h = p && p.radius || 0;
          e += s.getTranslation();
          var d = (r = (a = this.getPlotIndices(Math.floor(Math.max(s.getValue(e - h), 0))))[0]) > (n = (a = this.getPlotIndices(Math.ceil(Math.min(s.getValue(e + h), u - 1))))[a.length - 1]) ? [n, r] : [r, n];

          for (r = d[0], l = n = d[1]; l >= r && (!(o = c[l]) || !(i = this.isWithinShape(o, l, e, t))); l--) {
            ;
          }

          return i;
        }, t.prototype.getName = function () {
          return "candlestickline";
        }, t;
      }(i["default"]);

      t["default"] = h;
    },
    929: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(432),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      },
          i = o(125),
          l = o(924);

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var c = i.preDefStr.colors,
          u = c.B90000,
          p = c.FFFFFF,
          h = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return s(t, e), t.prototype.configureAttributes = function (e) {
          if (!e) return !1;
          this.trimData(e), this.config.JSONData = e;

          var t,
              o,
              a,
              r,
              n,
              l,
              s,
              c,
              h,
              d,
              f,
              g,
              m,
              v,
              b,
              y,
              x,
              k,
              w = this.config,
              C = this.config.JSONData,
              N = C.data || [],
              S = this.getFromEnv("chart-attrib"),
              A = this.getFromEnv("chartConfig"),
              E = N.length,
              D = this.getFromEnv("color-manager"),
              _ = w.bearBorderColor = (0, i.getFirstColor)((0, i.pluck)(S.bearbordercolor, A.vplotbordercolor, u)),
              T = w.bearFillColor = (0, i.getFirstColor)((0, i.pluck)(S.bearfillcolor, u)),
              L = w.bullBorderColor = (0, i.getFirstColor)((0, i.pluck)(S.bullbordercolor, A.vplotbordercolor, D.getColor("canvasBorderColor"))),
              P = w.bullFillColor = (0, i.getFirstColor)((0, i.pluck)(S.bullfillcolor, p)),
              O = (0, i.pluckNumber)(A.showplotborder, 1) ? (0, i.pluckNumber)(S.vplotborderthickness, 1) : 0,
              V = this.getFromEnv("number-formatter"),
              M = -Infinity,
              F = +Infinity,
              I = -Infinity,
              B = +Infinity,
              R = this.getFromEnv("number-formatter");

          for (this.setState("visible", 1 === (0, i.pluckNumber)(C.visible, 1)), !0 === this.getState("visible") ? this._conatinerHidden = !1 : this._containerHidden = !0, w.parentYAxis = 1, w.volumeToolText = (0, i.getValidValue)((0, i.parseUnsafeString)((0, i.pluck)(C.volumetooltext, S.volumetooltext, S.plottooltext))), w.name = (0, i.getValidValue)(C.seriesname), w.showTooltip = (0, i.pluck)(S.showtooltip, 1), w.showShadow = (0, i.pluckNumber)(S.showshadow, D.getColor("showShadow")), k = (0, i.pluck)(S.maxcolwidth), w.maxColWidth = Math.abs((0, i.pluckNumber)(k, 50)) || 1, x = Math.max((0, i.pluckNumber)(S.plotspacepercent, 20) % 100, 0), w.plotSpacePercent = w.groupPadding = x / 200, w.plotborderthickness = O, v = this.components.data = this.components.data || (this.components.data = []), f = (0, i.extend2)((0, i.extend2)({}, S), {
            sforcedecimals: (0, i.getFirstValue)(S.forcevdecimals, S.forcedecimals),
            sforceyaxisvaluedecimals: (0, i.getFirstValue)(S.forcevyaxisvaluedecimals, S.forceyaxisvaluedecimals),
            syaxisvaluedecimals: (0, i.getFirstValue)(S.vyaxisvaluedecimals, S.yaxisvaluedecimals),
            sformatnumber: (0, i.getFirstValue)(S.vformatnumber, S.formatnumber),
            sformatnumberscale: (0, i.getFirstValue)(S.vformatnumberscale, S.formatnumberscale, "1"),
            sdefaultnumberscale: (0, i.getFirstValue)(S.vdefaultnumberscale, S.defaultnumberscale),
            snumberscaleunit: (0, i.getFirstValue)(S.vnumberscaleunit, S.numberscaleunit),
            vnumberscalevalue: (0, i.getFirstValue)(S.vnumberscalevalue, S.numberscalevalue),
            sscalerecursively: (0, i.getFirstValue)(S.vscalerecursively, S.scalerecursively),
            smaxscalerecursion: (0, i.getFirstValue)(S.vmaxscalerecursion, S.maxscalerecursion),
            sscaleseparator: (0, i.getFirstValue)(S.vscaleseparator, S.scaleseparator),
            snumberprefix: (0, i.getFirstValue)(S.vnumberprefix, S.numberprefix),
            snumbersuffix: (0, i.getFirstValue)(S.vnumbersuffix, S.numbersuffix),
            sdecimals: (0, i.getFirstValue)(S.vdecimals, S.decimals)
          }), g = w.plotLineDashLen = (0, i.pluckNumber)(S.plotlinedashlen, 5), m = w.plotLineDashGap = (0, i.pluckNumber)(S.plotlinedashgap, 4), R.configure(f), r = 0; r < E; r += 1) {
            b = N[r], (n = v[r]) || (n = v[r] = {}), !n.config && (n.config = {}), !n.graphics && (n.graphics = {}), y = n.config, b && !b.vline && (l = y.open = V.getCleanValue(b.open), s = y.close = V.getCleanValue(b.close), c = y.volume = V.getCleanValue(b.volume, !0), y.high = V.getCleanValue(b.high), y.low = V.getCleanValue(b.low), h = y.x = V.getCleanValue(b.x), M = Math.max(M, c), F = Math.min(F, c), I = Math.max(I, h), B = Math.min(B, h), y.borderColor = (0, i.getFirstColor)((0, i.pluck)(b.bordercolor, s < l ? _ : L)), o = (0, i.pluckNumber)(b.alpha, 100), d = (0, i.pluckNumber)(A.vplotborderalpha, b.alpha, 100), t = (0, i.getFirstColor)((0, i.pluck)(b.color, s < l ? T : P)), a = {
              opacity: w.showShadow ? o / 100 : 0
            }, y.color = t, y.alpha = o, y.setLink = b.link, y.borderWidth = O, y.borderAlpha = d, y.y = c, y.colorArr = [{
              color: y.color,
              alpha: y.alpha
            }, {
              color: y.borderColor,
              alpha: y.borderAlpha
            }], y.toolText = this._parseToolText(r), y.toolTipValue = "", y.setValue = y._y = y.y, y.plotBorderDashStyle = (0, i.pluckNumber)(b.dashed) ? (0, i.getDashStyle)(g, m) : "none", h = null !== h ? h : r + 1, y._x = h, y.shadow = a);
          }

          w.defaultPadding = {
            left: 0,
            right: 0
          }, w.yMax = M, w.yMin = F, w.xMax = I, w.xMin = B, this.setState("dirty", !0);
        }, t.prototype._parseToolText = function (e) {
          return l._parseToolText.call(this, e);
        }, t.prototype.getPlotIndices = function (e) {
          var t,
              o,
              a = Math.floor(e),
              r = Math.ceil(e),
              n = [],
              i = this.config.JSONData && this.config.JSONData.data;

          for (t = i.length; t--;) {
            (o = i[t]).x >= a && o.x <= r && n.push(t);
          }

          return n;
        }, t.prototype._getHoveredPlot = function (e, t) {
          var o,
              a,
              r,
              n,
              i,
              l = this.getFromEnv("xAxis");

          for (e += l.getTranslation(), o = l.getValue(e), a = (n = this.getPlotIndices(o)).length - 1; a > -1 && !(r = (i = n[a]) - o > 0 ? this._checkPointerOverColumn(i, e, t) || this._checkPointerOverColumn(i - 1, e, t) : this._checkPointerOverColumn(i + 1, e, t) || this._checkPointerOverColumn(i, e, t)); a--) {
            ;
          }

          return r;
        }, t.prototype.getDataLimits = function () {
          var e = this.config;
          return {
            max: e.yMax,
            min: e.yMin,
            xMax: e.xMax,
            xMin: e.xMin
          };
        }, t.prototype.calculateScrollRange = function () {
          var e = this.config,
              t = this.components.data && this.components.data.length;
          e.scrollMinVal = 0, e.scrollMaxVal = t, e.scrollMinValForLabel = e.scrollMinVal, e.scrollMaxValForLabel = e.scrollMaxVal;
        }, t.prototype.drawLabel = function () {}, t.prototype.getName = function () {
          return "volume";
        }, t;
      }(n["default"]);

      t["default"] = h;
    },
    930: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = l(o(449)),
          r = o(125),
          n = o(132),
          i = l(o(931));

      function l(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      (0, n.addDep)({
        name: "trendsetAnimation",
        type: "animationRule",
        extension: i["default"]
      });

      var c = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return s(t, e), t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this), this.config.drawLine = 1;
        }, t.prototype.configureAttributes = function (e) {
          if (!e) return !1;
          this.trimData(e), this.config.JSONData = e;
          var t,
              o,
              a,
              n,
              i,
              l,
              s = this.getFromEnv("chart-attrib"),
              c = this.getFromEnv("chartConfig"),
              u = this.config.JSONData,
              p = this.index,
              h = u.data || u.set || [],
              d = this.config,
              f = this.components.data,
              g = -Infinity,
              m = +Infinity,
              v = -Infinity,
              b = +Infinity,
              y = this.getFromEnv("number-formatter"),
              x = (0, r.getFirstColor)((0, r.pluck)(u.color, s.trendsetcolor, "666666")),
              k = (0, r.pluck)(u.alpha, s.trendsetalpha, "100"),
              w = (0, r.pluckNumber)(u.thickness, s.trendsetthickness, 2),
              C = Boolean((0, r.pluckNumber)(u.dashed, s.trendsetdashed, 0)),
              N = (0, r.pluckNumber)(u.dashlen, s.trendsetdashlen, 4),
              S = (0, r.pluckNumber)(u.dashgap, s.trendsetdashgap, 4);

          for (d.includeInLegend = (0, r.pluckNumber)(u.includeinlegend, 1), d.lineColor = x, d.lineAlpha = k, d.connectNullData = (0, r.pluckNumber)(s.connectnulldata, 0), d.linethickness = w, d.lineDashStyle = C ? (0, r.getDashStyle)(N, S) : "none", d.name = (0, r.getValidValue)(u.name), d.includeInLegend = (0, r.pluckNumber)(u.includeinlegend, 1), d.defaultPadding = {
            left: .5,
            right: .5
          }, f || (f = this.components.data = []), p = 0, l = h.length; p < l; p += 1) {
            (t = h[p]) && !t.vline && (o = (n = (a = f[p] = f[p] || (f[p] = {})).config = a.config || (a.config = {}))._y = n.setValue = y.getCleanValue(t.value), n.setColor = d.lineColor, n.setAlpha = d.lineAlpha, i = y.getCleanValue(t.x), i = n._x = n.x = null !== i ? i : p + 1, g = Math.max(g, o), m = Math.min(m, o), b = Math.min(b, i), v = Math.max(v, i), n.anchorProps = this._parseAnchorProperties(p), n.hoverEffects = {}, a.graphics || (a.graphics = {}));
          }

          d.max = g, d.min = m, d.xMax = v, d.xMin = b, c.showLegend && this._addLegend(), this.setState("visible", !0), this.setState("dirty", !0);
        }, t.prototype._addLegend = function () {
          var e,
              t = this.config.JSONData,
              o = this.config,
              a = this.getFromEnv("legend"),
              n = {
            enabled: o.includeInLegend,
            interactiveLegend: !1,
            type: this.type,
            drawLine: !0,
            label: (0, r.getFirstValue)(t.name)
          };
          o.includeinlegend ? ((e = a.getItem(this.config.legendItemId)) ? e.configure({
            style: a.config.itemStyle,
            hiddenStyle: a.config.itemHiddenStyle,
            datasetVisible: a.config.datasetVisible,
            hoverStyle: a.config.itemHoverStyle
          }) : (this.config.legendItemId = a.createItem(this), e = a.getItem(this.config.legendItemId)), e.configure(n), e.setStateCosmetics("default", {
            symbol: {
              stroke: (0, r.toRaphaelColor)({
                color: o.lineColor,
                alpha: "100"
              }),
              rawFillColor: o.lineColor
            }
          })) : this.config.legendItemId && a.disposeItem(this.config.legendItemId);
        }, t.prototype.getDataLimits = function () {
          var e = this.config;
          return {
            max: e.max,
            min: e.min,
            xMax: e.xMax,
            xMin: e.xMin
          };
        }, t.prototype.getType = function () {
          return "trendset";
        }, t.prototype.drawLabel = function () {}, t.prototype.getName = function () {
          return "trendset";
        }, t;
      }(a["default"]);

      t["default"] = c;
    },
    931: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(452),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = {
        "initial.trendset.trendset": n["default"]["initial.dataset.line"]
      };
    },
    932: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = function (e) {
        var t,
            o = e.getChildren("canvas"),
            a = o[0],
            n = o[1],
            l = e.config.showVolumeChart,
            s = {
          zoomable: !0,
          pannable: !0
        },
            c = a.getChildren("axisRefVisualCartesian")[0],
            u = void 0,
            p = void 0,
            h = void 0,
            d = void 0,
            f = function f() {
          return c.asyncDraw();
        },
            g = function g() {
          return u.asyncDraw();
        };

        t = e._feedAxesRawData(), (0, r.componentFactory)(e, i["default"], "yAxis", l ? 2 : 1, t.yAxisConfigure), (0, r.componentFactory)(e, i["default"], "xAxis", 1, t.xAxisConfigure), h = e.getChildren("yAxis")[0], p = e.getChildren("yAxis")[1], h.setAxisConfig({
          relativeAxis: p
        }), p && p.setAxisConfig({
          relativeAxis: h
        }), d = e.getChildren("xAxis")[0], h.setLinkedItem("canvas", a), d.setLinkedItem("canvas", a), c.setLinkedItem(h.getId(), h), c.setLinkedItem(d.getId(), d), c.addExtEventListener("visiblerangeset", f, h), c.addExtEventListener("visiblerangeset", f, d), a.attachAxis(d, !1, e.zoomX ? s : {}), a.attachAxis(h, !0, e.zoomY ? s : {}), l && (u = n.getChildren("axisRefVisualCartesian")[0], n.attachAxis(d, !1, e.zoomX ? s : {}), p.setLinkedItem("canvas", n), u.setLinkedItem(p.getId(), p), u.setLinkedItem(d.getId(), d), u.addExtEventListener("visiblerangeset", g, p), u.addExtEventListener("visiblerangeset", g, d), n.attachAxis(p, !0, e.zoomY ? s : {})), e._setCategories();
      };
      var a,
          r = o(125),
          n = o(377),
          i = (a = n) && a.__esModule ? a : {
        "default": a
      };
    },
    933: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(934),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    934: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = s(o(518)),
          r = s(o(935)),
          n = s(o(939)),
          i = o(125),
          l = s(o(940));

      function s(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function c(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      i.setAttribDefs && (0, i.setAttribDefs)({
        whiskerslimitswidthratio: {
          type: i.attrTypeNum,
          pAttr: "whiskerslimitswidthratio"
        },
        outliersupperrangeratio: {
          type: i.attrTypeNum,
          pAttr: "outliersupperrangeratio"
        },
        outlierslowerrangeratio: {
          type: i.attrTypeNum,
          pAttr: "outlierslowerrangeratio"
        },
        showalloutliers: {
          type: i.attrTypeNum,
          pAttr: "showalloutliers"
        },
        showmean: {
          type: i.attrTypeNum,
          pAttr: "showmean"
        },
        showsd: {
          type: i.attrTypeNum,
          pAttr: "showsd"
        },
        showmd: {
          type: i.attrTypeNum,
          pAttr: "showmd"
        },
        showqd: {
          type: i.attrTypeNum,
          pAttr: "showqd"
        },
        showminvalues: {
          type: i.attrTypeNum,
          pAttr: "showminvalues"
        },
        showmaxvalues: {
          type: i.attrTypeNum,
          pAttr: "showmaxvalues"
        },
        showq1values: {
          type: i.attrTypeNum,
          pAttr: "showq1values"
        },
        showq3values: {
          type: i.attrTypeNum,
          pAttr: "showq3values"
        },
        showmedianvalues: {
          type: i.attrTypeNum,
          pAttr: "showmedianvalues"
        }
      });

      var u = i.preDefStr.POLYGON,
          p = i.preDefStr.colors.c000000,
          h = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this)),
              a = o;

          return a.maxColWidth = +Infinity, a.useErrorAnimation = 1, a.avoidCrispError = 0, a.plotSpacePercent = 20, a.useplotgradientcolor = 1, a.fireGroupEvent = !0, o.registerFactory("dataset", l["default"], ["vCanvas"]), o;
        }

        return c(t, e), t.getName = function () {
          return "BoxAndWhisker2D";
        }, t.prototype.getName = function () {
          return "BoxAndWhisker2D";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.decimals = 2, t.friendlyName = "Box and Whisker iapi", t.defaultDatasetType = "boxandwhisker2d", t.showplotborder = 1, t.plotborderdashlen = 5, t.plotborderdashgap = 4, t.plotfillalpha = i.HUNDREDSTRING, t.useroundedges = 0, t.plotborderthickness = 1, t.showvalues = 1, t.valuepadding = 2, t.decimals = 2, t.showtooltip = 1, t.maxcolwidth = 50, t.rotatevalues = 0, t.use3dlighting = 1, t.whiskerslimitswidthratio = 40, t.outliersupperrangeratio = 0, t.outlierslowerrangeratio = 0, t.showalloutliers = 0, t.showmean = 0, t.showsd = 0, t.showmd = 0, t.showqd = 0, t.showminvalues = 1, t.showmaxvalues = 1, t.showq1values = 0, t.showq3values = 0, t.showmedianvalues = 1, t.tooltipsepchar = ": ", t.anchorborderthickness = 1, t.anchorimageurl = void 0, t.anchorimagepadding = 1, t.anchorsides = 1, t.anchoralpha = void 0, t.anchorbgalpha = i.HUNDREDSTRING, t.anchorimagealpha = i.HUNDREDSTRING, t.anchorimagescale = 100, t.anchorstartangle = 90, t.anchorshadow = 0, t.anchorbgcolor = void 0, t.anchorbordercolor = void 0, t.anchorradius = 3, t.linedashlen = 5, t.linedashgap = 4, t.linedashed = void 0, t.linealpha = i.HUNDREDSTRING, t.linethickness = 2, t.drawfullareaborder = 1, t.connectnulldata = 0;
        }, t.prototype._getLineJSONdata = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              l,
              s,
              c,
              h,
              d,
              f,
              g,
              m,
              v,
              b,
              y,
              x,
              k,
              w,
              C = this.getChildren("BoxAndWhiskerStatisticalCalc")[0],
              N = this.getFromEnv("dataSource"),
              S = N.chart,
              A = N.dataset,
              E = A.length,
              D = [],
              _ = [],
              T = [],
              L = function L(e) {
            y = Number(e);
            var t = (0, i.extent)(C.values);
            v = t[0], b = t[1], (y < v || y > b) && m.push({
              value: y,
              index: x,
              anchorbgcolor: r.outliericoncolor,
              anchorradius: r.outliericonradius,
              anchoralpha: r.outliericonalpha,
              anchorbgalpha: r.outliericonalpha,
              anchorsides: r.outliericonsides,
              dip: r.outliericonshape
            });
          };

          for (w = 0; w < E; w++) {
            for (t = A[w], c = _[w] = {}, l = T[w] = {
              showMean: {
                seriesname: "Mean",
                showvalues: 0,
                anchorbgcolor: (0, i.pluck)(t.meaniconcolor, S.meaniconcolor, p),
                anchorbordercolor: p,
                anchorradius: (0, i.pluckNumber)(t.meaniconradius, S.meaniconradius, 5),
                anchoralpha: (0, i.pluck)(t.alpha, t.meaniconalpha, S.meaniconalpha),
                linethickness: (0, i.pluck)(t.linethickness, S.linethickness, 1),
                anchorsides: (0, i.pluck)(t.meaniconsides, S.meaniconsides, 3),
                showline: !(0, i.pluckNumber)(t.drawmeanconnector, S.drawmeanconnector),
                dip: (0, i.pluck)(t.meaniconshape, S.meaniconshape, u),
                color: (0, i.pluck)(t.meaniconcolor, S.meaniconcolor, p),
                data: []
              },
              showSD: {
                seriesname: "SD",
                showvalues: 0,
                anchorbgcolor: (0, i.pluck)(t.sdiconcolor, S.sdiconcolor, p),
                anchorbordercolor: p,
                anchorradius: (0, i.pluckNumber)(t.sdiconradius, S.sdiconradius, 5),
                anchoralpha: (0, i.pluck)(t.alpha, t.sdiconalpha, S.sdiconalpha),
                anchorbgalpha: (0, i.pluck)(t.sdiconalpha, S.sdiconalpha, 100),
                linethickness: (0, i.pluck)(t.linethickness, S.linethickness, 1),
                anchorsides: (0, i.pluck)(t.sdiconsides, S.sdiconsides, 3),
                showline: !(0, i.pluckNumber)(t.drawsdconnector, S.drawsdconnector),
                dip: (0, i.pluck)(t.sdiconshape, S.sdiconshape, u),
                color: (0, i.pluck)(t.sdiconcolor, S.sdiconcolor, p),
                data: []
              },
              showQD: {
                seriesname: "QD",
                showvalues: 0,
                anchorbgcolor: (0, i.pluck)(t.qdiconcolor, S.qdiconcolor, p),
                anchorbordercolor: p,
                anchorradius: (0, i.pluckNumber)(t.qdiconradius, S.qdiconradius, 5),
                anchoralpha: (0, i.pluck)(t.alpha, t.qdiconalpha, S.qdiconalpha),
                anchorbgalpha: (0, i.pluck)(t.qdiconalpha, S.qdiconalpha, 100),
                linethickness: (0, i.pluck)(t.linethickness, S.linethickness, 1),
                anchorsides: (0, i.pluck)(t.qdiconsides, S.qdiconsides, 3),
                showline: !(0, i.pluckNumber)(t.drawqdconnector, S.drawqdconnector),
                dip: (0, i.pluck)(t.qdiconshape, S.qdiconshape, u),
                color: (0, i.pluck)(t.qdiconcolor, S.qdiconcolor, p),
                data: []
              },
              showMD: {
                seriesname: "MD",
                showvalues: 0,
                anchorbgcolor: (0, i.pluck)(t.mdiconcolor, S.mdiconcolor, p),
                anchorbordercolor: p,
                anchorradius: (0, i.pluckNumber)(t.mdiconradius, S.mdiconradius, 5),
                anchoralpha: (0, i.pluck)(t.alpha, t.mdiconalpha, S.mdiconalpha),
                anchorbgalpha: (0, i.pluck)(t.mdiconalpha, S.mdiconalpha, 100),
                linethickness: (0, i.pluck)(t.linethickness, S.linethickness, 1),
                anchorsides: (0, i.pluck)(t.mdiconsides, S.mdiconsides, 3),
                showline: !(0, i.pluckNumber)(t.drawmdconnector, S.drawmdconnector),
                dip: (0, i.pluck)(t.mdiconshape, S.mdiconshape, u),
                color: (0, i.pluck)(t.mdiconcolor, S.mdiconcolor, p),
                data: []
              },
              outliers: {
                seriesname: "Outliers",
                showvalues: 0,
                anchorbgcolor: (0, i.pluck)(t.outliericoncolor, S.outliericoncolor, p),
                anchorbordercolor: p,
                anchorradius: (0, i.pluckNumber)(t.outliericonradius, S.outliericonradius, 5),
                anchoralpha: (0, i.pluck)(t.alpha, t.outliericonalpha, S.outliericonalpha),
                includeinlegend: t.seriesname ? 1 : 0,
                anchorbgalpha: (0, i.pluck)(t.outliericonalpha, S.outliericonalpha, 100),
                linethickness: (0, i.pluck)(t.linethickness, S.linethickness, 1),
                anchorsides: (0, i.pluck)(t.outliericonsides, S.outliericonsides, 3),
                showline: !(0, i.pluckNumber)(t.drawoutliersconnector, S.drawoutliersconnector),
                color: (0, i.pluck)(t.outliericoncolor, S.outliericoncolor, p),
                dip: (0, i.pluck)(t.outliericonshape, S.outliericonshape, u),
                data: []
              }
            }, e = (0, i.pluckNumber)(t.showmean, S.showmean, 0), h = (0, i.pluckNumber)(t.showsd, S.showsd, 0), d = (0, i.pluckNumber)(t.showqd, S.showqd, 0), f = (0, i.pluckNumber)(t.showmd, S.showmd, 0), a = (o = t.data) && o.length || 0, x = 0; x < a; x++) {
              r = o[x], C.setArray(r.value), C.getQuartiles(), g = r.outliers, e = c.showMean = c.showMean || (0, i.pluckNumber)(r.showmean, e), h = c.showSD = c.showSD || (0, i.pluckNumber)(r.showsd, h), d = c.showQD = c.showQD || (0, i.pluckNumber)(r.showqd, d), f = c.showMD = c.showMD || (0, i.pluckNumber)(r.showmd, f), l.showMean.data.push({
                value: e && C.getMean(),
                anchorbgcolor: r.meaniconcolor,
                anchorradius: r.meaniconradius,
                anchoralpha: r.meaniconalpha,
                anchorbgalpha: r.meaniconalpha,
                anchorsides: r.meaniconsides,
                dip: r.meaniconshape
              }), l.showSD.data.push({
                value: h && C.getSD(),
                anchorbgcolor: r.sdiconcolor,
                anchorradius: r.sdiconradius,
                anchoralpha: r.sdiconalpha,
                anchorbgalpha: r.sdiconalpha,
                anchorsides: r.sdiconsides,
                dip: r.sdiconshape
              }), l.showQD.data.push({
                value: d && C.getQD(),
                anchorbgcolor: r.qdiconcolor,
                anchorradius: r.qdiconradius,
                anchoralpha: r.qdiconalpha,
                anchorbgalpha: r.qdiconalpha,
                anchorsides: r.qdiconsides,
                dip: r.qdiconshape
              }), l.showMD.data.push({
                value: f && C.getMD(),
                anchorbgcolor: r.mdiconcolor,
                anchorradius: r.mdiconradius,
                anchoralpha: r.mdiconalpha,
                anchorbgalpha: r.mdiconalpha,
                anchorsides: r.mdiconsides,
                dip: r.mdiconshape
              }), g && (m = l.outliers.data, g.split(i.COMMA).forEach(L), c.outliers = !0);
            }
          }

          for (s = _.length, k = 0; k < s; k++) {
            for (w in c = _[k], n = D[k] = [], c) {
              c[w] && n.push(T[k][w]);
            }
          }

          return D;
        }, t.prototype.getDSdef = function () {
          return r["default"];
        }, t.prototype.getDSGroupdef = function () {
          return n["default"];
        }, t;
      }(a["default"]);

      t["default"] = h;
    },
    935: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = s(o(432)),
          r = s(o(936)),
          n = o(125),
          i = o(132),
          l = s(o(938));

      function s(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function c(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var u = n.preDefStr.colors.c000000,
          p = n.preDefStr.LABEL,
          h = n.preDefStr.UNDERSCORE,
          d = n.preDefStr.POINTER,
          f = n.preDefStr.BLANK,
          g = n.preDefStr.ROUND,
          m = n.preDefStr.GROUPID,
          v = n.preDefStr.POSITION_START,
          b = n.preDefStr.POSITION_BOTTOM,
          y = n.preDefStr.POSITION_TOP,
          x = n.preDefStr.showHoverEffectStr,
          k = n.preDefStr.EVENTARGS,
          w = n.preDefStr.POSITION_END,
          C = "M",
          N = "H",
          S = "V",
          A = n.preDefStr.pStr,
          E = n.preDefStr.sStr,
          D = function D(e, t, o) {
        return o.getFromEnv("animationManager").setAnimation({
          el: "group",
          attr: e,
          container: t,
          component: o,
          label: "group"
        });
      },
          _ = function _() {
        return function () {
          this.hide();
        };
      };

      (0, i.addDep)({
        name: "boxandwhisker2dAnimation",
        type: "animationRule",
        extension: l["default"]
      });

      var T = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return c(t, e), t.prototype.createContainer = function () {
          var e,
              t,
              o = this.type,
              a = this.groupName,
              r = this.getLinkedParent(),
              n = a || this.dsGroup || o;
          !r.getChildContainer(n + "VcanvasGroup") && (n = "default"), e = r.getChildContainer(n + "VcanvasGroup"), t = r.getChildContainer(n + "ShadowVcanvasGroup"), !this.getContainer("shadowGroup") && this.addContainer("shadowGroup", D({
            name: "shadow-group"
          }, t, this)), !this.getContainer("commonElemsGroup") && this.addContainer("lowerBoxGroup", D({
            name: "lower-box-group"
          }, e, this)), !this.getContainer("commonElemsGroup") && this.addContainer("upperBoxGroup", D({
            name: "upper-box-group"
          }, e, this)), !this.getContainer("commonElemsGroup") && this.addContainer("upperWhiskerGroup", D({
            name: "upper-whisker-group"
          }, e, this)), !this.getContainer("commonElemsGroup") && this.addContainer("lowerWhiskerGroup", D({
            name: "lower-whisker-group"
          }, e, this)), !this.getContainer("commonElemsGroup") && this.addContainer("medianGroup", D({
            name: "median-group"
          }, e, this)), !this.getContainer("labelGroup") && this.addContainer("labelGroup", D({
            name: "label-group",
            "class": "fusioncharts-datalabels"
          }, r.getChildContainer("vcanvasLabelGroup"), this));
        }, t.prototype.configureAttributes = function (e) {
          if (!e) return !1;
          this.trimData(e), this.config.JSONData = e;

          var t,
              o,
              a,
              r,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              d,
              f,
              g,
              m,
              v,
              b,
              y,
              x,
              k,
              w,
              C,
              N,
              S,
              D,
              _,
              T,
              L,
              P,
              O,
              V,
              M,
              F,
              I,
              B,
              R,
              j,
              G,
              H,
              W,
              z,
              U,
              J,
              K,
              q,
              Y,
              X,
              Q,
              Z,
              $,
              ee,
              te,
              oe,
              ae,
              re,
              ne,
              ie,
              le,
              se,
              ce,
              ue,
              pe,
              he,
              de,
              fe,
              ge,
              me,
              ve,
              be,
              ye,
              xe,
              ke,
              we = this.config,
              Ce = this.config.JSONData,
              Ne = Ce.data,
              Se = Ne && Ne.length,
              Ae = this.getFromEnv("chartConfig"),
              Ee = this.getFromEnv("xAxis"),
              De = Ee.getTicksLen(),
              _e = Math.min(De, Se),
              Te = this.getFromEnv("chart-attrib"),
              Le = this.getFromEnv("color-manager"),
              Pe = we.index,
              Oe = we.plotColor = Le.getPlotColor(Pe),
              Ve = (0, n.pluckNumber)(Ce.dashed, Te.plotborderdashed),
              Me = Ae.useplotgradientcolor,
              Fe = Ae.yaxisname,
              Ie = Ae.xaxisname,
              Be = (0, n.parseUnsafeString)((0, n.pluck)(Te.tooltipsepchar, ": ")),
              Re = this.components.data,
              je = this.getFromEnv("number-formatter"),
              Ge = -Infinity,
              He = +Infinity,
              We = this.getFromEnv("BoxAndWhiskerStatisticalCalc");

          for (this.setState("visible", !(1 !== (0, n.pluckNumber)(this.config.JSONData.visible, !Number(this.config.JSONData.initiallyhidden), 1))), (0, n.parseConfiguration)(Ce, we, Ae, {
            data: !0
          }), we.defaultPadding = {
            left: .5,
            right: .5
          }, we.seriesname = (0, n.parseUnsafeString)(Ce.seriesname), we.includeInLegend = (0, n.pluckNumber)(Ce.includeinlegend, we.seriesname ? 1 : 0), we.legendSymbolColor = we.plotColor, t = we.showplotborder, u = we.plotborderdashlen, p = we.plotborderdashgap, m = we.plotfillalpha, d = we.useroundedges, v = we.ratio, h = we.plotborderthickness, ve = we.showvalues = (0, n.pluckNumber)(Ce.showvalues, Te.showvalues, 1), o = we.showtooltip, we.rotatevalues && (we.rotatevalues = 270), be = we.showalloutliers, we.plotfillAngle = g = (0, n.pluckNumber)(360 - Te.plotfillangle, 90), we.plotColor = Oe = (0, n.pluck)(Ce.color, Oe), we.plotRadius = (0, n.pluckNumber)(Te.useroundedges, d ? 1 : 0), we.plotgradientcolor = b = (0, n.getDefinedColor)(Te.plotgradientcolor, Le.getColor("plotGradientColor")), !Me && (b = n.BLANKSTRING), we.plotBorderAlpha = y = t ? (0, n.pluck)(Te.plotborderalpha, m, n.HUNDREDSTRING) : 0, we.plotBorderColor = x = (0, n.pluck)(Te.plotbordercolor, Le.getColor("plotBorderColor")), we.plotBorderDashStyle = k = Ve ? (0, n.getDashStyle)(u, p, h) : "none", we.showShadow = d ? (0, n.pluckNumber)(Te.showshadow, 1) : (0, n.pluckNumber)(Te.showshadow, Le.getColor("showShadow")), we.showHoverEffect = f = (0, n.pluckNumber)(Te.plothovereffect, Te.showhovereffect, void 0), we.parentYAxis = X = (0, n.pluck)(Ce.parentyaxis && Ce.parentyaxis.toLowerCase(), A) === E ? 1 : 0, we.dataSeparator = n.COMMASTRING, we.textDirection = "1" === Te.hasrtltext ? "rtl" : n.BLANKSTRING, we.showMeanLegend = we.showSDLegend = we.showMDLegend = we.showQDLegend = we.showOutliersLegend = 0, !this.components.data && (this.components.data = []), Re = this.components.data, we.upperBoxColor = he = (0, n.pluck)(Ce.upperboxcolor, Te.upperboxcolor, Le.getPlotColor(2 * Pe)), de = we.upperBoxAlpha = (0, n.pluck)(Ce.upperboxalpha, Te.upperboxalpha, m, n.HUNDREDSTRING), we.lowerBoxColor = fe = (0, n.pluck)(Ce.lowerboxcolor, Te.lowerboxcolor, Le.getPlotColor(2 * Pe + 1)), ge = we.lowerBoxAlpha = (0, n.pluck)(Ce.lowerboxalpha, Te.lowerboxalpha, m, n.HUNDREDSTRING), ee = 0; ee < _e; ee++) {
            w = Ne && Ne[ee], S = (N = Re[ee]) && N.config, N || (N = Re[ee] = {
              graphics: {}
            }), N.config || (S = Re[ee].config = {}), w.value ? (w.value && (We.setArray(w.value), oe = (te = We.getQuartiles()).q1, ae = te.q3, re = We.getMinMax(), S.min = ne = re.min, S.max = ie = re.max, le = We.getMedian(), S.mean = se = We.getMean(), S.md = ce = We.getMD(), S.sd = ue = We.getSD(), S.qd = pe = We.getQD()), S.upperQuartile = {
              value: ae,
              color: (0, n.convertColor)((0, n.pluck)(w.upperquartilecolor, Ce.upperquartilecolor, Te.upperquartilecolor, Te.plotbordercolor, Le.getColor("plotBorderColor")), (0, n.pluckNumber)(w.upperquartilealpha, Ce.upperquartilealpha, Te.upperquartilealpha, Te.plotborderalpha, 100)),
              borderWidth: (0, n.pluckNumber)(w.upperquartilethickness, Ce.upperquartilethickness, Te.upperquartilethickness, Te.plotborderthickness, d ? 0 : 1),
              displayValue: je.dataLabels(ae)
            }, S.lowerQuartile = {
              value: oe,
              color: (0, n.convertColor)((0, n.pluck)(w.lowerquartilecolor, Ce.lowerquartilecolor, Te.lowerquartilecolor, Te.plotbordercolor, Le.getColor("plotBorderColor")), (0, n.pluckNumber)(w.lowerquartilealpha, Ce.lowerquartilealpha, Te.lowerquartilealpha, Te.plotborderalpha, 100)),
              borderWidth: (0, n.pluckNumber)(w.lowerquartilethickness, Ce.lowerquartilethickness, Te.lowerquartilethickness, Te.plotborderthickness, d ? 0 : 1),
              displayValue: je.dataLabels(oe)
            }, S.upperBoxBorder = {
              color: (0, n.convertColor)((0, n.pluck)(w.upperboxbordercolor, Ce.upperboxbordercolor, Te.upperboxbordercolor, Te.plotbordercolor, Le.getColor("plotBorderColor")), (0, n.pluckNumber)(w.upperboxborderalpha, Ce.upperboxborderalpha, Te.upperboxborderalpha, Te.plotborderalpha, 100)),
              borderWidth: (0, n.pluckNumber)(w.upperboxborderthickness, Ce.upperboxborderthickness, Te.upperboxborderthickness, !d && Te.plotborderthickness, d ? 0 : 1)
            }, S.lowerBoxBorder = {
              color: (0, n.convertColor)((0, n.pluck)(w.lowerboxbordercolor, Ce.lowerboxbordercolor, Te.lowerboxbordercolor, Te.plotbordercolor, Le.getColor("plotBorderColor")), (0, n.pluckNumber)(w.lowerboxborderalpha, Ce.lowerboxborderalpha, Te.lowerboxborderalpha, Te.plotborderalpha, 100)),
              borderWidth: (0, n.pluckNumber)(w.lowerboxborderthickness, Ce.lowerboxborderthickness, Te.lowerboxborderthickness, !d && Te.plotborderthickness, d ? 0 : 1)
            }, S.median = {
              value: le,
              color: (0, n.convertColor)((0, n.pluck)(w.mediancolor, Ce.mediancolor, Te.mediancolor, Te.plotbordercolor, Le.getColor("plotBorderColor")), (0, n.pluckNumber)(w.medianalpha, Ce.medianalpha, Te.medianalpha, Te.plotborderalpha, 100)),
              borderWidth: (0, n.pluckNumber)(w.medianthickness, Ce.medianthickness, Te.medianthickness, Te.plotborderthickness, 1),
              displayValue: je.dataLabels(le)
            }, we.upperBoxColor = he = (0, n.pluck)(w.upperboxcolor, Ce.upperboxcolor, Te.upperboxcolor, Le.getPlotColor(2 * Pe)), de = we.upperBoxAlpha = (0, n.pluck)(w.upperboxalpha, Ce.upperboxalpha, Te.upperboxalpha, m, n.HUNDREDSTRING), we.lowerBoxColor = fe = (0, n.pluck)(w.lowerboxcolor, Ce.lowerboxcolor, Te.lowerboxcolor, Le.getPlotColor(2 * Pe + 1)), ge = we.lowerBoxAlpha = (0, n.pluck)(w.lowerboxalpha, Ce.lowerboxalpha, Te.lowerboxalpha, m, n.HUNDREDSTRING), S.upperColorArr = (0, n.getColumnColor)(he, de, void 0, void 0, d, x, y.toString(), 0, !1), S.lowerColorArr = (0, n.getColumnColor)(fe, ge, void 0, void 0, d, x, y.toString(), 0, !1), S.showValue = (0, n.pluckNumber)(w.showvalue, ve), S.showMinValues = S.showValue ? (0, n.pluckNumber)(w.showminvalues, we.showminvalues) : 0, S.showMaxValues = S.showValue ? (0, n.pluckNumber)(w.showmaxvalues, we.showmaxvalues) : 0, S.showQ1Values = S.showValue ? (0, n.pluckNumber)(w.showq1values, we.showq1values) : 0, S.showQ3Values = S.showValue ? (0, n.pluckNumber)(w.showq3values, we.showq3values) : 0, S.showMedianValues = S.showValue ? (0, n.pluckNumber)(w.showmedianvalues, we.showmedianvalues) : 0, S.upperWhiskerAlpha = me = (0, n.getFirstAlpha)((0, n.pluck)(w.upperwhiskeralpha, Ce.upperwhiskeralpha, Te.upperwhiskeralpha, Te.plotborderalpha, 100)), S.upperWhiskerColor = (0, n.convertColor)((0, n.getFirstColor)((0, n.pluck)(w.upperwhiskercolor, Ce.upperwhiskercolor, Te.upperwhiskercolor, Te.plotbordercolor, Le.getColor("plotBorderColor"))), me), S.upperWhiskerThickness = (0, n.pluckNumber)(w.upperwhiskerthickness, Ce.upperwhiskerthickness, Te.upperwhiskerthickness, Te.plotborderthickness, 1), S.upperWhiskerShadowOpacity = we.showShadow ? me / 100 : 0, S.lowerWhiskerAlpha = xe = (0, n.getFirstAlpha)((0, n.pluck)(w.lowerwhiskeralpha, Ce.lowerwhiskeralpha, Te.lowerwhiskeralpha, Te.plotborderalpha, 100)), S.lowerWhiskerColor = (0, n.convertColor)((0, n.getFirstColor)((0, n.pluck)(w.lowerwhiskercolor, Ce.lowerwhiskercolor, Te.lowerwhiskercolor, Te.plotbordercolor, Le.getColor("plotBorderColor"))), xe), S.lowerWhiskerThickness = (0, n.pluckNumber)(w.lowerwhiskerthickness, Ce.lowerwhiskerthickness, Te.lowerwhiskerthickness, Te.plotborderthickness, 1), S.lowerWhiskerShadowOpacity = we.showShadow ? xe / 100 : 0, S.setValue = C = je.getCleanValue(w.value), S.setLink = (0, n.pluck)(w.link), S.toolTipValue = q = je.dataLabels(C, X), S.setDisplayValue = Y = (0, n.parseUnsafeString)(w.displayvalue), S.displayValue = (0, n.pluck)(Y, q), Q = (0, n.pluckNumber)(w.dashed), Z = (0, n.pluckNumber)(w.dashlen, u), $ = p = (0, n.pluckNumber)(w.dashgap, p), Ge = Math.max(Ge, ie), He = Math.min(He, ne), S.plotBorderDashStyle = 1 === Q ? (0, n.getDashStyle)(Z, $, h) : 0 === Q ? "none" : k, Oe = (0, n.pluck)(w.color, we.plotColor), m = (0, n.pluck)(w.alpha, we.plotfillalpha), C < 0 && !d && (s = g, g = 360 - g), S.colorArr = (0, n.getColumnColor)(Oe + n.COMMA + b, m, v, g, d, x, y.toString(), 0, !1), S.label = D = (0, n.getValidValue)((0, n.parseUnsafeString)(Ee.getLabel((0, n.pluckNumber)(ee)).label)), 0 !== f && (_ = (0, n.pluck)(w.upperboxhovercolor, Ce.upperboxhovercolor, Te.upperboxhovercolor, he), T = (0, n.pluck)(w.upperboxhoveralpha, Ce.upperboxhoveralpha, Te.upperboxhoveralpha, de), L = (0, n.pluck)(w.upperboxborderhovercolor, Ce.upperboxborderhovercolor, Te.upperboxborderhovercolor, w.upperboxbordercolor, Ce.upperboxbordercolor, Te.upperboxbordercolor, Te.plotbordercolor, Le.getColor("plotBorderColor")), P = (0, n.pluck)(w.upperboxborderhoveralpha, Ce.upperboxborderhoveralpha, Te.upperboxborderhoveralpha, w.upperboxborderalpha, Ce.upperboxborderalpha, Te.upperboxborderalpha, Te.plotborderalpha, 100), O = d ? 0 : (0, n.pluck)(w.upperboxborderhoverthickness, Ce.upperboxborderhoverthickness, Te.upperboxborderhoverthickness, S.upperBoxBorder.borderWidth), V = (0, n.pluck)(w.lowerboxhovercolor, Ce.lowerboxhovercolor, Te.lowerboxhovercolor, fe), M = (0, n.pluck)(w.lowerboxhoveralpha, Ce.lowerboxhoveralpha, Te.lowerboxhoveralpha, ge), F = (0, n.pluck)(w.lowerboxborderhovercolor, Ce.lowerboxborderhovercolor, Te.lowerboxborderhovercolor, w.lowerboxbordercolor, Ce.lowerboxbordercolor, Te.lowerboxbordercolor, Te.plotbordercolor, Le.getColor("plotBorderColor")), I = (0, n.pluck)(w.lowerboxborderhoveralpha, Ce.lowerboxborderhoveralpha, Te.lowerboxborderhoveralpha, w.lowerboxborderalpha, Ce.lowerboxborderalpha, Te.lowerboxborderalpha, Te.plotborderalpha, 100), B = d ? 0 : (0, n.pluck)(w.lowerboxborderhoverthickness, Ce.lowerboxborderhoverthickness, Te.lowerboxborderhoverthickness, S.lowerBoxBorder.borderWidth), R = (0, n.pluck)(w.upperquartilehovercolor, Ce.upperquartilehovercolor, Te.upperquartilehovercolor, w.upperquartilecolor, Ce.upperquartilecolor, Te.upperquartilecolor, Te.plotbordercolor, Le.getColor("plotBorderColor")), j = (0, n.pluck)(w.upperquartilehoveralpha, Ce.upperquartilehoveralpha, Te.upperquartilehoveralpha, w.upperquartilealpha, Ce.upperquartilealpha, Te.upperquartilealpha, Te.plotborderalpha, 100), G = (0, n.pluck)(w.upperquartilehoverthickness, Ce.upperquartilehoverthickness, Te.upperquartilehoverthickness, S.upperQuartile.borderWidth), H = (0, n.pluck)(w.lowerquartilehovercolor, Ce.lowerquartilehovercolor, Te.lowerquartilehovercolor, w.lowerquartilecolor, Ce.lowerquartilecolor, Te.lowerquartilecolor, Te.plotbordercolor, Le.getColor("plotBorderColor")), W = (0, n.pluck)(w.lowerquartilehoveralpha, Ce.lowerquartilehoveralpha, Te.lowerquartilehoveralpha, w.lowerquartilealpha, Ce.lowerquartilealpha, Te.lowerquartilealpha, Te.plotborderalpha, 100), z = (0, n.pluck)(w.lowerquartilehoverthickness, Ce.lowerquartilehoverthickness, Te.lowerquartilehoverthickness, S.lowerQuartile.borderWidth), U = (0, n.pluck)(w.medianhovercolor, Ce.medianhovercolor, Te.medianhovercolor, w.mediancolor, Ce.mediancolor, Te.mediancolor, Te.plotbordercolor, Le.getColor("plotBorderColor")), J = (0, n.pluck)(w.medianhoveralpha, Ce.medianhoveralpha, Te.medianhoveralpha, w.medianalpha, Ce.medianalpha, Te.medianalpha, Te.plotborderalpha, 100), K = (0, n.pluck)(w.medianhoverthickness, Ce.medianhoverthickness, Te.medianhoverthickness, S.median.borderWidth), 1 === f && (he === _ && (_ = (0, n.getLightColor)(_, 70)), fe === V && (V = (0, n.getLightColor)(V, 70))), S.upperBoxHoverColorArr = (0, n.getColumnColor)(_, T, void 0, void 0, d, x, y.toString(), 0, !1), S.lowerBoxHoverColorArr = (0, n.getColumnColor)(V, M, void 0, void 0, d, x, y.toString(), 0, !1), S.setUpperBoxRolloutAttr = {
              fill: (0, n.toRaphaelColor)(S.upperColorArr[0])
            }, S.setUpperBoxRolloverAttr = {
              fill: (0, n.toRaphaelColor)(S.upperBoxHoverColorArr[0])
            }, S.setLowerBoxRolloutAttr = {
              fill: (0, n.toRaphaelColor)(S.lowerColorArr[0])
            }, S.setLowerBoxRolloverAttr = {
              fill: (0, n.toRaphaelColor)(S.lowerBoxHoverColorArr[0])
            }, S.setUpperBoxBorderRolloverAttr = {
              stroke: (0, n.convertColor)(L, P),
              "stroke-width": O
            }, S.setUpperBoxBorderRolloutAttr = {
              stroke: S.upperBoxBorder.color,
              "stroke-width": S.upperBoxBorder.borderWidth
            }, S.setLowerBoxBorderRolloverAttr = {
              stroke: (0, n.convertColor)(F, I),
              "stroke-width": B
            }, S.setLowerBoxBorderRolloutAttr = {
              stroke: S.lowerBoxBorder.color,
              "stroke-width": S.lowerBoxBorder.borderWidth
            }, S.setUpperQuartileRolloverAttr = {
              stroke: (0, n.convertColor)(R, j),
              "stroke-width": G
            }, S.setUpperQuartileRolloutAttr = {
              stroke: S.upperQuartile.color,
              "stroke-width": S.upperQuartile.borderWidth
            }, S.setLowerQuartileRolloverAttr = {
              stroke: (0, n.convertColor)(H, W),
              "stroke-width": z
            }, S.setLowerQuartileRolloutAttr = {
              stroke: S.lowerQuartile.color,
              "stroke-width": S.lowerQuartile.borderWidth
            }, S.setMedianRolloverAttr = {
              stroke: (0, n.convertColor)(U, J),
              "stroke-width": K
            }, S.setMedianRolloutAttr = {
              stroke: S.median.color,
              "stroke-width": S.median.borderWidth
            }), a = S.toolTipValue, i = (0, n.getValidValue)((0, n.parseUnsafeString)((0, n.pluck)(w.tooltext, Ce.plottooltext, Te.plottooltext))), o ? null === a ? c = !1 : void 0 !== i ? (l = [1, 2, 3, 4, 5, 6, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80], r = {
              maxValue: ie,
              maxDataValue: je.dataLabels(ie),
              minValue: ne,
              minDataValue: je.dataLabels(ne),
              Q1: je.dataLabels(oe),
              unformattedQ1: oe,
              Q3: je.dataLabels(ae),
              unformattedQ3: ae,
              median: je.dataLabels(le),
              unformattedMedian: le,
              SD: je.dataLabels(ue),
              unformattedsd: ue,
              QD: je.dataLabels(pe),
              unformattedQD: pe,
              MD: je.dataLabels(ce),
              unformattedMD: ce,
              mean: je.dataLabels(se),
              unformattedMean: se,
              label: D,
              yaxisName: Fe,
              xaxisName: Ie,
              formattedValue: a,
              value: D
            }, c = (0, n.parseTooltext)(i, l, r, w, Te, Ce)) : c = "<b>Maximum" + Be + "</b>" + je.dataLabels(ie) + "<br /><b>Q3" + Be + "</b>" + je.dataLabels(ae) + "<br /><b>Median" + Be + "</b>" + je.dataLabels(le) + "<br /><b>Q1" + Be + "</b>" + je.dataLabels(oe) + "<br /><b>Minimum" + Be + "</b>" + je.dataLabels(ne) : c = !1, S.toolText = c, S.setTooltext = c, s && (g = s)) : S.setValue = void 0;
          }

          be ? (ke = this._getOutLiersLimit(), Ge = Math.max(Ge, ke.max), He = Math.min(He, ke.min)) : (ye = Ge - He, Ge += we.outliersupperrangeratio * ye, He -= we.outlierslowerrangeratio * ye), we.maxValue = Ge, we.minValue = He, this.setState("dirty", !0), this._createSubDS(), Ae.showLegend && this._addLegend();
        }, t.prototype._createSubDS = function () {
          var e = this.config.index,
              t = this.getFromEnv("lineJSON")[e],
              o = t.length;
          (0, n.datasetFactory)(this, r["default"], "dataset", o, t, function (e, t) {
            for (var o = []; t;) {
              o.unshift(e + Number("." + t)), t--;
            }

            return o;
          }(e, o)), o || this.iterateComponents(function (e) {
            "line" === e.getName() && e.remove();
          });
        }, t.prototype._getOutLiersLimit = function () {
          var e,
              t,
              o,
              a,
              r,
              n = this.config.index,
              i = this.getFromEnv("lineJSON")[n],
              l = i.length,
              s = -Infinity,
              c = +Infinity;

          for (r = 0; r < l; r++) {
            if ("Outliers" === (e = i[r]).seriesname) {
              for (t = (a = e.data).length, o = 0; o < t; o++) {
                s = Math.max(a[o].value, s), c = Math.min(a[o].value, c);
              }

              return {
                max: s,
                min: c
              };
            }
          }

          return {
            max: s,
            min: c
          };
        }, t.prototype.parsePlotAttributes = function (e, t) {
          var o,
              a,
              r,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              m,
              x,
              k,
              A,
              E,
              D,
              _,
              T,
              L,
              P,
              O,
              V,
              M,
              F,
              I,
              B,
              R,
              j,
              G,
              H,
              W,
              z,
              U,
              J,
              K,
              q,
              Y,
              X,
              Q,
              Z,
              $,
              ee,
              te,
              oe,
              ae,
              re,
              ne,
              ie,
              le,
              se,
              ce,
              ue,
              pe,
              he = this.config.JSONData,
              de = this.config,
              fe = de.index,
              ge = t,
              me = this.getState("visible"),
              ve = this.getFromEnv("chart"),
              be = this.getFromEnv("chartConfig"),
              ye = this.getFromEnv("xAxis"),
              xe = this.getFromEnv("yAxis"),
              ke = this.components.data,
              we = be.dataLabelStyle,
              Ce = de.rotatevalues,
              Ne = de.valuepadding,
              Se = this.getFromEnv("number-formatter"),
              Ae = Ce ? n.POSITION_LEFT : n.POSITION_MIDDLE,
              Ee = this.getFromEnv("smartLabel"),
              De = +Infinity;

          r = this.getFromEnv("columnXShift"), a = this.getFromEnv("columnWidth"), s = (c = e && e.config) && c.setValue, void 0 !== e && void 0 !== s && null !== s && (I = e.graphics, l = c.setLink, e.graphics || (ke[ge].graphics = {}), I.label || (ke[ge].graphics.label = []), o = ye.getPixel(ge) + r, h = ((p = (u = c.upperQuartile || {}) && u.value) || 0 === p) && xe.getPixel(p), k = ((x = (m = c.lowerQuartile || {}) && m.value) || 0 === x) && xe.getPixel(x), _ = (D = ((E = (A = c.median) && A.value) || 0 === E) && xe.getPixel(E)) - h, T = k - D, L = c.upperBoxBorder || {}, P = c.lowerBoxBorder || {}, i = c.toolText, c.eventArgs = {
            index: ge,
            link: l,
            maximum: c.max,
            minimum: c.min,
            median: E,
            q3: u.value,
            q1: m.value,
            maxDisplayValue: c.showMaxValues ? Se.dataLabels(c.max) : n.BLANKSTRING,
            minDisplayValue: c.showMinValues ? Se.dataLabels(c.min) : n.BLANKSTRING,
            medianDisplayValue: c.showMedianValues ? Se.dataLabels(E) : n.BLANKSTRING,
            q1DisplayValue: c.showQ1Values ? Se.dataLabels(m.value) : n.BLANKSTRING,
            q3DisplayValue: c.showQ3Values ? Se.dataLabels(u.value) : n.BLANKSTRING,
            categoryLabel: c.label,
            toolText: i,
            datasetIndex: fe,
            datasetName: he.seriesname,
            visible: me
          }, O = Math.round(o) + L.borderWidth % 2 * .5, V = Math.round(o + a) + L.borderWidth % 2 * .5, M = Math.round(h) + u.borderWidth % 2 * .5, a = V - O, F = {
            upperBox: {
              fill: (0, n.toRaphaelColor)(c.upperColorArr[0]),
              "stroke-width": 0,
              "stroke-dasharray": "none",
              cursor: l ? d : n.BLANKSTRING,
              visibility: me
            },
            lowerBox: {
              fill: (0, n.toRaphaelColor)(c.lowerColorArr[0]),
              "stroke-width": 0,
              "stroke-dasharray": "none",
              cursor: l ? d : f,
              visibility: me
            },
            upperBoxBorder: {
              stroke: L.color,
              "stroke-width": L.borderWidth,
              "stroke-linecap": g,
              dashstyle: L.dashStyle,
              visibility: me
            },
            lowerBoxBorder: {
              stroke: P.color,
              "stroke-width": P.borderWidth,
              dashstyle: P.dashStyle,
              "stroke-linecap": g,
              visibility: me
            },
            upperQuartile: {
              stroke: (0, n.toRaphaelColor)(u.color),
              "stroke-width": u.borderWidth,
              "stroke-dasharray": u.dashSyle,
              "stroke-linecap": g,
              cursor: l ? d : f,
              visibility: me
            },
            lowerQuartile: {
              stroke: (0, n.toRaphaelColor)(m.color),
              "stroke-width": m.borderWidth,
              "stroke-dasharray": m.dashSyle,
              cursor: l ? d : n.BLANKSTRING,
              "stroke-linecap": g,
              visibility: me
            },
            median: {
              stroke: (0, n.toRaphaelColor)(A.color),
              "stroke-width": A.borderWidth,
              "stroke-dasharray": A.dashSyle,
              cursor: l ? d : n.BLANKSTRING,
              "stroke-linecap": g,
              visibility: me
            }
          }, se = M, ee = Object.assign({
            x: O,
            y: M,
            width: Math.max(a, 0),
            height: Math.max(Math.min(De, _), 0),
            r: 0
          }, F.upperBox), $ = Object.assign({
            path: [C, O, M, S, M + _, C, V, M, S, M + _]
          }, F.upperBoxBorder), te = Object.assign({
            path: [C, O, M, N, O + a]
          }, F.upperQuartile), B = M, R = a * (de.whiskerslimitswidthratio / 100) / 2, H = j = xe.getPixel(c.max), G = O, H = Math.round(j) + c.upperWhiskerThickness % 2 / 2, O = Math.round(O + a / 2) + c.upperWhiskerThickness % 2 / 2, oe = {
            path: W = [C, O, B, S, Math.min(H, se), C, O - R, Math.min(H, se), N, O + R],
            "stroke-width": c.upperWhiskerThickness,
            cursor: l ? d : n.BLANKSTRING,
            "stroke-linecap": g,
            stroke: c.upperWhiskerColor
          }, Ee.useEllipsesOnOverflow(ve.config.useEllipsesWhenOverflow), Ee.setStyle(we), z = Ee.getOriSize(Se.dataLabels(c.max)), U = Ce ? z.width : z.height, (K = j - .5 * c.upperWhiskerThickness - Ne - U * (Ce ? .5 : 1)) - (Ce ? U / 2 : 0) < be.canvasTop && (K = be.canvasTop + (Ce ? U / 2 : 0)), ae = {
            text: Se.dataLabels(c.max),
            x: G + a / 2,
            title: u.originalText || n.BLANKSTRING,
            y: K,
            "text-anchor": Ce ? n.POSITION_MIDDLE : Ae,
            "vertical-align": Ce ? n.POSITION_MIDDLE : y,
            visibility: n.visibleStr,
            direction: de.textDirection,
            fill: we.color,
            transform: (0, n.getSuggestiveRotation)(Ce, G + a / 2, K),
            "text-bound": [we.backgroundColor, we.borderColor, we.borderThickness, we.borderPadding, we.borderRadius, we.borderDash]
          }, O = Math.round(o) + P.borderWidth % 2 * .5, V = Math.round(o + a) + P.borderWidth % 2 * .5, M = Math.round(D + T) + m.borderWidth % 2 * .5, pe = (ce = D) + (ue = Math.max(Math.min(De, M - D), 0)), Y = Object.assign({
            x: O,
            y: ce,
            width: Math.max(a, 0),
            height: ue,
            r: 0
          }, F.lowerBox), q = Object.assign({
            path: [C, O, D, S, D + T, C, V, D, S, D + T]
          }, F.lowerBoxBorder), M = Math.round(D + T) + m.borderWidth % 2 * .5, X = Object.assign({
            path: [C, O, M, N, O + a]
          }, F.lowerQuartile), B = M, R = a * (de.whiskerslimitswidthratio / 100) / 2, H = j = xe.getPixel(c.min), G = O, H = Math.round(j) + c.lowerWhiskerThickness % 2 / 2, G = Math.round(G + a / 2) + c.lowerWhiskerThickness % 2 / 2, W = [C, G, B, S, Math.max(H, pe), C, G - R, Math.max(H, pe), N, G + R], Ee.setStyle(we), z = Ee.getOriSize(Se.dataLabels(c.min)), U = Ce ? z.width : z.height, (J = j + .5 * c.lowerWhiskerThickness + Ne) + U > be.canvasBottom && (J = be.canvasBottom - U), re = {
            text: Se.dataLabels(c.min),
            x: G,
            title: u.originalText || n.BLANKSTRING,
            y: J,
            "text-anchor": Ce ? w : Ae,
            "vertical-align": Ce ? n.POSITION_MIDDLE : y,
            visibility: n.visibleStr,
            direction: de.textDirection,
            fill: we.color,
            transform: (0, n.getSuggestiveRotation)(Ce, G, J),
            "text-bound": [we.backgroundColor, we.borderColor, we.borderThickness, we.borderPadding, we.borderRadius, we.borderDash]
          }, Q = {
            path: W,
            "stroke-width": c.lowerWhiskerThickness,
            cursor: l ? d : n.BLANKSTRING,
            "stroke-linecap": g,
            stroke: c.lowerWhiskerColor
          }, M = Math.round(D) + A.borderWidth % 2 * .5, Z = Object.assign({
            path: [C, O, M, N, O + a]
          }, F.median), Ae = Ce ? n.POSITION_LEFT : n.POSITION_MIDDLE, ne = {
            text: u.displayValue,
            x: o + a / 2,
            title: u.originalText || n.BLANKSTRING,
            y: h - Ne,
            "text-anchor": Ce ? v : Ae,
            "vertical-align": Ce ? n.POSITION_MIDDLE : b,
            visibility: n.visibleStr,
            direction: de.textDirection,
            fill: we.color,
            transform: (0, n.getSuggestiveRotation)(Ce, o + a / 2, h - Ne),
            "text-bound": [we.backgroundColor, we.borderColor, we.borderThickness, we.borderPadding, we.borderRadius, we.borderDash]
          }, le = {
            text: A.displayValue,
            x: O + a / 2,
            y: D - Ne,
            title: A.originalText || n.BLANKSTRING,
            "text-anchor": Ce ? v : Ae,
            "vertical-align": Ce ? n.POSITION_MIDDLE : b,
            visibility: n.visibleStr,
            direction: de.textDirection,
            fill: we.color,
            transform: (0, n.getSuggestiveRotation)(Ce, O + a / 2, D - Ne),
            "text-bound": [we.backgroundColor, we.borderColor, we.borderThickness, we.borderPadding, we.borderRadius, we.borderDash]
          }, ie = {
            text: m.displayValue,
            x: o + a / 2,
            y: k + Ne,
            title: m.originalText || n.BLANKSTRING,
            "text-anchor": Ce ? v : Ae,
            "vertical-align": Ce ? n.POSITION_MIDDLE : y,
            visibility: n.visibleStr,
            direction: de.textDirection,
            fill: we.color,
            transform: (0, n.getSuggestiveRotation)(Ce, o + a / 2, k + Ne),
            "text-bound": [we.backgroundColor, we.borderColor, we.borderThickness, we.borderPadding, we.borderRadius, we.borderDash]
          }, c.props = {
            lowerBoxBorderEle: {
              attr: q
            },
            lowerBoxElem: {
              attr: Y
            },
            lowerQuartileEle: {
              attr: X
            },
            lowerWhiskerEle: {
              attr: Q
            },
            midLineElem: {
              attr: Z
            },
            upperBoxElem: {
              attr: ee
            },
            upperBoxBorderEle: {
              attr: $
            },
            upperQuartileEle: {
              attr: te
            },
            upperWhiskerEle: {
              attr: oe
            },
            upperQuartileMaxLabel: {
              attr: ae
            },
            upperQuartileMinLabel: {
              attr: re
            },
            medianLabel: {
              attr: le
            },
            upperQuartileLabel: {
              attr: ne
            },
            lowerQuartileLabel: {
              attr: ie
            }
          });
        }, t.prototype.allocatePosition = function () {
          var e,
              t,
              o,
              a = this.config.JSONData.data,
              r = a && a.length,
              n = this.getFromEnv("xAxis").getTicksLen(),
              i = this.components.data;

          for (o = Math.min(n, r), this.setColumnPosition(), t = 0; t < o; t++) {
            e = i[t], this.parsePlotAttributes(e, t);
          }
        }, t.prototype.drawPlots = function () {
          var e,
              t,
              o,
              a,
              r,
              i,
              l,
              s,
              c,
              u,
              d,
              g,
              v,
              b,
              y,
              w,
              C,
              N,
              S,
              A,
              E,
              D,
              T,
              L,
              P,
              O,
              V,
              M,
              F,
              I,
              B,
              R,
              j,
              G,
              H,
              W,
              z,
              U,
              J,
              K,
              q,
              Y,
              X,
              Q,
              Z,
              $,
              ee,
              te,
              oe = this,
              ae = oe.config.JSONData,
              re = oe.config,
              ne = re.index,
              ie = ae.data,
              le = ie && ie.length,
              se = oe.getState("visible"),
              ce = oe.getFromEnv("chart"),
              ue = oe.getFromEnv("xAxis").getTicksLen(),
              pe = re.showtooltip,
              he = oe.getFromEnv("toolTipController"),
              de = oe.components.data,
              fe = re.showShadow,
              ge = oe.getContainer("upperBoxGroup").toBack(),
              me = oe.getContainer("lowerBoxGroup"),
              ve = oe.getContainer("medianGroup"),
              be = oe.getContainer("upperWhiskerGroup"),
              ye = oe.getContainer("lowerWhiskerGroup"),
              xe = oe.getContainer("labelGroup"),
              ke = oe.getContainer("shadowGroup"),
              we = oe.getFromEnv("smartLabel"),
              Ce = (oe.components.removeDataArr || []).length,
              Ne = re.showHoverEffect,
              Se = oe.getFromEnv("animationManager"),
              Ae = function Ae(e) {
            return function (t) {
              ce.plotEventHandler(e, t);
            };
          },
              Ee = function Ee(e, t) {
            return function (o) {
              var a;
              if (0 !== t.data(x)) for (a in e) {
                a !== p && (Se.setAnimation({
                  el: e[a],
                  doNotRemove: !0,
                  attr: t.data("setRolloverAttr")[a],
                  component: oe
                }), ce.plotEventHandler(t, o, "DataPlotRollOver"));
              }
            };
          },
              De = function De(e, t) {
            return function (o) {
              var a;
              if (0 !== t.data(x)) for (a in e) {
                a !== p && (Se.setAnimation({
                  el: e[a],
                  doNotRemove: !0,
                  attr: t.data("setRolloutAttr")[a],
                  component: oe
                }), ce.plotEventHandler(t, o, "DataPlotRollOut"));
              }
            };
          };

          for (s = function s(e) {
            return function () {
              this.show(), this.shadow(e);
            };
          }, oe.setColumnPosition(), se ? (ge.show(), me.show(), be.show(), ye.show(), ve.show(), ke.show(), xe.show(), oe._conatinerHidden = !1) : (xe.hide(), be.hide(), ge.hide(), ye.hide(), me.hide(), ve.hide(), ke.hide()), e = Math.min(ue, le), t = 0; t < e; t++) {
            if (r = (i = (a = de[t]) && a.config) && i.setValue, H = !1, W = !1, z = !1, U = !1, J = !1, K = !1, q = !1, Y = !1, X = !1, void 0 !== a && void 0 !== r && null !== r) V = a.graphics, a.graphics || (de[t].graphics = {}), V.label || (de[t].graphics.label = []), l = i.upperQuartile || {}, c = i.lowerQuartile || {}, u = i.median, o = i.toolText, M = ne + h + t, g = a.graphics.upperBoxElem, d = Se.setAnimation({
              el: g || "rect",
              attr: i.props.upperBoxElem.attr,
              label: "upperBox",
              container: ge,
              component: oe
            }), g || (a.graphics.upperBoxElem = d, H = !0), d.shadow({
              opacity: fe ? re.upperBoxAlpha / 100 : 0
            }, ke), b = a.graphics.upperBoxBorderEle, v = Se.setAnimation({
              el: b || "path",
              attr: i.props.upperBoxBorderEle.attr,
              container: ge,
              label: "path",
              component: oe
            }), b || (a.graphics.upperBoxBorderEle = v, z = !0), w = a.graphics.upperQuartileEle, y = Se.setAnimation({
              el: w || "path",
              attr: i.props.upperQuartileEle.attr,
              label: "path",
              container: ge,
              component: oe
            }), w || (a.graphics.upperQuartileEle = y, J = !0), I = a.graphics.upperWhiskerEle, F = Se.setAnimation({
              el: I || "path",
              attr: i.props.upperWhiskerEle.attr,
              label: "path",
              container: be,
              component: oe
            }), s({
              opacity: i.upperWhiskerShadowOpacity
            }), I || (a.graphics.upperWhiskerEle = F, Y = !0), we.useEllipsesOnOverflow(ce.config.useEllipsesWhenOverflow), i.showMaxValues ? ((O = V.label[3]) && O.show(), P = Se.setAnimation({
              el: O || "text",
              attr: i.props.upperQuartileMaxLabel.attr,
              component: oe,
              label: "text",
              container: xe
            }), O || (V.label[3] = P), V.label[3].data(m, M)) : V.label[3] && Se.setAnimation({
              el: V.label[3],
              component: oe,
              attr: {
                "text-bound": []
              },
              callback: _.call(V.label[3])
            }), N = a.graphics.lowerBoxElem, C = Se.setAnimation({
              el: N || "rect",
              attr: i.props.lowerBoxElem.attr,
              label: "lowerBox",
              container: me,
              component: oe
            }), N || (a.graphics.lowerBoxElem = C, W = !0), C.shadow({
              opacity: fe ? re.lowerBoxAlpha / 100 : 0
            }, ke), A = a.graphics.lowerBoxBorderEle, S = Se.setAnimation({
              el: A || "path",
              attr: i.props.lowerBoxBorderEle.attr,
              component: oe,
              label: "path",
              container: me
            }), A || (a.graphics.lowerBoxBorderEle = S, U = !0), D = a.graphics.lowerQuartileEle, E = Se.setAnimation({
              el: D || "path",
              attr: i.props.lowerQuartileEle.attr,
              component: oe,
              label: "path",
              container: me
            }), D || (a.graphics.lowerQuartileEle = E, K = !0), B = a.graphics.lowerWhiskerEle, i.showMinValues ? ((O = V.label[4]) && O.show(), P = Se.setAnimation({
              el: O || "text",
              attr: i.props.upperQuartileMinLabel.attr,
              label: "text",
              container: xe,
              component: oe
            }), O || (V.label[4] = P), V.label[4].data(m, M)) : V.label[4] && Se.setAnimation({
              el: V.label[4],
              component: oe,
              attr: {
                "text-bound": []
              },
              callback: _.call(V.label[4])
            }), R = a.graphics.lowerWhiskerEle, B = Se.setAnimation({
              el: R || "path",
              attr: i.props.lowerWhiskerEle.attr,
              label: "path",
              container: ye,
              component: oe
            }), s({
              opacity: i.lowerWhiskerShadowOpacity
            }), R || (a.graphics.lowerWhiskerEle = B, X = !0), L = a.graphics.midLineElem, T = Se.setAnimation({
              el: L || "path",
              component: oe,
              label: "midline",
              container: ve,
              attr: i.props.midLineElem.attr
            }), L || (a.graphics.midLineElem = T, q = !0), Q = {
              upperBoxElem: i.setUpperBoxRolloverAttr,
              lowerBoxElem: i.setLowerBoxRolloverAttr,
              upperBoxBorderEle: i.setUpperBoxBorderRolloverAttr,
              lowerBoxBorderEle: i.setLowerBoxBorderRolloverAttr,
              upperQuartileEle: i.setUpperQuartileRolloverAttr,
              lowerQuartileEle: i.setLowerQuartileRolloverAttr,
              midLineElem: i.setMedianRolloverAttr
            }, Z = {
              upperBoxElem: i.setUpperBoxRolloutAttr,
              lowerBoxElem: i.setLowerBoxRolloutAttr,
              upperBoxBorderEle: i.setUpperBoxBorderRolloutAttr,
              lowerBoxBorderEle: i.setLowerBoxBorderRolloutAttr,
              upperQuartileEle: i.setUpperQuartileRolloutAttr,
              lowerQuartileEle: i.setLowerQuartileRolloutAttr,
              midLineElem: i.setMedianRolloutAttr
            }, d.data(m, M).data(k, i.eventArgs).data(x, Ne).data("setRolloverAttr", Q).data("setRolloutAttr", Z), H && (d.on("fc-click", Ae(d)), d.on("fc-mouseover", Ee(a.graphics, d)), d.on("fc-mouseout", De(a.graphics, d))), C.data(m, M).data(k, i.eventArgs).data(x, Ne).data("setRolloverAttr", Q).data("setRolloutAttr", Z), W && (C.on("fc-click", Ae(C)), C.on("fc-mouseover", Ee(a.graphics, C)), C.on("fc-mouseout", De(a.graphics, C))), v.data(m, M).data(k, i.eventArgs).data(x, Ne).data("setRolloverAttr", Q).data("setRolloutAttr", Z), z && (v.on("fc-click", Ae(v)), v.on("fc-mouseover", Ee(a.graphics, v)), v.on("fc-mouseout", De(a.graphics, v))), S.data(m, M).data(k, i.eventArgs).data(x, Ne).data("setRolloverAttr", Q).data("setRolloutAttr", Z), U && (S.on("fc-click", Ae(S)), S.on("fc-mouseover", Ee(a.graphics, S)), S.on("fc-mouseout", De(a.graphics, S))), y.data(m, M).data(k, i.eventArgs).data(x, Ne).data("setRolloverAttr", Q).data("setRolloutAttr", Z), J && (y.on("fc-click", Ae(y)), y.on("fc-mouseover", Ee(a.graphics, y)), y.on("fc-mouseout", De(a.graphics, y))), E.data(m, M).data(k, i.eventArgs).data(x, Ne).data("setRolloverAttr", Q).data("setRolloutAttr", Z), K && (E.on("fc-click", Ae(E)), E.on("fc-mouseover", Ee(a.graphics, E)), E.on("fc-mouseout", De(a.graphics, E))), T.data(m, M).data(k, i.eventArgs).data(x, Ne).data("setRolloverAttr", Q).data("setRolloutAttr", Z), q && (T.on("fc-click", Ae(T)), T.on("fc-mouseover", Ee(a.graphics, T)), T.on("fc-mouseout", De(a.graphics, T))), F.data(m, M).data(k, i.eventArgs).data(x, Ne).data("setRolloverAttr", Q).data("setRolloutAttr", Z), Y && (F.on("fc-click", Ae(F)), F.on("fc-mouseover", Ee(a.graphics, F)), F.on("fc-mouseout", De(a.graphics, F))), B.data(m, M).data(k, i.eventArgs).data(x, Ne).data("setRolloverAttr", Q).data("setRolloutAttr", Z), X && (B.on("fc-click", Ae(B)), B.on("fc-mouseover", Ee(a.graphics, B)), B.on("fc-mouseout", De(a.graphics, B))), (0, n.defined)(l.displayValue) && l.displayValue !== f && i.showQ3Values ? ((O = V.label[0]) && O.show(), P = Se.setAnimation({
              el: O || "text",
              attr: i.props.upperQuartileLabel.attr,
              component: oe,
              label: "text",
              container: xe
            }), O || (V.label[0] = P), V.label[0].data(m, M)) : V.label[0] && Se.setAnimation({
              el: V.label[0],
              component: oe,
              attr: {
                "text-bound": []
              },
              callback: _.call(V.label[0])
            }), (0, n.defined)(u.displayValue) && u.displayValue !== f && i.showMedianValues ? ((O = V.label[1]) && O.show(), P = Se.setAnimation({
              el: O || "text",
              attr: i.props.medianLabel.attr,
              component: oe,
              label: "text",
              container: xe
            }), O || (V.label[1] = P), V.label[1].data(m, M)) : V.label[1] && Se.setAnimation({
              el: V.label[1],
              component: oe,
              attr: {
                "text-bound": []
              },
              callback: _.call(V.label[1])
            }), (0, n.defined)(c.displayValue) && c.displayValue !== f && i.showQ1Values ? (O = V.label[2], P = Se.setAnimation({
              el: O || "text",
              component: oe,
              attr: i.props.lowerQuartileLabel.attr,
              container: xe
            }), O || (V.label[2] = P, P.show()), V.label[2].data(m, M)) : V.label[2] && Se.setAnimation({
              el: V.label[2],
              component: oe,
              attr: {
                "text-bound": []
              },
              callback: _.call(V.label[2])
            }), pe ? (he.enableToolTip(d, o), he.enableToolTip(C, o), he.enableToolTip(v, o), he.enableToolTip(S, o), he.enableToolTip(y, o), he.enableToolTip(E, o), he.enableToolTip(T, o), he.enableToolTip(F, o), he.enableToolTip(B, o)) : (he.enableToolTip(d, !1), he.enableToolTip(C, !1), he.enableToolTip(v, !1), he.enableToolTip(S, !1), he.enableToolTip(y, !1), he.enableToolTip(E, !1), he.enableToolTip(T, !1), he.enableToolTip(F, !1), he.enableToolTip(B, !1));else for (j in G = a.graphics) {
              if (G[j] instanceof Array) for ($ = 0, te = (ee = G[j]).length; $ < te; $++) {
                ee[$] && ee[$].hide();
              } else G[j].hide();
            }
          }

          !1 !== oe.getState("visible") || !1 !== oe._conatinerHidden && void 0 !== oe._conatinerHidden || (ge.hide(), me.hide(), be.hide(), ye.hide(), ve.hide(), ke.hide(), xe && xe.hide(), oe._conatinerHidden = !0), Ce && oe.removePlots();
        }, t.prototype.removePlots = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              i = this.components.removeDataArr,
              l = this.getFromEnv("animationManager"),
              s = i.length;

          for (a = 0; a < s; a++) {
            if (e = i[0], i.splice(0, 1), e && e.graphics) for (t in o = e.graphics) {
              if (t !== p) o[t].shadow({
                opacity: 0
              }), o[t].hide();else for (r = o[t].length, n = 0; n < r; n++) {
                o[t][n] && (o[t][n].shadow({
                  opacity: 0
                }), l.setAnimation({
                  el: o[t][n],
                  component: this,
                  attr: {
                    "text-bound": []
                  },
                  callback: _.call(o[t][n])
                }));
              }
            }
          }
        }, t.prototype.removeData = function (e, t, o) {
          var a = this.components,
              r = a.data,
              n = a.removeDataArr || (a.removeDataArr = []);
          t = t || 1, (e = e || 0) + t === r.length ? this.endPosition = !0 : 0 !== e && void 0 !== e || (this.endPosition = !1), a.removeDataArr = n = n.concat(r.splice(e, t)), o && this.asyncDraw();
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.showplotborder = void 0, t.plotborderdashlen = void 0, t.plotborderdashgap = void 0, t.plotfillalpha = void 0, t.useroundedges = void 0, t.ratio = void 0, t.plotborderthickness = void 0, t.showvalues = void 0, t.valuepadding = void 0, t.showtooltip = void 0, t.maxcolwidth = void 0, t.rotatevalues = void 0, t.use3dlighting = void 0, t.whiskerslimitswidthratio = void 0, t.outliersupperrangeratio = void 0, t.outlierslowerrangeratio = void 0, t.showalloutliers = void 0, t.showmean = void 0, t.showsd = void 0, t.showmd = void 0, t.showqd = void 0, t.showminvalues = void 0, t.showmaxvalues = void 0, t.showq1values = void 0, t.showq3values = void 0, t.showmedianvalues = void 0;
        }, t.prototype.getDataLimits = function () {
          var e = this.config,
              t = this.getState("removed");
          return {
            max: t ? -Infinity : e.maxValue,
            min: t ? +Infinity : e.minValue
          };
        }, t.prototype._addLegend = function () {
          var e,
              t,
              o,
              a,
              r = this.config,
              i = this.getFromEnv("legend"),
              l = r.upperBoxColor,
              s = r.lowerBoxColor;
          e = u, t = {
            FCcolor: {
              color: l + n.COMMA + s,
              angle: 90,
              ratio: "50, 0",
              alpha: "100, 100"
            }
          }, o = {
            label: (0, n.getFirstValue)(this.config.JSONData.seriesname),
            index: this.getJSONIndex(),
            mainDS: !0
          }, r.includeInLegend ? ((a = i.getItem(this.config.legendItemId)) || (this.config.legendItemId = i.createItem(this), a = i.getItem(this.config.legendItemId), this.addExtEventListener("fc-click", function () {
            a.itemClickFn();
          }, a)), a.configure(o), a.setStateCosmetics("default", {
            symbol: {
              fill: (0, n.toRaphaelColor)(t),
              rawFillColor: r.upperBoxColor,
              stroke: (0, n.toRaphaelColor)(e)
            },
            background: {
              legendBackgroundColor: (0, n.toRaphaelColor)(l),
              alpha: 20
            }
          }), this.getState("visible") ? a.removeLegendState("hidden") : a.setLegendState("hidden")) : this.config.legendItemId && i.disposeItem(this.config.legendItemId), this._mapChildren(function (e) {
            e.getState("removed") || (e.addToEnv("legendBackgroundColor", l), e && e._addLegend(!0));
          });
        }, t.prototype.legendInteractivity = function () {
          var e,
              t,
              o = this.getChildren("dataset");

          for (e = this.getState("visible") ? "hide" : "show", t = 0; t < (o && o.length); t++) {
            o[t][e]();
          }

          this[e]();
        }, t.prototype.drawLabel = function () {
          return this;
        }, t.prototype.getName = function () {
          return "boxandwhisker2D";
        }, t.prototype.childChanged = function () {
          return this;
        }, t.prototype.show = function () {
          e.prototype.show.call(this);
        }, t.prototype.hide = function () {
          e.prototype.hide.call(this);
        }, t;
      }(a["default"]);

      t["default"] = T;
    },
    936: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = l(o(449)),
          r = o(125),
          n = o(132),
          i = l(o(937));

      function l(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var c = r.preDefStr.POLYGON,
          u = r.preDefStr.SPOKE,
          p = function p(e, t, o) {
        return o.getFromEnv("animationManager").setAnimation({
          el: "group",
          attr: e,
          container: t,
          component: o,
          label: "group"
        });
      };

      (0, n.addDep)({
        name: "boxandwhiskerlineAnimation",
        type: "animationRule",
        extension: i["default"]
      });

      var h = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return s(t, e), t.prototype.getName = function () {
          return "boxandwhiskerline";
        }, t.prototype.createCoordinates = function () {
          var e,
              t,
              o,
              a,
              r,
              n = this.components.data,
              i = this.getFromEnv("yAxis"),
              l = this.getFromEnv("xAxis"),
              s = n.length,
              c = this.components.data,
              u = this.getFromEnv("columnXShift"),
              p = this.getFromEnv("columnWidth");

          for (o = 0; o < s; o++) {
            t = (e = c[o]) && e.config, void 0 !== e && (a = l.getPixel(t._x), r = i.getPixel(t._y), t._Px = a + u + p / 2, t._Py = r);
          }
        }, t.prototype.getAllPlots = function (e, t) {
          var o,
              a = this.components.data,
              r = [],
              n = void 0;

          for (n = 0, o = a.length; n < o; n++) {
            (a[n].config._x >= e || a[n].config._x <= t) && r.push(a[n]);
          }

          return r;
        }, t.prototype.calculateScrollRange = function () {
          var e = this.config,
              t = this.components.data;
          e.scrollMinVal = 0, e.scrollMaxVal = t.length, e.scrollMinValForLabel = e.scrollMinVal, e.scrollMaxValForLabel = e.scrollMaxVal;
        }, t.prototype._getHoveredPlot = function (e, t) {
          var o,
              a,
              r,
              n,
              i,
              l,
              s = this.getFromEnv("xAxis"),
              c = this.components.data.length,
              u = this.config,
              p = u && u.radius || 0;

          for (e += s.getTranslation(), a = Math.floor(Math.max(s.getValue(e - p), 0)), r = Math.ceil(Math.min(s.getValue(e + p), c - 1)), i = (l = this.getAllPlots(a, r)).length; i >= 0 && (!(o = l[i]) || !(n = this.isWithinShape(o, i, e, t))); i--) {
            ;
          }

          return n;
        }, t.prototype._addLegend = function (e) {
          if (e) {
            var t,
                o,
                a = this.getFromEnv("chart"),
                n = this.config,
                i = a.getChildren("legend")[0],
                l = (0, r.pluckNumber)(n.drawanchors, 1);
            n.includeinlegend ? (o = {
              anchorSide: l ? n.anchorsides : 0,
              label: (0, r.getFirstValue)(n.JSONData.seriesname),
              customLegendIcon: !1,
              spoke: "spoke" === n.dip ? 1 : 0,
              drawLine: !n.showline,
              index: this.getJSONIndex()
            }, (t = i.getItem(this.config.legendItemId)) || (this.config.legendItemId = i.createItem(this), t = i.getItem(this.config.legendItemId), this.addExtEventListener("fc-click", function () {
              t.itemClickFn();
            }, t)), t.configure(o), t.setStateCosmetics("default", {
              symbol: {
                fill: (0, r.toRaphaelColor)({
                  color: n.anchorbgcolor,
                  alpha: n.anchorbgalpha
                }),
                rawFillColor: n.anchorbgcolor,
                stroke: (0, r.toRaphaelColor)({
                  color: n.anchorbordercolor,
                  alpha: "100"
                })
              },
              background: {
                legendBackgroundColor: (0, r.toRaphaelColor)(this.getFromEnv("legendBackgroundColor")),
                alpha: 20
              }
            }), this.getState("visible") ? t.removeLegendState("hidden") : t.setLegendState("hidden")) : this.config.legendItemId && i.disposeItem(this.config.legendItemId);
          }
        }, t.prototype.configureAttributes = function (t) {
          e.prototype.configureAttributes.call(this, t);
          var o = this.config.JSONData,
              a = this.config;
          this.setState("visible", this.getLinkedParent().getState("visible")), a.skipCommonElements = o.showline, a.dip = o.dip;
        }, t.prototype.createContainer = function () {
          var e,
              t,
              o = this.getType(),
              a = this.groupName,
              r = this.getLinkedParent().getLinkedParent(),
              n = a || this.dsGroup || o;
          !r.getChildContainer(n + "VcanvasGroup") && (n = "default"), e = r.getChildContainer("manager-defaultVcanvasGroup-lines"), t = r.getChildContainer(n + "ShadowVcanvasGroup"), !this.getContainer("shadowGroup") && this.addContainer("shadowGroup", p({
            name: "shadow-group"
          }, t, this)), !this.getContainer("commonElemsGroup") && this.addContainer("commonElemsGroup", p({
            name: "common-elems-group"
          }, e, this)), !this.getContainer("plotGroup") && this.addContainer("plotGroup", p({
            name: "common-elems-group"
          }, e, this)), !this.getContainer("labelGroup") && this.addContainer("labelGroup", p({
            name: "label-group",
            "class": "fusioncharts-datalabels",
            opacity: 1
          }, r.getChildContainer("vcanvasLabelGroup"), this));
        }, t.prototype._setConfigure = function (e, t) {
          var o,
              a,
              n,
              i,
              l,
              s,
              p,
              h,
              d = this.getFromEnv("chart"),
              f = this.config,
              g = d.config,
              m = this.config.JSONData,
              v = e || m.data || [],
              b = this.getFromEnv("xAxis").getTicksLen(),
              y = e && e.data.length,
              x = "Outliers" === m.seriesname ? v.length : y || Math.min(b, v.length);

          for (f.imageCount = 0, (n = this.components.data) || (n = this.components.data = []), f.maxRadius = -Infinity, i = 0; i < x; i++) {
            e ? (o = e && e.data[i] || {}, a = void 0 !== t ? n[h = t + i] : n[h = n.length - x + i], l = h) : (a = n[i], o = v && v[i] || {}, l = i), a || (a = n[l] = {}), a.config || (a.config = {}), a.graphics || (a.graphics = {}), this._plotConfigure(l, o, y), h && h++, s = a && a.config, p = (0, r.pluck)(o.dip, m.dip), s.dip = p === c ? 0 : p === u ? 1 : 0, s.toolText = s.finalTooltext = "<b>" + m.seriesname + g.tooltipsepchar + "</b>" + s.displayValue;
          }
        }, t;
      }(a["default"]);

      t["default"] = h;
    },
    937: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = {
        "initial.dataset.boxandwhiskerline": function initialDatasetBoxandwhiskerline() {
          return {
            "line.appearing": [{
              initialAttr: {
                opacity: 0
              },
              finalAttr: {
                opacity: 1
              },
              slot: "plot",
              startEnd: {
                start: .5,
                end: 1
              }
            }],
            "anchor.appearing": [{
              initialAttr: {
                opacity: 0
              },
              finalAttr: {
                opacity: 1
              },
              slot: "plot",
              startEnd: {
                start: .5,
                end: 1
              }
            }]
          };
        }
      };
    },
    938: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = {
        "initial.dataset.boxandwhisker2D": function initialDatasetBoxandwhisker2D() {
          return {
            "upperBox.appearing": function upperBoxAppearing(e) {
              return [{
                initialAttr: {
                  x: e.attr.x,
                  y: e.attr.y + e.attr.height,
                  height: 0,
                  width: e.attr.width
                },
                slot: "plot",
                startEnd: {
                  start: 0,
                  end: .5
                }
              }];
            },
            "lowerBox.appearing": function lowerBoxAppearing(e) {
              return [{
                initialAttr: {
                  x: e.attr.x,
                  y: e.attr.y,
                  height: 0,
                  width: e.attr.width
                },
                slot: "plot",
                startEnd: {
                  start: 0,
                  end: .5
                }
              }];
            },
            "path.appearing": [{
              initialAttr: {
                opacity: 0
              },
              finalAttr: {
                opacity: 1
              },
              slot: "plot",
              startEnd: {
                start: .5,
                end: 1
              }
            }],
            "midline.appearing": [{
              initialAttr: {
                opacity: 0
              },
              finalAttr: {
                opacity: 1
              },
              slot: "plot",
              startEnd: {
                start: 0,
                end: .2
              }
            }],
            "group.appearing": function groupAppearing(e) {
              return "label-group" === e.attr.name ? [{
                initialAttr: {
                  opacity: 0
                },
                finalAttr: {
                  opacity: 1
                },
                slot: "final"
              }] : [{
                initialAttr: {
                  opacity: 1
                },
                finalAttr: {
                  opacity: 1
                },
                slot: "final"
              }];
            },
            "*": null
          };
        }
      };
    },
    939: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(516);

      function n(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var i = "manager-defaultVcanvasGroup-lines",
          l = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return n(t, e), t.prototype.createContainer = function () {
          e.prototype.createContainer.call(this);
          var t = this.getFromEnv("animationManager"),
              o = this.getLinkedParent().getChildContainer("defaultVcanvasGroup");
          !this.getChildContainer(i) && this.addChildContainer(i, t.setAnimation({
            el: "group",
            component: this,
            attr: {
              name: i
            },
            container: o
          }));
        }, t;
      }(((a = r) && a.__esModule ? a : {
        "default": a
      })["default"]);

      t["default"] = l;
    },
    940: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = function (e) {
        var t,
            o,
            a,
            n = e.getFromEnv("dataSource").dataset,
            l = void 0,
            s = l = e.getChildren().canvas[0].getChildren("vCanvas")[0],
            c = e.config.defaultDatasetType || "";
        n || e.setChartMessage(), t = e.getDSGroupdef(), (0, r.componentFactory)(l, t, "datasetGroup_" + c), (a = l.getChildren("datasetGroup_" + c)) && (s = a[0]), o = e.getDSdef(), (0, r.componentFactory)(e, i["default"], "BoxAndWhiskerStatisticalCalc"), l.getChildren("datasetGroup_" + c)[0].addToEnv("BoxAndWhiskerStatisticalCalc", e.getChildren("BoxAndWhiskerStatisticalCalc")[0]), s.addToEnv("lineJSON", e._getLineJSONdata()), (0, r.datasetFactory)(s, o, "dataset", n.length, n);
      };
      var a,
          r = o(125),
          n = o(941),
          i = (a = n) && a.__esModule ? a : {
        "default": a
      };
    },
    941: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = o(138),
          r = o(125);

      function n(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var i = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return n(t, e), t.prototype.setArray = function (e) {
          var t,
              o,
              a = this.getFromEnv("number-formatter"),
              n = r.COMMASTRING,
              i = 0;

          for (!e && (e = r.BLANK), o = e.replace(/\s/g, r.BLANK).split(n), t = this.dataLength = o && o.length; t--;) {
            i += o[t] = a.getCleanValue(o[t]);
          }

          o && o.sort(function (e, t) {
            return e - t;
          }), this.values = o, this.mean = i / this.dataLength, this.getFrequencies();
        }, t.prototype.getQuartiles = function () {
          var e,
              t,
              o,
              a,
              n,
              i,
              l = this.values,
              s = this.dataLength,
              c = s % 2;

          switch (r.BLANKSTRING) {
            case "tukey":
              c ? (e = (s + 3) / 4, o = (3 * s + 1) / 4) : (e = (s + 2) / 4, o = (3 * s + 2) / 4);
              break;

            case "mooremccabe":
              c ? o = 3 * (e = (s + 1) / 4) : (e = (s + 2) / 4, o = (3 * s + 2) / 4);
              break;

            case "freundperles":
              e = (s + 3) / 4, o = (3 * s + 1) / 4;
              break;

            case "mendenhallsincich":
              e = Math.round((s + 1) / 4), o = Math.round(3 * e);
              break;

            default:
              o = 3 * (e = (s + 1) / 4);
          }

          return e -= 1, o -= 1, t = Math.floor(e), a = Math.floor(o), n = e - t ? l[t] + (l[Math.ceil(e)] - l[t]) * (e - t) : l[e], i = o - a ? l[a] + (l[Math.ceil(o)] - l[a]) * (o - a) : l[o], this.quartiles = {
            q1: n,
            q3: i
          };
        }, t.prototype.getMinMax = function () {
          var e = this.values;
          return {
            min: e[0],
            max: e[this.dataLength - 1]
          };
        }, t.prototype.getMean = function () {
          return this.mean;
        }, t.prototype.getMD = function () {
          for (var e, t = this.mean, o = this.frequencies, a = o.length, r = 0; a--;) {
            r += (e = o[a]).frequency * Math.abs(e.value - t);
          }

          return r / this.dataLength;
        }, t.prototype.getSD = function () {
          for (var e = this.mean, t = this.values, o = this.dataLength, a = o, r = 0; o--;) {
            r += Math.pow(t[o] - e, 2);
          }

          return Math.sqrt(r / (a - 1));
        }, t.prototype.getQD = function () {
          return .5 * (this.quartiles.q3 - this.quartiles.q1);
        }, t.prototype.getFrequencies = function () {
          var e,
              t,
              o,
              a = [],
              n = this.dataLength,
              i = this.values,
              l = 0;

          for (o = 0; o < n; o += 1) {
            l += e = i[o], (0, r.defined)(a[o]) ? a[o].frequency += 1 : ((t = {}).value = e, t.frequency = 1, a[o] = t);
          }

          this.sum = l, this.frequencies = a;
        }, t.prototype.getMedian = function () {
          var e = this.dataLength,
              t = .5 * e,
              o = this.values;
          return e % 2 == 0 ? (o[t] + o[t - 1]) / 2 : o[Math.floor(t)];
        }, t;
      }(a.ComponentInterface);

      t["default"] = i;
    },
    942: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(943),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    943: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = p(o(459)),
          r = p(o(944)),
          n = p(o(946)),
          i = p(o(947)),
          l = p(o(461)),
          s = p(o(948)),
          c = p(o(952)),
          u = o(125);

      function p(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function h(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var d = u.preDefStr.defaultFontStr,
          f = u.preDefStr.divLineAlpha3DStr,
          g = u.preDefStr.divLineAlphaStr,
          m = u.preDefStr.altVGridColorStr,
          v = u.preDefStr.altVGridAlphaStr,
          b = u.preDefStr.altHGridColorStr,
          y = u.preDefStr.altHGridAlphaStr,
          x = u.preDefStr.colors.c000000,
          k = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.tooltipsepchar = " = ", o.hasGradientLegend = !0, o.registerFactory("axis", i["default"], ["canvas"]), o.registerFactory("legend", c["default"], ["canvas"]), o.registerFactory("colormanager-decider", s["default"], ["legend"]), o.registerFactory("dataset", l["default"], ["colormanager-decider", "vCanvas"]), o;
        }

        return h(t, e), t.getName = function () {
          return "HeatMap";
        }, t.prototype.getName = function () {
          return "HeatMap";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.isSingleSeries = !0, t.friendlyName = "Heatmap Chart", t.hasLegend = !0, t.defaultDatasetType = "heatmap", t.enablemousetracking = !0;
        }, t.prototype._checkInvalidSpecificData = function () {
          var e = this.getFromEnv("dataSource"),
              t = e.dataset,
              o = e.colorrange;
          if (!t || !o || !o.color && !Number(o.gradient)) return !0;
        }, t.prototype.parseChartAttr = function (t) {
          e.prototype.parseChartAttr.call(this, t), this.config.drawTrendRegion = 0;
        }, t.prototype.configureAttributes = function (e) {
          var t,
              o,
              a = this.config,
              r = this.getFromEnv("dataSource"),
              n = this.config.skipConfigureIteration = {},
              i = e.dataset,
              l = [];

          if (t = r.rows && r.rows.row.filter(function (e) {
            return "" !== e.id && e.id !== undefined;
          }), o = r.columns && r.columns.column.filter(function (e) {
            return "" !== e.id && e.id !== undefined;
          }), !t || !o) {
            for (var s = 0; s < i.length; s++) {
              for (var c = 0; c < i[s].data.length; c++) {
                l.push(i[s].data[c]);
              }
            }

            t || (t = l.map(function (e) {
              return e.rowid;
            }).filter(function (e, t, o) {
              return o.indexOf(e) === t;
            })), o || (o = l.map(function (e) {
              return e.columnid;
            }).filter(function (e, t, o) {
              return o.indexOf(e) === t;
            }));
          }

          this.parseChartAttr(e), this.addToEnv("chartColorRange", e.colorrange || {}), this.createComponent(e), this._feedAxesRawData(), n.axis = !0, this.addToEnv("totalRows", t.length), this.addToEnv("totalColumns", o.length), this._createToolBox(), this.configureChildren(), this.asyncDraw(), this.getFromEnv("toolTipController").setStyle({
            bgColor: (0, u.convertColor)(a.tooltipbgcolor || "FFF", a.tooltipbgalpha || 100),
            rawBgColor: (a.tooltipbgcolor || "FFF").replace(/^#?([a-f0-9]+)/gi, "#$1"),
            fontColor: (a.tooltipcolor || a.basefontcolor || "545454").replace(/^#?([a-f0-9]+)/gi, "#$1"),
            borderColor: (0, u.convertColor)(a.tooltipbordercolor || "666", a.tooltipborderalpha || 100),
            rawBorderColor: (a.tooltipbordercolor || "666").replace(/^#?([a-f0-9]+)/gi, "#$1"),
            bgAlpha: (0, u.pluckNumber)(a.tooltipbgalpha, 100),
            borderThickness: (0, u.pluckNumber)(a.tooltipborderthickness, 1),
            showToolTipShadow: (0, u.pluckNumber)(a.showtooltipshadow || 0),
            borderRadius: (0, u.pluckNumber)(a.tooltipborderradius, 0),
            "font-size": a.basefontsize || 10,
            "font-family": a.basefont || this.getFromEnv("style").inCanfontFamily,
            padding: (0, u.pluckNumber)(a.tooltippadding || 3),
            borderAlpha: (0, u.pluckNumber)(a.tooltipborderalpha, 100)
          });
        }, t.prototype._postSpaceManagement = function () {
          var e = this.config,
              t = this.getChildren("xAxis")[0],
              o = this.getFromEnv("legend"),
              a = e.xDepth;
          this.setAxisDimention(), t && t.shiftLabels(-a, 0), o && o.postSpaceManager(), this.allocateDimensionOfChartMenuBar();
        }, t.prototype.setAxisDimention = function () {
          var e = this.getChildren("xAxis") && this.getChildren("xAxis")[0],
              t = this.getChildren("yAxis") && this.getChildren("yAxis")[0],
              o = this.getFromEnv("chartConfig"),
              a = o.placeAxisLabelsOnTop,
              r = this.getChildren("canvas")[0],
              n = r.config,
              i = r.getEffectiveDimensions(),
              l = i.left,
              s = i.top,
              c = i.width,
              u = i.height,
              p = i.paddingLeft,
              h = i.paddingRight,
              d = n && n.canvasBorderWidth,
              f = n && n.canvasPadding;
          e && e.setAxisConfig({
            canvasPaddingLeft: Math.max(p, f),
            canvasPaddingRight: Math.max(h, f)
          }), e && e.setAxisDimention({
            x: l,
            y: a ? s + (o.shift || 0) - d : s + u + (o.shift || 0) + d,
            opposite: a ? s + u + d : s - d,
            axisLength: c
          }), t && t.setAxisDimention({
            x: l - d,
            y: s,
            opposite: l + c + d,
            axisLength: u
          });
        }, t.prototype._feedAxesRawData = function () {
          var e,
              t,
              o = this.getFromEnv("color-manager"),
              a = this.getFromEnv("dataSource"),
              r = a.chart,
              n = this.config.is3D,
              i = n ? u.chartPaletteStr.chart3D : u.chartPaletteStr.chart2D;
          return e = {
            mapTickValuesById: !0,
            isVertical: !1,
            isReverse: !1,
            isOpposit: !!this.config.placeAxisLabelsOnTop,
            outCanfontFamily: (0, u.pluck)(r.outcnvbasefont, r.basefont, d),
            outCanfontSize: (0, u.pluckFontSize)(r.outcnvbasefontsize, r.basefontsize, 10),
            outCancolor: (0, u.pluck)(r.outcnvbasefontcolor, r.basefontcolor, o.getColor(i.baseFontColor)).replace(/^#?([a-f0-9]+)/gi, "#$1"),
            axisNamePadding: r.xaxisnamepadding,
            axisValuePadding: r.labelpadding,
            axisNameFont: r.xaxisnamefont,
            axisNameFontSize: r.xaxisnamefontsize,
            axisNameFontColor: r.xaxisnamefontcolor,
            axisNameFontBold: r.xaxisnamefontbold,
            axisNameFontItalic: r.xaxisnamefontitalic,
            axisNameBgColor: r.xaxisnamebgcolor,
            axisNameBorderColor: r.xaxisnamebordercolor,
            axisNameAlpha: r.xaxisnamealpha,
            axisNameFontAlpha: r.xaxisnamefontalpha,
            axisNameBgAlpha: r.xaxisnamebgalpha,
            axisNameBorderAlpha: r.xaxisnameborderalpha,
            axisNameBorderPadding: r.xaxisnameborderpadding,
            axisNameBorderRadius: r.xaxisnameborderradius,
            axisNameBorderThickness: r.xaxisnameborderthickness,
            axisNameBorderDashed: r.xaxisnameborderdashed,
            axisNameBorderDashLen: r.xaxisnameborderdashlen,
            axisNameBorderDashGap: r.xaxisnameborderdashgap,
            useEllipsesWhenOverflow: r.useellipseswhenoverflow,
            divLineColor: (0, u.pluck)(r.vdivlinecolor, r.divlinecolor, o.getColor(i.divLineColor)),
            divLineAlpha: (0, u.pluck)(r.vdivlinealpha, r.divlinealpha, n ? o.getColor(f) : o.getColor(g)),
            divLineThickness: (0, u.pluckNumber)(r.vdivlinethickness, r.divlinethickness, 1),
            divLineIsDashed: Boolean((0, u.pluckNumber)(r.vdivlinedashed, r.vdivlineisdashed, r.divlinedashed, r.divlineisdashed, 0)),
            divLineDashLen: (0, u.pluckNumber)(r.vdivlinedashlen, r.divlinedashlen, 4),
            divLineDashGap: (0, u.pluckNumber)(r.vdivlinedashgap, r.divlinedashgap, 2),
            showAlternateGridColor: (0, u.pluckNumber)(r.showalternatevgridcolor, 0),
            alternateGridColor: (0, u.pluck)(r.alternatevgridcolor, o.getColor(m)),
            alternateGridAlpha: (0, u.pluck)(r.alternatevgridalpha, o.getColor(v)),
            numDivLines: r.numvdivlines,
            labelFont: r.labelfont,
            labelFontSize: r.labelfontsize,
            labelFontColor: r.labelfontcolor,
            labelFontAlpha: r.labelalpha,
            labelFontBold: r.labelfontbold,
            labelFontItalic: r.labelfontitalic,
            axisName: r.xaxisname,
            axisMinValue: r.xaxisminvalue,
            axisMaxValue: r.xaxismaxvalue,
            setAdaptiveMin: r.setadaptivexmin,
            adjustDiv: r.adjustvdiv,
            labelDisplay: r.labeldisplay,
            showLabels: (0, u.pluckNumber)(r.showxaxislabels, r.showlabels),
            rotateLabels: r.rotatexaxislabels,
            slantLabel: (0, u.pluckNumber)(r.slantlabels, r.slantlabel),
            labelStep: (0, u.pluckNumber)(r.labelstep, r.xaxisvaluesstep),
            showAxisValues: (0, u.pluckNumber)(r.showxaxisvalues, r.showxaxisvalue),
            maxLabelHeight: r.maxlabelheight,
            showZeroPlane: r.showvzeroplane,
            zeroPlaneColor: r.vzeroplanecolor,
            zeroPlaneThickness: r.vzeroplanethickness,
            zeroPlaneAlpha: r.vzeroplanealpha,
            showZeroPlaneValue: r.showvzeroplanevalue,
            trendlineColor: r.trendlinecolor,
            trendlineToolText: r.trendlinetooltext,
            trendlineThickness: r.trendlinethickness,
            trendlineAlpha: r.trendlinealpha,
            showTrendlinesOnTop: r.showtrendlinesontop,
            showAxisLine: (0, u.pluckNumber)(r.showxaxisline, r.showaxislines, r.drawAxisLines, 0),
            axisLineThickness: (0, u.pluckNumber)(r.xaxislinethickness, r.axislinethickness, 1),
            axisLineAlpha: (0, u.pluckNumber)(r.xaxislinealpha, r.axislinealpha, 100),
            axisLineColor: (0, u.pluck)(r.xaxislinecolor, r.axislinecolor, x)
          }, t = {
            mapTickValuesById: !0,
            isVertical: !0,
            isReverse: !1,
            isOpposit: !1,
            outCanfontFamily: (0, u.pluck)(r.outcnvbasefont, r.basefont, d),
            outCanfontSize: (0, u.pluckFontSize)(r.outcnvbasefontsize, r.basefontsize, 10),
            outCancolor: (0, u.pluck)(r.outcnvbasefontcolor, r.basefontcolor, o.getColor(i.baseFontColor)).replace(/^#?([a-f0-9]+)/gi, "#$1"),
            axisNamePadding: r.yaxisnamepadding,
            axisValuePadding: r.yaxisvaluespadding,
            axisNameFont: r.yaxisnamefont,
            axisNameFontSize: r.yaxisnamefontsize,
            axisNameFontColor: r.yaxisnamefontcolor,
            axisNameFontBold: r.yaxisnamefontbold,
            axisNameFontItalic: r.yaxisnamefontitalic,
            axisNameBgColor: r.yaxisnamebgcolor,
            axisNameBorderColor: r.yaxisnamebordercolor,
            axisNameAlpha: r.yaxisnamealpha,
            axisNameFontAlpha: r.yaxisnamefontalpha,
            axisNameBgAlpha: r.yaxisnamebgalpha,
            axisNameBorderAlpha: r.yaxisnameborderalpha,
            axisNameBorderPadding: r.yaxisnameborderpadding,
            axisNameBorderRadius: r.yaxisnameborderradius,
            axisNameBorderThickness: r.yaxisnameborderthickness,
            axisNameBorderDashed: r.yaxisnameborderdashed,
            axisNameBorderDashLen: r.yaxisnameborderdashlen,
            axisNameBorderDashGap: r.yaxisnameborderdashgap,
            axisNameWidth: r.yaxisnamewidth,
            useEllipsesWhenOverflow: r.useellipseswhenoverflow,
            rotateAxisName: (0, u.pluckNumber)(r.rotateyaxisname, 1),
            axisName: r.yaxisname,
            showAlternateGridColor: (0, u.pluckNumber)(r.showalternatehgridcolor, 1),
            alternateGridColor: (0, u.pluck)(r.alternatehgridcolor, o.getColor(b)),
            alternateGridAlpha: (0, u.pluck)(r.alternatehgridalpha, o.getColor(y)),
            numDivLines: r.numdivlines,
            axisMinValue: r.yaxisminvalue,
            axisMaxValue: r.yaxismaxvalue,
            setAdaptiveMin: r.setadaptiveymin,
            adjustDiv: r.adjustdiv,
            labelStep: r.yaxisvaluesstep,
            showLabels: (0, u.pluckNumber)(r.showyaxislabels, r.showlabels),
            maxLabelWidthPercent: r.maxlabelwidthpercent,
            showAxisValues: (0, u.pluckNumber)(r.showyaxisvalues, r.showyaxisvalue),
            divLineColor: (0, u.pluck)(r.hdivlinecolor, o.getColor(i.divLineColor)),
            divLineAlpha: (0, u.pluck)(r.hdivlinealpha, o.getColor(g)),
            divLineThickness: (0, u.pluckNumber)(r.hdivlinethickness, 1),
            divLineIsDashed: Boolean((0, u.pluckNumber)(r.hdivlinedashed, r.hdivlineisdashed, 0)),
            divLineDashLen: (0, u.pluckNumber)(r.hdivlinedashlen, 4),
            divLineDashGap: (0, u.pluckNumber)(r.hdivlinedashgap, 2),
            showZeroPlane: r.showzeroplane,
            zeroPlaneColor: r.zeroplanecolor,
            zeroPlaneThickness: r.zeroplanethickness,
            zeroPlaneAlpha: r.zeroplanealpha,
            showZeroPlaneValue: r.showzeroplanevalue,
            trendlineColor: r.trendlinecolor,
            trendlineToolText: r.trendlinetooltext,
            trendlineThickness: r.trendlinethickness,
            trendlineAlpha: r.trendlinealpha,
            showTrendlinesOnTop: r.showtrendlinesontop,
            showAxisLine: (0, u.pluckNumber)(r.showyaxisline, r.showaxislines, r.drawAxisLines, 0),
            axisLineThickness: (0, u.pluckNumber)(r.yaxislinethickness, r.axislinethickness, 1),
            axisLineAlpha: (0, u.pluckNumber)(r.yaxislinealpha, r.axislinealpha, 100),
            axisLineColor: (0, u.pluck)(r.yaxislinecolor, r.axislinecolor, x)
          }, e.vtrendlines = a.vtrendlines, t.trendlines = a.trendlines, {
            yAxisConf: [t],
            xAxisConf: [e]
          };
        }, t.prototype._setCategories = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              i,
              l,
              s,
              c,
              p = this.getFromEnv("dataSource"),
              h = this.getChildren("xAxis"),
              d = this.getChildren("yAxis"),
              f = [],
              g = [];
          if (!p.columns || !p.rows) for (p.columns = {}, p.columns.column = n = [], p.rows = {}, p.rows.row = i = [], o = 0; o < (p.dataset && p.dataset.length); o++) {
            for (e = p.dataset && p.dataset[o].data && p.dataset[o].data.length, t = 0; t < e; t++) {
              for (l = !0, s = !0, c = 0; c < n.length; c++) {
                p.dataset[o].data[t].columnid == n[c].id && (l = !1);
              }

              for (l && (a = {
                id: p.dataset[o].data[t].columnid,
                label: p.dataset[o].data[t].columnid
              }, p.columns.column.push(a)), c = 0; c < i.length; c++) {
                p.dataset[o].data[t].rowid == i[c].id && (s = !1);
              }

              s && (r = {
                id: p.dataset[o].data[t].rowid,
                label: p.dataset[o].data[t].rowid
              }, p.rows.row.push(r));
            }
          }

          for (n = p.columns.column, i = p.rows.row, t = 0; t < (n && n.length); t++) {
            n[t].label = (0, u.pluck)(n[t].label, n[t].name, n[t].id), void 0 !== n[t].label && f.push(n[t]);
          }

          for (p.columns.column = f, t = 0; t < (i && i.length); t++) {
            i[t].label = (0, u.pluck)(i[t].label, i[t].name, i[t].id), void 0 !== i[t].label && g.push(i[t]);
          }

          p.rows.row = g, p.columns && h[0].setTickValues(p.columns.column), p.rows && d[0].setTickValues(p.rows.row), h[0].setAxisConfig({
            categoryNumDivLines: this.getFromEnv("totalColumns") - 1,
            categoryDivLinesFromZero: 0,
            showAlternateGridColor: 0
          }), d[0].setAxisConfig({
            categoryNumDivLines: this.getFromEnv("totalRows") - 1,
            categoryDivLinesFromZero: 0,
            showAlternateGridColor: 0
          });
        }, t.prototype.getDSdef = function () {
          return r["default"];
        }, t.prototype.getDSGroupdef = function () {
          return n["default"];
        }, t;
      }(a["default"]);

      t["default"] = k;
    },
    944: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(138),
          n = o(125),
          i = o(132),
          l = o(945),
          s = (a = l) && a.__esModule ? a : {
        "default": a
      },
          c = o(136);

      function u(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var p = n.preDefStr.pStr,
          h = n.preDefStr.sStr,
          d = n.preDefStr.miterStr,
          f = n.preDefStr.hiddenStr,
          g = n.preDefStr.showHoverEffectStr,
          m = n.preDefStr.POSITION_START,
          v = n.preDefStr.POSITION_TOP,
          b = n.preDefStr.POSITION_END,
          y = n.preDefStr.POSITION_BOTTOM,
          x = n.preDefStr.DEFAULT,
          k = function k(e) {
        return void 0 !== e && null !== e;
      },
          w = function w(e, t, o) {
        return o.getFromEnv("animationManager").setAnimation({
          el: "group",
          attr: e,
          container: t,
          component: o,
          label: "group"
        });
      },
          C = "rgba(192,192,192," + (n.isIE ? .002 : 1e-6) + ")",
          N = n.hasTouch ? n.TOUCH_THRESHOLD_PIXELS : n.CLICK_THRESHOLD_PIXELS,
          S = Math.max,
          A = Math.min,
          E = Math.abs;

      (0, i.addDep)({
        name: "heatmapAnimation",
        type: "animationRule",
        extension: s["default"]
      });

      var D = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.components = {}, o.graphics = {}, o.dataSetArray = [], o;
        }

        return u(t, e), t.prototype.getType = function () {
          return "dataset";
        }, t.prototype.getName = function () {
          return "heatMap";
        }, t.prototype.configureAttributes = function (e) {
          if (!e) return !1;
          this.trimData(e), this.config.JSONData = e;

          var t,
              o,
              a,
              r,
              i,
              l,
              s,
              c,
              u,
              d,
              f,
              g,
              m,
              v,
              b,
              y,
              x,
              k = this.getFromEnv("chart"),
              w = this.getFromEnv("chartConfig").style,
              C = this.config,
              N = C.JSONData,
              S = N.data,
              A = S && S.length,
              E = this.getFromEnv("chart-attrib"),
              D = this.getFromEnv("color-manager"),
              _ = this.index || this.positionIndex,
              T = C.plotColor = D.getPlotColor(_),
              L = (0, n.pluckNumber)(N.dashed, E.plotborderdashed),
              P = this.components.data,
              O = this.components.plotGrid = [],
              V = this.getFromEnv("number-formatter"),
              M = k.isBar,
              F = k.config.is3D,
              I = -Infinity,
              B = +Infinity,
              R = this.getFromEnv("totalRows"),
              j = this.getFromEnv("totalColumns");

          for (g = 0; g < R; g++) {
            for (O.push([]), m = 0; m < j; m++) {
              O[g].push([]);
            }
          }

          for (this.setState("visible", 1 === (0, n.pluckNumber)(this.getState("visible"), this.config.JSONData.visible, !Number(this.config.JSONData.initiallyhidden), 1)), t = C.showplotborder = (0, n.pluckNumber)(E.showplotborder, F ? 0 : 1), C.plotDashLen = o = (0, n.pluckNumber)(E.plotborderdashlen, 5), C.plotDashGap = a = (0, n.pluckNumber)(E.plotborderdashgap, 4), C.plotfillAngle = (0, n.pluckNumber)(360 - E.plotfillangle, M ? 180 : 90), C.plotFillAlpha = i = (0, n.pluck)(N.alpha, E.plotfillalpha, "100"), C.plotColor = T = (0, n.pluck)(N.color, T), C.isRoundEdges = r = (0, n.pluckNumber)(E.useroundedges, 0), C.plotRadius = (0, n.pluckNumber)(E.useRoundEdges, C.isRoundEdges ? 1 : 0), C.plotFillRatio = (0, n.pluck)(N.ratio, E.plotfillratio), C.plotgradientcolor = (0, n.getDefinedColor)(E.plotgradientcolor, D.getColor("plotGradientColor")), C.plotBorderAlpha = t ? (0, n.pluck)(E.plotborderalpha, i, "100") : 0, C.plotBorderColor = (0, n.pluck)(E.plotbordercolor, F ? "FFFFFF" : D.getColor("plotBorderColor")), C.plotBorderThickness = (0, n.pluckNumber)(E.plotborderthickness, 1), C.plotBorderDashStyle = L ? (0, n.getDashStyle)(o, a) : "none", C.showValues = (0, n.pluckNumber)(N.showvalues, E.showvalues, 1), C.valuePadding = (0, n.pluckNumber)(E.valuepadding, 2), C.enableAnimation = d = (0, n.pluckNumber)(E.animation, E.defaultanimation, 1), C.animation = !!d && {
            duration: 1e3 * (0, n.pluckNumber)(E.animationduration, 1)
          }, C.transposeAnimation = (0, n.pluckNumber)(E.transposeanimation, d), C.transposeAnimDuration = 1e3 * (0, n.pluckNumber)(E.transposeanimduration, .2), C.showShadow = r || F ? (0, n.pluckNumber)(E.showshadow, 1) : (0, n.pluckNumber)(E.showshadow, D.getColor("showShadow")), C.showHoverEffect = (0, n.pluckNumber)(E.plothovereffect, E.showhovereffect, void 0), C.showTooltip = (0, n.pluckNumber)(E.showtooltip, 1), C.definedGroupPadding = Math.max((0, n.pluckNumber)(E.plotspacepercent), 0), C.plotSpacePercent = Math.max((0, n.pluckNumber)(E.plotspacepercent, 20) % 100, 0), C.maxColWidth = (0, n.pluckNumber)(M ? E.maxbarheight : E.maxcolwidth, 50), C.plotPaddingPercent = (0, n.pluckNumber)(E.plotpaddingpercent), C.rotateValues = (0, n.pluckNumber)(E.rotatevalues) ? 270 : 0, C.placeValuesInside = (0, n.pluckNumber)(E.placevaluesinside, 0), C.defaultPadding = {
            left: .5,
            right: .5,
            top: .5,
            bottom: .5
          }, v = w.inCanfontFamily, x = w.inCanfontSize, b = parseInt(x, 10 || 10), y = w.inCancolor, "normal", "normal", C.tlLabelStyle = {
            fontFamily: (0, n.pluck)(E.tlfont, v),
            fontSize: (0, n.pluckNumber)(E.tlfontsize, b) + "px",
            color: (0, n.convertColor)((0, n.pluck)(E.tlfontcolor, y), 100),
            fontWeight: "normal",
            fontStyle: "normal"
          }, (0, n.setLineHeight)(C.tlLabelStyle), C.trLabelStyle = {
            fontFamily: (0, n.pluck)(E.trfont, v),
            fontSize: (0, n.pluckNumber)(E.trfontsize, b) + "px",
            color: (0, n.convertColor)((0, n.pluck)(E.trfontcolor, y), 100),
            fontWeight: "normal",
            fontStyle: "normal"
          }, C.brLabelStyle = {
            fontFamily: (0, n.pluck)(E.brfont, v),
            fontSize: (0, n.pluckNumber)(E.brfontsize, b) + "px",
            color: (0, n.convertColor)((0, n.pluck)(E.brfontcolor, y), 100),
            fontWeight: "normal",
            fontStyle: "normal"
          }, C.blLabelStyle = {
            fontFamily: (0, n.pluck)(E.blfont, v),
            fontSize: (0, n.pluckNumber)(E.blfontsize, b) + "px",
            color: (0, n.convertColor)((0, n.pluck)(E.blfontcolor, y), 100),
            fontWeight: "normal",
            fontStyle: "normal"
          }, C.use3DLighting = (0, n.pluckNumber)(E.use3dlighting, 1), C.parentYAxis = (0, n.pluck)(N.parentyaxis && N.parentyaxis.toLowerCase(), p) === h ? 1 : 0, P || (P = this.components.data = []), f = 0; f < A; f++) {
            l = S && S[f], u = (c = P[f]) && c.config, c || (c = P[f] = {
              graphics: {}
            }), c.config || (u = P[f].config = {}), u.setValue = s = V.getCleanValue(l.value), I = Math.max(I, s), B = Math.min(B, s);
          }

          C.maxValue = I, C.minValue = B, this._setConfigure(), this.setState("dirty", !0);
        }, t.prototype._setConfigure = function () {
          var e,
              t,
              o,
              a,
              r,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              d,
              f,
              g,
              m,
              v,
              b,
              y,
              x,
              k,
              w,
              N,
              S,
              A,
              E,
              D,
              _,
              T,
              L,
              P,
              O,
              V,
              M,
              F,
              I,
              B,
              R,
              j,
              G = this,
              H = G.getFromEnv("chart"),
              W = G.config,
              z = G.config.JSONData,
              U = z.data,
              J = U && U.length,
              K = G.getFromEnv("chart-attrib"),
              q = G.getFromEnv("color-manager"),
              Y = G.index || G.positionIndex,
              X = W.showplotborder,
              Q = W.plotColor = q.getPlotColor(Y),
              Z = (0, n.pluckNumber)(K.showtooltip, 1),
              $ = (0, n.parseUnsafeString)(K.yaxisname),
              ee = (0, n.parseUnsafeString)(K.xaxisname),
              te = (0, n.parseUnsafeString)((0, n.pluck)(K.tooltipsepchar, ": ")),
              oe = (0, n.pluckNumber)(K.useplotgradientcolor, 1),
              ae = "",
              re = W.plotDashLen,
              ne = W.plotDashGap,
              ie = W.plotBorderThickness,
              le = W.isRoundEdges,
              se = W.showHoverEffect,
              ce = W.plotfillAngle,
              ue = W.plotFillAlpha,
              pe = W.plotFillRatio,
              he = W.plotBorderAlpha,
              de = W.plotBorderColor,
              fe = G.getFromEnv("chartColorRange"),
              ge = G.getFromEnv("xAxis"),
              me = G.getFromEnv("yAxis"),
              ve = W.mapByPercent = (0, n.pluckNumber)(fe.mapbypercent, 0),
              be = W.mapByCategory = (0, n.pluckNumber)(K.mapbycategory, 0),
              ye = fe && (0, n.pluckNumber)(fe.gradient),
              xe = G.components.data,
              ke = G.getFromEnv("number-formatter"),
              we = H.isBar,
              Ce = H.config.is3D,
              Ne = W.parentYAxis,
              Se = W.maxValue,
              Ae = W.minValue,
              Ee = (0, n.getValidValue)(K.tltype, n.BLANK),
              De = (0, n.getValidValue)(K.trtype, n.BLANK),
              _e = (0, n.getValidValue)(K.bltype, n.BLANK),
              Te = (0, n.getValidValue)(K.brtype, n.BLANK),
              Le = n.BLANK,
              Pe = n.BLANK,
              Oe = n.BLANK,
              Ve = n.BLANK,
              Me = H.getFromEnv("colorManager");

          if (A = Se - Ae, W.eventAttached || (G.addExtEventListener("legendUpdate", function (e, t) {
            if ("legend" === t.component) t.legendItem.hasState("hidden") ? G.show(t.legendItem, e) : G.hide(t.legendItem, e);else for (M = t.maxMinArray, F = M.length, S = 0; S < F; S++) {
              G.updatePlot(M[S].min, M[S].max);
            }
          }, Me), W.eventAttached = !0), (!ye || be) && (W.colorMap = [], fe.color)) for (S = 0; S < fe.color.length; S++) {
            W.colorMap[S] = {
              config: fe.color[S],
              dataSet: G
            }, W.colorMap[S].config.visible = !0;
          }

          for (S = 0; S < J; S++) {
            r = U && U[S], i = (s = (l = xe[S]) && l.config).setValue, s.showValue = (0, n.pluckNumber)(r.showvalue, W.showValues), s.setLink = (0, n.pluck)(r.link), s.toolTipValue = I = ke.dataLabels(i, Ne), s.setDisplayValue = N = (0, n.parseUnsafeString)(r.displayvalue), s.displayValue = (0, n.pluck)(N, I), B = (0, n.pluckNumber)(r.dashed), R = (0, n.pluckNumber)(r.dashlen, re), j = ne = (0, n.pluckNumber)(r.dashgap, ne), s.plotBorderDashStyle = 1 === B ? (0, n.getDashStyle)(R, j) : 0 === B ? "none" : W.plotBorderDashStyle, s.percentValue = ve ? P = r.value && Math.round((r.value - Ae) / A * 1e4) / 100 : void 0, s.value = V = be ? r.colorrangelabel || r.categoryid : ve ? P : s.setValue, E = Me.getColor(V), l.legendItemIndex = E.seriesIndex, s.legendItemId = E.legendItemId, E && !E.code && (E.code = "ffffff"), s.plotFillAlpha = ue = (0, n.pluckNumber)(r.alpha, E && E.oriAlpha, W.plotFillAlpha), Q = (0, n.pluck)(r.color, E && E.code), i < 0 && !le && (ce = we ? 180 - ce : 360 - ce), s.colorArr = (0, n.getColumnColor)(Q + "," + W.plotgradientcolor, ue.toString(), pe, ce, le, de, he.toString(), we ? 1 : 0, !!Ce), E && E.outOfRange ? (s.visible = !1, s.displayValue = n.BLANKSTRING) : (s.visible = !0, s.color = (0, n.convertColor)(Q, s.plotFillAlpha), 0 !== se && (p = (0, n.pluck)(r.hovercolor, z.hovercolor, K.plotfillhovercolor, K.columnhovercolor, Q), h = (0, n.pluck)(r.hoveralpha, z.hoveralpha, K.plotfillhoveralpha, K.columnhoveralpha, "25"), !(0, n.pluck)(r.hovergradientcolor, z.hovergradientcolor, K.plothovergradientcolor, !oe && n.BLANKSTRING) && n.BLANKSTRING, d = (0, n.pluck)(r.hoverratio, z.hoverratio, K.plothoverratio, pe), f = (0, n.pluckNumber)(360 - r.hoverangle, 360 - z.hoverangle, 360 - K.plothoverangle, ce), g = (0, n.pluck)(r.borderhovercolor, z.borderhovercolor, K.plotborderhovercolor, de), m = (0, n.pluck)(r.borderhoveralpha, z.borderhoveralpha, K.plotborderhoveralpha, he, ue), v = (0, n.pluckNumber)(r.borderhoverthickness, z.borderhoverthickness, K.plotborderhoverthickness, ie), b = (0, n.pluckNumber)(r.borderhoverdashed, z.borderhoverdashed, K.plotborderhoverdashed), y = (0, n.pluckNumber)(r.borderhoverdashgap, z.borderhoverdashgap, K.plotborderhoverdashgap, re), x = (0, n.pluckNumber)(r.borderhoverdashlen, z.borderhoverdashlen, K.plotborderhoverdashlen, ne), k = b ? (0, n.getDashStyle)(x, y) : W.plotBorderDashStyle, 1 == se && p === Q && (p = (0, n.getLightColor)(p, 70)), w = (0, n.getColumnColor)(p, h, d, f, le, g, m.toString(), we ? 1 : 0, !!Ce), s.setRolloutAttr = {
              fill: (0, n.toRaphaelColor)(s.color),
              stroke: X && (0, n.toRaphaelColor)(s.colorArr[1]) || C,
              "stroke-width": ie,
              "stroke-dasharray": []
            }, s.setRolloverAttr = {
              fill: (0, n.toRaphaelColor)(w[0]),
              stroke: X && (0, n.toRaphaelColor)(w[1]) || C,
              "stroke-width": v,
              "stroke-dasharray": k
            }), ve && (P = ke.percentValue(P)), s.setValue = i = ke.getCleanValue(r.value), s.toolTipValue = ke.dataLabels(i, Ne), e = s.toolTipValue, o = (0, n.getValidValue)((0, n.parseUnsafeString)((0, n.pluck)(r.tooltext, z.plottooltext, K.plottooltext))), s.tlLabel = D = (0, n.parseUnsafeString)((0, n.pluck)(r.tllabel, r.ltlabel)), s.trLabel = _ = (0, n.parseUnsafeString)((0, n.pluck)(r.trlabel, r.rtlabel)), s.blLabel = T = (0, n.parseUnsafeString)((0, n.pluck)(r.bllabel, r.lblabel)), s.brLabel = L = (0, n.parseUnsafeString)((0, n.pluck)(r.brlabel, r.rblabel)), N = (0, n.getValidValue)((0, n.parseUnsafeString)(r.displayvalue)), O = be ? N : (0, n.pluck)(r.displayvalue, e), s.displayValue = (0, n.pluck)(N, P, s.toolTipValue), Ee !== n.BLANK && (Le = "<b>" + Ee + te + "</b>"), De !== n.BLANK && (Pe = "<b>" + De + te + "</b>"), _e !== n.BLANK && (Oe = "<b>" + _e + te + "</b>"), Te !== n.BLANK && (Ve = "<b>" + Te + te + "</b>"), c = ge.getCategoryFromId(U[S].columnid.toLowerCase()), u = me.getCategoryFromId(U[S].rowid.toLowerCase()), Z && (null === e ? ae = !1 : void 0 !== o ? (a = [1, 2, 5, 6, 7, 14, 93, 94, 95, 96, 97, 98, 112, 113, 114, 115, 116, 117], t = {
              formattedValue: e,
              value: r.value,
              yaxisName: $,
              xaxisName: ee,
              displayValue: N,
              percentValue: ve ? P : n.BLANK,
              tlLabel: D,
              trLabel: _,
              blLabel: T,
              brLabel: L,
              rowLabel: u.tickObj && u.tickObj.label,
              columnLabel: c.tickObj && c.tickObj.label,
              percentDataValue: ve ? P : n.BLANK,
              trtype: De,
              tltype: Ee,
              brType: Te,
              blType: _e,
              colorRangeLabel: s.colorRangeLabel
            }, ae = (0, n.parseTooltext)(o, a, t, r, K, t)) : ae = (ve ? "<b>Value" + te + "</b>" + e + "<br /><b>Percentage" + te + "</b>" + P : O) + (D !== n.BLANK ? "<br />" + (Le + D) : n.BLANK) + (_ !== n.BLANK ? "<br />" + Pe + _ : n.BLANK) + (T !== n.BLANK ? "<br />" + Oe + T : n.BLANK) + (L !== n.BLANK ? "<br />" + Ve + L : n.BLANK)), s.toolText = ae, s.setTooltext = ae);
          }
        }, t.prototype.hide = function (e) {
          var t,
              o,
              a,
              r,
              n,
              i = this.components.data,
              l = this.getFromEnv("chart"),
              s = this.getFromEnv("animationManager"),
              c = l.getChildren("colorRange")[0];

          for (r = e.config.datasetObj.code, t = 0, o = i.length; t < o; t++) {
            Object.keys(i[t]).length && (n = c.getColorObj(i[t].config.value).code, a = i[t].config, r === n && (i[t].graphics.element && s.setAnimation({
              el: i[t].graphics.element,
              attr: {
                "fill-opacity": 0,
                "stroke-width": 0
              },
              component: this
            }), i[t].graphics.hotElement && i[t].graphics.hotElement.hide(), i[t].graphics.valEle && i[t].graphics.valEle.hide(), i[t].graphics.tlLabel && i[t].graphics.tlLabel.hide(), i[t].graphics.trLabel && i[t].graphics.trLabel.hide(), i[t].graphics.blLabel && i[t].graphics.blLabel.hide(), i[t].graphics.brLabel && i[t].graphics.brLabel.hide(), a.visible = !1, i[t].visible = !1));
          }

          e.setLegendState("hidden");
        }, t.prototype.show = function (e) {
          var t,
              o,
              a,
              r,
              n,
              i,
              l = this.components.data,
              s = this.config,
              c = this.getFromEnv("chart"),
              u = this.getFromEnv("animationManager"),
              p = c.getChildren("colorRange")[0];

          for (i = e.config.datasetObj.code, r = 0, n = l.length; r < n; r++) {
            Object.keys(l[r]).length && (o = (t = l[r].config).plotFillAlpha / 100, i === (!(a = p.getColorObj(l[r].config.value)).outOfRange && a.code) && (l[r].graphics.element && u.setAnimation({
              el: l[r].graphics.element,
              attr: {
                visibility: "visible"
              },
              component: this
            }), l[r].graphics.element && u.setAnimation({
              el: l[r].graphics.element,
              component: this,
              attr: {
                "fill-opacity": o,
                "stroke-width": s.plotBorderThickness
              }
            }), l[r].graphics.hotElement && l[r].graphics.hotElement.show(), l[r].graphics.valEle && l[r].graphics.valEle.show(), l[r].graphics.tlLabel && l[r].graphics.tlLabel.show(), l[r].graphics.trLabel && l[r].graphics.trLabel.show(), l[r].graphics.blLabel && l[r].graphics.blLabel.show(), l[r].graphics.brLabel && l[r].graphics.brLabel.show(), t.visible = !0, l[r].visible = !0));
          }

          e && e.removeLegendState("hidden");
        }, t.prototype.updatePlot = function () {
          var e,
              t,
              o,
              a,
              r,
              n = arguments[0],
              i = arguments[1],
              l = this.config,
              s = this.getFromEnv("animationManager"),
              c = this.components.data;

          for (o = 0, a = c.length; o < a; o++) {
            Object.keys(c[o]).length && (t = (e = c[o].config).plotFillAlpha / 100, (r = c[o].config.value) < n || r > i ? e.visible && (c[o].graphics.element && s.setAnimation({
              el: c[o].graphics.element,
              attr: {
                "fill-opacity": 0,
                "stroke-width": 0
              },
              component: this
            }), c[o].graphics.hotElement && c[o].graphics.hotElement.hide(), c[o].graphics.valEle && c[o].graphics.valEle.hide(), c[o].graphics.tlLabel && c[o].graphics.tlLabel.hide(), c[o].graphics.trLabel && c[o].graphics.trLabel.hide(), c[o].graphics.blLabel && c[o].graphics.blLabel.hide(), c[o].graphics.brLabel && c[o].graphics.brLabel.hide(), e.visible = !1, c[o].visible = !1) : e.visible || (c[o].graphics.element && s.setAnimation({
              el: c[o].graphics.element,
              attr: {
                "fill-opacity": t,
                "stroke-width": l.plotBorderThickness
              },
              callback: function callback() {
                this.show();
              },
              component: this
            }), c[o].graphics.hotElement && c[o].graphics.hotElement.show(), c[o].graphics.valEle && c[o].graphics.valEle.show(), c[o].graphics.tlLabel && c[o].graphics.tlLabel.show(), c[o].graphics.trLabel && c[o].graphics.trLabel.show(), c[o].graphics.blLabel && c[o].graphics.blLabel.show(), c[o].graphics.brLabel && c[o].graphics.brLabel.show(), e.visible = !0, c[o].visible = !0));
          }
        }, t.prototype._checkPointObj = function (e, t, o, a) {
          var r,
              n,
              i,
              l,
              s,
              c = this.components.plotGrid,
              u = this.getFromEnv("chartConfig"),
              p = u.viewPortConfig,
              h = p.x,
              d = p.scaleX,
              f = u.plotborderthickness,
              g = u.showplotborder;
          if (r = c[t] && c[t][e], n = (n = (f = g ? f : 0) / 2) % 2 == 0 ? n + 1 : Math.round(n), r && r.config && r.config.visible && (i = o - (r._xPos - h * d) + n, l = a - r._yPos + n, s = i >= 0 && i <= r._width + f && l >= 0 && l <= r._height + f)) return {
            pointIndex: r._index,
            hovered: s,
            pointObj: r
          };
        }, t.prototype._getHoveredPlot = function (e, t) {
          var o,
              a,
              r,
              n,
              i = this.getFromEnv("chartConfig"),
              l = this.getFromEnv("xAxis"),
              s = this.getFromEnv("yAxis"),
              c = i.canvasHeight / this.getFromEnv("totalRows");
          return e += l.getTranslation(), t += s.getTranslation(), a = s.getValue(t + c / 2), n = Math.floor(a), o = l.getValue(e), (r = Math.round(o)) - o > 0 ? a - n > .5 ? this._checkPointObj(r, n, e, t) || this._checkPointObj(r - 1, n, e, t) : this._checkPointObj(r, n - 1, e, t) || this._checkPointObj(r, n, e, t) : a - n > .5 ? this._checkPointObj(r + 1, n, e, t) || this._checkPointObj(r, n, e, t) : this._checkPointObj(r, n - 1, e, t) || this._checkPointObj(r + 1, n, e, t) || this._checkPointObj(r, n, e, t);
        }, t.prototype.parsePlotAttributes = function (e, t) {
          var o,
              a,
              r,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              g,
              m,
              v,
              b,
              y,
              x = this.config.JSONData,
              k = this.config,
              w = x.data,
              S = t,
              A = this.getState("visible"),
              E = this.getFromEnv("chart"),
              D = this.getFromEnv("xAxis"),
              _ = this.getFromEnv("yAxis"),
              T = this.getFromEnv("chartConfig"),
              L = T.showtooltip,
              P = this.components.data,
              O = _.getAxisBase(),
              V = (_.yBasePos = _.getPixel(O), k.plotBorderThickness),
              M = k.plotRadius,
              F = E.getFromEnv("legend") && E.getFromEnv("legend").config.isActive,
              I = this.components.plotGrid;

          e && Object.keys(e).length && (m = T.canvasWidth / this.getFromEnv("totalColumns"), l = T.canvasHeight / this.getFromEnv("totalRows"), y = e.trackerConfig = {}, u = (h = e && e.config).setValue, v = D.getCategoryFromId(w[S].columnid.toLowerCase()), b = _.getCategoryFromId(w[S].rowid.toLowerCase()), 0 !== v.index && !v.index || 0 !== b.index && !b.index || (k.mapByCategory || null !== u) && (c = h.setLink, g = h.colorArr, e.graphics || (P[S].graphics = {}), p = h.displayValue, a = D.getPixel(v.index) - m / 2, r = _.getPixel(b.index) - l / 2, i = m, s = h.toolText, y.eventArgs = {
            index: S,
            link: c,
            value: h.percentValue || u,
            displayValue: p,
            columnId: v.tickObj.id,
            rowId: b.tickObj.id,
            tlLabel: h.tlLabel,
            trLabel: h.trLabel,
            blLabel: h.blLabel,
            brLabel: h.brLabel,
            toolText: s || "",
            id: n.BLANKSTRING,
            datasetIndex: F ? e.datasetIndex : void 0,
            datasetName: F ? e.datasetName : void 0,
            visible: A
          }, o = {
            x: a,
            y: r,
            width: i,
            height: l || 1,
            r: M,
            fill: h.color,
            stroke: (0, n.toRaphaelColor)(g[1]),
            "stroke-width": V,
            "stroke-dasharray": void 0,
            "fill-opacity": h.plotFillAlpha / 100,
            "stroke-linejoin": d,
            visibility: h.visible ? "visible" : f,
            cursor: c ? "pointer" : n.BLANKSTRING
          }, e._xPos = a, e._yPos = r, e._height = l, e._width = i, e._index = S, I[b.index][v.index] = e, e.graphics.element ? ((o = {
            x: a,
            y: r,
            width: i,
            height: l || 1
          }).fill = h.color, o.stroke = (0, n.toRaphaelColor)(g[1]), o["fill-opacity"] = h.visible ? h.plotFillAlpha / 100 : 0, o["stroke-width"] = h.visible ? V : 0, o["stroke-dasharray"] = void 0, o["stroke-linejoin"] = d, o.visibility = h.visible ? "visible" : f, o.cursor = c ? "pointer" : n.BLANKSTRING) : (o["fill-opacity"] = h.plotFillAlpha / 100, o["stroke-width"] = V), (c || L) && (l < N && (r -= (N - l) / 2, l = N), y.attr = {
            x: a,
            y: r,
            width: i,
            height: l,
            r: M,
            cursor: c ? "pointer" : n.BLANKSTRING,
            stroke: C,
            "stroke-width": V,
            fill: C,
            visibility: h.visible ? "visible" : f
          }), h.props = {
            element: {
              attr: o
            }
          }));
        }, t.prototype.allocatePosition = function () {
          var e,
              t,
              o,
              a = this.config.JSONData.data,
              r = this.components.data;

          for (e = a && a.length, t = 0; t < e; t++) {
            o = r[t], this.parsePlotAttributes(o, t);
          }
        }, t.prototype.drawPlots = function () {
          var e,
              t,
              o,
              a,
              r,
              i,
              l,
              s,
              u,
              p,
              h,
              d = this.config.JSONData,
              f = this.config,
              m = d.data,
              v = this.getFromEnv("animationManager"),
              b = this.getState("visible"),
              y = this.getFromEnv("xAxis"),
              x = this.getFromEnv("yAxis"),
              k = this.getFromEnv("chartConfig"),
              w = this.components.data,
              C = f.showShadow,
              N = this.getContainer("plotGroup"),
              S = this.getContainer("shadowGroup"),
              A = [],
              E = (this.components.removeDataArr || []).length,
              D = f.showHoverEffect;

          for (e = m && m.length, t = 0; t < e; t++) {
            h = (o = w[t]).trackerConfig, i = o && o.config, o.graphics && (l = o.graphics.element ? b ? "updating" : "hiding" : "appearing", r = i.setValue, s = y.getCategoryFromId(m[t].columnid.toLowerCase()), u = x.getCategoryFromId(m[t].rowid.toLowerCase()), 0 !== s.index && !s.index || 0 !== u.index && !u.index ? o.graphics.element = o.graphics.element && v.setAnimation({
              el: o.graphics.element,
              component: this
            }) : (s.tickObj && u.tickObj && i.value !== n.BLANKSTRING || !o.graphics || (o.graphics.element = o.graphics.element && v.setAnimation({
              el: o.graphics.element,
              component: this
            })), f.mapByCategory || null !== r || !o.graphics ? (p = s.index.toString() + u.index.toString(), A.push(p), o.graphics.element ? (a = o.graphics.element, i.elemCreated = !1, v.setAnimation({
              el: a,
              state: l,
              attr: i.props.element.attr,
              component: this
            })) : (a = o.graphics.element = v.setAnimation({
              el: "rect",
              component: this,
              attr: i.props.element.attr,
              label: "rect",
              container: N
            }), i.elemCreated = !0), a.shadow({
              opacity: C
            }, S).data("BBox", void 0), k.enablemousetracking && a.data("eventArgs", h.eventArgs).data(g, D).data("setRolloverAttr", i.setRolloverAttr || {}).data("setRolloutAttr", i.setRolloutAttr || {})) : (o.graphics.element && o.graphics.element.hide(), o.graphics.hotElement && o.graphics.hotElement.hide())));
          }

          this.drawn ? this.drawLabel() : this.addJob("labelJob", this.drawLabel.bind(this), c.priorityList.label), this.drawn = !0, E && this.removeDataElems();
        }, t.prototype.drawLabel = function () {
          var e,
              t,
              o,
              a,
              r,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              d,
              g,
              x,
              C,
              N,
              S,
              A,
              E,
              D,
              _,
              T,
              L,
              P,
              O,
              V,
              M,
              F,
              I,
              B,
              R,
              j,
              G,
              H = this.getFromEnv("chartConfig"),
              W = this.getFromEnv("smartLabel"),
              z = this.getFromEnv("animationManager"),
              U = H.dataLabelStyle,
              J = this.config,
              K = (this.config.JSONData.data || []).length,
              q = this.components.data,
              Y = this.getContainer("labelGroup"),
              X = this.graphics.tlLabelContainer,
              Q = this.graphics.blLabelContainer,
              Z = this.graphics.trLabelContainer,
              $ = this.graphics.brLabelContainer;

          for (z.setAnimation({
            el: Y,
            attr: {
              opacity: 1
            },
            component: this,
            label: "text"
          }), X || (X = this.graphics.tlLabelContainer = w({
            name: "tlLabel"
          }, Y, this)), Q || (Q = this.graphics.blLabelContainer = w({
            name: "blLabel"
          }, Y, this)), Z || (Z = this.graphics.trLabelContainer = w({
            name: "trLabel"
          }, Y, this)), $ || ($ = this.graphics.brLabelContainer = w({
            name: "brLabel"
          }, Y, this)), c = J.tlLabelStyle, u = J.trLabelStyle, p = J.blLabelStyle, h = J.brLabelStyle, d = {
            fontFamily: c.fontFamily,
            fontSize: c.fontSize,
            lineHeight: c.lineHeight,
            fontWeight: c.fontWeight,
            fontStyle: c.fontStyle
          }, g = {
            fontFamily: u.fontFamily,
            fontSize: u.fontSize,
            lineHeight: u.lineHeight,
            fontWeight: u.fontWeight,
            fontStyle: u.fontStyle
          }, x = {
            fontFamily: p.fontFamily,
            fontSize: p.fontSize,
            lineHeight: p.lineHeight,
            fontWeight: p.fontWeight,
            fontStyle: p.fontStyle
          }, C = {
            fontFamily: h.fontFamily,
            fontSize: h.fontSize,
            lineHeight: h.lineHeight,
            fontWeight: h.fontWeight,
            fontStyle: h.fontStyle
          }, W.useEllipsesOnOverflow(H.useEllipsesWhenOverflow), W.setStyle(U), X.css(d), Q.css(x), Z.css(g), $.css(C), t = 0; t < K; t++) {
            void 0 !== (e = q[t]) && e.graphics && (G = (j = e && e.config).setValue, J.mapByCategory || null !== G ? (o = j.displayValue, N = e.graphics.element, S = e._width, A = e._height, E = e._xPos, D = e._yPos, W.setStyle(U), o = (_ = W.getSmartText(o, S, A, !1)).text, k(o) && o !== n.BLANK && j.showValue ? (a = D + .5 * A, r = E + .5 * S, s = {
              text: o,
              title: _.tooltext || n.BLANKSTRING,
              visibility: j.visible ? "visible" : f,
              fill: U.color,
              direction: j.textDirection,
              x: r,
              y: a,
              "text-bound": [U.backgroundColor, U.borderColor, U.borderThickness, U.borderPadding, U.borderRadius, U.borderDash]
            }, N ? e.graphics.valEle = z.setAnimation({
              el: e.graphics.valEle || "text",
              container: Y,
              component: this,
              label: "text",
              attr: s
            }) : e.graphics.valEle && (e.graphics.valEle = z.setAnimation({
              el: e.graphics.valEle,
              component: this
            })), T = j.tlLabel, L = j.trLabel, P = j.blLabel, O = j.brLabel, V = k(T) && T !== n.BLANK, M = k(L) && L !== n.BLANK, F = k(P) && P !== n.BLANK, I = k(O) && O !== n.BLANK, B = S * (V && M ? .5 : .9), R = .5 * (A - (_ && _.height || 0)), i = D + 4, V ? (W.setStyle(c), l = E, s = {
              text: o = (_ = W.getSmartText(T, B, R, !1)).text,
              title: _.tooltext || n.BLANKSTRING,
              visibility: j.visible ? "visible" : f,
              fill: c.color,
              "text-anchor": m,
              "vertical-align": v,
              direction: j.textDirection,
              x: l + 4,
              y: i,
              "text-bound": [c.backgroundColor, c.borderColor, c.borderThickness, c.borderPadding, c.borderRadius, c.borderDash]
            }, e.graphics.tlLabel = z.setAnimation({
              el: e.graphics.tlLabel || "text",
              component: this,
              attr: Object.assign(s, d),
              container: X
            })) : e.graphics.tlLabel && (e.graphics.tlLabel = z.setAnimation({
              el: e.graphics.tlLabel,
              component: this
            })), M ? (W.setStyle(u), l = E + S, s = {
              text: o = (_ = W.getSmartText(L, B, R, !1)).text,
              title: _.tooltext || n.BLANKSTRING,
              visibility: j.visible ? "visible" : f,
              fill: u.color,
              "text-anchor": b,
              "vertical-align": v,
              direction: j.textDirection,
              x: l - 4,
              y: i,
              "text-bound": [u.backgroundColor, u.borderColor, u.borderThickness, u.borderPadding, u.borderRadius, u.borderDash]
            }, e.graphics.trLabel = z.setAnimation({
              el: e.graphics.trLabel || "text",
              attr: Object.assign(s, g),
              container: Z,
              component: this
            })) : e.graphics.trLabel && (e.graphics.trLabel = z.setAnimation({
              el: e.graphics.trLabel,
              component: this
            })), i = D + A - 4, F ? (W.setStyle(p), l = E, s = {
              text: o = (_ = W.getSmartText(P, B, R, !1)).text,
              title: _.tooltext || n.BLANKSTRING,
              visibility: j.visible ? "visible" : f,
              fill: p.color,
              "text-anchor": m,
              "vertical-align": y,
              direction: j.textDirection,
              x: l + 4,
              y: i,
              "text-bound": [p.backgroundColor, p.borderColor, p.borderThickness, p.borderPadding, p.borderRadius, p.borderDash]
            }, e.graphics.blLabel = z.setAnimation({
              el: e.graphics.blLabel || "text",
              component: this,
              container: Q,
              attr: Object.assign(s, x)
            })) : e.graphics.blLabel && (e.graphics.blLabel = z.setAnimation({
              el: e.graphics.blLabel,
              component: this
            })), I ? (W.setStyle(p), l = E + S - 4, s = {
              text: o = (_ = W.getSmartText(O, B, R, !1)).text,
              title: _.tooltext || n.BLANKSTRING,
              visibility: j.visible ? "visible" : f,
              fill: h.color,
              "text-anchor": b,
              "vertical-align": y,
              direction: j.textDirection,
              x: l,
              y: i,
              "text-bound": [h.backgroundColor, h.borderColor, h.borderThickness, h.borderPadding, h.borderRadius, h.borderDash]
            }, e.graphics.brLabel = z.setAnimation({
              el: e.graphics.brLabel || "text",
              attr: Object.assign(s, C),
              container: $,
              component: this
            })) : e.graphics.brLabel && (e.graphics.brLabel = z.setAnimation({
              el: e.graphics.brLabel,
              component: this
            }))) : this.removeLabels(e)) : this.removeLabels(e));
          }

          this.labelDrawn = !0;
        }, t.prototype.removeLabels = function (e) {
          var t = this.getFromEnv("animationManager");
          e.graphics.valEle && (e.graphics.valEle = t.setAnimation({
            el: e.graphics.valEle,
            component: this
          })), e.graphics.tlLabel && (e.graphics.tlLabel = t.setAnimation({
            el: e.graphics.tlLabel,
            component: this
          })), e.graphics.trLabel && (e.graphics.trLabel = t.setAnimation({
            el: e.graphics.trLabel,
            component: this
          })), e.graphics.blLabel && (e.graphics.blLabel = t.setAnimation({
            el: e.graphics.blLabel,
            component: this
          })), e.graphics.brLabel && (e.graphics.brLabel = t.setAnimation({
            el: e.graphics.brLabel,
            component: this
          }));
        }, t.prototype.removeDataElems = function () {
          var e,
              t,
              o,
              a,
              r = this.getFromEnv("animationManager"),
              n = this.components,
              i = n.removeDataArr,
              l = n.pool || (n.pool = {
            element: [],
            hotElement: [],
            label: []
          }),
              s = i.length;

          for (a = 0; a < s; a++) {
            if (e = i[0], i.splice(0, 1), e && e.graphics) {
              for (t in o = e.graphics) {
                o[t] && (o[t] = r.setAnimation({
                  el: o[t],
                  component: this
                }));
              }

              e.graphics.element && (l.element = l.element.concat(e.graphics.element)), e.graphics.hotElement && (l.hotElement = l.hotElement.concat(e.graphics.hotElement)), e.graphics.label && (l.label = l.label.concat(e.graphics.label));
            }
          }

          n.pool = l;
        }, t.prototype.getAxisValuePadding = function () {
          return this.config.defaultPadding;
        }, t.prototype.getDataLimits = function () {
          var e,
              t,
              o = this.components.data,
              a = this.config,
              r = o.length,
              n = -Infinity,
              i = +Infinity;

          for (e = 0; e < r; e++) {
            o[e] && Object.keys(o[e]).length && void 0 !== (t = o[e].config.setValue) && null !== t && (n = S(n, t), i = A(i, t));
          }

          return a.maxValue = n, a.minValue = i, {
            max: a.maxValue,
            min: a.minValue
          };
        }, t.prototype.trimData = function (e) {
          if (this.config.JSONData) {
            var t = this.config,
                o = t && t.context,
                a = o && o.prevCatlen,
                r = this.getFromEnv("xAxis").getTicksLen(),
                n = a - r,
                i = t.JSONData,
                l = i.data && i.data.length,
                s = e.data && e.data.length || 0,
                c = l - s,
                u = void 0,
                p = void 0;
            n > c ? (u = n, p = r) : (u = c, p = s), u > 0 && this.removeData(p, u, !1);
          }
        }, t.prototype.draw = function () {
          var e = this.config,
              t = this.getFromEnv("xAxis"),
              o = t.getPixel(0),
              a = t.getPixel(1),
              r = this.getFromEnv("groupMaxWidth"),
              n = e.drawn;
          r || (r = E(a - o), this.addToEnv("groupMaxWidth", r)), !n && this.createContainer(), t.getState("scrolling") || this.createCoordinates(), this.drawPlots();
        }, t.prototype.createContainer = function () {
          var e,
              t,
              o = this.getType(),
              a = this.groupName,
              r = this.getFromEnv("chart"),
              n = this.getLinkedParent(),
              i = a || this.dsGroup || o;
          !n.getChildContainer(i + "VcanvasGroup") && (i = "default"), e = n.getChildContainer(i + "VcanvasGroup"), t = n.getChildContainer(i + "ShadowVcanvasGroup"), !this.getContainer("shadowGroup") && this.addContainer("shadowGroup", w({
            name: "shadow-group"
          }, t, this)), !this.getContainer("errorShadowGroup") && this.addContainer("errorShadowGroup", w({
            name: "error-shadow-group"
          }, t, this)), !this.getContainer("commonElemsGroup") && this.addContainer("commonElemsGroup", w({
            name: "common-elems-group"
          }, e, this)), !this.getContainer("plotGroup") && this.addContainer("plotGroup", w({
            name: "plot-group"
          }, e, this)), !this.getContainer("errorPlotGroup") && this.addContainer("errorPlotGroup", w({
            name: "error-plot-group"
          }, e, this)), r.hasAnchor && this.getContainer("errorPlotGroup").insertBefore(this.getContainer("plotGroup")), !this.getContainer("labelGroup") && this.addContainer("labelGroup", w({
            name: "label-group",
            "class": "fusioncharts-datalabels"
          }, n.getChildContainer("vcanvasLabelGroup"), this));
        }, t.prototype.createCoordinates = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              i,
              l = this.components.data,
              s = this.getFromEnv("chart"),
              c = s.isBar,
              u = this.getFromEnv("yAxis"),
              p = this.getFromEnv("xAxis"),
              h = u.getAxisBase(),
              d = u.getPixel(h),
              f = p.config.isVertical,
              g = s.config.xDepth || 0,
              m = s.config.yDepth || 0,
              v = l.length,
              b = this.components,
              y = this.getLinkedParent(),
              x = y.getstackConf && y.getstackConf(),
              k = b.data;

          for (!c && (g = -g), c && (m = -m), a = 0; a < v; a++) {
            t = (e = k[a]) && e.config, void 0 !== e && (o = t._b, r = p.getPixel(x && x[a].x || t._x) + g, n = u.getPixel(t._y) + m, i = (o ? u.getPixel(o) : d) + m, f ? (t._Px = n, t._Py = r, t._Pby = r, t._Pbx = i) : (t._Px = r, t._Py = n, t._Pby = i, t._Pbx = r), this.getLineShift && (t._Py += this.getLineShift("y")));
          }
        }, t.prototype._decideTooltipType = function (e, t) {
          var o = this.getLinkedParent(),
              a = this.getFromEnv("chart").config.drawTrendRegion,
              r = this.components,
              n = this.getFromEnv("toolTipController"),
              i = r.data[e],
              l = i && (i.config.finalTooltext || i.config.toolText),
              s = i && (i.graphics.element || this.graphics.sharedAnchor.element),
              c = this.config.currentToolTip,
              u = t.originalEvent;
          a && s ? this.config.currentToolTip = o._drawTooltip(e, this.config.index, u, c) : l && !a && (c ? n.draw(u, l, c) : c = this.config.currentToolTip = n.draw(u, l));
        }, t.prototype._firePlotEvent = function (e, t, o) {
          var a,
              r = this.getFromEnv("chart"),
              n = this.components,
              i = this.getFromEnv("toolTipController"),
              l = n.data[t],
              s = l.graphics.element,
              c = this.config.currentToolTip;
          if (s) switch (a = l.config.setLink, e) {
            case "fc-mouseover":
              this._decideTooltipType(t, o), function (e, t, o, a, r) {
                var n = t.graphics,
                    i = e.getFromEnv("animationManager"),
                    l = n && n.element,
                    s = l && l.getData();
                !0 !== s.draged && (i.setAnimationState("mouseOver"), l && 0 !== s.showHoverEffect && i.setAnimation({
                  el: l,
                  attr: l.getData().setRolloverAttr,
                  component: r
                }), !a && l && e.plotEventHandler(l, o, "DataPlotRollOver"));
              }(r, l, o, void 0, this), a && (s.node.style.cursor = "pointer");
              break;

            case "fc-mouseout":
              i.hide(c), function (e, t, o, a, r) {
                var n = t.graphics,
                    i = e.getFromEnv("animationManager"),
                    l = n && n.element,
                    s = l && l.getData();
                !0 !== s.draged && (i.setAnimationState("mouseOut"), l && 0 !== s.showHoverEffect && i.setAnimation({
                  el: l,
                  attr: l.getData().setRolloutAttr,
                  component: r
                }), !a && l && e.plotEventHandler(l, o, "DataPlotRollOut"));
              }(r, l, o, void 0, this), a && (s.node.style.cursor = x);
              break;

            case "fc-click":
              r.plotEventHandler(s, o);
              break;

            case "fc-mousemove":
              this._decideTooltipType(t, o);

          }
        }, t.prototype.removeData = function (e, t, o) {
          var a,
              r,
              n,
              i = this.getFromEnv("chart"),
              l = this.components,
              s = l.data,
              c = l.removeDataArr || (l.removeDataArr = []),
              u = this.config,
              p = this.maxminFlag;

          for (void 0 === t && (t = 1), (e = e || 0) + t !== s.length && i.isRealTime ? 0 !== e && void 0 !== e || (this.endPosition = !1) : this.endPosition = !0, l.removeDataArr = c = c.concat(s.splice(e, t)), a = (n = c.length) - 1; a >= 0; a--) {
            if (c[a]) {
              if ((r = c[a].config).setValue !== u.maxValue && r.setValue !== u.minValue || (p = this.maxminFlag = !0), r._x -= t, p) break;
            } else c.splice(a, 1);
          }

          this.removeDataLen = n, this.resetCatPos && this.resetCatPos(), p && this.getDataLimits && this.getDataLimits(), o && this.asyncDraw();
        }, t;
      }(r.ComponentInterface);

      t["default"] = D;
    },
    945: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = {
        "initial.dataset.heatMap": function initialDatasetHeatMap() {
          return {
            "rect.appearing": function rectAppearing() {
              return [{
                initialAttr: {
                  opacity: 0
                },
                finalAttr: {
                  opacity: 1
                },
                slot: "plot"
              }];
            },
            "text.appearing": function textAppearing() {
              return [{
                initialAttr: {
                  opacity: 0
                },
                finalAttr: {
                  opacity: 1
                },
                slot: "final"
              }];
            },
            "*": null
          };
        }
      };
    },
    946: function _(e, t, o) {
      "use strict";

      function a(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      t.__esModule = !0;

      var r = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.setState("visible", !0), o.getDataLimits = null, o;
        }

        return a(t, e), t.prototype.getType = function () {
          return "group";
        }, t.prototype.getName = function () {
          return "heatMapGroup";
        }, t.prototype.createContainer = function () {
          var e = void 0,
              t = this.getLinkedParent(),
              o = this.getFromEnv("animationManager"),
              a = void 0,
              r = t.getChildContainer();

          for (e in r) {
            a = r[e], !this.getChildContainer(e) && this.addChildContainer(e, o.setAnimation({
              el: "group",
              attr: {
                name: "manager-" + e
              },
              container: a,
              component: this,
              label: "group"
            }));
          }
        }, t.prototype.getLimits = function (e) {
          var t = +Infinity,
              o = -Infinity,
              a = void 0,
              r = 0,
              n = function n(e) {
            o = Math.max(o, e.max), t = Math.min(t, e.min);
          };

          return this._mapChildren(function (t) {
            t.getState("removed") || !1 === t.getState("visible") ? e && (a = t.getDataLimits(e), n(a)) : (r++, a = t.getDataLimits(e), n(a));
          }), r ? this.setState("visible", !0) : this.setState("visible", !1), this.config.range || (this.config.range = {}, this.config.range.min = this.config.dataMin, this.config.range.max = this.config.dataMax), {
            max: o,
            min: t
          };
        }, t.prototype.draw = function () {
          var e = this.getLimits(!0);
          this.addToEnv("datasetMinValue", e.min), this.addToEnv("datasetMaxValue", e.max), this.createContainer();
        }, t.prototype.getAxisValuePadding = function () {
          var e = {},
              t = -Infinity,
              o = -Infinity,
              a = -Infinity,
              r = -Infinity;
          return this._mapChildren(function (n) {
            n.getState("removed") || (e = n.getAxisValuePadding && n.getAxisValuePadding() || {}, t = Math.max(t, e.left || -Infinity), o = Math.max(o, e.right || -Infinity), a = Math.max(a, e.top || -Infinity), r = Math.max(r, e.bottom || -Infinity));
          }), t === -Infinity && (t = 0), o === -Infinity && (o = 0), a === -Infinity && (a = 0), r === -Infinity && (r = 0), this.config.padding || (this.config.padding = {}, this.config.padding.left = t, this.config.padding.right = o, this.config.padding.top = a, this.config.padding.bottom = r), {
            left: t,
            right: o,
            top: a,
            bottom: r
          };
        }, t;
      }(o(138).ComponentInterface);

      t["default"] = r;
    },
    947: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = function (e) {
        var t = e.getChildren("canvas")[0],
            o = t.getChildren("axisRefVisualCartesian")[0],
            a = {
          zoomable: !0,
          pannable: !0
        },
            n = e._feedAxesRawData(),
            l = void 0,
            s = void 0,
            c = function c() {
          return o.asyncDraw();
        };

        (0, r.componentFactory)(e, i["default"], "yAxis", 1, n.yAxisConf), (0, r.componentFactory)(e, i["default"], "xAxis", 1, n.xAxisConf), l = e.getChildren("yAxis")[0], s = e.getChildren("xAxis")[0], l.setLinkedItem("canvas", t), s.setLinkedItem("canvas", t), o.setLinkedItem(l.getId(), l), o.setLinkedItem(s.getId(), s), o.addExtEventListener("visiblerangeset", c, s), o.addExtEventListener("visiblerangeset", c, l), t.attachAxis(s, !1, e.zoomX ? a : {}), t.attachAxis(l, !0, e.zoomY ? a : {}), e._setCategories();
      };
      var a,
          r = o(125),
          n = o(422),
          i = (a = n) && a.__esModule ? a : {
        "default": a
      };
    },
    954: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(955),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    955: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = s(o(550)),
          r = s(o(956)),
          n = s(o(959)),
          i = s(o(963)),
          l = o(125);

      function s(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function c(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var u = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.registerFactory("canvas", i["default"]), o.registerFactory("axis", n["default"], ["canvas"]), o;
        }

        return c(t, e), t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this);

          var t = this.config;
          t.axisType = "polar", t.axisValuePadding = 10, t.gridLineWidth = 1, t.showRadarBorder = 1, t.showvalues = 0, t.radarBorderThickness = 2, t.skipCanvasDrawing = !0, t.useplotgradientcolor = 0, t.plotfillalpha = 50;
        }, t.prototype.setAxisDimention = function () {
          var e = this.getChildren("yAxis") && this.getChildren("yAxis")[0],
              t = this.config;
          e && e.setAxisDimention({
            x: t.canvasLeft + t.canvasWidth / 2,
            y: t.canvasTop,
            axisLength: t.canvasHeight / 2
          });
        }, t.prototype._feedAxesRawData = function () {
          var e,
              t,
              o = this.getFromEnv("dataSource");
          return e = this.getSpecificxAxisConf(), t = this.getSpecificyAxisConf(), e.vtrendlines = o.vtrendlines, t.trendlines = o.trendlines, {
            xAxisConf: [e],
            yAxisConf: [t]
          };
        }, t.prototype.getSpecificxAxisConf = function () {
          var e = this.getFromEnv("chart-attrib"),
              t = this.config,
              o = this.getBasexAxisConf();
          return o.isReverse = t.reverseXAxis, o.axisLineColor = (0, l.pluck)(e.xaxislinecolor, e.axislinecolor, "#000000"), o.showAlternateGridColor = (0, l.pluckNumber)(e.showalternatevgridcolor, 1), o.numDivLines = e.numvdivlines, o.axisName = e.xaxisname, o.setAdaptiveMin = e.setadaptivexmin, o.showLimits = e.showvlimits, o.showDivLineValues = (0, l.pluckNumber)(e.showvdivlinevalues, e.showvdivlinevalues), o.zeroPlaneThickness = e.vzeroplanethickness, o.zeroPlaneAlpha = e.vzeroplanealpha, o.showZeroPlaneValue = e.showvzeroplanevalue, o.showAxisLine = (0, l.pluckNumber)(e.showxaxisline, e.showaxislines, e.drawAxisLines, 0), o.showRadarBorder = e.showradarborder, o.radarBorderColor = e.radarbordercolor, o.radarBorderThickness = e.radarborderthickness, o.radarBorderAlpha = e.radarborderalpha, o.radarFillColor = e.radarfillcolor, o.radarFillAlpha = e.radarfillalpha, o.radarSpikeColor = e.radarspikecolor, o.radarSpikeThickness = e.radarspikethickness, o.radarSpikeAlpha = e.radarspikealpha, o.radarInLineAlpha = e.radarinlinealpha, o.showTooltip = (0, l.pluckNumber)(e.showtooltip, 1), o;
        }, t.prototype.getSpecificyAxisConf = function () {
          var e = this.getFromEnv("chart-attrib"),
              t = this.config,
              o = this.config.is3D ? l.chartPaletteStr.chart3D : l.chartPaletteStr.chart2D,
              a = t.isInverse,
              r = this.getFromEnv("color-manager");
          return {
            isVertical: !0,
            isReverse: !a,
            isOpposit: !1,
            outCanfontFamily: (0, l.pluck)(e.outcnvbasefont, e.basefont, "Verdana,sans"),
            outCanfontSize: (0, l.pluckFontSize)(e.outcnvbasefontsize, e.basefontsize, 10),
            outCancolor: (0, l.pluck)(e.outcnvbasefontcolor, e.basefontcolor, r.getColor(o.baseFontColor)).replace(/^#? ([a-f0-9]+)/gi, "#$1"),
            axisNamePadding: e.yaxisnamepadding,
            axisValuePadding: e.yaxisvaluespadding,
            axisNameFont: e.yaxisnamefont,
            axisNameFontSize: e.yaxisnamefontsize,
            axisNameFontColor: e.yaxisnamefontcolor,
            axisNameFontBold: e.yaxisnamefontbold,
            axisNameFontItalic: e.yaxisnamefontitalic,
            axisNameBgColor: e.yaxisnamebgcolor,
            axisNameBorderColor: e.yaxisnamebordercolor,
            axisNameAlpha: e.yaxisnamealpha,
            axisNameFontAlpha: e.yaxisnamefontalpha,
            axisNameBgAlpha: e.yaxisnamebgalpha,
            axisNameBorderAlpha: e.yaxisnameborderalpha,
            axisNameBorderPadding: e.yaxisnameborderpadding,
            axisNameBorderRadius: e.yaxisnameborderradius,
            axisNameBorderThickness: e.yaxisnameborderthickness,
            axisNameBorderDashed: e.yaxisnameborderdashed,
            axisNameBorderDashLen: e.yaxisnameborderdashlen,
            axisNameBorderDashGap: e.yaxisnameborderdashgap,
            axisNameWidth: e.yaxisnamewidth,
            useEllipsesWhenOverflow: e.useellipseswhenoverflow,
            rotateAxisName: (0, l.pluckNumber)(e.rotateyaxisname, 1),
            divLineColor: (0, l.pluck)(e.divlinecolor, r.getColor(o.divLineColor)),
            divLineAlpha: (0, l.pluck)(e.divlinealpha, r.getColor("divLineAlpha")),
            divLineThickness: (0, l.pluckNumber)(e.divlinethickness, 1),
            divLineIsDashed: Boolean((0, l.pluckNumber)(e.divlinedashed, e.divlineisdashed, 0)),
            divLineDashLen: (0, l.pluckNumber)(e.divlinedashlen, 4),
            divLineDashGap: (0, l.pluckNumber)(e.divlinedashgap, 2),
            showAlternateGridColor: (0, l.pluckNumber)(e.showalternatehgridcolor, 1),
            alternateGridColor: (0, l.pluck)(e.alternatehgridcolor, r.getColor("altHGridColor")),
            alternateGridAlpha: (0, l.pluck)(e.alternatehgridalpha, r.getColor("altHGridAlpha")),
            numDivLines: e.numdivlines,
            axisMinValue: e.yaxisminvalue,
            axisMaxValue: e.yaxismaxvalue,
            setAdaptiveMin: e.setadaptiveymin,
            adjustDiv: e.adjustvdiv,
            labelStep: e.yaxisvaluesstep,
            showAxisValues: (0, l.pluckNumber)(e.showyaxisvalues, e.showyaxisvalue),
            showLimits: (0, l.pluckNumber)(e.showyaxislimits, e.showlimits, this.showLimits),
            showDivLineValues: (0, l.pluckNumber)(e.showdivlinevalues, e.showdivlinevalue),
            zeroPlaneColor: e.zeroplanecolor,
            zeroPlaneThickness: (0, l.pluckNumber)(e.zeroplanethickness, e.divlinethickness, 2),
            zeroPlaneAlpha: e.zeroplanealpha,
            showZeroPlaneValue: e.showzeroplanevalue,
            trendlineColor: e.trendlinecolor,
            trendlineToolText: e.trendlinetooltext,
            trendlineThickness: e.trendlinethickness,
            trendlineAlpha: e.trendlinealpha,
            showTrendlinesOnTop: e.showtrendlinesontop,
            axisLineThickness: (0, l.pluckNumber)(e.yaxislinethickness, e.axislinethickness, 1),
            axisLineAlpha: (0, l.pluckNumber)(e.yaxislinealpha, e.axislinealpha, 100),
            axisLineColor: (0, l.pluck)(e.yaxislinecolor, e.axislinecolor, "#000000"),
            showTooltip: (0, l.pluckNumber)(e.showtooltip, 1)
          };
        }, t.prototype._spaceManager = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              i,
              s = this.config,
              c = s.radarBorderThickness,
              u = s.legendposition,
              p = this.getChildren("xAxis") && this.getChildren("xAxis")[0],
              h = (this.getChildren("yAxis") && this.getChildren("yAxis") || [])[0],
              d = s.hasLegend,
              f = this.getChildren("legend") && this.getChildren("legend")[0],
              g = l.preDefStr.POSITION_BOTTOM,
              m = Math,
              v = m.min,
              b = m.abs;
          r = u === g ? .3 * s.canvasHeight : .3 * s.canvasWidth, !1 !== d && p && s.showLegend && this._allocateSpace(f._manageLegendPosition(r)), a = .7 * s.canvasHeight, o = .7 * s.canvasWidth, p && this._allocateSpace(p.placeAxis(o, a)), o = .7 * s.canvasWidth, h && h.placeAxis(o), e = .225 * s.availableHeight, t = this._manageActionBarSpace && (this._manageActionBarSpace(e) || {}), this._allocateSpace(t), n = s.radarradius > 0 ? 2 * s.radarradius : v(s.canvasHeight, s.canvasWidth), s.canvasHeight > n && (i = b((s.canvasHeight - n) / 2), this._allocateSpace({
            top: i,
            bottom: i
          })), s.canvasWidth > n && (i = b((s.canvasWidth - n) / 2), this._allocateSpace({
            left: i,
            right: i
          })), a = u === g ? .6 * s.availableHeight : .6 * s.availableWidth, this._manageChartMenuBar(a), h.setAxisDimention({
            x: s.canvasLeft + s.canvasWidth / 2 - c / 2,
            y: s.canvasTop,
            axisLength: s.canvasHeight / 2
          }), p.setAxisConfig({
            radius: v(s.canvasWidth / 2, s.canvasHeight / 2) - c / 2
          }), p.setAxisDimention({
            x: s.canvasLeft + s.canvasWidth / 2,
            y: s.canvasTop + s.canvasHeight / 2
          });
        }, t.getName = function () {
          return "Radar";
        }, t.prototype.getName = function () {
          return "Radar";
        }, t.prototype.getDSdef = function () {
          return r["default"];
        }, t;
      }(a["default"]);

      t["default"] = u;
    },
    956: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = s(o(450)),
          r = s(o(957)),
          n = o(132),
          i = o(958),
          l = o(125);

      function s(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function c(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var u = l.regex.dropHash;
      (0, n.addDep)({
        name: "radarAnimation",
        type: "animationRule",
        extension: r["default"]
      });

      var p = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return c(t, e), t.prototype.getName = function () {
          return "radar";
        }, t.prototype.createCoordinates = function () {
          var e,
              t,
              o,
              a,
              r,
              n,
              l,
              s,
              c = this.components.data,
              u = this.getFromEnv("chart").config,
              p = this.getFromEnv("yAxis"),
              h = this.getFromEnv("xAxis"),
              d = c.length,
              f = this.components.data;

          for (o = 0; o < d; o++) {
            s = (t = (e = f[o]) && e.config).setValue, void 0 !== e && (l = p.getPixel(s + 0), r = (n = (0, i.getCoordinates)({
              radius: u.canvasTop + u.canvasHeight / 2 - l,
              theta: o
            }, h)).y, a = n.x, t._Px = a, t._Py = r, t._Pbx = a, t._Pby = r);
          }
        }, t.prototype.getLinePath = function (e, t, o) {
          var a,
              r,
              n,
              l,
              s,
              c = this.getFromEnv("chart").config,
              u = {},
              p = u.lastValidValue || !1,
              h = u.temp || [],
              d = u.temp2 || [],
              f = u.pathArr || [],
              g = e.length,
              m = u.pointsJoined || 0,
              v = t && t.begin || 0,
              b = t && t.end || g,
              y = c.viewPortConfig.step || 1,
              x = this.getFromEnv("yAxis"),
              k = this.getFromEnv("xAxis"),
              w = x.getPixel(0),
              C = (this.removeDataLen, []);

          for (0, C = C.concat(e), a = v; a < b + 0; a += y) {
            (s = C[a]) && (null === (r = s.config).setValue || r && !0 === r.isSkipped ? (n = (0, i.getCoordinates)({
              theta: k.getLimit().min
            }, k).x, l = x.getPixel(x.config.axisRange.min)) : (n = r._Px, l = r._Py), "zero" === o ? l = w : "base" === o && (l = r._Pby), p ? (h.length && (f = f.concat(h), h = [], m++), f.push(["L", n, l])) : (h.push(["M", n, l]), m = 0, p = !0));
          }

          return "Z" !== f[f.length - 1] && m > 0 && f.push("Z"), {
            pathArr: f,
            path2Arr: [],
            lastValidValue: p,
            pointsJoined: m,
            temp: h,
            temp2: d,
            getPathArr: function getPathArr() {
              var e = this.pathArr,
                  t = this.path2Arr;
              return e.length || t.length ? e.concat(t) : [];
            }
          };
        }, t.prototype.configureAttributes = function (t) {
          if (!t) return !1;
          this.trimData(t), this.JSONData = t;
          var o = this.config,
              a = this.getFromEnv("chart"),
              r = this.index,
              n = a.getFromEnv("dataSource").chart,
              i = this.getFromEnv("color-manager"),
              s = this.JSONData,
              c = i.getPlotColor(r);
          e.prototype.configureAttributes.call(this, t), o.defaultPadding = {
            left: 0,
            right: 0
          }, o.plotfillcolor = (0, l.pluck)(s.color, n.plotfillcolor, c), o.plotbordercolor = (0, l.pluck)(s.plotbordercolor, n.plotbordercolor, n.areabordercolor, c).split(",")[0], o.fillColor = {
            color: o.plotfillcolor + (o.plotgradientcolor ? "," + o.plotgradientcolor : l.BLANKSTRING),
            alpha: o.plotfillalpha,
            angle: o.plotfillangle
          }, o.legendSymbolColor = o.plotfillcolor;
        }, t.prototype._getHoveredPlot = function (e, t) {
          var o,
              a,
              r,
              n,
              l = this.getFromEnv("xAxis"),
              s = this.components.data,
              c = s.length,
              u = this.config,
              p = 360 / c;

          for (a = Math.floor(Math.max((0, i.getPlotFromPixel)({
            x: e - u.maxRadius,
            y: t
          }, l) / p - 1, 0)), n = Math.floor(Math.max((0, i.getPlotFromPixel)({
            x: e + u.maxRadius,
            y: t
          }, l) / p, c - 1)); n >= a && (!(o = s[n]) || !(r = this.isWithinShape(o, n, e, t))); n--) {
            ;
          }

          return r;
        }, t.prototype._contextChanged = function () {
          this.config.context || (this.config.context = {});
          var t,
              o,
              a = this.config.context,
              r = this.getFromEnv("xAxis"),
              n = a.axisCenterX;
          return t = !((o = r.config.axisDimention.centerX) === n), a.axisCenterX = o, t || e.prototype._contextChanged.call(this);
        }, t.prototype.getPlotInCategoryAt = function (e, t) {
          var o = this.components.data,
              a = this.getFromEnv("xAxis"),
              r = this.getState("visible"),
              n = Math.round((0, i.getPlotFromPixel)({
            x: e,
            y: t
          }, a)),
              l = o.find(function (e, t, o) {
            var r,
                l,
                s,
                c,
                u = void 0,
                p = void 0;
            return 0 === t ? (u = o[t + 1], p = o[o.length - 1]) : t === o.length - 1 ? (u = o[0], p = o[o.length - 2]) : (u = o[t + 1], p = o[t - 1]), r = (0, i.getPlotFromPixel)({
              x: e.config._Px,
              y: e.config._Py
            }, a), l = t === o.length - 1 ? 360 : (0, i.getPlotFromPixel)({
              x: u.config._Px,
              y: u.config._Py
            }, a), s = (0, i.getPlotFromPixel)({
              x: p.config._Px,
              y: p.config._Py
            }, a), n <= 0 + (c = (l - r) / 2) ? n >= 0 && n <= 0 + c : n > 360 - c ? n >= 360 - c && n <= 360 : n >= s + c && n <= l - c;
          }),
              s = this._getHoveredPlot(e, t);

          return r && s ? s : !(!r || !l) && {
            pointIndex: l._index,
            hovered: !1,
            pointObj: l
          };
        }, t.prototype._addLegend = function () {
          var e,
              t,
              o,
              a,
              r = this.config,
              n = this.getFromEnv("chart-attrib"),
              i = this.getFromEnv("legend"),
              s = r.legendSymbolColor,
              c = (0, l.pluckNumber)(n.use3dlighting, n.useplotgradientcolor, 1);
          e = (0, l.getLightColor)(s, 60).replace(u, l.HASHSTRING), t = c ? {
            FCcolor: {
              color: s + "," + s + "," + (0, l.getLightColor)(s, 40) + "," + s + "," + s,
              ratio: "0,70,30",
              angle: 270,
              alpha: "100,100,100,100,100"
            }
          } : {
            FCcolor: {
              color: s,
              angle: 0,
              ratio: "0",
              alpha: "100"
            }
          }, o = {
            enabled: r.includeInLegend,
            type: this.type,
            label: (0, l.getFirstValue)(this.JSONData.seriesname)
          }, r.includeinlegend ? ((a = i.getItem(this.config.legendItemId)) || (this.config.legendItemId = i.createItem(this), a = i.getItem(this.config.legendItemId), this.addExtEventListener("fc-click", function () {
            a.itemClickFn();
          }, a)), a.configure(o), a.setStateCosmetics("default", {
            symbol: {
              fill: (0, l.toRaphaelColor)(t),
              rawFillColor: s,
              stroke: (0, l.toRaphaelColor)(e)
            }
          }), this.getState("visible") ? a.removeLegendState("hidden") : a.setLegendState("hidden")) : this.config.legendItemId && i.disposeItem(this.config.legendItemId);
        }, t.prototype.getOldPath = function (e, t) {
          var o,
              a = t.x,
              r = t.y,
              n = this.config && this.config.prevLim,
              i = n.x,
              s = n.y,
              c = 0,
              u = e.pathArr.length,
              p = function p(e) {
            return (e = ((e = (e = (e - i.minPixel.x) / (i.maxPixel.x - i.minPixel.x)) * (i.max - i.min) + i.min) - a.min) / (a.max - a.min)) * (a.maxPixel.x - a.minPixel.x) + a.minPixel.x + 1;
          },
              h = function h(e) {
            return e === s.base ? r.base : function (e) {
              return (e < s.base && e > r.base || e > s.base && e < r.base) && (e = r.base), e - 1;
            }(e);
          };

          if (s.min === r.min && i.min === a.min && s.max === r.max && i.max === a.max) return e;
          if (e = (0, l.extend2)({}, e), !n) return [];

          for (e.pathArr = e.pathArr.slice(0), e.path2Arr = e.path2Arr.slice(0), c = u; c--;) {
            (o = e.pathArr[c].slice(0))[1] && o.join && (o[1] = p(o[1]), o[2] = h(o[2]), e.pathArr[c] = o);
          }

          for (c = e.path2Arr.length; c--;) {
            (o = e.path2Arr[c].slice(0))[1] && o.join && (o[1] = p(o[1]), o[2] = h(o[2]), e.path2Arr[c] = o);
          }

          return e;
        }, t.prototype._setConfigure = function () {
          var e,
              t,
              o,
              a,
              r = this.config,
              n = this.config.JSONData.data || [],
              i = this.getFromEnv("xAxis").getTicksLen();

          for (r.imageCount = 0, (o = this.components.data) || (o = this.components.data = []), r.maxRadius = -Infinity, a = 0; a < i; a++) {
            t = o[a], e = n && n[a] || {}, t || (t = o[a] = {}), t.config || (o[a].config = {}), t.graphics || (t.graphics = {}), this._plotConfigure(a, e);
          }
        }, t;
      }(a["default"]);

      t["default"] = p;
    },
    957: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = o(958);
      t["default"] = {
        "initial.dataset.radar": function initialDatasetRadar() {
          return {
            "anchor.appearing": function anchorAppearing() {
              return [{
                initialAttr: {
                  opacity: 0
                },
                finalAttr: {
                  opacity: 1
                },
                startEnd: {
                  start: .5,
                  end: 1
                },
                slot: "plot"
              }];
            },
            "anchor.updating": function anchorUpdating() {
              return [{
                initialAttr: {
                  opacity: 0
                },
                finalAttr: {
                  opacity: 1
                },
                slot: "final"
              }];
            },
            "anchor.disappearing": function anchorDisappearing() {
              return [{
                finalAttr: {
                  opacity: 0,
                  "fill-opacity": 0,
                  "stroke-opacity": 0
                },
                slot: "final"
              }];
            },
            "line.appearing": function lineAppearing(e) {
              var t = e.component,
                  o = t.getFromEnv("xAxis"),
                  r = t.getFromEnv("yAxis"),
                  n = o.getTicksLen(),
                  i = t.getFromEnv("chartConfig"),
                  l = e.attr,
                  s = i.canvasTop + i.canvasHeight / 2,
                  c = [],
                  u = void 0;

              for (u = 0; u < n; u++) {
                c.push(u ? "L" : "M"), c.push((0, a.getCoordinates)({
                  radius: s,
                  theta: 0
                }, o).x), c.push(r.getPixel(0));
              }

              return c.push("Z"), [{
                initialAttr: {
                  opacity: 0,
                  path: c
                },
                finalAttr: {
                  opacity: 1,
                  path: l.path
                },
                startEnd: {
                  start: 0,
                  end: .5
                },
                slot: "middle"
              }];
            },
            "label.appearing": [{
              initialAttr: {
                opacity: 0
              },
              finalAttr: {
                opacity: 1
              },
              slot: "final"
            }],
            "*": null
          };
        }
      };
    },
    959: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = function (e) {
        var t = e.getChildren("canvas")[0],
            o = e._feedAxesRawData(),
            i = t.getChildren("axisRefVisualPolar")[0],
            l = void 0,
            s = void 0,
            c = function c() {
          return i.asyncDraw();
        };

        (0, n.componentFactory)(e, a["default"], "yAxis", 1, o.yAxisConf), (0, n.componentFactory)(e, r["default"], "xAxis", 1, o.xAxisConf), l = e.getChildren("yAxis")[0], s = e.getChildren("xAxis")[0], l.setLinkedItem("canvas", t), i.setLinkedItem(l.getId(), l), i.setLinkedItem(s.getId(), s), i.addExtEventListener("visiblerangeset", c, s), i.addExtEventListener("visiblerangeset", c, l), t.attachAxis(s, !1, {}), t.attachAxis(l, !0, {}), e._setCategories();
      };
      var a = i(o(377)),
          r = i(o(960)),
          n = o(125);

      function i(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }
    },
    960: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = h(o(380)),
          r = o(125),
          n = o(958),
          i = h(o(383)),
          l = h(o(398)),
          s = h(o(961)),
          c = o(132),
          u = h(o(423)),
          p = o(386);

      function h(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function d(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var f = r.preDefStr.POSITION_MIDDLE,
          g = r.preDefStr.POSITION_START,
          m = r.preDefStr.POSITION_TOP,
          v = r.preDefStr.POSITION_BOTTOM,
          b = r.preDefStr.POSITION_END,
          y = Math,
          x = y.min,
          k = y.PI,
          w = 2 * k;
      (0, c.addDep)({
        name: "polarAnimation",
        type: "animationRule",
        extension: s["default"]
      });

      var C = function (e) {
        function t() {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t);

          var o = function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.call(this));

          return o.config.scale = new u["default"](), o.config.referenceInfo = [], o;
        }

        return d(t, e), t.prototype.getName = function () {
          return "polarCategory";
        }, t.prototype.__setDefaultConfig = function () {
          e.prototype.__setDefaultConfig.call(this), this.config.drawPlotBands = !1, this.config.forceZeroTick = !1;
        }, t.prototype.configureAttributes = function (t) {
          var o = this.config,
              a = t,
              n = this.getFromEnv("chart").getFromEnv("dataSource").chart,
              i = this.getFromEnv("color-manager");
          e.prototype.configureAttributes.call(this, t), o.gridLineColor = (0, r.convertColor)((0, r.pluck)(a.radarSpikeColor, i.getColor("divLineColor")), (0, r.pluckNumber)(a.radarSpikeAlpha, a.radarInLineAlpha, i.getColor("divLineAlpha"))), o.radarSpikeThickness = (0, r.pluckNumber)(n.radarspikethickness, 1);
        }, t.prototype.setAxisDimention = function (e) {
          var t,
              o = this.getScale(),
              a = this.config,
              n = this.getFromEnv("chart").config,
              i = a.startAngle || -k / 2,
              l = a.totalAngle || -w,
              s = i + l,
              c = l / ((a.tickValues.tickValue || []).length || 1),
              u = a.axisDimention || (a.axisDimention = {});
          u.opposite = (0, r.pluckNumber)(e.opposite, u.opposite), u.centerX = (0, r.pluckNumber)(e.x, u.x, n.canvasLeft), u.centerY = (0, r.pluckNumber)(e.y, u.y, n.canvasTop), u.axisLength = w, s -= c, t = a.clockWise ? [s, i] : [i, s], o.setRange(t);
        }, t.prototype._parseCategoryPlotLine = function () {
          var e,
              t,
              o,
              a = this.config,
              r = a.tickValues.tickValue,
              n = a.gridLineColor,
              i = a.radarSpikeThickness,
              l = a.referenceInfo;
          if (e = {
            stroke: n,
            "stroke-width": i
          }, (!r[0] || void 0 === r[0].x && void 0 === r[0].y) && a.lines.isDraw && a.numDivLines) for (t = 0; t < r.length; ++t) {
            o = t, l.push({
              from: o,
              type: "line",
              layer: 1,
              attr: e
            });
          }
        }, t.prototype.placeAxis = function (e, t) {
          var o,
              a,
              n,
              i,
              l,
              s,
              c,
              u,
              p = this.config,
              h = this.getFromEnv("chart"),
              d = h.getFromEnv("smartLabel"),
              f = p.labels.style,
              g = h.getFromEnv("dataSource").categories,
              m = p.labelPadding = (0, r.pluckNumber)(p.rawAttr.axisValuePadding, 10),
              v = p.useEllipsesWhenOverflow,
              b = 0,
              y = 0,
              k = 0,
              w = 0,
              C = t / 2,
              N = t / 2,
              S = e / 2,
              A = e / 2,
              E = p.tickValues && p.tickValues.tickValue;

          if (p.labels.isDraw = 1, p.labels.drawNormalVal = 1, p.labels.drawLimitVal = 1, this.components || (this.components = {}), this.components.labels = [], p.showLabels) {
            if (g) {
              var D = g[0];
              l = {
                fontFamily: D.font,
                fontSize: D.fontsize,
                color: D.fontcolor
              };
            }

            for (o = 0, a = E.length; o < a; o++) {
              s = {
                fontFamily: (n = E[o]).font,
                fontSize: n.fontsize,
                fontWeight: n.fontbold ? "bold" : "normal",
                fontStyle: n.fontitalic ? "italic" : "normal"
              }, c = {
                fontFamily: (0, r.pluck)(s.fontFamily, l.fontFamily, f.fontFamily),
                fontSize: (0, r.pluck)(s.fontSize, l.fontSize, f.fontSize),
                fontWeight: (0, r.pluck)(s.fontWeight, f.fontWeight),
                fontStyle: (0, r.pluck)(s.fontStyle, f.fontStyle)
              }, u = (0, r.setLineHeight)(c), d.useEllipsesOnOverflow(h.config.useEllipsesWhenOverflow), d.setStyle(c), void 0 === n.oriLabel && (n.oriLabel = n.label), 0 === o ? (i = d.getSmartText(n.oriLabel, e, x(u, C), v), n.label = i.text, n.tooltext = i.tooltext, i.width += m, i.height += m, i.height > b && (w = b = i.height)) : o === a / 2 ? (i = d.getSmartText(n.oriLabel, e, x(u, N), v), n.label = i.text, n.tooltext = i.tooltext, i.width += m, i.height += m, i.height > w && (w = i.height)) : o < a / 2 ? (i = d.getSmartText(n.oriLabel, A, u, v), n.label = i.text, n.tooltext = i.tooltext, i.width += m, i.height += m, i.width > y && (y = i.width)) : (i = d.getSmartText(n.oriLabel, S, u, v), n.label = i.text, n.tooltext = i.tooltext, i.width += m, i.height += m, i.width > k && (k = i.width)), this.components.labels.push({
                config: {
                  width: i.width,
                  height: i.height,
                  props: {
                    label: {
                      attr: {}
                    }
                  }
                }
              });
            }
          } else for (o = 0, a = E.length; o < a; o++) {
            this.components.labels.push({
              config: {
                width: 0,
                height: 0,
                props: {
                  label: {
                    attr: {}
                  }
                }
              }
            });
          }

          return {
            top: b,
            left: y,
            right: k,
            bottom: w
          };
        }, t.prototype._drawComponents = function () {
          var e = this.config;
          e.drawLabels && e.hasCategory && this._drawCategory();
        }, t.prototype.allocatePosition = function () {
          var e = this.config;
          e.drawLabels && e.hasCategory && this._parseCategory();
        }, t.prototype._parseCategory = function () {
          var e,
              t,
              o,
              a,
              i,
              l,
              s,
              c,
              u,
              p,
              h,
              d,
              y,
              x,
              k,
              w,
              C,
              N,
              S = this.config,
              A = this.getFromEnv("chart"),
              E = S.isOpposit,
              D = S.labels,
              _ = D.style,
              T = this.config.categoryLabel || (this.config.categoryLabel = {}),
              L = A.getFromEnv("dataSource").categories,
              P = S.tickValues.tickValue,
              O = S.labelPadding,
              V = {},
              M = {},
              F = S.axisDimention.centerX,
              I = S.axisDimention.centerY,
              B = this.getScale();

          if (x = (0, r.pluckNumber)(S.radius, 0), 0, t = P ? P.length - 1 : 0, S.labels.isDraw) {
            if (L) {
              var R = L[0];
              V.fontFamily = R.font, V.fontSize = R.fontsize, V.color = R.fontcolor;
            }

            for (e = 0; e <= t; e++) {
              o = P[e], h = (0, r.pluckNumber)(o.x, o.y, e), (S.labels.drawNormalVal || S.labels.drawLimitVal && (0 === e || h === t)) && (S.labels.drawNormalVal || 0 === h || h === t) && (S.labels.drawLimitVal || 0 !== h && h !== t) && (M = {
                fontFamily: (0, r.pluck)(o.font, o.labelfont),
                fontSize: (0, r.pluck)(o.fontsize, o.labelfontsize),
                fontWeight: (0, r.pluckNumber)(o.fontbold, o.labelfontbold, 0) ? "bold" : void 0,
                fontStyle: (0, r.pluckNumber)(o.fontitalic, o.labelfontitalic, 0) ? "italic" : void 0
              }, u = (0, r.convertColor)((0, r.pluck)(o.fontcolor, o.labelfontcolor, V.color, _.color), (0, r.pluckNumber)(o.labelalpha, S.rawAttr.labelFontAlpha, 100)), (s = {
                fontFamily: (0, r.pluck)(M.fontFamily, V.fontFamily, _.fontFamily),
                fontSize: (0, r.pluck)(M.fontSize, V.fontSize, _.fontSize),
                fontWeight: (0, r.pluck)(M.fontWeight, _.fontWeight),
                fontStyle: (0, r.pluck)(M.fontStyle, _.fontStyle)
              }).lineHeight = (0, r.setLineHeight)(s), s.lineHeight && -1 !== (i = s.lineHeight).indexOf("px") && (i = i.replace(/px/i, ""), i = parseFloat(i)), w = B.getRangeValue(h), (p = (0, n.polarToCartesian)(x + O, w)).x += F, p.y += I, d = p.x, y = p.y, a = o.label || "", 0 !== (0, r.pluckNumber)(o.showlabel, 1) && 0 !== S.showLabels || (a = ""), l = o.labelPadding || 0, c = {
                fill: u,
                "line-height": i,
                "font-size": _.fontSize,
                text: a,
                cursor: o.link ? "pointer" : "default",
                x: d,
                y: y
              }, l && (c.y += l), c["vertical-align"] = E ? v : m, 0 === e ? (c["text-anchor"] = f, c["vertical-align"] = v) : e === (t + 1) / 2 ? (c["text-anchor"] = f, c["vertical-align"] = m) : e < (t + 1) / 2 ? (c["text-anchor"] = b, c["vertical-align"] = f) : (c["text-anchor"] = g, c["vertical-align"] = f), w = B.getRangeValue(h), (k = (0, n.polarToCartesian)(x, w)).x += F, k.y += I, D.shiftX && (c.x += D.shiftX), D.shiftY && (c.y += D.shiftY), (T = S.categoryLabel = T || {})[N = "Label" + e] = T[N] || {}, T[N].config = T[N].config || {}, T[N].config.labelBox = C = {
                label: a,
                lineHeight: s.lineHeight,
                border: (0, r.pluckNumber)(o.borderthickness, o.labelborderthickness) ? (0, r.pluckNumber)(o.borderthickness, o.labelborderthickness, 1) + "px solid" : "",
                borderColor: o.bordercolor || o.labelbordercolor ? (0, r.convertColor)(o.bordercolor || o.labelbordercolor, (0, r.pluckNumber)(o.borderalpha, o.labelborderalpha, o.alpha, o.labelalpha, 100)) : r.BLANKSTRING,
                borderThickness: (0, r.pluckNumber)(o.borderthickness, o.labelborderthickness),
                borderPadding: (0, r.pluckNumber)(o.borderpadding, o.labelborderpadding),
                borderRadius: (0, r.pluckNumber)(o.borderradius, o.labelborderradius),
                backgroundColor: o.bgcolor || o.labelbgcolor ? (0, r.convertColor)(o.bgcolor || o.labelbgcolor, (0, r.pluckNumber)(o.bgalpha, o.labelbgalpha, o.alpha, o.labelalpha, 100)) : r.BLANKSTRING,
                borderDash: (0, r.pluckNumber)(o.borderdashed, o.labelborderdashed, 0) ? (0, r.getDashStyle)((0, r.pluckNumber)(o.borderdashlen, o.labelborderdashlen, 4), (0, r.pluckNumber)(o.borderdashgap, o.labelborderdashgap, 2)) : 0 === (0, r.pluckNumber)(o.borderdashed, o.labelborderdashed) ? "none" : _.borderDash
              }, T[N].config.labelBox["text-bound"] = a ? [(0, r.pluck)(C.backgroundColor, _.backgroundColor), (0, r.pluck)(C.borderColor, _.borderColor), (0, r.pluck)(C.borderThickness, _.borderThickness), (0, r.pluck)(C.borderPadding, _.borderPadding), (0, r.pluck)(C.borderRadius, _.borderRadius), (0, r.pluck)(C.borderDash, _.borderDash)] : [], c["text-bound"] = T[N].config.labelBox["text-bound"], this.components.labels[e].config.props.label.css = s, this.components.labels[e].config.props.label.attr = Object.assign(this.components.labels[e].config.props.label.attr, c));
            }
          }
        }, t.prototype._drawCategory = function () {
          var e,
              t,
              o,
              a,
              n,
              l,
              s,
              c,
              u,
              p,
              h,
              d = this,
              f = d.config,
              g = d.getFromEnv("chart"),
              m = g.getFromEnv("animationManager"),
              v = f.labels.style,
              b = f.axisContainer,
              y = f.tickValues.tickValue,
              x = function x(e) {
            return function (t) {
              g.plotEventHandler(this, t, e);
            };
          },
              k = d.getFromEnv("toolTipController"),
              w = 0,
              C = [];

          if (0, t = y ? y.length - 1 : 0, f.labels.isDraw) {
            for (e = 0, w = 0; e <= t; e++) {
              o = y[e], c = (0, r.pluckNumber)(o.x, o.y, e), (f.labels.drawNormalVal || f.labels.drawLimitVal && (0 === e || c === t)) && (f.labels.drawNormalVal || 0 === c || c === t) && (f.labels.drawLimitVal || 0 !== c && c !== t) && (p = "Label" + e, C.push(p), s = d.components.labels[e].config.props.label.attr, l = d.components.labels[e].config.props.label.css, n = d.getGraphicalElement(p), a = m.setAnimation({
                css: l,
                el: n || "text",
                attr: s,
                container: b,
                component: d,
                label: "polarLabel"
              }), f.showTooltip && o.tooltext ? k.enableToolTip(a, o.tooltext) : k.disableToolTip(a), a.data("eventArgs", {
                link: o.link || o.labellink || v.labelLink,
                text: s.text,
                index: w
              }), n || (d.addGraphicalElement(p, a), a.on("fc-click", x("datalabelclick")).hover(x("dataLabelRollOver"), x("dataLabelRollOut"))), w += 1);
            }

            f.labelMap = f.labelMap || [], h = (0, i["default"])(f.labelMap, C);
          } else h = C;

          f.labelMap = C, function (t) {
            for (e = 0; e < t.length; ++e) {
              (u = d.getGraphicalElement(t[e])) && d.removeGraphicalElement(u);
            }
          }(h);
        }, t.prototype.getTranslation = function () {
          if (this) return 0;
        }, t.prototype.getReferenceInfo = function () {
          return this.config.referenceInfo;
        }, t.prototype.setVisibleConfig = function (e, t) {
          var o,
              a = this.config,
              r = this.getScale();
          return !(e >= t || e < a.axisRange.min || t > a.axisRange.max) && (o = r.setDomain([e, t]).getDomain(), a.visibleMin = o[0], a.visibleMax = o[1], this.clearReferenceInfo(), this._parseReferenceVisuals(), this.fireEvent("visiblerangeset", {
            minValue: e,
            maxValue: t
          }), this.asyncDraw(), !0);
        }, t.prototype._parseReferenceVisuals = function () {
          this.config.drawPlotlines && this._parseCategoryPlotLine();
        }, t.prototype.clearReferenceInfo = function () {
          this.config.referenceInfo = [];
        }, t.prototype._setAxisRange = function (e) {
          var t,
              o = e.min,
              a = e.max,
              r = this.config,
              n = r.axisRange,
              i = e.divGap;
          o > a || (t = (a - o) / (r.categoryNumDivLines + 1), this.getScale().setDomain([o, a]), r.ticks = (0, l["default"])(o, a, t).concat(a), r._allTicks = r.ticks.slice(), n.min = o, n.max = a, n.tickInterval = i || t, this.setVisibleConfig(n.min, n.max));
        }, t;
      }(a["default"]);

      C.prototype.setTickValues = p.setTickValues, C.prototype.shiftLabels = p.shiftLabels, C.prototype._createContainer = p._createContainer, C.prototype.setAxisPadding = p.setAxisPadding, C.prototype.getPixel = p.getPixel, C.prototype.getLabel = p.getLabel, t["default"] = C;
    },
    961: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(962),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = {
        "initial.axis.polar": function initialAxisPolar() {
          return {
            "path.appearing": n["default"],
            "text.appearing": n["default"]
          };
        }
      };
    },
    963: function _(e, t, o) {
      "use strict";

      t.__esModule = !0, t["default"] = function (e) {
        var t = void 0;
        (0, n.componentFactory)(e, a["default"], "canvas", e.config.showVolumeChart ? 2 : 1);

        for (var o = 0, i = (t = e.getChildren("canvas")).length; o < i; o++) {
          t[o].configure(), (0, n.componentFactory)(t[o], r["default"], "axisRefVisualPolar");
        }
      };
      var a = i(o(964)),
          r = i(o(965)),
          n = o(125);

      function i(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }
    },
    964: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(364),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      },
          i = o(958),
          l = o(125);

      function s(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      var c = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return s(t, e), t.prototype.getName = function () {
          return "polarCanvas";
        }, t.prototype.getType = function () {
          return "canvas";
        }, t.prototype.configureAttributes = function () {
          e.prototype.configureAttributes.call(this);
          var t = this.config,
              o = this.getFromEnv("chart"),
              a = o.getFromEnv("dataSource").chart,
              r = o.getFromEnv("color-manager");
          t.radarBorderColor = (0, l.convertColor)((0, l.pluck)(a.radarbordercolor, r.getColor("divLineColor")), (0, l.pluckNumber)(a.radarborderalpha, 100)), t.radarFillColor = (0, l.convertColor)((0, l.pluck)(a.radarfillcolor, r.getColor("altHGridColor")), (0, l.pluckNumber)(a.radarfillalpha, r.getColor("altHGridAlpha"))), t.radarBorderThickness = (0, l.pluckNumber)(a.radarborderthickness, 2), t.showRadarBorder = (0, l.pluckNumber)(a.showradarborder, 1);
        }, t.prototype.draw = function () {
          this.createGroup(), this.drawCanvas();
        }, t.prototype.drawCanvas = function () {
          var e,
              t,
              o,
              a,
              r = this.config,
              n = this.getFromEnv("chart"),
              s = n.config,
              c = n.getChildren("xAxis")[0],
              u = n.getFromEnv("animationManager"),
              p = this.getContainer("radarBorderContainer"),
              h = this.getContainer("canvasGroup"),
              d = c.config,
              f = {
            stroke: r.radarBorderColor,
            fill: r.radarFillColor,
            "stroke-width": r.radarBorderThickness,
            path: []
          },
              g = void 0,
              m = d.tickValues.tickValue,
              v = void 0,
              b = c.getScale(),
              y = void 0,
              x = this.getGraphicalElement("radarBorder"),
              k = d.axisDimention.centerX,
              w = d.axisDimention.centerY;

          if (o = (0, l.pluckNumber)(d.radius, 0), 0, t = m ? m.length - 1 : 0, r.canvasLeft = r.canvasLeft || s.canvasLeft, r.canvasTop = r.canvasTop || s.canvasTop, r.canvasWidth = r.canvasWidth || s.canvasWidth, r.canvasHeight = r.canvasHeight || s.canvasHeight, 0 !== r.showRadarBorder) {
            for (f.path.push("M"), g = 0; g <= t; g++) {
              v = b.getRangeValue(g), (y = (0, i.polarToCartesian)(o, v)).x += k, y.y += w, f.path.push(y.x, y.y, "L");
            }

            f.path.pop(), f.path.push("Z");
          }

          e = u.setAnimation({
            el: p || "group",
            attr: {
              name: "radarBorderContainer"
            },
            container: h,
            component: this,
            label: "group"
          }), p || this.addContainer("radarBorderContainer", e), a = u.setAnimation({
            el: x || "path",
            attr: f,
            container: e,
            component: c,
            label: "path"
          }), x || this.addGraphicalElement("radarBorder", a);
        }, t;
      }(n["default"]);

      t["default"] = c;
    },
    965: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a = s(o(425)),
          r = o(958),
          n = o(125),
          i = o(132),
          l = s(o(966));

      function s(e) {
        return e && e.__esModule ? e : {
          "default": e
        };
      }

      function c(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
          }
        }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : function (e, t) {
          for (var o = Object.getOwnPropertyNames(t), a = 0; a < o.length; a++) {
            var r = o[a],
                n = Object.getOwnPropertyDescriptor(t, r);
            n && n.configurable && e[r] === undefined && Object.defineProperty(e, r, n);
          }
        }(e, t));
      }

      (0, i.addDep)({
        name: "axisRefPolarAnimation",
        type: "animationRule",
        extension: l["default"]
      });

      var u = function (e) {
        function t() {
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, t), function (e, t) {
            if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !t || "object" != typeof t && "function" != typeof t ? e : t;
          }(this, e.apply(this, arguments));
        }

        return c(t, e), t.prototype.getType = function () {
          return "axisRefVisuals";
        }, t.prototype.getName = function () {
          return "axisRefVisualsPolar";
        }, t.prototype.createLine = function (e, t) {
          return "polarCategory" === t.getName() ? this.createNormalLine(e, t) : "numeric" === t.getName() ? this.createRadialLine(e, t) : void 0;
        }, t.prototype.createRadialLine = function (e, t) {
          var o,
              a,
              n = this.getFromEnv("xAxis")[0],
              i = n.config.tickValues.tickValue,
              l = t,
              s = this.config.containers[e.layer],
              c = this.getFromEnv("animationManager"),
              u = this.getFromEnv("toolTipController"),
              p = void 0,
              h = void 0,
              d = e.attr,
              f = ["M"],
              g = void 0,
              m = l.getId() + "_" + (e.id || e.from),
              v = e.handlers,
              b = this.getGraphicalElement(m);

          for (a = function (e, t) {
            var o = e.getScale(),
                a = e.config.axisRange;
            return Math.abs(o.getRangeValue(t) - o.getRangeValue(a.min));
          }(l, e.from), 0, o = i ? i.length - 1 : 0, p = 0; p <= o; p++) {
            g = (0, r.getCoordinates)({
              radius: a,
              theta: p
            }, n), f.push(g.x, g.y, "L");
          }

          for (h in f.pop(), f.push("Z"), d.path = f, b = this.addGraphicalElement(m, c.setAnimation({
            container: s,
            el: b || "path",
            attr: d,
            component: this,
            label: "path"
          })), e.toolText ? u.enableToolTip(b, e.toolText) : u.disableToolTip(b), v) {
            v.hasOwnProperty(h) && b.on(h, v[h].bind(t));
          }

          return [m];
        }, t.prototype.createNormalLine = function (e, t) {
          var o,
              a = this.config,
              i = t.config,
              l = (0, n.pluckNumber)(i.radius, 0),
              s = ["M"],
              c = a.containers[e.layer],
              u = this.getFromEnv("animationManager"),
              p = this.getFromEnv("toolTipController"),
              h = void 0,
              d = i.axisDimention.centerX,
              f = i.axisDimention.centerY,
              g = t.getId() + "_" + (e.id || e.from),
              m = e.handlers,
              v = this.getGraphicalElement(g);

          for (h in s.push(d, f, "L"), o = (0, r.getCoordinates)({
            radius: l,
            theta: e.from
          }, t), s.push(o.x, o.y), e.attr.path = s, v = this.addGraphicalElement(g, u.setAnimation({
            container: c,
            el: v || "path",
            attr: e.attr,
            component: this,
            label: "path"
          })), e.toolText ? p.enableToolTip(v, e.toolText) : p.disableToolTip(v), m) {
            m.hasOwnProperty(h) && v.on(h, m[h].bind(t));
          }

          return [g];
        }, t.prototype.createBand = function () {
          return [];
        }, t;
      }(a["default"]);

      t["default"] = u;
    },
    966: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(962),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = {
        "initial.axis.axisRefVisualsPolar": function initialAxisAxisRefVisualsPolar() {
          return {
            "path.appearing": n["default"],
            "text.appearing": n["default"]
          };
        }
      };
    },
    967: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(879),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    },
    969: function _(e, t, o) {
      "use strict";

      t.__esModule = !0;
      var a,
          r = o(271),
          n = (a = r) && a.__esModule ? a : {
        "default": a
      };
      t["default"] = n["default"];
    }
  }]);
});